import React__default, { createContext, useContext, Fragment, useEffect, forwardRef, createElement, useRef, useState, useMemo, useCallback, memo, useReducer, useImperativeHandle, Component, createFactory } from 'react';
import _ConfigProvider from 'antd/lib/config-provider';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import styled, { css, createGlobalStyle, ThemeProvider } from 'styled-components';
import { useTranslation, initReactI18next } from 'react-i18next';
import { withRouter, useLocation, useParams, Switch, Route as Route$1, Redirect as Redirect$1 } from 'react-router';
import { Link, Redirect, Route, useHistory, useLocation as useLocation$1 } from 'react-router-dom';
import reactIs from 'react-is';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import _Typography from 'antd/lib/typography';
import _Tag from 'antd/lib/tag';
import i18n from 'i18next';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import _Row from 'antd/lib/row';
import _Col from 'antd/lib/col';
import uniqueId from 'lodash/uniqueId';
import _Card from 'antd/lib/card';
import _List from 'antd/lib/list';
import { isEmpty, get as get$1, omit, isArray, omitBy, startsWith, pick, partition } from 'lodash';
import _Skeleton from 'antd/lib/skeleton';
import { Line, Column, Pie } from '@ant-design/charts';
import _Spin from 'antd/lib/spin';
import _Button from 'antd/lib/button';
import _Table from 'antd/lib/table';
import { useMedia, useWindowSize } from 'react-use';
import _Menu from 'antd/lib/menu';
import _Collapse from 'antd/lib/collapse';
import _Checkbox from 'antd/lib/checkbox';
import _Pagination from 'antd/lib/pagination';
import _Modal from 'antd/lib/modal';
import { getTranslatedValue as getTranslatedValue$1 } from '@thewebops/admin-panel';
import { createAction, createReducer } from 'redux-starter-kit';
import _Alert from 'antd/lib/alert';
import _Space from 'antd/lib/space';
import _Switch from 'antd/lib/switch';
import _TimePicker from 'antd/lib/time-picker';
import _DatePicker from 'antd/lib/date-picker';
import _InputNumber from 'antd/lib/input-number';
import _Input from 'antd/lib/input';
import _Form from 'antd/lib/form';
import ReactHtmlParser from 'react-html-parser';
import _Upload from 'antd/lib/upload';
import _Image from 'antd/lib/image';
import ReactPlayer from 'react-player';
import { MediaEntry } from '@thewebops/genops-media';
export { media } from '@thewebops/genops-media';
import every from 'lodash/every';
import isObject from 'lodash/isObject';
import intersection$1 from 'lodash/intersection';
import LanguageDetector from 'i18next-browser-languagedetector';
import _Dropdown from 'antd/lib/dropdown';
import { push, goBack } from 'connected-react-router';
import { NotificationCenter, useFirebasePermissions, notificationsConfigs, notificationsSlice, firebaseTokensSlice, sagas } from '@thewebops/notifications';
import Color from 'color';
import useReactRouter from 'use-react-router';
import isEmpty$1 from 'lodash/isEmpty';
import _Divider from 'antd/lib/divider';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { GoogleMap as GoogleMap$2, OverlayView, withScriptjs, withGoogleMap, Polygon, Marker } from 'react-google-maps';
import DrawingManager from 'react-google-maps/lib/components/drawing/DrawingManager';
import StandaloneSearchBox from 'react-google-maps/lib/components/places/StandaloneSearchBox';
import 'symbol-observable';
import Barcode from 'react-barcode';
import _Avatar from 'antd/lib/avatar';
import ChatopsOnActioncable, { chatConfigs } from '@thewebops/chatops-on-actioncable/dist/wrapped';
import merge from 'lodash/merge';
import _Select from 'antd/lib/select';
import debounce from 'lodash/debounce';
import keyBy from 'lodash/keyBy';
import moment from 'moment';
import _Radio from 'antd/lib/radio';
import cloneDeep from 'lodash/cloneDeep';
import Highlighter from 'react-highlight-words';
import { Editor } from '@tinymce/tinymce-react';
import { API_BASE_URL } from 'utils/constants';
import _Drawer from 'antd/lib/drawer';
import _Breadcrumb from 'antd/lib/breadcrumb';
import ProLayout from '@ant-design/pro-layout';
import '@ant-design/pro-layout/dist/layout.css';
import 'antd/dist/antd.css';
import 'react-notifications/lib/notifications.css';
import { takeEvery, takeLatest, put, select as select$2, call as call$1, cancel, all } from 'redux-saga/effects';
import axios from 'axios';
import set from 'lodash/set';
import { saveAs } from 'file-saver';

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */


var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {
      /**/
    }
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function printWarning$1() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);

        if (checkerResult == null) {
          return null;
        }

        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }

      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

var getEntity = function getEntity(state, entityName) {
  return state.get(entityName);
};

var loadFromLocalStorage = function loadFromLocalStorage(key) {
  var item = localStorage.getItem(key);

  if (item) {
    return JSON.parse(item);
  }

  return null;
};

var addToLocalStorage = function addToLocalStorage(key, obj) {
  localStorage.setItem(key, JSON.stringify(obj));
};

var AppContext = createContext({});

var currentRoleEqualTo = function currentRoleEqualTo(roleType) {
  var _auth$authConfig$name;

  var _useContext = useContext(AppContext),
      authConfig = _useContext.authConfig;

  var auth = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var role = (_auth$authConfig$name = auth[authConfig.name]) === null || _auth$authConfig$name === void 0 ? void 0 : _auth$authConfig$name.role;
  return role ? role === roleType : true;
};

var filtersToAttributes = function filtersToAttributes(entity, data) {
  var filters = [].concat(entity.filters || [], entity.fieldsFilters || []);
  if (filters.length === 0) return {};
  return filters.reduce(function (attributes, filter) {
    var _extends2;

    return _extends({}, attributes, (_extends2 = {}, _extends2[filter.name] = data[filter.name], _extends2));
  }, {});
};

var handleFormatErrorsObject = function handleFormatErrorsObject(errors) {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array.isArray(errors) ? errors.map(function (error) {
    return /*#__PURE__*/React__default.createElement("span", {
      key: error
    }, "\u2022 " + humanize(i18n.t("formErrors:" + error)) + " \n");
  }) : humanize(i18n.t("formErrors:" + errors)));
};

var capitalizeString = function capitalizeString(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
};

var convertIdType = function convertIdType(identifier) {
  var convertedIdentifier = parseInt(identifier);

  if (convertedIdentifier && convertedIdentifier.toString() === identifier) {
    return convertedIdentifier;
  }

  return identifier;
};

var toggleLanguage = function toggleLanguage() {
  i18n.changeLanguage(i18n.language === "en" ? "ar" : "en");
};

var getDirection = function getDirection(rtlLanguages, language) {
  return rtlLanguages && rtlLanguages.has(language) ? "rtl" : "ltr";
};

var getTranslatedValue = function getTranslatedValue(value, accessor, getAllPossibleTranslations, customLanguage) {
  if (accessor === void 0) {
    accessor = null;
  }

  if (getAllPossibleTranslations === void 0) {
    getAllPossibleTranslations = false;
  }

  if (customLanguage === void 0) {
    customLanguage = null;
  }

  var language = i18n.language,
      options = i18n.options;
  var usedLanguage = customLanguage || language;
  if (getAllPossibleTranslations) return options.languages.reduce(function (accum, language) {
    return [].concat(accum, [getTranslatedValue(value, accessor, false, language)]);
  }, []);
  if (!value) return "";
  if (accessor) return value[accessor + "_" + usedLanguage] || value[accessor];

  switch (typeof value) {
    case "string":
      return value;

    case "object":
      return value[usedLanguage] || value[options.fallbackLng[0]];

    default:
      return "";
  }
};

var showNotification = function showNotification(entity, type, message, title, isSticky, allowCopy, mainNotificationType) {
  var mainType = mainNotificationType || (type.toLowerCase().includes("error") ? "error" : "success");
  var baseTitle = title || i18n.t("notifications:" + mainType);
  var notificationTitle = allowCopy ? baseTitle + " " + i18n.t("notifications:copyTitle") : baseTitle;
  var notificationBody = message || i18n.t("notifications:" + type, {
    entity: entity
  });
  var timeOut = isSticky ? 60 * 60 * 1000 : undefined;
  return NotificationManager[mainType](notificationBody, notificationTitle, timeOut, function () {
    if (allowCopy) {
      navigator.clipboard.writeText(notificationBody);
      showNotification(null, null, i18n.t("notifications:copiedBody"), i18n.t("notifications:copiedTitle"), false, false, "info");
    }
  });
};

var getAccessorValue = function getAccessorValue(data, accessor, getDirectAccessorValue, getAllPossibleTranslations, skipTranslation) {
  if (getDirectAccessorValue === void 0) {
    getDirectAccessorValue = false;
  }

  if (getAllPossibleTranslations === void 0) {
    getAllPossibleTranslations = false;
  }

  if (skipTranslation === void 0) {
    skipTranslation = false;
  }

  var language = i18n.language,
      options = i18n.options;
  if (typeof accessor === "function") return accessor(data, language);
  if (getAllPossibleTranslations) return getTranslatedValue(data, accessor, getAllPossibleTranslations);
  if (skipTranslation) return getTranslatedValue(data, accessor, false, options.fallbackLng[0]);
  if (getDirectAccessorValue) return getTranslatedValue(accessor);
  return getTranslatedValue(data, accessor);
};

var pascalCaseToSentence = function pascalCaseToSentence(string) {
  if (string === void 0) {
    string = "";
  }

  var regex = /([A-Z])(?=[A-Z][a-z])|([a-z])(?=[A-Z])/g;
  return string.replace(regex, "$& ");
};

var humanize = function humanize(str) {
  if (!str) return "N/A";
  if (typeof str !== "string") return str;
  return str.replace(/^[\s_]+|[\s_]+$/g, "").replace(/[_\s]+/g, " ").replace(/([A-Z])(?=[A-Z][a-z])|([a-z])(?=[A-Z])/g, "$& ").replace(/^[a-z]/, function (word) {
    return word.toUpperCase();
  });
};

var displayedTag = function displayedTag(value, _temp) {
  var _values$language, _values$language2;

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values;

  var language = i18n.language;
  return values[value] || ((_values$language = values[language]) === null || _values$language === void 0 ? void 0 : _values$language[value]) || ((_values$language2 = values[language]) === null || _values$language2 === void 0 ? void 0 : _values$language2["default"]) || (values === null || values === void 0 ? void 0 : values["default"]);
};

var displayWithTag = function displayWithTag(tagColorCode, component) {
  return tagColorCode ? /*#__PURE__*/React__default.createElement(_Tag, {
    color: tagColorCode
  }, component) : component;
};

var displayField = function displayField(_ref2) {
  var referencedLink = _ref2.referencedLink,
      Component = _ref2.component,
      value = _ref2.value,
      isFile = _ref2.isFile,
      inDataPage = _ref2.inDataPage,
      useHumanizer = _ref2.useHumanizer,
      tagColorCode = _ref2.tagColorCode;
  return function () {
    var _displayedValue;

    if (Component) return /*#__PURE__*/React__default.createElement(Component, {
      value: value
    });
    if (Array.isArray(value)) return value.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement("span", {
        key: index
      }, displayField(_extends({}, item, {
        useHumanizer: useHumanizer
      }))(), " , ");
    });
    var displayedValue = useHumanizer ? humanize("" + value) : value;
    if (!React__default.isValidElement(displayedValue)) displayedValue = (_displayedValue = displayedValue) === null || _displayedValue === void 0 ? void 0 : _displayedValue.toString();
    if (referencedLink) return displayWithTag(tagColorCode, /*#__PURE__*/React__default.createElement(Link, {
      to: referencedLink
    }, displayedValue));
    if (isFile && value && value !== "_") return /*#__PURE__*/React__default.createElement("a", {
      href: value,
      target: "_blank",
      rel: "noopener noreferrer"
    }, value && i18n.t("general:viewFile"));
    return displayWithTag(tagColorCode, inDataPage ? /*#__PURE__*/React__default.createElement(_Typography.Text, null, displayedValue || "") : displayedValue || null);
  };
};

var getOptionalFunctionValue = function getOptionalFunctionValue(data, args) {
  return typeof data === "function" ? args !== undefined ? data.apply(void 0, args) : data() : data;
};

var getJSONValue = function getJSONValue(value) {
  try {
    return typeof value === "string" ? JSON.parse(value) : value || {};
  } catch (_unused) {
    return {};
  }
};

var getValue = function getValue(config, state, source) {
  var sourceKey = getOptionalFunctionValue(config[source]);
  return get(state, sourceKey);
};

var getURL = function getURL(prefix, url) {
  var suffix = (url === null || url === void 0 ? void 0 : url.charAt(0)) !== "/" ? "/" + url : url || "";
  if (prefix === "/") return suffix;else return "" + prefix + suffix;
};

var convertToEnglishNumbers = function convertToEnglishNumbers(value) {
  return value.replace(/([٠١٢٣٤٥٦٧٨٩])|([۰۱۲۳۴۵۶۷۸۹])/g, function (m, $1, $2) {
    return m.charCodeAt(0) - ($1 ? 1632 : 1776);
  });
};

var isValueEmpty = function isValueEmpty(value) {
  return ["", null, undefined].includes(value) || isEqual([], value) || isEqual({}, value);
};

var isFileField = function isFileField(fieldType) {
  return ["file", "image", "video", "profilePicture", "pdf"].includes(fieldType);
};

var modifyAccessor = function modifyAccessor(accessor, fieldType, options) {
  if (options === void 0) {
    options = {};
  }

  return typeof accessor === "string" && options.constructFileAccessor && isFileField(fieldType) ? accessor + "_url" : accessor;
};

var getToggleValue = function getToggleValue(toggleConfig, value) {
  if (toggleConfig === void 0) {
    toggleConfig = {};
  }

  var defaultConfig = {
    on: true,
    off: null
  };

  var config = _extends({}, defaultConfig, toggleConfig);

  var key = value ? "on" : "off";
  return config[key];
};

var getFiltersDefaultValues = function getFiltersDefaultValues(filters) {
  return filters === null || filters === void 0 ? void 0 : filters.reduce(function (acc, filter) {
    var _filter$selectConfig;

    if (((_filter$selectConfig = filter.selectConfig) === null || _filter$selectConfig === void 0 ? void 0 : _filter$selectConfig.optionsType) === "static") acc[filter.name] = filter.selectConfig.defaultValue;else if (filter.type === "toggle") acc[filter.name] = getToggleValue(filter.toggleConfig, filter.defaultValue || false);else if (filter.defaultValue) acc[filter.name] = filter.defaultValue;
    return acc;
  }, {});
};

var renderComponent = function renderComponent(UserDefinedComponent, FallBackComponent, props) {
  return UserDefinedComponent ? /*#__PURE__*/React__default.createElement(UserDefinedComponent, props) : /*#__PURE__*/React__default.createElement(FallBackComponent, props);
};

var splitFirstCharacter = function splitFirstCharacter(string, character) {
  var splitString = string.split(character);
  return [splitString[0], splitString.slice(1).join(character)];
};

var camelizeFromSnakeCase = function camelizeFromSnakeCase(string) {
  return string.toLowerCase().replace(/[-_][a-z]/g, function (group) {
    return group.slice(-1).toUpperCase();
  });
};

var seperateActions = function seperateActions(allActions) {
  return Object.keys(allActions).reduce(function (accum, actionKey) {
    var action = allActions[actionKey];
    if (action.isAPIEntity) accum.apiEntityActions[actionKey] = action;else accum.staticEntityActions[actionKey] = action;
    return accum;
  }, {
    staticEntityActions: {},
    apiEntityActions: {}
  });
};

var _excluded = ["path"];

var PrivateRoute = function PrivateRoute(_ref) {
  var path = _ref.path,
      configs = _objectWithoutPropertiesLoose(_ref, _excluded);

  var authHeaders = loadFromLocalStorage("authHeaders");
  var authEntity = useSelector(function (state) {
    return getEntity(state, "auth");
  });

  var _useContext = useContext(AppContext),
      authConfig = _useContext.authConfig,
      publicRouteURL = _useContext.publicRouteURL;

  var loginURL = getURL(publicRouteURL, "/login");
  var auth = authEntity === null || authEntity === void 0 ? void 0 : authEntity[authConfig.name];
  if (!authHeaders) return /*#__PURE__*/React__default.createElement(Redirect, {
    to: {
      pathname: loginURL,
      state: {
        from: configs.location.pathname
      }
    }
  });
  if (authConfig.preventDashboardAccess && authConfig.preventDashboardAccess(auth) && path !== authConfig.preventDashboardAccess(auth)) return /*#__PURE__*/React__default.createElement(Redirect, {
    to: authConfig.preventDashboardAccess(auth)
  });
  return /*#__PURE__*/React__default.createElement(Route, _extends({
    path: path
  }, configs));
};

PrivateRoute.propTypes = {
  "private": propTypes.bool
};

var generateWidthMediaQueries = function generateWidthMediaQueries(_ref, _ref2) {
  var _ref$widthConfig = _ref.widthConfig,
      widthConfig = _ref$widthConfig === void 0 ? {} : _ref$widthConfig,
      theme = _ref.theme;
  var _ref2$desktop = _ref2.desktop,
      desktop = _ref2$desktop === void 0 ? "" : _ref2$desktop,
      _ref2$mobile = _ref2.mobile,
      mobile = _ref2$mobile === void 0 ? "" : _ref2$mobile,
      _ref2$tablet = _ref2.tablet,
      tablet = _ref2$tablet === void 0 ? "" : _ref2$tablet;
  return "\n width: " + (widthConfig.desktop || desktop) + ";\n\n " + ((widthConfig.tablet || tablet) && "@media only screen and (max-width: " + theme.breakpoints.md + ") {\n    width: " + (widthConfig.tablet || tablet) + ";\n  }") + "\n\n\n " + ((widthConfig.mobile || mobile) && "@media only screen and (max-width: " + theme.breakpoints.xs + ") {\n     width: " + (widthConfig.mobile || mobile) + ";\n   }") + "\n\n";
};

var getDataValue = function getDataValue(data, config, defaultValue, sentProps) {
  if (!config) return getTranslatedValue(defaultValue || "");
  var staticValue = config.staticValue,
      accessor = config.accessor,
      customComponent = config.customComponent;

  if (customComponent) {
    var Component = customComponent;
    return /*#__PURE__*/React__default.createElement(Component, sentProps);
  }

  if (staticValue) return getTranslatedValue(staticValue);
  if (accessor) return Array.isArray(accessor) ? get(data, accessor) : getAccessorValue(data, accessor);
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var StyledGroupContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  .card {\n    padding: 10px;\n  }\n  .ant-card-body {\n    padding: 0px 24px 24px 24px;\n  }\n  .ant-list-item a:not(:hover) {\n    color: ", ";\n  }\n  @media only screen and (min-width: ", ") {\n    ", "\n  }\n\n  @media only screen and (max-width: ", ") {\n    .card {\n      padding: 5px;\n    }\n  }\n\n  ", "\n"])), function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.alignHorizontally && ".ant-spin-container {\n      position: relative;\n      -webkit-transition: opacity 0.3s;\n      transition: opacity 0.3s;\n      display: flex;\n      flex-wrap: wrap;\n      max-height: 300px;\n      flex-direction: column;\n      overflow: auto;\n    }";
}, function (props) {
  return props.theme.breakpoints.xs;
}, function (props) {
  return generateWidthMediaQueries(props, {
    desktop: "",
    mobile: "100%",
    tablet: "100%"
  });
});
var StyledWelcomeWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  .welcome {\n    flex-grow: 1;\n    padding: 20px;\n  }\n  ", "\n  @media only screen and (max-width: ", ") {\n    .welcome-title {\n      font-size: 100%;\n    }\n    .welcome {\n      padding: 0px 0px 10px 0px;\n    }\n  }\n"])), function (props) {
  return generateWidthMediaQueries(props, {
    desktop: "100%"
  });
}, function (props) {
  return props.theme.breakpoints.xs;
});
var StyledWidthWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n\n  @media only screen and (max-width: ", ") {\n    padding: 0px 0px 10px 0px;\n  }\n"])), function (props) {
  return generateWidthMediaQueries(props, {
    desktop: "100%",
    mobile: "100%",
    tablet: "100%"
  });
}, function (props) {
  return props.theme.breakpoints.xs;
});
var StyledGraphWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n"])), function (props) {
  return props.isGraph && ".ant-card-body {\n    padding: 10px;\n    direction: ltr;\n\n  }";
}, function (props) {
  return props.isTable && ".ant-card-body {\n      padding: 0px 24px 24px 24px;\n   }\n\n  ";
});
var Title = _Typography.Title;

var Welcome = function Welcome(_ref) {
  var authData = _ref.authData,
      config = _ref.config,
      t = _ref.t,
      dataSource = _ref.data;
  var name = authData === null || authData === void 0 ? void 0 : authData.name;
  var width = config.width,
      _config$data = config.data,
      data = _config$data === void 0 ? {} : _config$data;
  var title = data.title,
      description = data.description;
  var titleContent = getDataValue(dataSource, title, t("welcome", {
    name: name
  }));
  var descriptionContent = getDataValue(dataSource, description, t("description"));
  return /*#__PURE__*/React__default.createElement(StyledWelcomeWrapper, {
    widthConfig: width
  }, /*#__PURE__*/React__default.createElement(_Col, {
    className: "welcome"
  }, /*#__PURE__*/React__default.createElement(_Card, {
    title: /*#__PURE__*/React__default.createElement(Title, {
      className: "welcome-title",
      level: 3
    }, " ", titleContent)
  }, /*#__PURE__*/React__default.createElement(Title, {
    level: 5
  }, descriptionContent))));
};

var EntityGroups = function EntityGroups(_ref) {
  var groups = _ref.groups,
      t = _ref.t,
      authData = _ref.authData,
      privateRouteURL = _ref.privateRouteURL,
      config = _ref.config;
  var width = config.width,
      alignHorizontally = config.alignHorizontally;
  var role = authData === null || authData === void 0 ? void 0 : authData.role;
  return groups.map(function (group, index) {
    return !isEmpty(group.entities) && /*#__PURE__*/React__default.createElement(StyledGroupContainer, {
      widthConfig: width,
      alignHorizontally: alignHorizontally,
      key: index
    }, /*#__PURE__*/React__default.createElement(_Col, {
      key: group.name
    }, /*#__PURE__*/React__default.createElement(_Card, {
      className: "card",
      title: group.name === "ungrouped" ? t("ungrouped") : getTranslatedValue(group.name)
    }, /*#__PURE__*/React__default.createElement(_List, null, Object.keys(group.entities).map(function (key) {
      var entity = group.entities[key];
      if (entity.canView(role)) return /*#__PURE__*/React__default.createElement(_List.Item, {
        key: entity.name
      }, /*#__PURE__*/React__default.createElement(Link, {
        to: getURL(privateRouteURL, entity.pathName)
      }, entity.getDisplayName()));
      return /*#__PURE__*/React__default.createElement(Fragment, null);
    })))));
  });
};

var DisplayCard = function DisplayCard(_ref) {
  var authData = _ref.authData,
      config = _ref.config,
      isLoading = _ref.isLoading,
      dataSource = _ref.data,
      isTable = _ref.isTable;
  var width = config.width,
      _config$data = config.data,
      data = _config$data === void 0 ? {} : _config$data,
      style = config.style,
      isGraph = config.isGraph;
  var title = data.title,
      body = data.body;
  var customComponentProps = {
    authData: authData,
    config: config
  };
  var titleContent = getDataValue(dataSource, title, null, customComponentProps);
  var bodyContent = getDataValue(dataSource, body, null, customComponentProps);
  return /*#__PURE__*/React__default.createElement(StyledWidthWrapper, {
    widthConfig: width
  }, /*#__PURE__*/React__default.createElement(_Col, null, /*#__PURE__*/React__default.createElement(StyledGraphWrapper, {
    isGraph: isGraph,
    isTable: isTable
  }, /*#__PURE__*/React__default.createElement(_Card, {
    style: _extends({}, style),
    title: titleContent
  }, isLoading ? /*#__PURE__*/React__default.createElement(_Skeleton, {
    active: true
  }) : bodyContent))));
};

var Graph = function Graph(_ref) {
  var _config$data;

  var authData = _ref.authData,
      config = _ref.config,
      isLoading = _ref.isLoading,
      data = _ref.data;
  var type = config.type,
      _config$labelFontSize = config.labelFontSize,
      labelFontSize = _config$labelFontSize === void 0 ? 14 : _config$labelFontSize,
      showXAxisLabel = config.showXAxisLabel,
      showYAxisLabel = config.showYAxisLabel;
  var supportedGraphs = {
    line: Line,
    column: Column,
    pie: Pie
  };
  var Component = supportedGraphs[type];
  var graphData = getDataValue(data, (_config$data = config.data) === null || _config$data === void 0 ? void 0 : _config$data.graphData) || [];
  if (!Component) throw new Error("Unsupported graph, choose one of " + Object.keys(supportedGraphs));
  var label = type === "pie" ? {
    type: "inner",
    offset: "-30%",
    content: function content(_ref2) {
      var percent = _ref2.percent;
      return (percent * 100).toFixed(1) + "%";
    },
    style: {
      fontSize: labelFontSize,
      textAlign: "center"
    }
  } : null;

  var graphConfig = _extends({}, config, {
    data: graphData,
    label: label
  }, showXAxisLabel && {
    xAxis: {
      title: {}
    }
  }, showYAxisLabel && {
    yAxis: {
      title: {}
    }
  });

  var graph = function graph() {
    return /*#__PURE__*/React__default.createElement(Component, graphConfig);
  };

  config.data.body = {
    customComponent: graph
  };
  config.isGraph = true;
  return /*#__PURE__*/React__default.createElement(DisplayCard, {
    authData: authData,
    isLoading: isLoading,
    config: config
  });
};

var IconContext = /*#__PURE__*/createContext({});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */


function bound01(n, max) {
  if (isOnePointZero(n)) {
    n = '100%';
  }

  var isPercent = isPercentage(n);
  n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n))); // Automatically convert percentage into number

  if (isPercent) {
    n = parseInt(String(n * max), 10) / 100;
  } // Handle floating point rounding errors


  if (Math.abs(n - max) < 0.000001) {
    return 1;
  } // Convert into [0, 1] range if it isn't already


  if (max === 360) {
    // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
  } else {
    // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
  }

  return n;
}
/**
 * Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
 * <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
 * @hidden
 */


function isOnePointZero(n) {
  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
/**
 * Check to see if string passed in is a percentage
 * @hidden
 */


function isPercentage(n) {
  return typeof n === 'string' && n.indexOf('%') !== -1;
}
/**
 * Return a valid alpha value [0,1] with all invalid values being set to 1
 * @hidden
 */


function boundAlpha(a) {
  a = parseFloat(a);

  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }

  return a;
}
/**
 * Replace a decimal with it's percentage value
 * @hidden
 */


function convertToPercentage(n) {
  if (n <= 1) {
    return "".concat(Number(n) * 100, "%");
  }

  return n;
}
/**
 * Force a hex value to have 2 characters
 * @hidden
 */


function pad2(c) {
  return c.length === 1 ? '0' + c : String(c);
} // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

/**
 * Handle bounds / percentage checking to conform to CSS color spec
 * <http://www.w3.org/TR/css3-color/>
 * *Assumes:* r, g, b in [0, 255] or [0, 1]
 * *Returns:* { r, g, b } in [0, 255]
 */


function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}

function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }

  if (t > 1) {
    t -= 1;
  }

  if (t < 1 / 6) {
    return p + (q - p) * (6 * t);
  }

  if (t < 1 / 2) {
    return q;
  }

  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }

  return p;
}
/**
 * Converts an HSL color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */


function hslToRgb(h, s, l) {
  var r;
  var g;
  var b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);

  if (s === 0) {
    // achromatic
    g = l;
    b = l;
    r = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}
/**
 * Converts an RGB color value to HSV
 *
 * *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
 * *Returns:* { h, s, v } in [0,1]
 */


function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h = 0;
  var v = max;
  var d = max - min;
  var s = max === 0 ? 0 : d / max;

  if (max === min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h,
    s: s,
    v: v
  };
}
/**
 * Converts an HSV color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */


function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h);
  var f = h - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  var mod = i % 6;
  var r = [v, q, p, p, t, v][mod];
  var g = [t, v, v, q, p, p][mod];
  var b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}
/**
 * Converts an RGB color to hex
 *
 * Assumes r, g, and b are contained in the set [0, 255]
 * Returns a 3 or 6 character hex
 */


function rgbToHex(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))]; // Return a 3 character hex if possible

  if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }

  return hex.join('');
}
/** Converts a hex value to a decimal */


function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
/** Parse a base-16 hex value into a base-10 integer */


function parseIntFromHex(val) {
  return parseInt(val, 16);
} // https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json

/**
 * @hidden
 */


var names = {
  aliceblue: '#f0f8ff',
  antiquewhite: '#faebd7',
  aqua: '#00ffff',
  aquamarine: '#7fffd4',
  azure: '#f0ffff',
  beige: '#f5f5dc',
  bisque: '#ffe4c4',
  black: '#000000',
  blanchedalmond: '#ffebcd',
  blue: '#0000ff',
  blueviolet: '#8a2be2',
  brown: '#a52a2a',
  burlywood: '#deb887',
  cadetblue: '#5f9ea0',
  chartreuse: '#7fff00',
  chocolate: '#d2691e',
  coral: '#ff7f50',
  cornflowerblue: '#6495ed',
  cornsilk: '#fff8dc',
  crimson: '#dc143c',
  cyan: '#00ffff',
  darkblue: '#00008b',
  darkcyan: '#008b8b',
  darkgoldenrod: '#b8860b',
  darkgray: '#a9a9a9',
  darkgreen: '#006400',
  darkgrey: '#a9a9a9',
  darkkhaki: '#bdb76b',
  darkmagenta: '#8b008b',
  darkolivegreen: '#556b2f',
  darkorange: '#ff8c00',
  darkorchid: '#9932cc',
  darkred: '#8b0000',
  darksalmon: '#e9967a',
  darkseagreen: '#8fbc8f',
  darkslateblue: '#483d8b',
  darkslategray: '#2f4f4f',
  darkslategrey: '#2f4f4f',
  darkturquoise: '#00ced1',
  darkviolet: '#9400d3',
  deeppink: '#ff1493',
  deepskyblue: '#00bfff',
  dimgray: '#696969',
  dimgrey: '#696969',
  dodgerblue: '#1e90ff',
  firebrick: '#b22222',
  floralwhite: '#fffaf0',
  forestgreen: '#228b22',
  fuchsia: '#ff00ff',
  gainsboro: '#dcdcdc',
  ghostwhite: '#f8f8ff',
  goldenrod: '#daa520',
  gold: '#ffd700',
  gray: '#808080',
  green: '#008000',
  greenyellow: '#adff2f',
  grey: '#808080',
  honeydew: '#f0fff0',
  hotpink: '#ff69b4',
  indianred: '#cd5c5c',
  indigo: '#4b0082',
  ivory: '#fffff0',
  khaki: '#f0e68c',
  lavenderblush: '#fff0f5',
  lavender: '#e6e6fa',
  lawngreen: '#7cfc00',
  lemonchiffon: '#fffacd',
  lightblue: '#add8e6',
  lightcoral: '#f08080',
  lightcyan: '#e0ffff',
  lightgoldenrodyellow: '#fafad2',
  lightgray: '#d3d3d3',
  lightgreen: '#90ee90',
  lightgrey: '#d3d3d3',
  lightpink: '#ffb6c1',
  lightsalmon: '#ffa07a',
  lightseagreen: '#20b2aa',
  lightskyblue: '#87cefa',
  lightslategray: '#778899',
  lightslategrey: '#778899',
  lightsteelblue: '#b0c4de',
  lightyellow: '#ffffe0',
  lime: '#00ff00',
  limegreen: '#32cd32',
  linen: '#faf0e6',
  magenta: '#ff00ff',
  maroon: '#800000',
  mediumaquamarine: '#66cdaa',
  mediumblue: '#0000cd',
  mediumorchid: '#ba55d3',
  mediumpurple: '#9370db',
  mediumseagreen: '#3cb371',
  mediumslateblue: '#7b68ee',
  mediumspringgreen: '#00fa9a',
  mediumturquoise: '#48d1cc',
  mediumvioletred: '#c71585',
  midnightblue: '#191970',
  mintcream: '#f5fffa',
  mistyrose: '#ffe4e1',
  moccasin: '#ffe4b5',
  navajowhite: '#ffdead',
  navy: '#000080',
  oldlace: '#fdf5e6',
  olive: '#808000',
  olivedrab: '#6b8e23',
  orange: '#ffa500',
  orangered: '#ff4500',
  orchid: '#da70d6',
  palegoldenrod: '#eee8aa',
  palegreen: '#98fb98',
  paleturquoise: '#afeeee',
  palevioletred: '#db7093',
  papayawhip: '#ffefd5',
  peachpuff: '#ffdab9',
  peru: '#cd853f',
  pink: '#ffc0cb',
  plum: '#dda0dd',
  powderblue: '#b0e0e6',
  purple: '#800080',
  rebeccapurple: '#663399',
  red: '#ff0000',
  rosybrown: '#bc8f8f',
  royalblue: '#4169e1',
  saddlebrown: '#8b4513',
  salmon: '#fa8072',
  sandybrown: '#f4a460',
  seagreen: '#2e8b57',
  seashell: '#fff5ee',
  sienna: '#a0522d',
  silver: '#c0c0c0',
  skyblue: '#87ceeb',
  slateblue: '#6a5acd',
  slategray: '#708090',
  slategrey: '#708090',
  snow: '#fffafa',
  springgreen: '#00ff7f',
  steelblue: '#4682b4',
  tan: '#d2b48c',
  teal: '#008080',
  thistle: '#d8bfd8',
  tomato: '#ff6347',
  turquoise: '#40e0d0',
  violet: '#ee82ee',
  wheat: '#f5deb3',
  white: '#ffffff',
  whitesmoke: '#f5f5f5',
  yellow: '#ffff00',
  yellowgreen: '#9acd32'
};
/**
 * Given a string or object, convert that input to RGB
 *
 * Possible string inputs:
 * ```
 * "red"
 * "#f00" or "f00"
 * "#ff0000" or "ff0000"
 * "#ff000000" or "ff000000"
 * "rgb 255 0 0" or "rgb (255, 0, 0)"
 * "rgb 1.0 0 0" or "rgb (1, 0, 0)"
 * "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
 * "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
 * "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
 * "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
 * "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
 * ```
 */

function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;

  if (typeof color === 'string') {
    color = stringInputToObject(color);
  }

  if (typeof color === 'object') {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = 'hsv';
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = 'hsl';
    }

    if (Object.prototype.hasOwnProperty.call(color, 'a')) {
      a = color.a;
    }
  }

  a = boundAlpha(a);
  return {
    ok: ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a
  };
} // <http://www.w3.org/TR/css3-values/#integers>


var CSS_INTEGER = '[-\\+]?\\d+%?'; // <http://www.w3.org/TR/css3-values/#number-value>

var CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?'; // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.

var CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")"); // Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren

var PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var matchers = {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp('rgb' + PERMISSIVE_MATCH3),
  rgba: new RegExp('rgba' + PERMISSIVE_MATCH4),
  hsl: new RegExp('hsl' + PERMISSIVE_MATCH3),
  hsla: new RegExp('hsla' + PERMISSIVE_MATCH4),
  hsv: new RegExp('hsv' + PERMISSIVE_MATCH3),
  hsva: new RegExp('hsva' + PERMISSIVE_MATCH4),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
/**
 * Permissive string parsing.  Take in a number of formats, and output an object
 * based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
 */

function stringInputToObject(color) {
  color = color.trim().toLowerCase();

  if (color.length === 0) {
    return false;
  }

  var named = false;

  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color === 'transparent') {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: 'name'
    };
  } // Try to match string input using regular expressions.
  // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
  // Just return an object and let the conversion functions handle that.
  // This way the result will be the same whether the tinycolor is initialized with string or object.


  var match = matchers.rgb.exec(color);

  if (match) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }

  match = matchers.rgba.exec(color);

  if (match) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }

  match = matchers.hsl.exec(color);

  if (match) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }

  match = matchers.hsla.exec(color);

  if (match) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }

  match = matchers.hsv.exec(color);

  if (match) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }

  match = matchers.hsva.exec(color);

  if (match) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }

  match = matchers.hex8.exec(color);

  if (match) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? 'name' : 'hex8'
    };
  }

  match = matchers.hex6.exec(color);

  if (match) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? 'name' : 'hex'
    };
  }

  match = matchers.hex4.exec(color);

  if (match) {
    return {
      r: parseIntFromHex(match[1] + match[1]),
      g: parseIntFromHex(match[2] + match[2]),
      b: parseIntFromHex(match[3] + match[3]),
      a: convertHexToDecimal(match[4] + match[4]),
      format: named ? 'name' : 'hex8'
    };
  }

  match = matchers.hex3.exec(color);

  if (match) {
    return {
      r: parseIntFromHex(match[1] + match[1]),
      g: parseIntFromHex(match[2] + match[2]),
      b: parseIntFromHex(match[3] + match[3]),
      format: named ? 'name' : 'hex'
    };
  }

  return false;
}
/**
 * Check to see if it looks like a CSS unit
 * (see `matchers` above for definition).
 */


function isValidCSSUnit(color) {
  return Boolean(matchers.CSS_UNIT.exec(String(color)));
}

var hueStep = 2; // 色相阶梯

var saturationStep = 0.16; // 饱和度阶梯，浅色部分

var saturationStep2 = 0.05; // 饱和度阶梯，深色部分

var brightnessStep1 = 0.05; // 亮度阶梯，浅色部分

var brightnessStep2 = 0.15; // 亮度阶梯，深色部分

var lightColorCount = 5; // 浅色数量，主色上

var darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表

var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}]; // Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`

function toHsv(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  var hsv = rgbToHsv(r, g, b);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`


function toHex(_ref2) {
  var r = _ref2.r,
      g = _ref2.g,
      b = _ref2.b;
  return "#".concat(rgbToHex(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.


function mix(rgb1, rgb2, amount) {
  var p = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}

function getHue(hsv, i, light) {
  var hue; // 根据色相不同，色相转向不同

  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }

  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }

  return hue;
}

function getSaturation(hsv, i, light) {
  // grey color don't change saturation
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }

  var saturation;

  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  } // 边界值修正


  if (saturation > 1) {
    saturation = 1;
  } // 第一格的 s 限制在 0.06-0.1 之间


  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }

  if (saturation < 0.06) {
    saturation = 0.06;
  }

  return Number(saturation.toFixed(2));
}

function getValue$1(hsv, i, light) {
  var value;

  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }

  if (value > 1) {
    value = 1;
  }

  return Number(value.toFixed(2));
}

function generate(color) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var patterns = [];
  var pColor = inputToRGB(color);

  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(inputToRGB({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue$1(hsv, i, true)
    }));
    patterns.push(colorString);
  }

  patterns.push(toHex(pColor));

  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);

    var _colorString = toHex(inputToRGB({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue$1(_hsv, _i)
    }));

    patterns.push(_colorString);
  } // dark theme patterns


  if (opts.theme === 'dark') {
    return darkColorMap.map(function (_ref3) {
      var index = _ref3.index,
          opacity = _ref3.opacity;
      var darkColorString = toHex(mix(inputToRGB(opts.backgroundColor || '#141414'), inputToRGB(patterns[index]), opacity * 100));
      return darkColorString;
    });
  }

  return patterns;
}

var presetPrimaryColors = {
  red: '#F5222D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FADB14',
  lime: '#A0D911',
  green: '#52C41A',
  cyan: '#13C2C2',
  blue: '#1890FF',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#666666'
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function (key) {
  presetPalettes[key] = generate(presetPrimaryColors[key]);
  presetPalettes[key].primary = presetPalettes[key][5]; // dark presetPalettes

  presetDarkPalettes[key] = generate(presetPrimaryColors[key], {
    theme: 'dark',
    backgroundColor: '#141414'
  });
  presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
});
/* eslint-disable no-console */

var warned = {};

function warning(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}

function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

function warningOnce(valid, message) {
  call(warning, valid, message);
}
/* eslint-enable */


function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

var MARK_KEY = "rc-util-key";

function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      mark = _ref.mark;

  if (mark) {
    return mark.startsWith('data-') ? mark : "data-".concat(mark);
  }

  return MARK_KEY;
}

function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }

  var head = document.querySelector('head');
  return head || document.body;
}

function injectCSS(css) {
  var _option$csp;

  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!canUseDom()) {
    return null;
  }

  var styleNode = document.createElement('style');

  if ((_option$csp = option.csp) === null || _option$csp === void 0 ? void 0 : _option$csp.nonce) {
    var _option$csp2;

    styleNode.nonce = (_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce;
  }

  styleNode.innerHTML = css;
  var container = getContainer(option);
  var firstChild = container.firstChild;

  if (option.prepend && container.prepend) {
    // Use `prepend` first
    container.prepend(styleNode);
  } else if (option.prepend && firstChild) {
    // Fallback to `insertBefore` like IE not support `prepend`
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }

  return styleNode;
}

var containerCache = new Map();

function findExistNode(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var container = getContainer(option);
  return Array.from(containerCache.get(container).children).find(function (node) {
    return node.tagName === 'STYLE' && node.getAttribute(getMark(option)) === key;
  });
}

function updateCSS(css, key) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var container = getContainer(option); // Get real parent

  if (!containerCache.has(container)) {
    var placeholderStyle = injectCSS('', option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    parentNode.removeChild(placeholderStyle);
  }

  var existNode = findExistNode(key, option);

  if (existNode) {
    var _option$csp3, _option$csp4;

    if (((_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce) && existNode.nonce !== ((_option$csp4 = option.csp) === null || _option$csp4 === void 0 ? void 0 : _option$csp4.nonce)) {
      var _option$csp5;

      existNode.nonce = (_option$csp5 = option.csp) === null || _option$csp5 === void 0 ? void 0 : _option$csp5.nonce;
    }

    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }

    return existNode;
  }

  var newNode = injectCSS(css, option);
  newNode.setAttribute(getMark(option), key);
  return newNode;
}

function warning$1(valid, message) {
  warningOnce(valid, "[@ant-design/icons] ".concat(message));
}

function isIconDefinition(target) {
  return _typeof(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (_typeof(target.icon) === 'object' || typeof target.icon === 'function');
}

function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];

    switch (key) {
      case 'class':
        acc.className = val;
        delete acc.class;
        break;

      default:
        acc[key] = val;
    }

    return acc;
  }, {});
}

function generate$1(node, key, rootProps) {
  if (!rootProps) {
    return /*#__PURE__*/React__default.createElement(node.tag, _objectSpread2({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate$1(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }

  return /*#__PURE__*/React__default.createElement(node.tag, _objectSpread2(_objectSpread2({
    key: key
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function (child, index) {
    return generate$1(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}

function getSecondaryColor(primaryColor) {
  // choose the second color
  return generate(primaryColor)[0];
}

function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }

  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
} // These props make sure that the SVG behaviours like general text.


var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";

var useInsertStyles = function useInsertStyles() {
  var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iconStyles;

  var _useContext = useContext(IconContext),
      csp = _useContext.csp;

  useEffect(function () {
    updateCSS(styleStr, '@ant-design-icons', {
      prepend: true,
      csp: csp
    });
  }, []);
};

var _excluded$1 = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];
var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};

function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}

function getTwoToneColors() {
  return _objectSpread2({}, twoToneColorPalette);
}

var IconBase = function IconBase(props) {
  var icon = props.icon,
      className = props.className,
      onClick = props.onClick,
      style = props.style,
      primaryColor = props.primaryColor,
      secondaryColor = props.secondaryColor,
      restProps = _objectWithoutProperties(props, _excluded$1);

  var colors = twoToneColorPalette;

  if (primaryColor) {
    colors = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }

  useInsertStyles();
  warning$1(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));

  if (!isIconDefinition(icon)) {
    return null;
  }

  var target = icon;

  if (target && typeof target.icon === 'function') {
    target = _objectSpread2(_objectSpread2({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }

  return generate$1(target.icon, "svg-".concat(target.name), _objectSpread2({
    className: className,
    onClick: onClick,
    style: style,
    'data-icon': target.name,
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true'
  }, restProps));
};

IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;

function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return IconBase.setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}

function getTwoToneColor() {
  var colors = IconBase.getTwoToneColors();

  if (!colors.calculated) {
    return colors.primaryColor;
  }

  return [colors.primaryColor, colors.secondaryColor];
}

var _excluded$2 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"]; // should move it to antd main repo?

setTwoToneColor('#1890ff');
var Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classNames;

  var className = props.className,
      icon = props.icon,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      twoToneColor = props.twoToneColor,
      restProps = _objectWithoutProperties(props, _excluded$2);

  var _React$useContext = useContext(IconContext),
      _React$useContext$pre = _React$useContext.prefixCls,
      prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre;

  var classString = classnames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), _defineProperty(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), _classNames), className);
  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return /*#__PURE__*/createElement("span", _objectSpread2(_objectSpread2({
    role: "img",
    "aria-label": icon.name
  }, restProps), {}, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), /*#__PURE__*/createElement(IconBase, {
    icon: icon,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    style: svgStyle
  }));
});
Icon.displayName = 'AntdIcon';
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor; // This icon file is generated automatically.

var ArrowLeftOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "arrow-left",
  "theme": "outlined"
};

var ArrowLeftOutlined$1 = function ArrowLeftOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: ArrowLeftOutlined
  }));
};

ArrowLeftOutlined$1.displayName = 'ArrowLeftOutlined';
var ArrowLeftOutlined$2 = /*#__PURE__*/forwardRef(ArrowLeftOutlined$1); // This icon file is generated automatically.

var BarsOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
      }
    }]
  },
  "name": "bars",
  "theme": "outlined"
};

var BarsOutlined$1 = function BarsOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: BarsOutlined
  }));
};

BarsOutlined$1.displayName = 'BarsOutlined';
var BarsOutlined$2 = /*#__PURE__*/forwardRef(BarsOutlined$1); // This icon file is generated automatically.

var CheckOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
      }
    }]
  },
  "name": "check",
  "theme": "outlined"
};

var CheckOutlined$1 = function CheckOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: CheckOutlined
  }));
};

CheckOutlined$1.displayName = 'CheckOutlined';
var CheckOutlined$2 = /*#__PURE__*/forwardRef(CheckOutlined$1); // This icon file is generated automatically.

var CloseCircleTwoTone = {
  "icon": function render(primaryColor, secondaryColor) {
    return {
      "tag": "svg",
      "attrs": {
        "viewBox": "64 64 896 896",
        "focusable": "false"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
          "fill": primaryColor
        }
      }, {
        "tag": "path",
        "attrs": {
          "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 01-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z",
          "fill": secondaryColor
        }
      }, {
        "tag": "path",
        "attrs": {
          "d": "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z",
          "fill": primaryColor
        }
      }]
    };
  },
  "name": "close-circle",
  "theme": "twotone"
};

var CloseCircleTwoTone$1 = function CloseCircleTwoTone$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: CloseCircleTwoTone
  }));
};

CloseCircleTwoTone$1.displayName = 'CloseCircleTwoTone';
var CloseCircleTwoTone$2 = /*#__PURE__*/forwardRef(CloseCircleTwoTone$1); // This icon file is generated automatically.

var CloseOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
      }
    }]
  },
  "name": "close",
  "theme": "outlined"
};

var CloseOutlined$1 = function CloseOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: CloseOutlined
  }));
};

CloseOutlined$1.displayName = 'CloseOutlined';
var CloseOutlined$2 = /*#__PURE__*/forwardRef(CloseOutlined$1); // This icon file is generated automatically.

var DeleteFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z"
      }
    }]
  },
  "name": "delete",
  "theme": "filled"
};

var DeleteFilled$1 = function DeleteFilled$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: DeleteFilled
  }));
};

DeleteFilled$1.displayName = 'DeleteFilled';
var DeleteIcon = /*#__PURE__*/forwardRef(DeleteFilled$1); // This icon file is generated automatically.

var DeleteOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
      }
    }]
  },
  "name": "delete",
  "theme": "outlined"
};

var DeleteOutlined$1 = function DeleteOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: DeleteOutlined
  }));
};

DeleteOutlined$1.displayName = 'DeleteOutlined';
var DeleteOutlined$2 = /*#__PURE__*/forwardRef(DeleteOutlined$1); // This icon file is generated automatically.

var DownOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
      }
    }]
  },
  "name": "down",
  "theme": "outlined"
};

var DownOutlined$1 = function DownOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: DownOutlined
  }));
};

DownOutlined$1.displayName = 'DownOutlined';
var DropDownIcon = /*#__PURE__*/forwardRef(DownOutlined$1); // This icon file is generated automatically.

var EditFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z"
      }
    }]
  },
  "name": "edit",
  "theme": "filled"
};

var EditFilled$1 = function EditFilled$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: EditFilled
  }));
};

EditFilled$1.displayName = 'EditFilled';
var EditIcon = /*#__PURE__*/forwardRef(EditFilled$1); // This icon file is generated automatically.

var EllipsisOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
      }
    }]
  },
  "name": "ellipsis",
  "theme": "outlined"
};

var EllipsisOutlined$1 = function EllipsisOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: EllipsisOutlined
  }));
};

EllipsisOutlined$1.displayName = 'EllipsisOutlined';
var EllipsisOutlined$2 = /*#__PURE__*/forwardRef(EllipsisOutlined$1); // This icon file is generated automatically.

var ExportOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z"
      }
    }]
  },
  "name": "export",
  "theme": "outlined"
};

var ExportOutlined$1 = function ExportOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: ExportOutlined
  }));
};

ExportOutlined$1.displayName = 'ExportOutlined';
var ExportIcon = /*#__PURE__*/forwardRef(ExportOutlined$1); // This icon file is generated automatically.

var FilterOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
      }
    }]
  },
  "name": "filter",
  "theme": "outlined"
};

var FilterOutlined$1 = function FilterOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: FilterOutlined
  }));
};

FilterOutlined$1.displayName = 'FilterOutlined';
var FilterOutlined$2 = /*#__PURE__*/forwardRef(FilterOutlined$1); // This icon file is generated automatically.

var ImportOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zM902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "import",
  "theme": "outlined"
};

var ImportOutlined$1 = function ImportOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: ImportOutlined
  }));
};

ImportOutlined$1.displayName = 'ImportOutlined';
var ImportIcon = /*#__PURE__*/forwardRef(ImportOutlined$1); // This icon file is generated automatically.

var LoadingOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
      }
    }]
  },
  "name": "loading",
  "theme": "outlined"
};

var LoadingOutlined$1 = function LoadingOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: LoadingOutlined
  }));
};

LoadingOutlined$1.displayName = 'LoadingOutlined';
var LoadingOutlined$2 = /*#__PURE__*/forwardRef(LoadingOutlined$1); // This icon file is generated automatically.

var MenuOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "menu",
  "theme": "outlined"
};

var MenuOutlined$1 = function MenuOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: MenuOutlined
  }));
};

MenuOutlined$1.displayName = 'MenuOutlined';
var MenuOutlined$2 = /*#__PURE__*/forwardRef(MenuOutlined$1); // This icon file is generated automatically.

var MinusCircleOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
      }
    }]
  },
  "name": "minus-circle",
  "theme": "outlined"
};

var MinusCircleOutlined$1 = function MinusCircleOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: MinusCircleOutlined
  }));
};

MinusCircleOutlined$1.displayName = 'MinusCircleOutlined';
var MinusCircleOutlined$2 = /*#__PURE__*/forwardRef(MinusCircleOutlined$1); // This icon file is generated automatically.

var MinusOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "minus",
  "theme": "outlined"
};

var MinusOutlined$1 = function MinusOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: MinusOutlined
  }));
};

MinusOutlined$1.displayName = 'MinusOutlined';
var MinusOutlined$2 = /*#__PURE__*/forwardRef(MinusOutlined$1); // This icon file is generated automatically.

var PaperClipOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
      }
    }]
  },
  "name": "paper-clip",
  "theme": "outlined"
};

var PaperClipOutlined$1 = function PaperClipOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: PaperClipOutlined
  }));
};

PaperClipOutlined$1.displayName = 'PaperClipOutlined';
var PaperClipOutlined$2 = /*#__PURE__*/forwardRef(PaperClipOutlined$1); // This icon file is generated automatically.

var PlusOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "defs",
      "attrs": {},
      "children": [{
        "tag": "style",
        "attrs": {}
      }]
    }, {
      "tag": "path",
      "attrs": {
        "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z"
      }
    }]
  },
  "name": "plus",
  "theme": "outlined"
};

var PlusOutlined$1 = function PlusOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: PlusOutlined
  }));
};

PlusOutlined$1.displayName = 'PlusOutlined';
var AddIcon = /*#__PURE__*/forwardRef(PlusOutlined$1); // This icon file is generated automatically.

var SearchOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
      }
    }]
  },
  "name": "search",
  "theme": "outlined"
};

var SearchOutlined$1 = function SearchOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: SearchOutlined
  }));
};

SearchOutlined$1.displayName = 'SearchOutlined';
var SearchOutlined$2 = /*#__PURE__*/forwardRef(SearchOutlined$1); // This icon file is generated automatically.

var SettingFilled = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 00-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 009.3-35.2l-.9-2.6a442.5 442.5 0 00-79.6-137.7l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.3a353.44 353.44 0 00-98.9 57.3l-81.8-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a445.93 445.93 0 00-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0025.8 25.7l2.7.5a448.27 448.27 0 00158.8 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z"
      }
    }]
  },
  "name": "setting",
  "theme": "filled"
};

var SettingFilled$1 = function SettingFilled$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: SettingFilled
  }));
};

SettingFilled$1.displayName = 'SettingFilled';
var SettingFilled$2 = /*#__PURE__*/forwardRef(SettingFilled$1); // This icon file is generated automatically.

var UserOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
      }
    }]
  },
  "name": "user",
  "theme": "outlined"
};

var UserOutlined$1 = function UserOutlined$1(props, ref) {
  return /*#__PURE__*/createElement(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: UserOutlined
  }));
};

UserOutlined$1.displayName = 'UserOutlined';
var UserOutlined$2 = /*#__PURE__*/forwardRef(UserOutlined$1);

var _templateObject$1;

var ProgressWrapper = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  max-width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.3);\n  zindex: 3;\n"])));
var _excluded$3 = ["render", "loading", "action", "inAuthForm", "isFormModal"];
var antIcon = /*#__PURE__*/React__default.createElement(LoadingOutlined$2, {
  spin: true
});

var Loadable = function Loadable(_ref) {
  var render = _ref.render,
      loading = _ref.loading,
      action = _ref.action,
      inAuthForm = _ref.inAuthForm,
      isFormModal = _ref.isFormModal,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var didMount = useRef(false);

  var _useState = useState(false),
      didFinishInitialLoad = _useState[0],
      setDidFinishInitialLoad = _useState[1];

  var didStartInitialLoad = useRef(false);
  useEffect(function () {
    if (!didMount.current) didMount.current = true;
  }, [didMount]);
  useEffect(function () {
    if (!(loading || didFinishInitialLoad) && didStartInitialLoad.current) {
      setDidFinishInitialLoad(true);
    }
  }, [loading, didFinishInitialLoad, didStartInitialLoad]);
  useEffect(function () {
    if (!didStartInitialLoad.current && loading) {
      didStartInitialLoad.current = true;
    }
  }, [loading, didStartInitialLoad]);

  var renderComponent = function renderComponent() {
    var isLoadingProp = inAuthForm && {
      loading: loading
    };
    var component = render(_extends({
      action: action
    }, isLoadingProp, props));

    switch (action) {
      case "create":
        return component;

      case "edit":
        if (didMount.current && didFinishInitialLoad) return component;
        return null;

      default:
        if (didMount.current && !loading) return component;
    }
  };

  return /*#__PURE__*/React__default.createElement(Fragment, null, loading && (inAuthForm || isFormModal ? /*#__PURE__*/React__default.createElement(_Spin, {
    indicator: antIcon
  }) : /*#__PURE__*/React__default.createElement(ProgressWrapper, null, /*#__PURE__*/React__default.createElement(_Spin, {
    indicator: antIcon,
    size: "large"
  }))), renderComponent());
};

var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

var ToolbarContainer = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  @media (max-width: ", ") {\n    align-items: flex-start;\n  }\n"])), function (props) {
  return props.hasFiltersToolbar ? "10px" : "0px";
}, function (props) {
  return props.hasFiltersToolbar ? "30px" : "0px";
}, function (props) {
  return props.theme.breakpoints.md;
});
var ButtonsContainer = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  button,\n  .custom-link-button {\n    margin: 5px;\n    @media (max-width: ", ") {\n      width: 100%;\n    }\n  }\n  @media (max-width: ", ") {\n    width: 100%;\n  }\n"])), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.md;
});
var ContainerWrapper = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n  padding: 20px 0;\n  .ant-btn {\n    text-transform: capitalize;\n  }\n  .ant-table-cell {\n    min-width: 50px;\n  }\n  .data-list-title {\n    text-align: center;\n  }\n"])));
var ExpandableWrapper = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n  .title-wrapper {\n    .ant-typography {\n      margin: 0 10px;\n    }\n  }\n\n  .ant-collapse {\n    font-size: 18px;\n    background-color: white;\n    .ant-collapse-content-box {\n      padding: 30px;\n    }\n  }\n"])));
var PaginationWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  margin-top: 20px;\n  display: flex;\n  justify-content: ", ";\n\n  ", "\n"])), function (props) {
  return props.isReduced ? "center" : "flex-end";
}, function (props) {
  return props.isReduced && ".ant-pagination-simple-pager {\n    width: 41%;\n    font-size: 0;\n    input {\n      font-size: initial;\n    }\n  }";
});
var BulkActionsToolbarWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  .ant-collapse-content > .ant-collapse-content-box {\n    padding: 0;\n  }\n"])));
var DatePickerWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  .ant-picker {\n    width: 100%;\n  }\n"])));
var FiltersToolbarWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  .row-wrapper {\n    width: 100%;\n    justify-content: flex-end;\n    align-items: flex-end;\n    transition: all 0.5s ease-in-out;\n    @media (max-width: ", ") {\n      margin: 0 5px !important;\n    }\n  }\n  .col-wrapper {\n    width: 19%;\n    margin: 10px 0;\n    .ant-form-item {\n      margin 0;\n    }\n    @media (max-width: ", ") {\n      width: 100%;\n    }\n  }\n  .button-wrapper {\n    width: fit-content;\n    text-align: end;\n  }\n  h5.ant-typography {\n    font-size: 13px;\n  }\n"])), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.md;
});
var FiltersDrawerWrapper = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  .filter-btn {\n    display: flex;\n    justify-content: flex-end;\n  }\n"])));
var FiltersWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  .ant-form-item {\n    margin 0;\n  }\n"])));
var ColumnFiltersWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n  width: 200px;\n  padding: 10px;\n  h5.ant-typography {\n    font-size: 13px;\n  }\n  .ant-divider-horizontal {\n    margin: 10px 0;\n  }\n  .filter-buttons-wrapper {\n    display: flex;\n    justify-content: flex-end;\n  }\n  .ant-form-item {\n    margin: 0;\n  }\n"])));
var CardRowActionsMenu = styled(_Menu)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  > * {\n    display: block;\n  }\n"])));
var CardListWrapper = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  @media (max-width: ", ") {\n    .data-card-view-button-col {\n      width: 100%;\n      text-align: center;\n      button {\n        width: fit-content;\n      }\n    }\n  }\n"])), function (props) {
  return props.theme.breakpoints.sm;
});
var EditableCell = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  position: relative;\n  min-height: 2vh;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n"])));
var EditableFieldWrapper = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: fit-content;\n  margin: auto;\n  .anticon {\n    padding: 0px 5px;\n    color: green;\n    cursor: pointer;\n  }\n  .ant-form-item {\n    width: fit-content;\n    margin-bottom: 0px;\n  }\n"])));
var EditIndication = styled.span(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n  margin-left: 1vw;\n"])));
var CellWrapper = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n  .newRow {\n    background-color: #d2f7dc;\n  }\n"])));
var ButtonsWrapper = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n  margin-top: 1vw;\n  .ant-btn {\n    margin-right: 1vw;\n  }\n  @media (max-width: ", ") {\n    display: flex;\n    justify-content: center;\n  }\n"])), function (props) {
  return props.theme.breakpoints.md;
});

var ItemTitle = function ItemTitle(_ref) {
  var entity = _ref.entity,
      item = _ref.item,
      itemId = _ref.itemId,
      selected = _ref.selected,
      handleSelect = _ref.handleSelect,
      dataObject = _ref.dataObject;
  var title = useMemo(function () {
    var _item$find;

    return entity.titleField ? (_item$find = item.find(function (_ref2) {
      var field = _ref2.field;
      return field.identifier === entity.titleField;
    })) === null || _item$find === void 0 ? void 0 : _item$find.value : itemId;
  }, [entity, item, itemId]);

  var handleClick = function handleClick(event) {
    event.stopPropagation();
    handleSelect(dataObject)(event);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "title-wrapper"
  }, entity.isBulkActionsEnabled() && /*#__PURE__*/React__default.createElement(_Checkbox, {
    checked: selected,
    onClick: handleClick
  }), /*#__PURE__*/React__default.createElement(_Typography.Text, null, title));
};

var Expandable = function Expandable(_ref3) {
  var item = _ref3.item,
      renderRowActions = _ref3.renderRowActions,
      entity = _ref3.entity,
      itemId = _ref3.itemId,
      dataObject = _ref3.dataObject,
      selected = _ref3.selected,
      handleSelect = _ref3.handleSelect;

  var _useTranslation = useTranslation("dataTable"),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var language = i18n.language;
  var position = useMemo(function () {
    return i18n.dir(language) === "ltr" ? "right" : "left";
  }, [i18n, language]);

  var renderFieldValue = function renderFieldValue(field, value) {
    var displayValue = field.getDisplayValue(dataObject, {
      value: value,
      id: itemId,
      tagsConfig: field.tagsConfig
    });
    return displayValue();
  };

  return /*#__PURE__*/React__default.createElement(ExpandableWrapper, null, /*#__PURE__*/React__default.createElement(_Collapse, {
    expandIconPosition: position
  }, /*#__PURE__*/React__default.createElement(_Collapse.Panel, {
    className: entity.getCustomDataTableRowClass(dataObject),
    header: /*#__PURE__*/React__default.createElement(ItemTitle, {
      entity: entity,
      item: item,
      itemId: itemId,
      selected: selected,
      handleSelect: handleSelect,
      dataObject: dataObject
    }),
    key: itemId
  }, item.map(function (_ref4) {
    var field = _ref4.field,
        value = _ref4.value;
    return /*#__PURE__*/React__default.createElement(_Row, {
      gutter: [8, 8],
      key: field.identifier
    }, /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement(_Typography.Text, {
      strong: true
    }, field.getLabel())), /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement(_Typography.Text, null, renderFieldValue(field, value))));
  }), entity.showRowActions && /*#__PURE__*/React__default.createElement(_Row, {
    gutter: [8, 8]
  }, /*#__PURE__*/React__default.createElement(_Col, {
    span: 12
  }, /*#__PURE__*/React__default.createElement(_Typography.Text, {
    strong: true
  }, t("actions"))), /*#__PURE__*/React__default.createElement(_Col, {
    span: 12
  }, renderRowActions(itemId, dataObject))))));
};

var showTotal = function showTotal(total, range) {
  return range[0] + "-" + range[1] + " of " + total;
};

var DataPagination = function DataPagination(_ref) {
  var currentPage = _ref.currentPage,
      _ref$rowsPerPage = _ref.rowsPerPage,
      rowsPerPage = _ref$rowsPerPage === void 0 ? 10 : _ref$rowsPerPage,
      totalEntries = _ref.totalEntries,
      onPaginationChange = _ref.onPaginationChange,
      entityRowsPerPage = _ref.entityRowsPerPage,
      isReduced = _ref.isReduced;
  var rowsPerPageOptions = useMemo(function () {
    var defaultRowPageOptions = [5, 10, 15, 20, 25];
    if (!entityRowsPerPage || defaultRowPageOptions.includes(entityRowsPerPage)) return defaultRowPageOptions;
    return [].concat(defaultRowPageOptions, [entityRowsPerPage]).sort(function (elementA, elementB) {
      return elementA - elementB;
    });
  }, [entityRowsPerPage]);
  var reducedPaginationProps = isReduced && {
    simple: true,
    total: Number.MAX_VALUE,
    showTotal: false
  };
  return /*#__PURE__*/React__default.createElement(PaginationWrapper, {
    isReduced: isReduced
  }, /*#__PURE__*/React__default.createElement(_Pagination, _extends({
    current: currentPage,
    total: totalEntries,
    pageSize: rowsPerPage,
    pageSizeOptions: rowsPerPageOptions,
    showSizeChanger: true,
    showLessItems: true,
    showTotal: showTotal,
    onChange: onPaginationChange,
    size: "small"
  }, reducedPaginationProps)));
};

var ActionButton = function ActionButton(_ref) {
  var confirmable = _ref.confirmable,
      confirmationMessage = _ref.confirmationMessage,
      onActionClick = _ref.onActionClick,
      className = _ref.className,
      type = _ref.type,
      disabled = _ref.disabled,
      children = _ref.children,
      formConfirmationConfig = _ref.formConfirmationConfig,
      isSubmit = _ref.isSubmit;

  var _useTranslation = useTranslation("actionButton"),
      t = _useTranslation.t;

  var _useState = useState(false),
      confirmed = _useState[0],
      setConfirmed = _useState[1];

  var handleOpenDialog = useCallback(function () {
    _Modal.confirm({
      title: confirmationMessage,
      okText: formConfirmationConfig !== null && formConfirmationConfig !== void 0 && formConfirmationConfig.confirmLabel ? getTranslatedValue$1(formConfirmationConfig.confirmLabel) : t("ok"),
      cancelText: formConfirmationConfig !== null && formConfirmationConfig !== void 0 && formConfirmationConfig.rejectLabel ? getTranslatedValue$1(formConfirmationConfig.rejectLabel) : t("cancel"),
      onOk: function onOk() {
        setConfirmed(true);
      },
      centered: true,
      maskClosable: true
    });
  }, [confirmationMessage]);
  useEffect(function () {
    if (!confirmed) return;
    onActionClick();
    setConfirmed(false);
  }, [confirmed, onActionClick]);

  var onButtonClick = function onButtonClick(e) {
    var _e$preventDefault;

    if (isSubmit) (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 ? void 0 : _e$preventDefault.call(e);
    if (confirmable) handleOpenDialog();else onActionClick();
  };

  return /*#__PURE__*/React__default.createElement(_Button, {
    onClick: onButtonClick,
    className: className,
    type: type,
    disabled: disabled,
    htmlType: isSubmit ? "submit" : "button"
  }, children);
};

var entitiesActions = {};

var createActions = function createActions(entityName, type, additionalActions) {
  if (additionalActions === void 0) {
    additionalActions = [];
  }

  var generatedAdditionalActions = {};
  if (Array.isArray(additionalActions)) generatedAdditionalActions = additionalActions.reduce(function (accum, actionName) {
    var _extends2;

    return _extends({}, accum, (_extends2 = {}, _extends2[actionName] = createAction(entityName + "/" + type + "/" + actionName), _extends2));
  }, {});
  return _extends({
    request: createAction(entityName + "/" + type + "/request"),
    success: createAction(entityName + "/" + type + "/success"),
    failure: createAction(entityName + "/" + type + "/failure")
  }, generatedAdditionalActions);
};

var createConditionalActions = function createConditionalActions(_ref) {
  var condition = _ref.condition,
      entityName = _ref.entityName,
      entityPluralName = _ref.entityPluralName,
      actionGroupName = _ref.actionGroupName,
      _ref$additionalAction = _ref.additionalActions,
      additionalActions = _ref$additionalAction === void 0 ? [] : _ref$additionalAction;

  if (condition) {
    var _extends3;

    entitiesActions[entityName] = _extends({}, entitiesActions[entityName], (_extends3 = {}, _extends3[actionGroupName] = createActions(entityPluralName, actionGroupName, additionalActions), _extends3));
  }
};

var createEventSubscriptionsActions = function createEventSubscriptionsActions(entity, entityName) {
  var _entity$getSubscribed;

  var eventSubscriptions = (_entity$getSubscribed = entity.getSubscribedEvents()) === null || _entity$getSubscribed === void 0 ? void 0 : _entity$getSubscribed.reduce(function (accum, event) {
    accum[event] = createAction(entityName + "/eventSubscription/" + event);
    return accum;
  }, {});
  if (!eventSubscriptions) return;
  entitiesActions[entityName] = _extends({}, entitiesActions[entityName], {
    eventSubscriptions: eventSubscriptions
  });
};

var generateActions = function generateActions(role, currentEntities) {
  if (currentEntities === void 0) {
    currentEntities = [];
  }

  Object.keys(entitiesActions).forEach(function (key) {
    return delete entitiesActions[key];
  });
  Object.keys(currentEntities).forEach(function (entityKey) {
    var entity = currentEntities[entityKey];
    var entityName = entity.isReferenced ? entityKey : entity.name;
    var entityPluralName = entity.isReferenced ? entityKey : entity.pluralName;
    if (!entity.canUse(role)) return;
    entitiesActions[entityName] = {
      list: createActions(entityPluralName, "list", ["reset", "resetErrors", "filtersFetched"]),
      show: createActions(entityPluralName, "show"),
      form: createActions(entityPluralName, "form", ["reset", "resetErrors", "openFormModal", "closeFormModal", "cancelFormModal"])
    };
    createConditionalActions({
      condition: entity.canCreate(role),
      entityName: entityName,
      entityPluralName: entityPluralName,
      actionGroupName: "create"
    });
    createConditionalActions({
      condition: entity.canEdit(role),
      entityName: entityName,
      entityPluralName: entityPluralName,
      actionGroupName: "edit"
    });
    createConditionalActions({
      condition: entity.canDelete(role),
      entityName: entityName,
      entityPluralName: entityPluralName,
      actionGroupName: "delete"
    });
    createConditionalActions({
      condition: entity.canExport(role),
      entityName: entityName,
      entityPluralName: entityPluralName,
      actionGroupName: "export"
    });
    createConditionalActions({
      condition: entity.canImport(role),
      entityName: entityName,
      entityPluralName: entityPluralName,
      actionGroupName: "import",
      additionalActions: ["toggleDialogStatus"]
    });
    createConditionalActions({
      condition: entity.isApiFieldsSource(),
      entityName: entityName,
      entityPluralName: entityPluralName,
      actionGroupName: "apiFieldsSource"
    });
    entitiesActions[entityName].isAPIEntity = entity.isAPIEntity();
    createEventSubscriptionsActions(entity, entityName);
    entitiesActions[entityName] = _extends({}, entitiesActions[entityName], typeof entity.customActions === "object" && entity.customActions);
  });
  return entitiesActions;
};

var BulkActionsToolbar = function BulkActionsToolbar(_ref) {
  var entity = _ref.entity,
      role = _ref.role,
      numberOfSelectedItems = _ref.numberOfSelectedItems,
      selectedItems = _ref.selectedItems,
      onBulkDelete = _ref.onBulkDelete,
      onCustomBulkActionTriggered = _ref.onCustomBulkActionTriggered,
      clearSelected = _ref.clearSelected;

  var _useTranslation = useTranslation(["general", "dataTable"]),
      t = _useTranslation.t;

  var bulkActions = useMemo(function () {
    return entity.getBulkActions();
  }, [entity]);
  var handleBulkActions = useCallback(function (action) {
    return function () {
      if (selectedItems.current.size > 0) {
        var selected = [];
        selectedItems.current.forEach(function (_, key) {
          selected.push(key);
        });
        if (action.name === "delete") onBulkDelete(selected);else onCustomBulkActionTriggered(action, selected);
        clearSelected();
      }
    };
  }, [selectedItems, onCustomBulkActionTriggered, clearSelected]);
  return /*#__PURE__*/React__default.createElement(BulkActionsToolbarWrapper, null, /*#__PURE__*/React__default.createElement(_Collapse, {
    ghost: true,
    activeKey: numberOfSelectedItems > 0 ? ["1"] : []
  }, /*#__PURE__*/React__default.createElement(_Collapse.Panel, {
    key: "1",
    showArrow: false
  }, /*#__PURE__*/React__default.createElement(_Alert, {
    message: /*#__PURE__*/React__default.createElement(_Space, null, /*#__PURE__*/React__default.createElement(_Button, {
      onClick: clearSelected,
      icon: /*#__PURE__*/React__default.createElement(CloseOutlined$2, null),
      type: "text"
    }), /*#__PURE__*/React__default.createElement(_Typography.Text, {
      strong: true
    }, numberOfSelectedItems, " selected")),
    type: "info",
    action: /*#__PURE__*/React__default.createElement(_Space, null, entity.canDeleteMultiple(role, {}) && /*#__PURE__*/React__default.createElement(ActionButton, {
      onActionClick: handleBulkActions({
        name: "delete"
      }),
      confirmable: true,
      confirmationMessage: t("dataTable:deleteConfirmationMessage"),
      type: "ghost"
    }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)), bulkActions && bulkActions.map(function (action, index) {
      return entity.canRolePerformAction(role, ["globalActions", index, "bulkActions"]) && /*#__PURE__*/React__default.createElement(ActionButton, {
        key: index,
        onActionClick: handleBulkActions(action),
        confirmable: action.requireConfirmation,
        confirmationMessage: action.confirmationMessage,
        type: "ghost"
      }, entity.getDisplayName(action.label));
    }))
  }))));
};

var useBulkActions = function useBulkActions(_ref) {
  var entity = _ref.entity,
      resize = _ref.resize;
  var selectedItemsMap = useRef(new Map());
  var prevResize = useRef(resize);

  var _useState = useState([]),
      selectedKeys = _useState[0],
      setSelectedKeys = _useState[1];

  var _useState2 = useState(0),
      numberOfSelectedItems = _useState2[0],
      setNumberOfSelectedItems = _useState2[1];

  useEffect(function () {
    selectedItemsMap.current = new Map(selectedKeys.map(function (selectedId) {
      return [selectedId, true];
    }));
    setNumberOfSelectedItems(selectedKeys.length);
  }, [selectedKeys]);
  useEffect(function () {
    if (prevResize !== resize) {
      var selected = [];

      if (selectedItemsMap.current.size > 0) {
        selectedItemsMap.current.forEach(function (_, key) {
          selected.push(key);
        });
      }

      setSelectedKeys(selected);
      prevResize.current = resize;
    }
  }, [resize]);

  var handleSelect = function handleSelect(data) {
    return function (event) {
      var key = entity.getIdentifierValue(data);

      if (event.target.checked) {
        setNumberOfSelectedItems(numberOfSelectedItems + 1);
        selectedItemsMap.current.set(key, true);
      } else if (isSelected(data)) {
        setNumberOfSelectedItems(numberOfSelectedItems - 1);
        selectedItemsMap.current["delete"](key);
      }
    };
  };

  var isSelected = function isSelected(data) {
    var key = entity.getIdentifierValue(data);
    return selectedItemsMap.current.has(key);
  };

  var clearSelected = function clearSelected() {
    selectedItemsMap.current.clear();
    setNumberOfSelectedItems(0);
    setSelectedKeys([]);
  };

  return {
    selectedItemsMap: selectedItemsMap,
    selectedKeys: selectedKeys,
    numberOfSelectedItems: numberOfSelectedItems,
    isSelected: isSelected,
    handleSelect: handleSelect,
    setSelectedKeys: setSelectedKeys,
    clearSelected: clearSelected
  };
};

var _templateObject$3, _templateObject2$2;

var FieldDescriptionWrapper = styled.span(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  .description-btn {\n    padding: 0;\n    margin: 0 -5px;\n    text-transform: ", ";\n  }\n"])), function (props) {
  return props.inline ? "lowercase" : "none";
});
var ModalBody = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n  height: 300px;\n  overflow-y: auto;\n  * {\n    width: 90%;\n  }\n"])));

var FieldDescription = function FieldDescription(_ref) {
  var _field$getDescription, _field$description, _description$modalBod;

  var field = _ref.field;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useTranslation = useTranslation("actionButton"),
      t = _useTranslation.t;

  var description = field === null || field === void 0 ? void 0 : (_field$getDescription = field.getDescription) === null || _field$getDescription === void 0 ? void 0 : _field$getDescription.call(field);

  var toggleModal = function toggleModal() {
    setOpen(function (open) {
      return !open;
    });
  };

  if (!description) return null;
  return /*#__PURE__*/React__default.createElement(FieldDescriptionWrapper, {
    inline: (_field$description = field.description) === null || _field$description === void 0 ? void 0 : _field$description.inline
  }, /*#__PURE__*/React__default.createElement(_Button, {
    type: "link",
    onClick: toggleModal,
    size: "small",
    className: "description-btn"
  }, description.linkTitle), /*#__PURE__*/React__default.createElement(_Modal, {
    visible: open,
    onCancel: toggleModal,
    centered: true,
    title: description.modalTitle,
    footer: [/*#__PURE__*/React__default.createElement(_Button, {
      onClick: toggleModal,
      className: "btn-custom",
      key: "ok"
    }, description.actionButtonLabel || t("ok"))]
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, description !== null && description !== void 0 && description.useHTMLParser ? ReactHtmlParser(description.modalBody) : description === null || description === void 0 ? void 0 : (_description$modalBod = description.modalBody) === null || _description$modalBod === void 0 ? void 0 : _description$modalBod.split("\n").map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(_Typography, {
      key: index
    }, item);
  }))));
};

var _excluded$4 = ["label", "required", "error", "withoutWrapper", "hideTypography", "field"];
var labelCol = {
  span: 24
};

var FieldHandler = function FieldHandler(_ref) {
  var label = _ref.label,
      required = _ref.required,
      error = _ref.error,
      field = _ref.field,
      children = _ref.children;
  var validateStatus = useMemo(function () {
    return error ? "error" : "";
  }, [error]);
  var help = useMemo(function () {
    return error ? handleFormatErrorsObject(error) : null;
  }, [error]);
  return /*#__PURE__*/React__default.createElement(FieldHandlerWrapper, null, /*#__PURE__*/React__default.createElement(_Form.Item, {
    label: label,
    colon: false,
    required: required,
    validateStatus: validateStatus,
    help: help,
    labelCol: labelCol
  }, children, /*#__PURE__*/React__default.createElement(FieldDescription, {
    field: field
  })));
};

var withFieldHandler = function withFieldHandler(Field) {
  return function (_ref2) {
    var label = _ref2.label,
        required = _ref2.required,
        error = _ref2.error,
        withoutWrapper = _ref2.withoutWrapper,
        hideTypography = _ref2.hideTypography,
        field = _ref2.field,
        props = _objectWithoutPropertiesLoose(_ref2, _excluded$4);

    if (withoutWrapper || hideTypography) return /*#__PURE__*/React__default.createElement(Field, _extends({
      label: label,
      required: required,
      error: error
    }, props));
    return /*#__PURE__*/React__default.createElement(FieldHandler, {
      label: label,
      required: required,
      error: error,
      field: field
    }, /*#__PURE__*/React__default.createElement(Field, _extends({
      label: label,
      required: required,
      field: field
    }, props)));
  };
};

var _excluded$5 = ["inAuthForm", "type", "placeholder", "label", "required", "field"];

var _templateObject$4, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1, _templateObject16$1, _templateObject17$1;

var CountryCodeWrapper = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  .ant-select {\n    min-width: 100px;\n  }\n"])));
var StyledField = memo(withFieldHandler(function (_ref) {
  var type = _ref.type,
      placeholder = _ref.placeholder,
      label = _ref.label,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  var extraProps = _extends({}, props, {
    placeholder: placeholder || label,
    label: label
  });

  switch (type) {
    case "string":
    case "email":
    case "password":
      return /*#__PURE__*/React__default.createElement(_Input, _extends({}, extraProps, {
        type: type
      }));

    case "number":
      return /*#__PURE__*/React__default.createElement(_InputNumber, _extends({
        type: "number"
      }, extraProps));

    case "text":
      return /*#__PURE__*/React__default.createElement(_Input.TextArea, extraProps);

    case "datetime":
      return /*#__PURE__*/React__default.createElement(_DatePicker, _extends({
        showTime: true
      }, extraProps));

    case "date":
      return /*#__PURE__*/React__default.createElement(_DatePicker, extraProps);

    case "time":
      return /*#__PURE__*/React__default.createElement(_TimePicker, extraProps);

    default:
      return null;
  }
}));
var StyledForm = styled.form(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  @media only screen and (max-width: ", ") {\n    width: 100%;\n  }\n  *:disabled,\n  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n    color: black !important;\n  }\n"])), function (props) {
  return props.inAuthForm || props.isFullWidth ? "100%" : "50%";
}, function (props) {
  return props.theme.breakpoints.md;
});
var CustomFormImage = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n  max-width: 200px;\n  img {\n    width: 100%;\n  }\n"])));
var ButtonContainer = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"])));
var styledList = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n  max-height: 200px;\n  overflow: auto;\n"])));
var LabelContainer = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  align-items: flex-start;\n  display: flex;\n  -enter {\n    opacity: 0.01;\n    transform: scale(1.1);\n  }\n\n  .dialog-enter-active {\n    opacity: 1;\n    transform: scale(1);\n    transition: all 300ms;\n  }\n"])));
var FieldWithDescription = styled.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n  div {\n    width: 100%;\n  }\n  .ant-switch-handle {\n    width: 18px;\n  }\n  .ant-form-item-control-input-content > .ant-row {\n    display: ", ";\n    width: ", ";\n  }\n  .ant-input-number-handler-wrap {\n    width: 22px;\n  }\n"])), function (props) {
  return props.inline ? "inline-block" : "block";
}, function (props) {
  return props.inline ? "fit-content" : "100%";
});
var GlobalErorrs = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 25px;\n  width: fit-content;\n  span {\n    display: block;\n  }\n"])));
var FieldHandlerWrapper = styled.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n  .ant-col-24.ant-form-item-label {\n    text-align: start;\n  }\n  .ant-form-item-label > label {\n    white-space: normal;\n    font-weight: 600;\n    height: fit-content !important;\n    margin-bottom: 5px;\n  }\n  .ant-picker {\n    width: 100%;\n  }\n"])));
var DynamicFieldWrapper = styled.div(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n  .dynamic-record {\n    padding: 20px;\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    margin-bottom: 20px;\n  }\n"])));
var ListWrapper = styled.div(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteralLoose(["\n  .ant-card-body {\n    padding: 1px 0;\n  }\n  .ant-list {\n    padding: 0 24px;\n  }\n  .options-wrapper {\n    height: 250px;\n    overflow: auto;\n  }\n  .number-selected {\n    font-size: 12px;\n  }\n"])));
var TransferListWrapper = styled.div(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  @media only screen and (max-width: ", ") {\n    flex-direction: column;\n  }\n\n  .transferList-buttons {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    @media only screen and (max-width: ", ") {\n      width: 100%;\n      transform: rotate(90deg);\n      padding: 10px;\n    }\n    .ant-btn {\n      margin: 3px;\n    }\n  }\n"])), function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints.sm;
});
var FormContainer = styled.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteralLoose(["\n  padding: 20px;\n  width: 100%;\n  .form-back-button {\n    margin-bottom: 5px;\n  }\n  .ant-col-24.ant-form-item-label {\n    text-align: unset;\n  }\n  .data-form-title {\n    text-align: center;\n  }\n  .data-form-subtittle {\n    margin-bottom: 20px;\n    display: block;\n  }\n"])));
var ExternalComponentWrapper = styled.div(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteralLoose(["\n  overflow-x: auto;\n  margin-bottom: 24px;\n"])));
var FileFieldWrapper = styled.div(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteralLoose(["\n  .ant-upload.ant-upload-select {\n    margin-bottom: 10px;\n  }\n  .ant-btn {\n    margin-top: 10px;\n  }\n  .ant-upload-list-text .ant-upload-span > * {\n    width: fit-content;\n  }\n"])));
var ProfilePictureWrapper = styled.div(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-bottom: 10px;\n"])));
var EditIconWrapper = styled.div(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  margin-left: ", ";\n  margin-right: ", ";\n"])), function (props) {
  return props.theme.direction === "ltr" ? "1vw" : "0";
}, function (props) {
  return props.theme.direction === "rtl" ? "1vw" : "0";
});

var customFileFunction = function customFileFunction() {
  return false;
};

var Uploader = function Uploader(_ref) {
  var _ref$field = _ref.field,
      identifier = _ref$field.identifier,
      allowMarkForDeletion = _ref$field.allowMarkForDeletion,
      allowedExtensions = _ref$field.allowedExtensions,
      field = _ref.field,
      onChange = _ref.onChange,
      file = _ref.file,
      action = _ref.action,
      type = _ref.type,
      _ref$listType = _ref.listType,
      listType = _ref$listType === void 0 ? "text" : _ref$listType,
      disabled = _ref.disabled,
      filePreview = _ref.filePreview;

  var _useTranslation = useTranslation("dataForm"),
      t = _useTranslation.t;

  var _useMarkedForDeletion = useMarkedForDeletionState(onChange, identifier),
      isMarkedForDeletion = _useMarkedForDeletion[0],
      toggleIsMarkedForDeletion = _useMarkedForDeletion[1];

  var _useState = useState(),
      uploadedFile = _useState[0],
      setUploadedFile = _useState[1];

  var accept = useMemo(function () {
    return allowedExtensions ? "." + allowedExtensions : type === "file" ? "" : type + "/*";
  }, [allowedExtensions, type]);
  var showUploadList = useMemo(function () {
    return {
      showRemoveIcon: type === "image"
    };
  }, [type]);

  var handleRemoveFile = function handleRemoveFile() {
    onChange(field, "");
  };

  var handleChange = function handleChange(files) {
    var file = files.fileList[0];

    if (file) {
      delete file.originFileObj.uid;
      setUploadedFile(window.URL.createObjectURL(file.originFileObj));
      onChange(field, file.originFileObj);
    }
  };

  var showFilePreview = filePreview && typeof filePreview === 'string';

  var preview = function preview() {
    switch (listType) {
      case "image":
        return /*#__PURE__*/React__default.createElement(CustomFormImage, null, /*#__PURE__*/React__default.createElement(_Image, {
          src: uploadedFile || filePreview
        }));

      case "video":
        return uploadedFile ? /*#__PURE__*/React__default.createElement(ReactPlayer, {
          url: uploadedFile,
          controls: true
        }) : filePreview ? /*#__PURE__*/React__default.createElement(ReactPlayer, {
          url: filePreview,
          controls: true
        }) : "";

      case "pdf":
      case "other":
      case "file":
        return showFilePreview ? /*#__PURE__*/React__default.createElement("a", {
          href: filePreview,
          target: "_blank",
          rel: "noopener noreferrer"
        }, t("general:viewFile")) : "";

      default:
        return filePreview;
    }
  };

  return /*#__PURE__*/React__default.createElement(FileFieldWrapper, null, /*#__PURE__*/React__default.createElement(_Upload, {
    accept: accept,
    beforeUpload: customFileFunction,
    onChange: handleChange,
    onRemove: handleRemoveFile,
    showUploadList: showUploadList,
    listType: listType === "image" ? "picture" : "",
    onPreview: customFileFunction,
    maxCount: 1,
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(_Button, {
    icon: /*#__PURE__*/React__default.createElement(PaperClipOutlined$2, null)
  }, file ? t("change") : t("choose"), " ", t("file"))), filePreview && preview(), allowMarkForDeletion && action === "edit" && !disabled && /*#__PURE__*/React__default.createElement(_Button, {
    onClick: toggleIsMarkedForDeletion,
    type: isMarkedForDeletion ? "primary" : "secondary"
  }, isMarkedForDeletion ? t("undoDeletion") : t("delete")));
};

var useMarkedForDeletionState = function useMarkedForDeletionState(onChange, fieldIdentifier) {
  var _useState2 = useState(null),
      isMarkedForDeletion = _useState2[0],
      setIsMarkedForDeletion = _useState2[1];

  useEffect(function () {
    if (isMarkedForDeletion === null) return;
    onChange("remove_" + fieldIdentifier, isMarkedForDeletion);
  }, [fieldIdentifier, isMarkedForDeletion, onChange]);

  var toggleIsMarkedForDeletion = function toggleIsMarkedForDeletion() {
    setIsMarkedForDeletion(!isMarkedForDeletion);
  };

  return [isMarkedForDeletion, toggleIsMarkedForDeletion];
};

var generateDependeeValues = function generateDependeeValues(fields, field, fieldValue, fieldsState, dataObject) {
  var identifier = field.identifier,
      type = field.type;
  var arrayOfValues = [];

  if (type === "checkbox") {
    arrayOfValues = Array.isArray(fieldValue) ? fieldValue : fieldValue.split(",");
  }

  var sendEmptyDependantFields = function sendEmptyDependantFields(dependantField) {
    return dependantField.isSentEmptyDependantField() && dependantField.getDataValue(dataObject, {
      isForm: true,
      canReturnUndefined: true,
      constructFileAccessor: true
    });
  };

  var getResetKeysInReducer = function getResetKeysInReducer() {
    var _extends2;

    var arrayOfResetableValues = fields.filter(function (field) {
      return field.dependsOn === identifier || field.dependeeList && field.dependeeList.some(function (_ref) {
        var dependsOn = _ref.dependsOn;
        return dependsOn === identifier;
      });
    });

    var nextState = _extends({}, fieldsState, (_extends2 = {}, _extends2[field.identifier] = fieldValue, _extends2));

    return arrayOfResetableValues.map(function (item) {
      var willAppear = item.dependsOnAny ? isDependeeSet(nextState, item) : isDependeeEqualsDependant(nextState, fields, item);
      var wasVisible = sendEmptyDependantFields(item) ? !(fieldsState[item.identifier] === null) : !(fieldsState[item.identifier] === undefined);
      return {
        identifier: item.identifier,
        willAppear: willAppear,
        wasVisible: wasVisible,
        dependantField: item
      };
    });
  };

  var getNextValue = function getNextValue(field, willAppear, fieldType) {
    if (willAppear && field.persistDependeeValues) {
      var customAccessor = fieldType === "transferList" && field.transferListConfig.accessor;
      return field.getDataValue(dataObject, {
        isForm: true,
        canReturnUndefined: true,
        customAccessor: customAccessor,
        constructFileAccessor: true
      });
    }

    return sendEmptyDependantFields(field) ? null : undefined;
  };

  arrayOfValues = arrayOfValues.map(function (value) {
    return value && field.getDependantWithCondition("type", value).identifier;
  });
  return getResetKeysInReducer().reduce(function (accum, _ref2) {
    var _extends5;

    var elemIdentifier = _ref2.identifier,
        wasVisible = _ref2.wasVisible,
        willAppear = _ref2.willAppear,
        dependantField = _ref2.dependantField;
    var willChangeState = willAppear !== wasVisible;
    var fieldType = dependantField.getType({
      formState: fieldsState
    });
    if (!willChangeState) return accum;

    if (type === "checkbox" && arrayOfValues.includes(elemIdentifier)) {
      return accum;
    } else if (fieldType === "dynamic" && !dependantField.preventMultiple) {
      var _extends3;

      return _extends({}, accum, (_extends3 = {}, _extends3[elemIdentifier] = [], _extends3));
    } else if (fieldType === "dynamic" && dependantField.preventMultiple) {
      var _extends4;

      return _extends({}, accum, (_extends4 = {}, _extends4[elemIdentifier] = {}, _extends4));
    }

    var nextValue = getNextValue(dependantField, willAppear, fieldType);
    return _extends({}, accum, (_extends5 = {}, _extends5[elemIdentifier] = nextValue, _extends5));
  }, {});
};

var fieldsIds = [];

var generateId = function generateId(_ref3) {
  var identifier = _ref3.identifier,
      type = _ref3.type;
  var newId = identifier + "|" + type;
  fieldsIds.push(newId);
  return newId;
};

var mergeDependsOnId = function mergeDependsOnId(dependsOnId, flag) {
  return fieldsIds.find(function (fieldId) {
    return fieldId.split("|")[0] === dependsOnId;
  });
};

var generateDependencies = function generateDependencies(fields, entity) {
  var fieldsObject = {};
  fields.forEach(function (field) {
    var _Object$assign;

    return fieldsObject = Object.assign(fieldsObject, (_Object$assign = {}, _Object$assign[generateId(field)] = new Field({
      field: field,
      entity: entity
    }), _Object$assign));
  });

  var setDependenciesValues = function setDependenciesValues(field, dependsOnId, dependsOnValue, dependsOnAny) {
    var _Object$assign2;

    var dependant = fieldsObject[generateId(field)];
    var dependee = fieldsObject[mergeDependsOnId(dependsOnId)];
    dependant.addDependees(dependee, dependsOnValue, dependsOnAny);
    dependee.addDependant(dependant);
    Object.assign(fieldsObject, (_Object$assign2 = {}, _Object$assign2[generateId(field)] = dependant, _Object$assign2[mergeDependsOnId(dependsOnId)] = dependee, _Object$assign2));
  };

  fields.forEach(function (field) {
    if (field.dependsOn) {
      var dependsOn = field.dependsOn,
          dependsOnAny = field.dependsOnAny,
          dependsOnValue = field.dependsOnValue;
      setDependenciesValues(field, dependsOn, dependsOnValue, dependsOnAny);
    }

    if (field.dependeeList) {
      field.dependeeList.forEach(function (_ref4) {
        var dependsOn = _ref4.dependsOn,
            dependsOnValue = _ref4.dependsOnValue,
            dependsOnAny = _ref4.dependsOnAny;
        return setDependenciesValues(field, dependsOn, dependsOnValue, dependsOnAny);
      });
    }
  });
  fieldsIds = [];
  return Object.keys(fieldsObject).map(function (key) {
    return fieldsObject[key];
  });
};

function intersect(a, b) {
  return a.filter(Set.prototype.has, new Set(b));
}

var isDependeeEqualsDependant = function isDependeeEqualsDependant(state, fields, field) {
  var checkDependee = function checkDependee(dependsOn, dependsOnValue) {
    var _fields$find = fields.find(function (_ref5) {
      var identifier = _ref5.identifier;
      return identifier === dependsOn;
    }),
        dependantType = _fields$find.type;

    switch (dependantType) {
      case "checkbox":
        {
          var stateDependsOn = state[dependsOn];

          if (!Array.isArray(state[dependsOn])) {
            stateDependsOn = state[dependsOn].split(",");
            if (stateDependsOn.length > 1) stateDependsOn.pop();
          }

          return typeof dependsOnValue === "string" ? stateDependsOn.includes(dependsOnValue) : intersect(stateDependsOn, dependsOnValue).length > 0;
        }

      default:
        return Array.isArray(dependsOnValue) ? dependsOnValue.includes(state[dependsOn]) : state[dependsOn] === dependsOnValue;
    }
  };

  if (field.dependsOn) {
    return checkDependee(field.dependsOn, field.dependsOnValue);
  }

  if (field.dependeeList) {
    var dependeeListOperator = field.dependeeListOperator === "or" ? "some" : "every";
    return field.dependeeList[dependeeListOperator](function (_ref6) {
      var dependsOn = _ref6.dependsOn,
          dependsOnValue = _ref6.dependsOnValue,
          dependsOnAny = _ref6.dependsOnAny;
      return dependsOnAny ? Boolean(state[dependsOn]) : checkDependee(dependsOn, dependsOnValue);
    });
  }
};

var isDependeeNotHavingDependantValue = function isDependeeNotHavingDependantValue(state, fields, field) {
  var checkDependee = function checkDependee(dependsOn, hideOnValue) {
    var _fields$find2 = fields.find(function (_ref7) {
      var identifier = _ref7.identifier;
      return identifier === dependsOn;
    }),
        dependantType = _fields$find2.type;

    switch (dependantType) {
      case "checkbox":
        {
          var stateDependsOn = state[dependsOn];

          if (!Array.isArray(state[dependsOn])) {
            stateDependsOn = state[dependsOn].split(",");
            if (stateDependsOn.length > 1) stateDependsOn.pop();
          }

          return typeof hideOnValue === "string" ? !stateDependsOn.includes(hideOnValue) : intersect(stateDependsOn, hideOnValue).length === 0;
        }

      default:
        return Array.isArray(hideOnValue) ? !hideOnValue.includes(state[dependsOn]) : state[dependsOn] !== hideOnValue;
    }
  };

  if (field.dependsOn) {
    return checkDependee(field.dependsOn, field.hideOnValue);
  }
};

var isDependeeSet = function isDependeeSet(state, field) {
  var dependsOn = field.dependsOn;
  return Boolean(state[dependsOn]);
};

var GOOGLE_API_KEY = "AIzaSyBjZcO-lMRLE7w9onAbHa3NrnkKuw3HSs0";
var supportedRegexPatterns = {
  textOnly: /^[a-zA-Z\s]*$/,
  phoneNumber: /^(0020-1|00201|\+20-1|\+201|01)[0-2,5]{1}[0-9]{8}$/
};
var validatableFields = ["string", "phoneNumber"];

var SchemaFieldBuilder = /*#__PURE__*/function () {
  function SchemaFieldBuilder(fieldSchema, _temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        entity = _ref.entity,
        parentField = _ref.parentField,
        customConfig = _ref.customConfig,
        _ref$skipAddingFieldT = _ref.skipAddingFieldToParent,
        skipAddingFieldToParent = _ref$skipAddingFieldT === void 0 ? false : _ref$skipAddingFieldT,
        staticField = _ref.staticField;

    var isRequired = !!(parentField !== null && parentField !== void 0 && parentField.isDefaultFieldRequired());
    var type = fieldSchema.type,
        label = fieldSchema.label,
        name = fieldSchema.name,
        _fieldSchema$required = fieldSchema.required,
        required = _fieldSchema$required === void 0 ? isRequired : _fieldSchema$required,
        wrapper = fieldSchema.wrapper,
        defaultValue = fieldSchema.default_value,
        supportedType = fieldSchema.supported_type,
        isTranslatable = fieldSchema.is_translatable;

    var _ref2 = adminConfigs.getConfigs().apiFieldsConfig || {},
        _ref2$enableTranslati = _ref2.enableTranslation,
        enableTranslation = _ref2$enableTranslati === void 0 ? true : _ref2$enableTranslati;

    this.isTranslatable = enableTranslation && ((supportedType === null || supportedType === void 0 ? void 0 : supportedType.is_translatable) || isTranslatable);
    this.type = this.getFieldType(type);
    this.originalType = type;
    this.label = label;
    this.identifier = name;
    this.required = required;
    this.wrapper = wrapper;
    this.customConfig = customConfig;
    this.parentField = parentField;
    this.entity = entity;
    this.skipAddingFieldToParent = skipAddingFieldToParent;
    this.defaultValue = defaultValue;
    this.staticField = staticField;
  }

  var _proto = SchemaFieldBuilder.prototype;

  _proto.getFieldType = function getFieldType(type) {
    if (this.isTranslatable) return "dynamic";
    return SchemaFieldBuilder.apiTypesToFieldTypesMapping[type] || "string";
  };

  _proto.setFieldDecorators = function setFieldDecorators(field) {
    var type = field.type;
    var decoratedTypes = {
      image: FileFieldDecorator,
      video: FileFieldDecorator,
      pdf: FileFieldDecorator
    };
    var Decorator = decoratedTypes[type];
    if (Decorator) return new Decorator(field);
    return field;
  };

  _proto.build = function build() {
    var schemaField = new Field({
      field: this.fieldConfig(),
      entity: this.entity
    });
    if (this.originalType === "buttonLink") console.log(this.fieldConfig());
    var decoratedField = this.setFieldDecorators(schemaField);
    this.addFieldToParent(decoratedField);
    return decoratedField;
  };

  _proto.buildStatic = function buildStatic() {
    var field = new Field({
      field: this.staticFieldConfig(),
      entity: this.entity
    });
    var type = this.staticField.type;
    if (type === "api") field = new ApiFieldDecorator(field);
    this.addFieldToParent(field);
    return field;
  };

  _proto.staticFieldConfig = function staticFieldConfig() {
    var type = this.staticField.type;
    var fieldsInDynamicField = null;
    if (type === "dynamic") fieldsInDynamicField = this.getStaticFieldsInDynamicField(this.staticField);
    var wrapper = this.wrapper,
        parentField = this.parentField,
        customConfig = this.customConfig;

    var config = _extends({}, this.staticField, {
      parentField: parentField,
      isVirtualField: true,
      stateWrapperPath: wrapper
    }, fieldsInDynamicField && {
      fields: fieldsInDynamicField
    }, customConfig);

    return config;
  };

  _proto.getStaticFieldsInDynamicField = function getStaticFieldsInDynamicField(dynamicField) {
    var _this = this;

    var fieldsInDynamicField = dynamicField.fields.map(function (field) {
      var staticField = new SchemaFieldBuilder({
        wrapper: _this.wrapper
      }, {
        staticField: field,
        entity: _this.entity,
        parentField: _this.parentField,
        customConfig: {
          isVirtualField: false
        },
        skipAddingFieldToParent: true
      }).buildStatic();
      return staticField;
    });
    return fieldsInDynamicField;
  };

  _proto.getTranslatedDynamicField = function getTranslatedDynamicField() {
    switch (this.originalType) {
      case "Editor":
        return "editor";

      default:
        return "string";
    }
  };

  _proto.getTranslatedConfig = function getTranslatedConfig() {
    var _this2 = this;

    var _ref3 = adminConfigs.getConfigs().apiFieldsConfig || {},
        _ref3$supportedLangua = _ref3.supportedLanguages,
        supportedLanguages = _ref3$supportedLangua === void 0 ? [] : _ref3$supportedLangua;

    var fields = supportedLanguages.map(function (language) {
      return new Field({
        field: {
          identifier: language,
          accessor: language,
          label: humanize(language),
          inList: true,
          type: _this2.getTranslatedDynamicField()
        }
      });
    });
    return {
      fields: fields,
      preventMultiple: true,
      initiallySet: true,
      allowRemove: false
    };
  };

  _proto.fieldConfig = function fieldConfig() {
    var identifier = this.identifier,
        type = this.type,
        label = this.label,
        wrapper = this.wrapper,
        customConfig = this.customConfig,
        required = this.required,
        parentField = this.parentField;
    var overrides = parentField === null || parentField === void 0 ? void 0 : parentField.getFieldOverrides(identifier);

    var newFieldConfig = _extends({
      identifier: identifier,
      type: type,
      isVirtualField: true,
      label: label || identifier,
      accessor: identifier,
      required: required,
      stateWrapperPath: wrapper,
      parentField: parentField
    }, this.defaultValue && {
      defaultValue: this.defaultValue
    }, this.type === "toggle" && {
      toggleConfig: {
        on: true,
        off: false
      }
    }, customConfig, overrides, SchemaFieldBuilder.extraCustomConfig[this.originalType] || SchemaFieldBuilder.extraCustomConfig[type], this.isTranslatable && this.getTranslatedConfig(), {
      extraWrapper: [identifier]
    });

    return newFieldConfig;
  };

  _proto.addFieldToParent = function addFieldToParent(schemaField) {
    if (this.skipAddingFieldToParent) return;

    if (!this.parentField) {
      this.entity.addField(schemaField);
      return;
    }

    var parentFieldOfParent = this.parentField.getParentField();
    var isInDynamicField = (parentFieldOfParent === null || parentFieldOfParent === void 0 ? void 0 : parentFieldOfParent.getType()) === "dynamic";
    if (isInDynamicField) parentFieldOfParent.addField(schemaField);else this.entity.addField(schemaField);
  };

  return SchemaFieldBuilder;
}();

SchemaFieldBuilder.apiTypesToFieldTypesMapping = {
  "boolean": "toggle",
  date_time: "datetime",
  date: "date",
  text: "text",
  integer: "number",
  "float": "number",
  pdf: "string",
  image: "image",
  file: "string",
  string: "string",
  dynamic: "dynamic",
  Editor: "editor",
  icon: "image",
  video: "video",
  iconOrVideo: "video",
  buttonLink: "pdf",
  iconLink: "string"
};
SchemaFieldBuilder.extraCustomConfig = {
  image: {
    useGallery: true,
    mediaOptions: {
      aspectRatio: "free"
    },
    sendObjectPayload: true,
    allowExternal: true
  },
  video: {
    useGallery: true,
    sendObjectPayload: true,
    allowExternal: true
  },
  iconOrVideo: {
    useGallery: true,
    sendObjectPayload: true,
    allowExternal: true,
    allowedExtensions: "image/*,video/*",
    listType: ["image", "video"]
  },
  buttonLink: {
    useGallery: true,
    sendObjectPayload: true,
    allowExternal: true
  },
  iconLink: {
    required: false
  }
};
var _excluded$6 = ["extraFields"];

var ApiFieldDynamicGroupBuilder = /*#__PURE__*/function () {
  function ApiFieldDynamicGroupBuilder(groupDynamicConfig, apiField, schema, _temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        customConfig = _ref.customConfig;

    var extraFields = customConfig.extraFields,
        rest = _objectWithoutPropertiesLoose(customConfig, _excluded$6);

    this.groupDynamicConfig = groupDynamicConfig;
    this.schema = schema;
    this.apiField = apiField;
    this.customConfig = rest;
    this.entity = apiField.getEntity();
    this.extraFields = extraFields;
  }

  var _proto = ApiFieldDynamicGroupBuilder.prototype;

  _proto.build = function build() {
    this.setFields();
    this.dynamicField = new Field({
      field: this.fieldConfig(),
      entity: this.entity
    });
    this.addFieldToParent();
    return this.dynamicField;
  };

  _proto.fieldConfig = function fieldConfig() {
    var groupDynamicConfig = this.groupDynamicConfig,
        schema = this.schema,
        customConfig = this.customConfig,
        apiField = this.apiField;
    var identifierAccessor = groupDynamicConfig.identifierAccessor;
    var identifier = getAccessorValue(schema, identifierAccessor);

    var config = _extends({
      identifier: identifier,
      type: "dynamic",
      label: identifier,
      isVirtualField: true,
      accessor: identifier,
      fields: this.fields,
      parentField: apiField
    }, customConfig);

    return config;
  };

  _proto.setFields = function setFields() {
    var groupDynamicConfig = this.groupDynamicConfig,
        schema = this.schema,
        apiField = this.apiField;
    var nestedAccessor = groupDynamicConfig.nestedAccessor;
    var schemaArray = getAccessorValue(schema, nestedAccessor);
    this.fields = schemaArray.map(function (schemaField) {
      return new SchemaFieldBuilder(schemaField, {
        entity: apiField.getEntity(),
        parentField: apiField,
        customConfig: {
          isVirtualField: false
        },
        skipAddingFieldToParent: true
      }).build();
    });
    this.setExtraFields();
  };

  _proto.setExtraFields = function setExtraFields() {
    var _this = this;

    if (!this.extraFields) return;
    this.extraFields.forEach(function (field) {
      var apiField = _this.apiField;
      var extraField = new SchemaFieldBuilder({}, {
        entity: apiField.getEntity(),
        parentField: apiField,
        customConfig: {
          isVirtualField: false
        },
        skipAddingFieldToParent: true,
        staticField: field
      }).buildStatic();

      _this.fields.push(extraField);
    });
  };

  _proto.addFieldToParent = function addFieldToParent() {
    var parentField = this.apiField.getParentField();

    if (!parentField) {
      this.entity.addField(this.dynamicField);
      return;
    }

    var isInDynamicField = (parentField === null || parentField === void 0 ? void 0 : parentField.getType()) === "dynamic";

    if (isInDynamicField) {
      parentField.addField(this.dynamicField);
    } else this.entity.addField(this.dynamicField);
  };

  return ApiFieldDynamicGroupBuilder;
}();

var BaseDecorator = /*#__PURE__*/function () {
  var _proto = BaseDecorator.prototype;

  _proto.getInstance = function getInstance() {
    return this.instance;
  };

  _proto.handler = function handler() {
    var decoratedInstance = this;
    return {
      get: function get(target, prop, receiver) {
        return decoratedInstance[prop] || Reflect.get.apply(Reflect, arguments);
      }
    };
  };

  function BaseDecorator(instance) {
    this.instance = instance;
    return new Proxy(instance, this.handler());
  }

  return BaseDecorator;
}();

var ApiFieldDecorator = /*#__PURE__*/function (_BaseDecorator) {
  _inheritsLoose(ApiFieldDecorator, _BaseDecorator);

  function ApiFieldDecorator() {
    return _BaseDecorator.apply(this, arguments) || this;
  }

  var _proto = ApiFieldDecorator.prototype;

  _proto.getFields = function getFields(schema, options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    if (!schema) return {};
    this.schema = schema;

    var _BaseDecorator$protot = _BaseDecorator.prototype.getInstance.call(this),
        _BaseDecorator$protot2 = _BaseDecorator$protot.apiFieldConfig,
        accessor = _BaseDecorator$protot2.accessor,
        groups = _BaseDecorator$protot2.groups;

    if (accessor) return this.getUngroupedFields(accessor, options);
    if (groups) return {
      groups: groups.map(function (group) {
        return _this.getGroupedFields(group.accessor, group);
      })
    };
  };

  _proto.apiFieldSourceEndpoint = function apiFieldSourceEndpoint() {
    var dataSource = _BaseDecorator.prototype.getInstance.call(this).apiFieldConfig.dataSource;

    return dataSource.endpoint;
  };

  _proto.getAPIFieldReferencedEntityName = function getAPIFieldReferencedEntityName() {
    var _BaseDecorator$protot3 = _BaseDecorator.prototype.getInstance.call(this),
        apiFieldConfig = _BaseDecorator$protot3.apiFieldConfig;

    if (!apiFieldConfig) return null;
    var _apiFieldConfig$dataS = apiFieldConfig.dataSource,
        entity = _apiFieldConfig$dataS.entity,
        endpoint = _apiFieldConfig$dataS.endpoint;
    return "apiFieldSource/" + (entity || endpoint);
  };

  _proto.getSchemaFields = function getSchemaFields(schemaArray, wrapper, isNested, extraFields) {
    if (extraFields === void 0) {
      extraFields = [];
    }

    var entity = _BaseDecorator.prototype.getInstance.call(this).getEntity();

    var builderPayload = {
      entity: entity,
      parentField: this,
      skipAddingFieldToParent: isNested
    };
    var fields = schemaArray.map(function (schemaField) {
      return new SchemaFieldBuilder(_extends({}, schemaField, {
        wrapper: wrapper
      }), builderPayload).build();
    });
    if (extraFields) extraFields.forEach(function (staticField) {
      var extraField = new SchemaFieldBuilder({
        wrapper: wrapper
      }, _extends({}, builderPayload, {
        staticField: staticField
      })).buildStatic();
      fields.push(extraField);
    });
    return fields;
  };

  _proto.getGroupedFields = function getGroupedFields(accessor, group) {
    var _this2 = this;

    var schema = this.schema;
    var schemaArray = getAccessorValue(schema, accessor) || [];
    var nestedGroups = null;
    var dynamicConfig = group.dynamicConfig;

    if (dynamicConfig) {
      var identifierAccessor = dynamicConfig.identifierAccessor,
          initiallySet = dynamicConfig.initiallySet,
          preventMultiple = dynamicConfig.preventMultiple;
      nestedGroups = schemaArray.map(function (element) {
        var identifier = getAccessorValue(element, identifierAccessor);
        var newField = new ApiFieldDynamicGroupBuilder(group.dynamicConfig, _this2, element, {
          customConfig: {
            stateWrapperPath: group.identifier,
            applyIsVirtual: _this2.applyIsVirtual,
            preventMultiple: preventMultiple,
            initiallySet: initiallySet,
            extraFields: group.extraFields
          }
        }).build();
        return {
          label: identifier,
          field: newField
        };
      });
    }

    return _extends({
      label: getTranslatedValue(group.label),
      fields: this.getSchemaFields(schemaArray, group.identifier, !!nestedGroups, group.extraFields),
      identifier: group.identifier
    }, nestedGroups && {
      nestedGroups: nestedGroups
    });
  };

  _proto.getUngroupedFields = function getUngroupedFields(accessor, options) {
    var schemaArray = options.inShow ? this.schema : getAccessorValue(this.schema, accessor);
    return {
      fields: this.getSchemaFields(schemaArray)
    };
  };

  _proto.getSchemaShowAccessor = function getSchemaShowAccessor() {
    var _BaseDecorator$protot4 = _BaseDecorator.prototype.getInstance.call(this),
        apiFieldConfig = _BaseDecorator$protot4.apiFieldConfig;

    return apiFieldConfig.schemaShowAccessor;
  };

  _proto.getFieldOverrides = function getFieldOverrides(fieldIdentifier) {
    var _BaseDecorator$protot5 = _BaseDecorator.prototype.getInstance.call(this),
        fieldOverrides = _BaseDecorator$protot5.apiFieldConfig.fieldOverrides;

    if (!fieldOverrides) return {};
    return fieldOverrides[fieldIdentifier];
  };

  _proto.isDefaultFieldRequired = function isDefaultFieldRequired() {
    var _BaseDecorator$protot6 = _BaseDecorator.prototype.getInstance.call(this),
        apiFieldConfig = _BaseDecorator$protot6.apiFieldConfig;

    return !apiFieldConfig.defaultNotRequired;
  };

  _proto.isFieldPresentInSchema = function isFieldPresentInSchema(field, dataObject, hideIfWrapped) {
    var schema = this.getDataValue(dataObject, {
      customAccessor: this.getSchemaShowAccessor()
    });
    if (!schema) return false;
    var stateWrapperPath = field.getStateWrapperPath();
    if (stateWrapperPath && hideIfWrapped) return false;
    var schemaObject = get$1(schema, stateWrapperPath) || schema[field.identifier];
    if (!schemaObject) return true;
    var isFound = Array.isArray(schemaObject) ? schemaObject.find(function (object) {
      return object.name === field.identifier;
    }) : schemaObject.name === field.identifier;
    return isFound;
  };

  _proto.getParent = function getParent() {
    return _BaseDecorator.prototype.getInstance.call(this).getParentField() || _BaseDecorator.prototype.getInstance.getEntity();
  };

  _proto.removeSchemaFieldsFromParent = function removeSchemaFieldsFromParent(fields) {
    var parent = this.getParent();
    if (!(parent && fields)) return;
    fields.forEach(function (field) {
      return parent.removeField(field);
    });
  };

  return ApiFieldDecorator;
}(BaseDecorator);

var FileFieldDecorator = /*#__PURE__*/function (_BaseDecorator) {
  _inheritsLoose(FileFieldDecorator, _BaseDecorator);

  function FileFieldDecorator() {
    return _BaseDecorator.apply(this, arguments) || this;
  }

  var _proto = FileFieldDecorator.prototype;

  _proto.getMediaOptions = function getMediaOptions() {
    return this.mediaOptions;
  };

  _proto.usesGallery = function usesGallery() {
    return adminConfigs.getConfigs().useGallery && this.useGallery;
  };

  _proto.getAllowedExtensions = function getAllowedExtensions() {
    return this.allowedExtensions;
  };

  _proto.getListType = function getListType() {
    return this.listType;
  };

  return FileFieldDecorator;
}(BaseDecorator);

var unLabelledFields = ["profilePicture"];
var _excluded$7 = ["enableFilters", "enableFieldsFilters", "enableGlobalActions", "fields", "fieldsFilters", "filters", "filterParams", "fieldsOverrides", "fieldsToBeRemoved"],
    _excluded2 = ["name", "type", "staticDataAccessor"],
    _excluded3 = ["entity", "identifier"];

function getValidationPattern(_ref) {
  var type = _ref.type,
      customPattern = _ref.customPattern;
  if (customPattern) return typeof customPattern === "string" ? new RegExp(customPattern) : customPattern;else if (type && supportedRegexPatterns[type]) return supportedRegexPatterns[type];
  return undefined;
}

function getTypeValue(type, data) {
  return typeof type === "function" ? type === null || type === void 0 ? void 0 : type(data) : type;
}

function canRolePerformAction(role, path) {
  if (path === void 0) {
    path = [];
  }

  var authorizedRoles = get(this, path);
  if (!authorizedRoles || !role) return true;
  return authorizedRoles.includes(role);
}

function localizeFields(fields) {
  return fields.reduce(function (acc, field) {
    if (field.localized && ["string", "text", "editor"].includes(getTypeValue(field.type))) {
      return [].concat(acc, field.locales.map(function (localeConfig) {
        return _extends({}, field, {
          identifier: field.identifier + "_" + localeConfig.locale,
          accessor: typeof field.accessor === "string" ? field.accessor + "_" + localeConfig.locale : field.accessor,
          label: setLabel(field.label, field.locales, localeConfig),
          required: localeConfig.required === undefined ? field.required : localeConfig.required,
          usedToShow: localeConfig.usedToShow === undefined ? field.usedToShow : localeConfig.usedToShow,
          inList: localeConfig.inList === undefined ? field.inList : localeConfig.inList
        });
      }));
    } else {
      return [].concat(acc, [field]);
    }
  }, []);
}

function setLabel(label, locales, currentLocaleConfig) {
  return locales.reduce(function (acc, localeConfig) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[localeConfig.locale] = (typeof label === "string" ? label : label[localeConfig.locale]) + " " + currentLocaleConfig.labelSuffix[localeConfig.locale], _extends2));
  }, {});
}

function setResetDependants(field, fields) {
  var resetDependantsObject = field.resetDependants.reduce(function (accum, resetDependantIdentifier) {
    var _extends3;

    var resetDependantField = fields.find(function (field) {
      return field.identifier === resetDependantIdentifier;
    });
    return _extends({}, accum, (_extends3 = {}, _extends3[resetDependantIdentifier] = resetDependantField.defaultValue || "", _extends3));
  }, {});
  field.setResetDependantsObject(resetDependantsObject);
}

function setFields(fields, entity) {
  var localizedFields = localizeFields(fields);
  return generateDependencies(localizedFields, entity).map(function (field, index) {
    var type = getTypeValue(field.type);

    if (["dynamic", "table", "scannableTable"].includes(type)) {
      var _field$fields = field.fields,
          dynamicFields = _field$fields === void 0 ? [] : _field$fields;
      var dynamicFieldsWithParent = dynamicFields.map(function (dynamicField) {
        return _extends({}, dynamicField, {
          parentField: field
        });
      });
      var fieldObject = Object.assign(field, {
        fields: setFields(dynamicFieldsWithParent, entity)
      });
      return new Field({
        field: fieldObject,
        entity: entity
      });
    }

    if (field.resetDependants) setResetDependants(field, fields);

    switch (type) {
      case "api":
        return new ApiFieldDecorator(field);

      case "pdf":
      case "file":
      case "video":
      case "image":
        return new FileFieldDecorator(field);

      default:
        return field;
    }
  });
}

function addField(field) {
  if (!this.fields) return;
  var index = this.fields.findIndex(function (element) {
    return element.identifier === field.identifier;
  });

  if (index > -1) {
    this.fields[index] = field;
  } else this.fields.push(field);
}

function removeField(field) {
  if (!this.fields) return;
  var index = this.fields.findIndex(function (element) {
    return element.identifier === field.identifier;
  });

  if (index > -1) {
    this.fields.splice(index, 1);
  }
}

function Field(_ref2) {
  var _this = this;

  var field = _ref2.field,
      entity = _ref2.entity;
  this.dependants = [];
  this.dependees = [];
  Object.keys(field).forEach(function (key) {
    _this[key] = field[key];
  });
  this.entity = entity;
  this.dependsOnAny = Boolean(field.dependsOnAny);

  this.getResetDependantsObject = function () {
    return this.resetDependantsObject || {};
  };

  this.setResetDependantsObject = function (resetDependantsObject) {
    this.resetDependantsObject = resetDependantsObject;
  };

  this.getParentField = function () {
    return this.parentField;
  };

  this.getEntity = function () {
    return this.entity;
  };

  this.setReferencedEntity = function (referencedEntity) {
    this.referencedEntity = referencedEntity;
  };

  this.getReferencedEntity = function () {
    return this.referencedEntity;
  };

  this.get = function (path) {
    return get(this, path);
  };

  this.getDependants = function () {
    return this.dependants || [];
  };

  this.addDependant = function (field) {
    return this.getDependants().push(field);
  };

  this.getDependees = function () {
    return this.dependees || [];
  };

  this.getDependeesFields = function () {
    return this.dependees.map(function (dependee) {
      return dependee.field;
    }) || [];
  };

  this.addDependees = function (field, dependsOnValue, dependsOnAny) {
    return this.getDependees().push({
      field: field,
      dependsOnValue: dependsOnValue,
      dependsOnAny: dependsOnAny
    });
  };

  this.getDependantWithCondition = function (depandantKey, dependeeValue) {
    return this.getDependants().find(function (dependant) {
      return dependant[depandantKey] === dependeeValue;
    }) || {};
  };

  this.getType = function (data) {
    return getTypeValue(field.type, data);
  };

  this.checkMediaRelation = function () {
    return this.isMediaRelation;
  };

  this.isHiddenInShow = function (data, role) {
    var isHidden = typeof this.hideInShow === "function" ? this.hideInShow(data) : this.hideInShow;
    return !this.canRoleUseIn(role, "show") || isHidden || !this.isDependeesEqualsDependants(data);
  };

  this.isDependant = function () {
    return Boolean(this.dependsOn);
  };

  this.canRoleUseIn = function (role, action) {
    return this.canRolePerformAction(role, ["authorizedRoles", "field"]) && this.canRolePerformAction(role, ["authorizedRoles", action]);
  };

  this.isDependeesEqualsDependants = function (data) {
    var _this2 = this;

    var dependeeListOperator = this.dependeeListOperator === "or" ? "some" : "every";
    return this.getDependees()[dependeeListOperator](function (_ref3) {
      var field = _ref3.field,
          dependsOnValue = _ref3.dependsOnValue,
          dependsOnAny = _ref3.dependsOnAny;
      if (dependsOnAny) return isDependeeSet(data, _this2);
      var dependeeAccessor = field.getDataValue(data);

      var dependenceCondition = _this2.isDependenceConditionSatisfied(field, data, dependeeAccessor, dependsOnValue);

      return (dependeeAccessor || true) && dependenceCondition;
    });
  };

  this.isDependenceConditionSatisfied = function (field, data, dependeeAccessor, dependsOnValue) {
    var possibleTranslations = field.getPossibleTranslations(data);
    if (Array.isArray(dependsOnValue)) return dependsOnValue.includes(dependeeAccessor) || intersection$1(dependsOnValue, possibleTranslations).length > 0;
    return dependeeAccessor === dependsOnValue || possibleTranslations.includes(dependsOnValue);
  };

  this.isHiddenInCreate = function (state, role) {
    return !this.canRoleUseIn(role, "create") || (typeof this.hideInCreate === "function" ? this.hideInCreate(state) : this.hideInCreate);
  };

  this.isHiddenInEdit = function (data, state, role) {
    return !this.canRoleUseIn(role, "edit") || (typeof this.hideInEdit === "function" ? this.hideInEdit(data, state) : this.hideInEdit);
  };

  this.isHiddenInList = function (role, dataObject) {
    return !this.canRoleUseIn(role, "list") || !(typeof field.inList === "function" ? field.inList(dataObject, role) : field.inList);
  };

  this.getSelectValue = function (_ref4) {
    var _this3 = this;

    var dataObject = _ref4.dataObject;
    var staticOptions = this.getStaticOptions();
    return staticOptions ? staticOptions.reduce(function (acc, element) {
      if (element.value === _this3.getDataValue(dataObject)) {
        acc = getTranslatedValue(element.label) || element.value;
        return acc;
      } else return acc;
    }, []) : element.value;
  };

  this.getDataValue = function (data, options) {
    if (data === void 0) {
      data = {};
    }

    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$isForm = _options.isForm,
        isForm = _options$isForm === void 0 ? false : _options$isForm,
        _options$canReturnUnd = _options.canReturnUndefined,
        canReturnUndefined = _options$canReturnUnd === void 0 ? false : _options$canReturnUnd,
        _options$customAccess = _options.customAccessor,
        customAccessor = _options$customAccess === void 0 ? null : _options$customAccess,
        _options$constructFil = _options.constructFileAccessor,
        constructFileAccessor = _options$constructFil === void 0 ? false : _options$constructFil,
        _options$getAllPossib = _options.getAllPossibleTranslations,
        getAllPossibleTranslations = _options$getAllPossib === void 0 ? false : _options$getAllPossib,
        _options$skipTranslat = _options.skipTranslation,
        skipTranslation = _options$skipTranslat === void 0 ? false : _options$skipTranslat,
        _options$skipStateWra = _options.skipStateWrapperPath,
        skipStateWrapperPath = _options$skipStateWra === void 0 ? false : _options$skipStateWra;
    var fieldType = this.getType({
      dataObject: data
    });
    var accessor = customAccessor || isForm && get(this, ["formAccessor"]) || get(this, ["accessor"]);
    var modifiedAccessor = modifyAccessor(accessor, fieldType, {
      constructFileAccessor: constructFileAccessor
    });
    var stateWrapperPath = this.getStateWrapperPath();
    var targetData = !skipStateWrapperPath && stateWrapperPath ? get(data, stateWrapperPath) || data : data;
    var value = getAccessorValue(targetData, modifiedAccessor, false, getAllPossibleTranslations, skipTranslation);
    return value === undefined && !canReturnUndefined ? "_" : value;
  };

  this.isNotAutoFillable = function () {
    return field.disableAutoComplete ? "new-password" : "";
  };

  this.getReferencedLink = function (data, options) {
    var _this$optionsEntity;

    if ((_this$optionsEntity = this.optionsEntity) !== null && _this$optionsEntity !== void 0 && _this$optionsEntity.displayAsLink) {
      var linkValue = this.getDataValue(data, _extends({
        isForm: true
      }, options));

      var _this$getReferencedEn = this.getReferencedEntity(),
          pathName = _this$getReferencedEn.pathName;

      return linkValue && getURL(adminConfigs.getConfigs().privateRouteURL, pathName + "/" + linkValue);
    }

    return null;
  };

  this.getReferencedFieldDisplayData = function (dataObject, enableLink, value) {
    var _this$optionsEntity2 = this.optionsEntity,
        labelField = _this$optionsEntity2.labelField,
        valueLabel = _this$optionsEntity2.valueLabel,
        valueField = _this$optionsEntity2.valueField;
    var referencedDisplayValue = this.getDataValue(dataObject, {
      customAccessor: labelField
    });
    var useValueLabel = this.getDataValue(dataObject, {
      customAccessor: valueLabel,
      canReturnUndefined: true
    });
    var referencedLink = enableLink && this.getReferencedLink(dataObject, {
      customAccessor: useValueLabel ? valueLabel : valueField
    });
    var displayValue = value || referencedDisplayValue;
    return {
      referencedLink: referencedLink,
      value: displayValue
    };
  };

  this.getDisplayValue = function (dataObject, _temp) {
    var _this4 = this;

    var _ref5 = _temp === void 0 ? {} : _temp,
        value = _ref5.value,
        id = _ref5.id,
        inDataPage = _ref5.inDataPage,
        _ref5$enableLink = _ref5.enableLink,
        enableLink = _ref5$enableLink === void 0 ? true : _ref5$enableLink,
        tagsConfig = _ref5.tagsConfig,
        parentRecordId = _ref5.parentRecordId,
        parentPathname = _ref5.parentPathname;

    var type = this.getType({
      dataObject: dataObject
    });
    var useHumanizer = this.useHumanizer;
    var tags = inDataPage && !(tagsConfig !== null && tagsConfig !== void 0 && tagsConfig.hideInShow) || !inDataPage && !(tagsConfig !== null && tagsConfig !== void 0 && tagsConfig.hideInList) ? tagsConfig : undefined;
    if (this.component) return displayField({
      component: this.component,
      value: value
    });

    if (this.optionsEntity) {
      if (this.multiple) {
        var displayDataArray = Array.isArray(value) && value.map(function (item) {
          return _extends({}, _this4.getReferencedFieldDisplayData(item, enableLink), {
            tagColorCode: displayedTag(value, tags)
          });
        });
        return displayField({
          value: displayDataArray,
          useHumanizer: useHumanizer
        });
      }

      var referencedFieldDisplayData = this.getReferencedFieldDisplayData(dataObject, enableLink, value);
      return displayField(_extends({}, referencedFieldDisplayData, {
        tagColorCode: displayedTag(value, tags)
      }));
    }

    if (this.usedToShow && id) {
      var _this$getEntity = this.getEntity(),
          pathName = _this$getEntity.pathName,
          isChild = _this$getEntity.isChild;

      var referencedLink = getURL(adminConfigs.getConfigs().privateRouteURL, isChild ? parentPathname + "/" + parentRecordId + "/" + pathName + "/" + id : pathName + "/" + id);
      return displayField({
        referencedLink: referencedLink,
        value: value,
        inDataPage: inDataPage,
        useHumanizer: useHumanizer,
        tagColorCode: displayedTag(value, tags)
      });
    }

    if (type === "file") return displayField({
      value: value,
      isFile: true
    });
    if (type === "select") return displayField({
      value: this.getSelectValue({
        dataObject: dataObject
      })
    });
    if (type === "radio") return displayField({
      value: this.getSelectValue({
        dataObject: dataObject
      })
    });
    if (type === "checkbox" && this.checkboxConfig && this.checkboxConfig.format === "array") return displayField({
      value: value.join(", ")
    });
    return displayField({
      value: value,
      inDataPage: inDataPage,
      useHumanizer: useHumanizer,
      tagColorCode: displayedTag(value, tags)
    });
  };

  this.getLabel = function (value) {
    return getTranslatedValue(value || this.label);
  };

  this.hasLabel = function () {
    return !unLabelledFields.includes(this.type);
  };

  this.isParentDisabled = function (action, dataObject, location, state) {
    var parentField = this.getParentField();
    return parentField && parentField.isDisabled(action, dataObject, location, state);
  };

  this.isDisabled = function (action, dataObject, location, state) {
    return this.isParentDisabled(action, dataObject, location, state) || (this.isPrepopulatedDisabled() ? this.prepopulationConfig.disablePrepopulation : ["boolean", "undefined"].includes(typeof this.disabled) ? this.disabled : this.disabled(action, dataObject, location, state));
  };

  this.isPrepopulatedDisabled = function () {
    return this.prepopulationConfig && this.prepopulationConfig.disablePrepopulation;
  };

  this.isPrepopulated = function (action, dataObject, state) {
    if (!this.prepopulationConfig) return false;
    var enabled = this.prepopulationConfig.enabled;
    return Boolean(typeof enabled === "function" ? enabled(action, dataObject, state) : enabled) && [action, "both"].includes(this.prepopulationConfig.action);
  };

  this.prepopulater = function (action) {
    if (!this.prepopulationConfig) return false;
    var prepopulater = this.prepopulationConfig.prepopulater;
    return typeof prepopulater === "string" && [action, "both"].includes(prepopulater) || Boolean(prepopulater) && [action, "both"].includes(this.prepopulationConfig.action);
  };

  this.getPrepopulationValue = function (formState, rawRouteState, routeParams, reduxState, auth) {
    var prepopulationConfig = field.prepopulationConfig;
    var routeState = getJSONValue(rawRouteState);
    var prepopulationObject = {
      formState: formState,
      routeState: routeState,
      routeParams: routeParams,
      reduxState: (reduxState || {}).current,
      auth: auth
    };
    var labelKey = getOptionalFunctionValue(prepopulationConfig.labelField);
    this.prepopulationLabel = ["reduxState", "routeState", "auth"].includes(prepopulationConfig.source) && prepopulationObject[prepopulationConfig.source] && get(prepopulationObject[prepopulationConfig.source], labelKey);
    this.prepopulaterValueNotSet = prepopulationObject[prepopulationConfig.source] && Object.keys(prepopulationObject[prepopulationConfig.source]).length === 0;
    var valueKey = getOptionalFunctionValue(prepopulationConfig.valueKey);
    return prepopulationObject[prepopulationConfig.source] && get(prepopulationObject[prepopulationConfig.source], valueKey);
  };

  this.getPrepopulationLabel = function () {
    return this.prepopulationLabel;
  };

  this.getPrepopulaterValueNotSet = function () {
    return this.prepopulaterValueNotSet;
  };

  this.isDynamic = function () {
    return ["reference", "transferList", "dynamicCheckbox", "table", "scannableTable", "api"].includes(getTypeValue(field.type));
  };

  this.getBooleanPropertyValue = function (propertyName, data) {
    var property = this.get(propertyName);
    if (typeof property === "function") return property(data);
    return property === undefined || property;
  };

  this.getDynamicFieldsIdentifierValue = function (data) {
    var dynamicFieldsIdentifierValue = this.dynamicFieldsIdentifier || "id";
    return data[dynamicFieldsIdentifierValue];
  };

  this.sanitized = function (dataValue) {
    var _this$valuesRejectedO;

    return !((_this$valuesRejectedO = this.valuesRejectedOnSubmit) !== null && _this$valuesRejectedO !== void 0 && _this$valuesRejectedO.includes(dataValue));
  };

  this.isRequired = function (action, dataObject, location, state) {
    return typeof this.required === "function" ? this.required(action, dataObject, location, state) : this.required;
  };

  this.isValid = function (value, action, dataObject, location, state) {
    var invalid = false;
    var validationMessage = "";

    if (this.isRequired(action, dataObject, location, state)) {
      invalid = isValueEmpty(value);

      if (Array.isArray(value) && every(value, isObject)) {
        invalid = value.every(function (item) {
          return item._destroy || item._remove;
        });
      }

      switch (getTypeValue(this.type)) {
        case "file":
        case "image":
        case "video":
          invalid = invalid || value === false;
          break;

        case "phoneNumber":
          invalid = invalid || value === "-";
          break;
      }

      validationMessage = invalid ? "requiredFields" : "";
    } else if (validatableFields.includes(getTypeValue(this.type)) && this.validationRules) {
      var regex = getValidationPattern(this.validationRules);
      if (regex) invalid = !regex.test(value);
      validationMessage = invalid ? getTranslatedValue(this.validationRules.validationMessage) || "Invalid input" : "";
    }

    return {
      isValid: !invalid,
      validationMessage: validationMessage
    };
  };

  this.getErrors = function (errors, data) {
    switch (getTypeValue(this.type, data)) {
      case "file":
        return errors[this.identifier] || errors.message;

      case "reference":
        {
          var name = this.optionsEntity,
              identifier = this.identifier;
          var generalIdentifier = identifier.replace("_id", "");
          var fieldErrors = errors[name] || errors[identifier] || errors[generalIdentifier];
          return fieldErrors;
        }

      default:
        return errors === null || errors === void 0 ? void 0 : errors[this.identifier];
    }
  };

  this.canRolePerformAction = canRolePerformAction;

  this.isSentEmptyDependantField = function () {
    return this.sendEmptyDependantField || this.getEntity().sendEmptyDependantFields;
  };

  this.getPossibleTranslations = function (data, isForm) {
    return this.getDataValue(data, {
      isForm: isForm,
      canReturnUndefined: true,
      getAllPossibleTranslations: true
    }) || [];
  };

  this.getEqualVirtualFields = function (data) {
    var fieldType = this.getType(data);

    switch (fieldType) {
      case "markerMap":
        {
          var _this$mapConfig = this.mapConfig,
              mapConfig = _this$mapConfig === void 0 ? {} : _this$mapConfig;
          var lngFieldIdentifier = mapConfig.lngFieldIdentifier,
              latFieldIdentifier = mapConfig.latFieldIdentifier;
          if (lngFieldIdentifier && latFieldIdentifier) return [{
            name: lngFieldIdentifier,
            valueKey: "lng"
          }, {
            name: latFieldIdentifier,
            valueKey: "lat"
          }];
          return [];
        }

      default:
        return [];
    }
  };

  this.getDescription = function () {
    var _ref6 = this.description || {},
        linkTitle = _ref6.linkTitle,
        modalTitle = _ref6.modalTitle,
        modalBody = _ref6.modalBody,
        actionButtonLabel = _ref6.actionButtonLabel;

    return this.description && _extends({}, this.description, {
      linkTitle: getTranslatedValue(linkTitle),
      modalTitle: getTranslatedValue(modalTitle),
      modalBody: getTranslatedValue(modalBody),
      actionButtonLabel: getTranslatedValue(actionButtonLabel)
    });
  };

  this.getDefaultValue = function () {
    var fieldDefault = "";
    var fieldType = this.getType();
    if (fieldType === "dynamic") fieldDefault = this.preventMultiple ? {} : [];
    return this.defaultValue || fieldDefault;
  };

  this.getStaticOptions = function (dataObject, state, action) {
    if (!this.options) return null;
    return typeof this.options === "function" ? this.options(dataObject, state, action) : this.options;
  };

  this.isAuthenticated = function () {
    return this.authenticated;
  };

  this.isVirtual = function () {
    return this.isVirtualField;
  };

  this.addField = addField;
  this.removeField = removeField;

  this.getStateWrapperPath = function () {
    return this.stateWrapperPath;
  };
}

var allowedFilterTypes = {
  select: true,
  date: true,
  datetime: true,
  time: true,
  searchInput: true,
  string: true,
  number: true,
  toggle: true
};

function setFilters(filters, entity) {
  return filters === null || filters === void 0 ? void 0 : filters.map(function (filter) {
    if (!allowedFilterTypes[filter.type]) throw new TypeError("Please choose one of the supported filter types [" + Object.keys(allowedFilterTypes) + "] for the following filter (" + filter.name + ") in " + entity.pluralName + " entity.");
    if (filter.type === "searchInput") filter.type = "string";
    return filter;
  });
}

function setImportConfig(importConfig, entity) {
  var config = [];
  var afterCreateRedirectPath = entity.afterCreateRedirectPath,
      requestParams = entity.requestParams;

  if (afterCreateRedirectPath) {
    console.warn("afterCreateRedirectPath config in " + entity.name + " entity will soon be deprecated in the next major release. Please add it directly to the import action you want to use it with.");
  }

  if (requestParams !== null && requestParams !== void 0 && requestParams["import"]) {
    console.warn("import key used in requestParams config in " + entity.name + " entity will soon be deprecated in the next major release. Please add it directly to the import action you want to use it with.");
  }

  if (!Array.isArray(importConfig)) {
    console.warn("You are using old format of the import config in " + entity.name + " entity. This will soon be deprecated in the next major release. Please update it to use the new synatx.");
    importConfig = _extends({}, afterCreateRedirectPath && {
      afterCreateRedirectPath: afterCreateRedirectPath
    }, (requestParams === null || requestParams === void 0 ? void 0 : requestParams["import"]) && {
      requestParams: requestParams["import"]
    }, importConfig);
    if (Object.prototype.hasOwnProperty.call(importConfig, "enabled")) console.warn("enabled is no longer used in the import config. Please update you configs in " + entity.name + ".");

    if (importConfig.enabled) {
      importConfig = _extends({
        label: {
          en: "Import",
          ar: "رفع ملف"
        },
        name: "import"
      }, importConfig);
      config = [importConfig];
    }
  } else config = importConfig;

  return config;
}

function configureChildEntities(_ref7) {
  var entity = _ref7.entity;
  var childEntities = entity.childEntities;
  Object.keys(childEntities).map(function (key) {
    childEntities[key].isChild = true;
    childEntities[key].parentEntity = entity;
    childEntities[key].showInSidebar = false;
  });
  return childEntities;
}

function Entity(obj) {
  var _this5 = this;

  Object.keys(obj).forEach(function (key) {
    if (key === "fields") {
      var fields = setFields(obj[key], _this5);
      _this5[key] = fields;
    } else if (key === "filters") {
      var filters = setFilters(obj[key], _this5);
      _this5[key] = filters;
    } else if (key === "import") {
      var importConfig = setImportConfig(obj[key], obj);
      _this5[key] = importConfig;
    } else if (key === "childEntities") {
      var childEntities = configureChildEntities({
        entity: obj
      });
      _this5[key] = childEntities;
    } else {
      _this5[key] = obj[key];
    }
  });

  if (obj.fieldsFilters) {
    obj.fieldsFilters.map(function (fieldFilter) {
      if (!fieldFilter.fieldIdentifier) {
        throw new Error("Please provide a field identifier in this fieldFilter (" + fieldFilter.name + ") in " + _this5.pluralName + " entity.");
      }

      var field = _this5.fields.find(function (field) {
        return field.identifier === fieldFilter.fieldIdentifier;
      });

      if (field) {
        field.filters = [].concat(field.filters || [], setFilters([fieldFilter]));
      } else {
        throw new Error("Please make sure that the field identifier provided in fieldFilters is correct(" + fieldFilter.fieldIdentifier + ") in " + _this5.pluralName + " entity.");
      }
    });
  }

  this.get = function (path) {
    return get(this, path);
  };

  this.isExportable = function (path) {
    return get(this, ["export", "enabled"]);
  };

  this.isImportable = function (role) {
    var _this$import,
        _this$import2,
        _this6 = this;

    return ((_this$import = this["import"]) === null || _this$import === void 0 ? void 0 : _this$import.length) > 0 && ((_this$import2 = this["import"]) === null || _this$import2 === void 0 ? void 0 : _this$import2.reduce(function (acc, _, index) {
      return acc || _this6.canRolePerformAction(role, ["import", index, "authorizedRoles"]);
    }, false));
  };

  this.canRolePerformAction = canRolePerformAction;
  this.showAuthFormNotification = this.showAuthFormNotification || false;

  this.canCreate = function (role) {
    return getOptionalFunctionValue(this.allowCreate) && this.canRolePerformAction(role, ["authorizedRoles", "create"]);
  };

  this.canEdit = function (role, dataObject) {
    return (typeof this.allowEdit === "function" && dataObject !== undefined ? this.allowEdit(dataObject) : this.allowEdit) && this.canRolePerformAction(role, ["authorizedRoles", "edit"]);
  };

  this.canDelete = function (role, dataObject) {
    return (typeof this.allowDelete === "function" && dataObject !== undefined ? this.allowDelete(dataObject) : this.allowDelete) && this.canRolePerformAction(role, ["authorizedRoles", "delete"]);
  };

  this.canShow = function (role) {
    return this.canRolePerformAction(role, ["authorizedRoles", "show"]);
  };

  this.canList = function (role) {
    return this.canRolePerformAction(role, ["authorizedRoles", "list"]);
  };

  this.canDeleteMultiple = function (role, dataObject) {
    return (typeof this.allowBulkDelete === "function" && dataObject !== undefined ? this.allowBulkDelete(dataObject) : this.allowBulkDelete) && this.canRolePerformAction(role, ["authorizedRoles", "deleteMultiple"]);
  };

  this.canView = function (role) {
    return !this.isPassive && this.canRolePerformAction(role, ["authorizedRoles", "entity"]) && this.canRolePerformAction(role, ["authorizedRoles", "list"]);
  };

  this.canUse = function (role) {
    return this.isPassive || this.canRolePerformAction(role, ["authorizedRoles", "entity"]) && (this.canRolePerformAction(role, ["authorizedRoles", "list"]) || this.canRolePerformAction(role, ["authorizedRoles", "show"]));
  };

  this.canPreformBulkActions = function (role) {
    return this.canRolePerformAction(role, ["authorizedRoles", "bulkActions"]);
  };

  this.isBulkActionsEnabled = function () {
    var bulkActions = this.getBulkActions();
    return this.allowBulkDelete || (bulkActions === null || bulkActions === void 0 ? void 0 : bulkActions.length) > 0;
  };

  this.getBulkActions = function () {
    var _this$globalActions;

    return (_this$globalActions = this.globalActions) === null || _this$globalActions === void 0 ? void 0 : _this$globalActions.filter(function (action) {
      return ["bulk", "both"].includes(action.type);
    });
  };

  this.canExport = function (role) {
    return this.isExportable() && this.canRolePerformAction(role, ["export", "authorizedRoles"]);
  };

  this.canImport = function (role) {
    return this.canRolePerformAction(role, ["authorizedRoles", "import"]) && this.isImportable(role);
  };

  this.getIdentifier = function () {
    return this.entityIdentifier || "id";
  };

  this.getIdentifierValue = function (dataObject) {
    return dataObject[this.getIdentifier()];
  };

  this.getDisplayName = function (value) {
    return getTranslatedValue(value || this.displayName);
  };

  this.getExportLabel = function () {
    return getTranslatedValue(this.get(["export", "label"])) || i18n.t("dataTable:export");
  };

  this.getSubmitButtonText = function (action) {
    return typeof this.submitButtonText === "function" ? getTranslatedValue(this.submitButtonText(action)) : getTranslatedValue(this.submitButtonText);
  };

  this.getDisplayTitle = function (action) {
    return typeof this.title === "function" ? getTranslatedValue(this.title(action)) : getTranslatedValue(this.title);
  };

  this.getDisplaySubTitle = function (action) {
    return typeof this.subTitle === "function" ? getTranslatedValue(this.subTitle(action)) : getTranslatedValue(this.subTitle);
  };

  this.isDataGrouped = function () {
    return Object.prototype.hasOwnProperty.call(this, "groupBy");
  };

  this.getGroupFormat = function (item) {
    var itemGroup = get(item, this.groupBy);
    return this.formatGroup ? this.formatGroup(itemGroup) : itemGroup;
  };

  this.compareIdentifierValue = function (dataObject, identifier) {
    return this.getIdentifierValue(dataObject) === convertIdType(identifier);
  };

  this.getCustomDataTableRowClass = function (dataObject) {
    return typeof this.customDataTableRowClass === "function" ? this.customDataTableRowClass(dataObject) : this.customDataTableRowClass;
  };

  this.getEndpointForAction = function (action, payload) {
    switch (action) {
      case "create":
        return this.getCreateEndpoint(payload);

      case "edit":
        return this.getCustomEndpointWithId(payload, this.customEditEndpoint);

      case "delete":
        return this.getCustomEndpointWithId(payload, this.customDeleteEndpoint);

      case "show":
        return this.getCustomEndpointWithId(payload, this.customShowEndpoint);

      case "list":
        return this.getListEndpoint(payload, this.customShowEndpoint);

      default:
        return this.endpoint;
    }
  };

  this.getPathnameForAction = function (action) {
    switch (action) {
      case "create":
        return this.isChild ? this.parentEntity.pathName + "/:id/" + this.pathName + "/create" : this.pathName + "/create";

      case "edit":
        return this.isChild ? this.parentEntity.pathName + "/:id/" + this.pathName + "/:childId/edit" : this.pathName + "/:id/edit";

      case "list":
        return this.isChild ? this.parentEntity.pathName + "/:id/" + this.pathName : this.pathName;

      case "show":
        return this.isChild ? this.parentEntity.pathName + "/:id/" + this.pathName + "/:childId" : this.pathName + "/:id";

      default:
        return this.endpoint;
    }
  };

  this.getCreateEndpoint = function (payload) {
    if (this.customCreateEndpoint) return typeof this.customCreateEndpoint === "function" ? this.customCreateEndpoint(payload) : this.customCreateEndpoint;
    var parentPathname = payload.parentPathname,
        recordId = payload.recordId;
    return this.isChild ? adminConfigs.getConfigs().privateRouteURL + "/" + parentPathname + "/" + recordId + "/" + this.endpoint : this.endpoint;
  };

  this.getListEndpoint = function (payload) {
    var isExporting = payload.isExporting,
        parentRecordId = payload.parentRecordId,
        parentPathname = payload.parentPathname;
    return isExporting ? this.endpoint + "." + this.get(["export", "extension"]) : this.isChild ? adminConfigs.getConfigs().privateRouteURL + "/" + parentPathname + "/" + parentRecordId + "/" + this.endpoint + ".json" : this.endpoint + ".json";
  };

  this.getCustomEndpointWithId = function (payload, customEndpoint) {
    var id = payload.id;
    if (customEndpoint) return typeof customEndpoint === "function" ? customEndpoint(payload) : customEndpoint + "/" + id;
    var parentPathname = payload.parentPathname,
        parentRecordId = payload.parentRecordId;
    return this.isChild ? adminConfigs.getConfigs().privateRouteURL + "/" + parentPathname + "/" + parentRecordId + "/" + this.endpoint + "/" + id : this.endpoint + "/" + id;
  };

  this.handleNotification = function (type, dataObject, message) {
    if (dataObject === void 0) {
      dataObject = {};
    }

    if (message === void 0) {
      message = null;
    }

    var _type$split$reverse = type.split(/(?=[A-Z])/).reverse(),
        mainNotificationType = _type$split$reverse[0],
        actionSplitArray = _type$split$reverse.slice(1);

    var action = actionSplitArray.join("");
    var customNotification = this.get(["customNotifications", action, mainNotificationType.toLowerCase()]);

    if (customNotification) {
      var customMessage = customNotification.message,
          customTitle = customNotification.title,
          isCustomSticky = customNotification.isSticky,
          allowCopy = customNotification.allowCopy;
      var isSticky = isCustomSticky === undefined ? this.isStickyNotifications : isCustomSticky;
      var allowCopyNotifications = allowCopy === undefined ? this.allowCopyNotifications : allowCopy;

      var _message = getAccessorValue(dataObject, customMessage, true);

      var title = getAccessorValue(dataObject, customTitle, true);
      return showNotification(this.getDisplayName(), type, _message, title, isSticky, allowCopyNotifications);
    }

    showNotification(this.getDisplayName(), type, message, null, this.isStickyNotifications, this.allowCopyNotifications);
  };

  this.applyCustomRequestParams = function (action, requestParams, routeState) {
    var _this$requestParams, _this$requestParams2;

    if (requestParams === void 0) {
      requestParams = {};
    }

    if (routeState === void 0) {
      routeState = {};
    }

    var customParams = ((_this$requestParams = this.requestParams) === null || _this$requestParams === void 0 ? void 0 : _this$requestParams[action]) || ((_this$requestParams2 = this.requestParams) === null || _this$requestParams2 === void 0 ? void 0 : _this$requestParams2.entity);
    var dataSource = {
      routeState: getJSONValue(routeState)
    };
    var dynamicRequestParams = customParams && Object.keys(customParams).reduce(function (accum, key) {
      if (typeof customParams[key] === "object") {
        if (Array.isArray(customParams[key].value)) accum[key] = get(dataSource, customParams[key].value);
      }

      return accum;
    }, {});
    return _extends({}, customParams, requestParams, dynamicRequestParams);
  };

  this.isReducedPaginationMode = function () {
    if (!this.paginationMode) return adminConfigs.getConfigs().globalPaginationMode === "reduced";
    return this.paginationMode === "reduced";
  };

  this.getSubscribedEvents = function () {
    return this.subscribeTo;
  };

  this.isApiFieldsSource = function () {
    return this.apiFieldSource;
  };

  this.getApiFieldsSourceEndpoint = function (field, params) {
    var filterParamInEndpoint = field.apiFieldConfig.filterParamInEndpoint;
    var identifier = params === null || params === void 0 ? void 0 : params[filterParamInEndpoint];

    if (filterParamInEndpoint) {
      if (!identifier) return null;
      return this.endpoint + "/" + identifier;
    }

    return this.endpoint;
  };

  this.addField = addField;
  this.removeField = removeField;

  this.isAPIEntity = function () {
    return this.apiEntity;
  };

  this.isAPIEntitiesSource = function () {
    return this.APIEntitiesSource;
  };
}

var AuthorizedEntities = function AuthorizedEntities(entities, role) {
  if (Array.isArray(entities)) {
    return entities.filter(function (entity) {
      return entity.canView(role);
    });
  } else {
    return Object.keys(entities).reduce(function (accum, entityName) {
      if (entities[entityName].canView(role) || entities[entityName].canUse(role)) {
        accum[entityName] = entities[entityName];
      }

      return accum;
    }, {});
  }
};

function flattenFields(fields) {
  if (fields === void 0) {
    fields = [];
  }

  return fields.map(function (field) {
    return field.getType() === "dynamic" ? flattenFields(field.fields) : field;
  }).flat();
}

var overrideReferencedFields = function overrideReferencedFields(field, fieldsOverrides) {
  return _extends({}, field, {
    hideInCreate: false,
    hideInEdit: false
  }, fieldsOverrides);
};

var generateReferencedEntity = function generateReferencedEntity(entity, config) {
  var requestParams = entity !== null && entity !== void 0 && entity.requestParams ? entity.requestParams : {};

  if (config) {
    var enableFilters = config.enableFilters,
        enableFieldsFilters = config.enableFieldsFilters,
        enableGlobalActions = config.enableGlobalActions,
        fields = config.fields,
        fieldsFilters = config.fieldsFilters,
        filters = config.filters,
        _config$filterParams = config.filterParams,
        filterParams = _config$filterParams === void 0 ? {} : _config$filterParams,
        fieldsOverrides = config.fieldsOverrides,
        fieldsToBeRemoved = config.fieldsToBeRemoved,
        entityConfig = _objectWithoutPropertiesLoose(config, _excluded$7);

    var entityFilters = enableFilters && (filters ? entity.filters.filter(function (filterField) {
      return filters.includes(filterField.name);
    }) : entity.filters);
    var entityFieldsFilters = enableFieldsFilters && (fieldsFilters ? entity.filters.filter(function (filterField) {
      return fieldsFilters.includes(filterField.name);
    }) : entity.fieldsFilters);
    var entityFields = fields && entity.fields.filter(function (field) {
      return fields.includes(field.identifier);
    }) || fieldsOverrides && entity.fields.filter(function (field) {
      return fieldsOverrides[field.identifier];
    }).map(function (field) {
      return overrideReferencedFields(field, fieldsOverrides[field.identifier]);
    }) || entity.fields || [];
    var entityGlobalActions = enableGlobalActions && entity.globalActions;
    var customFilterParams = Array.isArray(filterParams) ? {
      entity: {}
    } : {
      entity: _extends({}, filterParams)
    };
    if (!Array.isArray(filterParams)) console.warn("filterParams of type object will be deprecated soon, please use filterParams of type array");
    return new Entity(_extends({}, entity, {
      allowCreate: false,
      showRowActions: false,
      isPassive: true,
      isReferenced: true,
      showSearch: false,
      filters: entityFilters,
      fields: entityFields,
      fieldsFilters: entityFieldsFilters,
      globalActions: entityGlobalActions
    }, entityConfig, {
      requestParams: _extends({}, customFilterParams, requestParams),
      fieldsToBeRemoved: fieldsToBeRemoved
    }));
  }

  return new Entity(_extends({}, entity, {
    isPassive: true,
    isReferenced: true
  }));
};

var generateSelectReferencedEntiy = function generateSelectReferencedEntiy(_ref8) {
  var _extends4;

  var acc = _ref8.acc,
      current = _ref8.current,
      entities = _ref8.entities;
  var selectReferenceName = current.filterType === "columnFilter" ? "columnFilter_" + current.selectConfig.optionsEntity.name + "_" + current.parentEntity.name + "_" + current.name : "filter_" + current.selectConfig.optionsEntity.name + "_" + current.parentEntity.name + "_" + current.name;
  return _extends({}, acc, (_extends4 = {}, _extends4[selectReferenceName] = generateReferencedEntity(_extends({}, entities[current.selectConfig.optionsEntity.name], {
    parentEntity: current.parentEntity,
    dynamicFilters: null,
    isFilter: true,
    filterName: current.name,
    filterType: current.filterType
  })), _extends4));
};

var generateTableReferencedEntiy = function generateTableReferencedEntiy(_ref9) {
  var _extends5;

  var acc = _ref9.acc,
      current = _ref9.current,
      entities = _ref9.entities;

  var _current$tableConfig = current.tableConfig,
      configs = _objectWithoutPropertiesLoose(_current$tableConfig, _excluded2);

  return _extends({}, acc, (_extends5 = {}, _extends5["table_" + current.tableConfig.name + "_" + current.parentEntity.name + "_" + current.identifier] = generateReferencedEntity(entities[current.tableConfig.name], _extends({}, configs, {
    fieldsToBeRemoved: [{
      name: "id",
      basedOn: "new"
    }, {
      name: "new",
      basedOn: "new"
    }]
  })), _extends5));
};

var generateFormModalReferencedEntiy = function generateFormModalReferencedEntiy(_ref10) {
  var _current$entityConfig, _extends6;

  var acc = _ref10.acc,
      current = _ref10.current,
      entities = _ref10.entities;
  return _extends({}, acc, (_extends6 = {}, _extends6["rowAction_" + current.entityConfig.name + "_" + current.parentEntity.name + "_" + current.identifier] = generateReferencedEntity(entities[current.entityConfig.name], _extends({
    fieldsOverrides: current.entityConfig.fieldsOverrides,
    allowCreate: true,
    allowEdit: true,
    enableFilters: true,
    enableFieldsFilters: true,
    showSearch: entities[current.entityConfig.name].showSearch
  }, (_current$entityConfig = current.entityConfig) === null || _current$entityConfig === void 0 ? void 0 : _current$entityConfig.entityOverrides)), _extends6));
};

var generateAPIFieldReferencedEntity = function generateAPIFieldReferencedEntity(_ref11) {
  var _extends7;

  var acc = _ref11.acc,
      current = _ref11.current,
      entities = _ref11.entities;
  var sourceEndpoint = current.apiFieldSourceEndpoint();
  var entity = sourceEndpoint ? new Entity({
    endpoint: sourceEndpoint
  }) : entities[current.apiFieldConfig.dataSource.entity];
  return _extends({}, acc, (_extends7 = {}, _extends7[current.getAPIFieldReferencedEntityName()] = generateReferencedEntity(entity, {
    apiFieldSource: true
  }), _extends7));
};

var getReferencedEntityFromFieldType = function getReferencedEntityFromFieldType(field, entities, parentEntity) {
  switch (field.type) {
    case "table":
    case "scannableTable":
      return entities[field.tableConfig.name];

    case "api":
      var dataSource = field.apiFieldConfig.dataSource;
      return dataSource.entity ? entities[dataSource.entity] : generateReferencedEntity(parentEntity, {
        apiFieldsSource: true
      });

    default:
      return entities[field.optionsEntity.name];
  }
};

function setReferencedEntities(entities) {
  var referenceFieldsAndFilters = Object.keys(entities).reduce(function (acc, entityName) {
    return [].concat(acc, (flattenFields(entities[entityName].fields) || []).filter(function (field) {
      return field.isDynamic();
    }).map(function (field) {
      var parentEntity = entities[entityName];
      var referencedEntity = getReferencedEntityFromFieldType(field, entities, parentEntity);
      field.setReferencedEntity(referencedEntity);
      return _extends({}, field, {
        parentEntity: entities[entityName]
      });
    }), (entities[entityName].filters || []).filter(function (filter) {
      return filter.type === "select" && filter.selectConfig.optionsType === "dynamic";
    }).map(function (filter) {
      return _extends({}, filter, {
        parentEntity: entities[entityName]
      });
    }), (entities[entityName].fieldsFilters || []).filter(function (filter) {
      return filter.type === "select" && filter.selectConfig.optionsType === "dynamic";
    }).map(function (filter) {
      return _extends({}, filter, {
        filterType: "columnFilter",
        parentEntity: entities[entityName]
      });
    }), (entities[entityName].rowActions || []).filter(function (action) {
      return action.type === "formModal" && action.entityConfig;
    }).map(function (action) {
      return _extends({}, action, {
        parentEntity: entities[entityName]
      });
    }));
  }, []);
  return referenceFieldsAndFilters.reduce(function (acc, current) {
    var _extends8;

    switch (current.type) {
      case "select":
        return generateSelectReferencedEntiy({
          acc: acc,
          current: current,
          entities: entities
        });

      case "table":
        return generateTableReferencedEntiy({
          acc: acc,
          current: current,
          entities: entities
        });

      case "scannableTable":
        {
          return generateTableReferencedEntiy({
            acc: acc,
            current: current,
            entities: entities
          });
        }

      case "formModal":
        return generateFormModalReferencedEntiy({
          acc: acc,
          current: current,
          entities: entities
        });

      case "api":
        return generateAPIFieldReferencedEntity({
          acc: acc,
          current: new ApiFieldDecorator(current),
          entities: entities
        });

      default:
        return _extends({}, acc, (_extends8 = {}, _extends8["field_" + current.optionsEntity.name + "_" + current.parentEntity.name + "_" + current.identifier] = generateReferencedEntity(entities[current.optionsEntity.name], current === null || current === void 0 ? void 0 : current.entityOverrides), _extends8));
    }
  }, {});
}

function setDashBoardEntities(entities, dashboardConfig) {
  if (!dashboardConfig) return null;
  var dashboardEntities = dashboardConfig.groups.reduce(function (accum, group) {
    var dashboardEntities = group.components.reduce(function (groupAccum, _ref12) {
      var _dashboardEntity;

      var _ref12$config = _ref12.config,
          config = _ref12$config === void 0 ? {} : _ref12$config;

      var entity = config.entity,
          identifier = config.identifier,
          configs = _objectWithoutPropertiesLoose(config, _excluded3);

      if (!entity) return groupAccum;
      var dashboardEntity = (_dashboardEntity = {}, _dashboardEntity["dashboard_" + entity + "_" + identifier] = generateReferencedEntity(entities[entity], _extends({}, configs)), _dashboardEntity);
      return _extends({}, groupAccum, dashboardEntity);
    }, {});
    return _extends({}, accum, dashboardEntities);
  }, {});
  return dashboardEntities;
}

var generateReferencedEntityCustomName = function generateReferencedEntityCustomName(referenceType, entityName, parentEntityName, identifier) {
  switch (referenceType) {
    case "dashboard":
      return "dashboard_" + entityName + "_" + identifier;

    case "rowAction":
      return referenceType + "_" + entityName + "_" + parentEntityName + "_" + identifier;

    case "table":
      return "table_" + entityName + "_" + parentEntityName + "_" + identifier;

    default:
      return referenceType + "_" + entityName + "_" + parentEntityName + "_" + identifier;
  }
};

var general = {
  back: "Back",
  viewFile: "View File",
  edit: "Edit",
  create: "Create",
  search: "Search . . .",
  view: "View"
};
var homePage = {
  logIn: "Login to your account",
  email: "Email",
  password: "Password"
};
var actionButton = {
  ok: "Ok",
  cancel: "Cancel"
};
var authGenerator = {
  forgotPassword: "Forgot Password?",
  resendConfirmationLink: "Resend Confirmation Link",
  accessDenied: "Access is not allowed"
};
var dashboard = {
  description: "Here you can see all entities related to your web app as well as analytics charts.",
  yourEntities: "Your entities",
  welcome: "Welcome {{name}}",
  ungrouped: "General",
  error: "something went wrong"
};
var dataForm = {
  update: "Update",
  "delete": "Delete",
  undoDeletion: "Undo Deletion",
  upload: "Upload",
  remove: "Remove",
  image: "image",
  video: "video",
  file: "file",
  change: "change",
  fromGallery: "From gallery",
  choose: "choose",
  notSet: "not set",
  choices: "Choices",
  selected: "selected",
  loading: "Loading...",
  add: "Add",
  countryCode: "Country Code",
  phoneNumber: "Number",
  create: "Create {{name}}",
  edit: "Edit {{name}}",
  search: "Search",
  chooseFile: "Choose a file",
  useSelector: "Use the selector to adjust your image",
  placeHolderMediaName: "Example: Image for Product..."
};
var dataTable = {
  deleteConfirmationMessage: "Are you sure you want to delete?",
  actions: "Actions",
  "import": "Import",
  "export": "Export",
  reset: "Clear Filters",
  save: "save",
  expand: "See more",
  collapse: "See less",
  filter: "Filter",
  searchField: "Search {{label}}...",
  Filters: "Filters",
  insert_row: "Insert row"
};
var header = {
  logout: "Logout",
  language: "ع"
};
var footer = {
  contactNumber: "Contact Number: {{number}}"
};
var notifications = {
  error: "Error",
  errorMsg: "There was an error",
  success: "Success",
  passwordReset: "Password has been reset successfully",
  createSuccess: "{{entity}} created successfully",
  editSuccess: "{{entity}} updated successfully",
  deleteSuccess: "{{entity}} deleted successfully",
  importSuccess: "{{entity}} imported successfully",
  createError: "There was an error creating {{entity}}",
  showError: "There was an error showing {{entity}}",
  editError: "There was an error updating {{entity}}",
  deleteError: "There was an error deleting {{entity}}",
  importError: "There was an error importing {{entity}}",
  exportError: "There was an error exporting {{entity}}",
  listError: "There was an error listing {{entity}}",
  copyTitle: "(Click to copy)",
  copiedTitle: "Copied to clipboard",
  copiedBody: "You can now paste the content",
  formError: "Please fill out all the required fields"
};
var select = {
  noOptions: "No options",
  selectPlaceholder: "Select..."
};
var maps = {
  searchPlaceholder: "Search for your location"
};
var layout = {
  ungrouped: "General",
  searchEntities: " Search entities",
  mainRouteName: "Dashboard",
  extra: "Extra",
  chat: "Chat"
};
var formErrors = {
  requiredFields: "This field is required"
};
var unhandledErrors = {
  error: "something went wrong"
};
var scannableTable = {
  labels: {
    add: "Add Code or Serial Number",
    remove: "Remove Code",
    count: "Added: "
  },
  feedback: {
    add: "New item added successfully",
    remove: "Item removed successfully"
  },
  errors: {
    added: "This item is already added",
    notFound: "This item is not found"
  }
};
var chat = {
  selectConversation: "Select a conversation",
  searchConversations: "Search conversations",
  send: "Send",
  firstMessage: "No messages sent",
  sentAttachment: "sent an attachment",
  isTyping: "typing...",
  areTyping: "are typing",
  writeMessage: "Write your message",
  formatRelative: {
    today: "'Today'",
    yesterday: "'Yesterday'",
    lastWeek: "eeee",
    other: "MMM dd, yyyy"
  },
  broadcast: "Broadcast",
  noContactsFound: "No contacts found",
  contactsTitle: "Contacts",
  selectAll: "Select All"
};
var englishTranslations = {
  general: general,
  homePage: homePage,
  actionButton: actionButton,
  authGenerator: authGenerator,
  dashboard: dashboard,
  dataForm: dataForm,
  dataTable: dataTable,
  header: header,
  footer: footer,
  notifications: notifications,
  select: select,
  maps: maps,
  layout: layout,
  formErrors: formErrors,
  unhandledErrors: unhandledErrors,
  scannableTable: scannableTable,
  chat: chat
};
var general$1 = {
  back: "رجوع",
  viewFile: "عرض الملف",
  edit: "تعديل",
  create: "انشاء",
  search: "بحث ٠ ٠ ٠",
  view: "عرض"
};
var homePage$1 = {
  logIn: "تسجيل الدخول للحساب",
  email: "البريد الإلكتروني",
  password: "كلمة المرور"
};
var actionButton$1 = {
  ok: "استمرار",
  cancel: "الغاء"
};
var authGenerator$1 = {
  forgotPassword: "نسيت كلمة المرور؟",
  resendConfirmationLink: "اعادة ارسال رابط التأكيد",
  accessDenied: "لا يمكنك الدخول الي هذه الصفحة"
};
var dashboard$1 = {
  description: "هنا يمكنك رؤية جميع الكيانات المتعلقة بتطبيق الويب الخاص بك وكذلك مخططات التحليلات٠",
  yourEntities: "كياناتك",
  welcome: "اهلا بك يا {{name}}",
  ungrouped: "عام"
};
var dataForm$1 = {
  update: "تحديث",
  "delete": "حذف",
  undoDeletion: "الغاء الحذف",
  upload: "رفع",
  remove: "حذف",
  image: "صورة",
  video: "فيديو",
  file: "ملف",
  change: "تغيير",
  fromGallery: "من معرض الصور",
  choose: "اختيار",
  notSet: "غير محدد",
  choices: "اختيارات",
  selected: "اختيار",
  loading: "تحميل٠٠٠",
  add: "اضافة",
  countryCode: "كود البلد",
  phoneNumber: "رقم",
  create: "انشاء {{name}}",
  edit: "تعديل {{name}}",
  search: "بحث",
  chooseFile: "اختر ملف",
  useSelector: "استخدم المنقار لتغير الصورة",
  placeHolderMediaName: "مثال: صورة للمنتج ..."
};
var dataTable$1 = {
  deleteConfirmationMessage: "هل انت متأكد من الحذف؟",
  actions: "اجراءات",
  "import": "رفع ملف",
  "export": "تحميل ملف",
  reset: "مسح الكل",
  save: "حفظ",
  expand: "رؤية المزيد",
  collapse: "اغلق",
  filter: "تصفية",
  searchField: "بحث {{label}}...",
  Filters: "منقي",
  insert_row: "اضافة"
};
var header$1 = {
  logout: "تسجيل خروج",
  language: "E"
};
var footer$1 = {
  contactNumber: "رقم الاتصال: {{number}}"
};
var notifications$1 = {
  error: "خطأ",
  errorMsg: "هناك خطأ ما",
  success: "تم بنجاح",
  passwordReset: "تم إعادة تعيين كلمة المرور الخاصة بك",
  createSuccess: "{{entity}} تم إنشاء بنجاح",
  editSuccess: "{{entity}} تم تعديل بنجاح",
  deleteSuccess: "{{entity}} تم مسح بنجاح",
  importSuccess: "{{entity}} تم رفع ملف",
  createError: "خطأ فى انشاء {{entity}}",
  showError: "خطأ فى اظهار {{entity}}",
  editError: "خطأ فى تعديل {{entity}}",
  deleteError: "خطأ فى مسح {{entity}}",
  importError: "خطأ فى رفع {{entity}}",
  exportError: "خطأ فى تحميل {{entity}}",
  listError: "خطأ فى اظهار قائمة {{entity}}",
  copyTitle: "(انقر للنسخ)",
  copiedTitle: "تم النسخ الي الحافظة",
  copiedBody: "يمكنك الآن نقل المحتوى",
  formError: "يرجى ملء جميع الخانات المطلوبة"
};
var select$1 = {
  noOptions: "لا خيارات",
  selectPlaceholder: "اختار..."
};
var maps$1 = {
  searchPlaceholder: "البحث عن المكان"
};
var layout$1 = {
  ungrouped: "عام",
  searchEntities: " البحث عن المجموعات",
  mainRouteName: "لوحة القيادة",
  extra: "إضافي"
};
var formErrors$1 = {
  requiredFields: "هذه الخانة مطلوبه"
};
var unhandledErrors$1 = {
  error: "هناك خطأ ما"
};
var scannableTable$1 = {
  labels: {
    add: "إضافة كود الشحنة أو رقم المسلسل",
    remove: "حذف الشحنة",
    count: "مضاف:"
  },
  feedback: {
    add: "تمت إضافة عنصر جديد بنجاح",
    remove: "تمت إزالة العنصر بنجاح"
  },
  errors: {
    added: "تمت إضافة هذا العنصر بالفعل",
    notFound: "لم يتم العثور على هذا العنصر"
  }
};
var chat$1 = {
  selectConversation: "حدد محادثة",
  searchConversations: "البحث عن المحادثات",
  send: "أرسل",
  firstMessage: "لم يتم إرسال أي رسالة",
  sentAttachment: "أرسل مرفقًا",
  isTyping: "كتابة ...",
  areTyping: "يكتبون",
  writeMessage: "اكتب رسالتك",
  formatRelative: {
    today: "'اليوم'",
    yesterday: "'الامس'",
    lastWeek: "eeee",
    other: "MMM dd, yyyy"
  },
  broadcast: "إذاعة",
  noContactsFound: "لم يتم العثور على جهات اتصال",
  contactsTitle: "جهات الاتصال",
  selectAll: "اختر الكل"
};
var arabicTranslations = {
  general: general$1,
  homePage: homePage$1,
  actionButton: actionButton$1,
  authGenerator: authGenerator$1,
  dashboard: dashboard$1,
  dataForm: dataForm$1,
  dataTable: dataTable$1,
  header: header$1,
  footer: footer$1,
  notifications: notifications$1,
  select: select$1,
  maps: maps$1,
  layout: layout$1,
  formErrors: formErrors$1,
  unhandledErrors: unhandledErrors$1,
  scannableTable: scannableTable$1,
  chat: chat$1
};
var resources = {
  en: englishTranslations,
  ar: arabicTranslations
};

function initTranslation(resources) {
  i18n.use(LanguageDetector).use(initReactI18next).init({
    resources: resources,
    ns: ["common"],
    defaultNS: "common",
    languages: Object.keys(resources),
    fallbackLng: "en",
    load: "currentOnly",
    whitelist: Object.keys(resources)
  });
}

var generateEntities = function generateEntities(entities, role) {
  return new AuthorizedEntities(entities, role);
};

var generateGroups = function generateGroups(groups, role) {
  return groups.map(function (group) {
    return _extends({}, group, {
      entities: new AuthorizedEntities(group.entities, role)
    });
  });
};

var createActions$1 = function createActions(entityName) {
  return {
    request: createAction(entityName + "/request"),
    success: createAction(entityName + "/success"),
    failure: createAction(entityName + "/failure")
  };
};

var authAction = createActions$1("authActions");
var authActionShow = createActions$1("authActionShow");
var resetReducer = createAction("resetReducer");
var logout = createAction("logout");
var updateAuth = createAction("updateAuth");

var _templateObject$5, _templateObject2$4, _templateObject3$3;

var StyledMenuBar = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  background-image: ", ";\n  background-size: cover;\n  & svg: {\n    color: ", ";\n  }\n  box-shadow: ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding-left: 24px;\n  padding-right: 24px;\n  justify-content: center;\n  @media only screen and (max-width: ", ") {\n    justify-content: center !important;\n    padding-left: 10px;\n    padding-right: 10px;\n    align-items: ", ";\n  }\n  .logo {\n    ", ";\n    ", ";\n    display: inline-block;\n    img {\n      ", ";\n      ", ";\n    }\n    @media only screen and (max-width: ", ") {\n      position: absolute;\n    }\n  }\n\n  .ant-btn-text > span {\n    color: ", ";\n  }\n  .burger-menu {\n    .anticon {\n      font-size: 20px;\n    }\n    margin: 0 5px;\n  }\n"])), function (props) {
  return props.theme.header.background || props.theme.colors.background;
}, function (props) {
  return props.theme.header.backgroundImage ? "url(" + props.theme.header.backgroundImage + ")" : "";
}, function (props) {
  return props.theme.colors.main;
}, function (props) {
  return props.theme.header.enableBoxShadow && "0px 0px 8px rgba(0, 0, 0, 0.6)";
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.isNotificationIconVisible ? "center" : "baseline";
}, function (props) {
  return props.theme.header.logoWidth ? "width: " + props.theme.header.logoWidth : "max-width: 150px";
}, function (props) {
  return props.theme.header.logoHeight && "height: " + props.theme.header.logoHeight;
}, function (props) {
  return props.theme.header.logoWidth ? "width: " + props.theme.header.logoWidth : "max-width: 150px";
}, function (props) {
  return props.theme.header.logoHeight && "height: " + props.theme.header.logoHeight;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.header.color || props.theme.colors.main;
});
var ActionButtonsWrapper = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n  ", "\n  .ant-btn {\n    margin: 0 5px;\n  }\n  ", ";\n"])), function (props) {
  return props.direction === "rtl" ? "margin-right: auto;" : "margin-left: auto;";
}, function (props) {
  return props.isNotificationIconVisible && "display: flex;\n  align-items: center";
});
var NotificationsWrapper = styled.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n  margin: 0 5px;\n"])));

var Image = function Image(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      customClass = _ref.customClass;
  return /*#__PURE__*/React__default.createElement("img", {
    src: src,
    alt: alt,
    className: customClass
  });
};

Image.propTypes = {
  src: propTypes.string.isRequired,
  alt: propTypes.string,
  customClass: propTypes.string
};
Image.defaultProps = {
  alt: ""
};
var eventAPIMapping = {
  update: "edit",
  destroy: "delete"
};

var useEventSubscriber = function useEventSubscriber(externalOnReceiveNotification) {
  var dispatch = useDispatch();

  var _useContext = useContext(AppContext),
      entities = _useContext.entities;

  var onReceiveNotification = useCallback(function (notification) {
    var _entitiesActions$enti, _entitiesActions$enti2;

    var eventKey = notification.event_key,
        dataObject = notification.data_object;

    var _splitFirstCharacter = splitFirstCharacter(eventKey, "_"),
        event = _splitFirstCharacter[0],
        snakeCaseEntityName = _splitFirstCharacter[1];

    var entityName = camelizeFromSnakeCase(snakeCaseEntityName);
    var action = (_entitiesActions$enti = entitiesActions[entityName]) === null || _entitiesActions$enti === void 0 ? void 0 : (_entitiesActions$enti2 = _entitiesActions$enti.eventSubscriptions) === null || _entitiesActions$enti2 === void 0 ? void 0 : _entitiesActions$enti2[eventAPIMapping[event] || event];
    if (action) dispatch(action(dataObject[entityName]));
    externalOnReceiveNotification && externalOnReceiveNotification(notification);
  }, [externalOnReceiveNotification, entities, dispatch]);
  return onReceiveNotification;
};

var _excluded$8 = ["disableMenu", "disableActionsMenu", "toggleCollapse", "isNotAuthenticated", "className", "isCollapsed"];

var Header = function Header(_ref) {
  var disableMenu = _ref.disableMenu,
      disableActionsMenu = _ref.disableActionsMenu,
      toggleCollapse = _ref.toggleCollapse,
      isNotAuthenticated = _ref.isNotAuthenticated,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      isCollapsed = _ref.isCollapsed,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  var _useContext = useContext(AppContext),
      authEntities = _useContext.authEntities,
      authConfig = _useContext.authConfig,
      availableLanguages = _useContext.availableLanguages,
      fullLogo = _useContext.fullLogo,
      privateRouteURL = _useContext.privateRouteURL,
      disableLocalization = _useContext.disableLocalization,
      logoLink = _useContext.logoLink,
      removeLocaleFromHeader = _useContext.removeLocaleFromHeader,
      notificationConfigs = _useContext.notificationConfigs,
      theme = _useContext.theme;

  var _useTranslation = useTranslation("header"),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var dispatch = useDispatch();

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var isMedium = useMedia("(max-width:" + theme.breakpoints.md + ")");
  var authEntity = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var auth = authEntity === null || authEntity === void 0 ? void 0 : authEntity[authConfig.name];
  var isNotificationIconVisible = notificationConfigs.enabled,
      externalOnReceiveNotification = notificationConfigs.onReceiveNotification;
  var onReceiveNotification = useEventSubscriber(externalOnReceiveNotification);

  var logoutHandler = function logoutHandler() {
    dispatch(logout());
  };

  var authActionsHandler = function authActionsHandler(entity) {
    dispatch(push(getURL(privateRouteURL, entity.path)));
  };

  useEffect(function () {
    if (isMedium && !isCollapsed) toggleCollapse();
  }, [pathname]);
  var dropDownMenu = /*#__PURE__*/React__default.createElement(_Menu, {
    selectable: true
  }, Object.values(authEntities).filter(function (entity) {
    return !entity.hideFromNavbar && !entity.showInSidebar && (entity.action !== "create" || entity.requestConfig.authenticated) && (!entity.preventAccess || !entity.preventAccess(auth));
  }).map(function (entity, index) {
    return /*#__PURE__*/React__default.createElement(_Menu.Item, {
      key: index,
      onClick: function onClick() {
        return authActionsHandler(entity);
      }
    }, getTranslatedValue(entity.title));
  }), /*#__PURE__*/React__default.createElement(_Menu.Item, {
    onClick: logoutHandler
  }, t("logout")));

  var renderMenuControl = function renderMenuControl() {
    return /*#__PURE__*/React__default.createElement(Fragment, null, !disableMenu && !isNotAuthenticated && /*#__PURE__*/React__default.createElement(_Button, {
      icon: /*#__PURE__*/React__default.createElement(MenuOutlined$2, null),
      type: "text",
      shape: "circle",
      onClick: toggleCollapse,
      className: "burger-menu"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "logo"
    }, isNotAuthenticated ? /*#__PURE__*/React__default.createElement("a", {
      href: logoLink
    }, /*#__PURE__*/React__default.createElement(Image, {
      src: fullLogo
    })) : /*#__PURE__*/React__default.createElement(Link, {
      to: privateRouteURL
    }, /*#__PURE__*/React__default.createElement(Image, {
      src: fullLogo
    }))));
  };

  var renderHeaderActions = function renderHeaderActions() {
    return /*#__PURE__*/React__default.createElement(ActionButtonsWrapper, {
      isNotificationIconVisible: isNotificationIconVisible,
      direction: i18n.dir()
    }, isNotificationIconVisible && /*#__PURE__*/React__default.createElement(NotificationsWrapper, null, /*#__PURE__*/React__default.createElement(NotificationCenter, {
      align: i18n.dir() === "ltr" ? "right" : "left",
      displayAsLink: notificationConfigs.displayAsLink,
      onReceiveNotification: onReceiveNotification
    })), !disableLocalization && !removeLocaleFromHeader && availableLanguages.length > 1 && /*#__PURE__*/React__default.createElement(_Button, {
      shape: "circle",
      onClick: toggleLanguage,
      type: "text"
    }, t("language")), !disableActionsMenu && /*#__PURE__*/React__default.createElement(_Dropdown, {
      overlay: dropDownMenu,
      placement: "bottomCenter"
    }, /*#__PURE__*/React__default.createElement(_Button, {
      shape: "circle",
      icon: theme.header.customSettingsIcon || /*#__PURE__*/React__default.createElement(SettingFilled$2, null),
      type: "text"
    })));
  };

  return /*#__PURE__*/React__default.createElement(StyledMenuBar, {
    isNotificationIconVisible: isNotificationIconVisible,
    className: className
  }, isNotificationIconVisible ? /*#__PURE__*/React__default.createElement("div", null, renderMenuControl(), " ") : renderMenuControl(), !isNotAuthenticated && renderHeaderActions());
};

var Header$1 = withRouter(Header);

var _templateObject$6, _templateObject2$5, _templateObject3$4, _templateObject4$3, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2, _templateObject14$2, _templateObject15$2, _templateObject16$2, _templateObject17$2, _templateObject18$1;

var AuthContainer = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  input {\n    font-size: 16px;\n  }\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 10%;\n  width: 100%;\n  display: flex;\n  align-items: ", ";\n  flex-direction: column;\n  ", ";\n  ::-webkit-scrollbar {\n    ", ";\n    width: 4px;\n    border-width: 1px;\n    border-color: ", ";\n  }\n  ::-webkit-scrollbar-track {\n    background: ", ";\n  }\n  ::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 10px;\n  }\n  ::-webkit-scrollbar-thumb:hover {\n    background: ", ";\n  }\n\n  .ant-typography {\n    margin-bottom: 10px;\n  }\n  .ant-typography-secondary {\n    color: ", ";\n  }\n  span.ant-typography {\n    font-weight: 300;\n    text-align: center;\n    display: block;\n  }\n  .ant-form-item-no-colon {\n    color: ", ";\n  }\n"])), function (props) {
  return props.isFullWidth ? "flex-start" : "center";
}, function (props) {
  return props.isFullWidth && css(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n      align-items: flex-start;\n    "])));
}, function (props) {
  return props.isFullWidth && css(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n        display: none;\n      "])));
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.isFullWidth ? props.theme.colors.background : props.theme.colors.main;
}, function (props) {
  return props.isFullWidth ? props.theme.colors.background : props.theme.colors.main;
});
var AuthLayoutWrapper = styled.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n  direction: ltr;\n  height: ", ";\n  display: flex;\n  flex-direction: row;\n  background-color: ", ";\n  overflow: hidden;\n  ", ";\n  ", ";\n  .auth-landing-section {\n    width: 50%;\n    @media only screen and (max-width: ", ") {\n      width: 100%;\n    }\n  }\n  @media only screen and (max-width: ", ") {\n    ", ";\n  }\n"])), function (props) {
  return props.isFullHeight ? "100%" : "100vh";
}, function (props) {
  return props.theme.colors.background;
}, function (props) {
  return props.isFullWidth && css(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n      background-color: ", ";\n    "])), function (props) {
    return props.theme.colors.main;
  });
}, function (props) {
  return props.showLandingSection && css(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n      overflow-y: auto;\n    "])));
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.showLandingSection && css(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n        flex-direction: column;\n      "])));
});
var AuthFormWrapper = styled.div(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  width: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  transform: translateY(200px);\n  opacity: 0;\n  -webkit-animation: slide 0.5s forwards;\n  animation: slide 0.5s forwards;\n  position: relative;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);\n  @keyframes slide {\n    0% {\n      transform: translateY(200px);\n      opacity: 0;\n    }\n    100% {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n  direction: ", ";\n  ", ";\n  ", ";\n\n  @media only screen and (max-width: ", ") {\n    width: 100%;\n    z-index: 2;\n    background-color: ", ";\n    ", ";\n  }\n"])), function (props) {
  return props.theme.colors.background;
}, function (props) {
  return props.isFullWidth ? "100%" : "50%";
}, function (props) {
  return props.direction;
}, function (props) {
  return props.isAuthenticated && css(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n      width: 100%;\n      overflow-y: auto;\n    "])));
}, function (props) {
  return props.isFullWidth && css(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteralLoose(["\n      background-color: ", ";\n      justify-content: flex-start;\n    "])), props.theme.colors.main);
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return !props.showLandingSection && Color(props.theme.colors.background).fade(0.2).toString();
}, function (props) {
  return props.isFullWidth && !props.showLandingSection && css(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteralLoose(["\n        background-color: transparent;\n      "])));
});
var AuthImage = styled.div(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteralLoose(["\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  flex: 1;\n\n  @media only screen and (max-width: ", ") {\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    background-color: transparent;\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    -webkit-filter: blur(2px);\n    -moz-filter: blur(2px);\n    -o-filter: blur(2px);\n    -ms-filter: blur(2px);\n    filter: blur(2px);\n  }\n"])), function (props) {
  return props.landing;
}, function (props) {
  return props.theme.breakpoints.md;
});
var AuthLogo = styled.div(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n\n  animation: float 1s cubic-bezier(0.79, 0.14, 0.15, 0.86) infinite alternate;\n  -webkit-animation: float 1s cubic-bezier(0.79, 0.14, 0.15, 0.86) infinite alternate;\n\n  @-webkit-keyframes float {\n    0% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(-2px);\n    }\n  }\n  @keyframes float {\n    0% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(-2px);\n    }\n  }\n"])), function (props) {
  return props.theme.authLogo.width;
}, function (props) {
  return props.theme.authLogo.height;
}, function (props) {
  return props.logo;
});
var TitleWrapper = styled.div(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-start;\n  margin-bottom: 30px;\n  direction: ltr;\n"])));
var Title$1 = styled.div(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteralLoose(["\n  white-space: pre;\n  padding-left: 20px;\n  margin-left: 40px;\n  line-height: 30px;\n  border-left: 1px solid ", ";\n  .ant-typography {\n    color: ", ";\n    margin: 0 !important;\n  }\n  h4.ant-typography {\n    font-weight: 300;\n    direction: ltr;\n  }\n"])), function (props) {
  return props.theme.colors.main;
}, function (props) {
  return props.theme.colors.main;
});
var Popups = styled.div(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteralLoose(["\n  opacity: ", ";\n  transition: all 0.5s ease-in-out;\n"])), function (props) {
  return props.children ? 1 : 0;
});
var ForgetLink = styled(Link)(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  margin: 5px;\n"])), function (props) {
  return props.isfullwidth ? props.theme.colors.background : props.theme.colors.main;
});
var HeaderComponent = styled.div(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 20px;\n  direction: ltr;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 60px;\n  color: ", ";\n  button {\n    color: ", ";\n    padding: 0;\n    font-size: 25px;\n  }\n  button:hover,\n  button:active,\n  button:focus {\n    color: ", ";\n  }\n  .lng-btn {\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.main;
}, function (props) {
  return props.theme.colors.main;
}, function (props) {
  return props.theme.colors.main;
}, function (props) {
  return props.isFullHeight ? "black" : props.theme.colors.main;
});

var createCredentials = function createCredentials(auth, requestConfig) {
  var _Object$keys$reduce;

  var payloadWrapper = requestConfig.payloadWrapper;
  if (!payloadWrapper) return auth;
  var fields = payloadWrapper.fields,
      name = payloadWrapper.name;
  var credentials = Object.keys(auth).reduce(function (acc, key) {
    if (fields.includes(key)) acc[name][key] = auth[key];else acc[key] = auth[key];
    return acc;
  }, (_Object$keys$reduce = {}, _Object$keys$reduce[name] = {}, _Object$keys$reduce));
  return credentials;
};

var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};

var usePrepopulation = function usePrepopulation(field, onChange, state, value, action, data, errors) {
  var dispatch = useDispatch();

  var _useReactRouter = useReactRouter(),
      location = _useReactRouter.location,
      match = _useReactRouter.match;

  var _useContext = useContext(AppContext),
      entities = _useContext.entities,
      authConfig = _useContext.authConfig;

  var prepopulationReduxState = useSelector(function (reduxState) {
    return field.isPrepopulated(action, data, state) && field.prepopulationConfig.source === "reduxState" && getEntity(reduxState, entities[field.prepopulationConfig.entityName].pluralName);
  });
  var prepopulationAuth = useSelector(function (reduxState) {
    return field.isPrepopulated(action, data, state) && field.prepopulationConfig.source === "auth" && getEntity(reduxState, "auth")[authConfig.name];
  });
  var prepopulationValue = field.isPrepopulated(action, data, state) && field.getPrepopulationValue(state, location.state, match.params, prepopulationReduxState, prepopulationAuth);
  var prevPrepopulationValue = usePrevious(errors);

  var getDefaultStateValue = function getDefaultStateValue(field) {
    var fieldType = field.getType();
    if (fieldType === "dynamic") return field.preventMultiple ? {} : [];
    return "";
  };

  useEffect(function () {
    var defaultValue = isEmpty$1(errors) || prevPrepopulationValue !== undefined ? getDefaultStateValue(field) : state === null || state === void 0 ? void 0 : state[field.identifier];

    if (field.isPrepopulated(action, data, state)) {
      var newValue = prepopulationValue === undefined ? defaultValue : prepopulationValue;
      onChange(field, newValue);
      var equalVirtualFields = field.getEqualVirtualFields(data);

      if (newValue && typeof newValue === "object") {
        equalVirtualFields.forEach(function (virtualField) {
          onChange(virtualField.name, newValue[virtualField.valueKey]);
        });
      }
    }
  }, [action, prepopulationValue]);
  useEffect(function () {
    field.prepopulater(action) && value && dispatch(entitiesActions[field.prepopulationConfig.entityName].show.request({
      entity: entities[field.prepopulationConfig.entityName],
      id: value
    }));
    return function () {
      if (field.prepopulater(action) && value) dispatch(entitiesActions[field.prepopulationConfig.entityName].list.reset());
    };
  }, [action, dispatch, field, value, entities]);
};

var _excluded$9 = ["action", "field", "onChange", "value", "data", "errors", "state", "inAuthForm", "location"];

var Field$1 = function Field(_ref) {
  var _field$description;

  var action = _ref.action,
      field = _ref.field,
      onChange = _ref.onChange,
      value = _ref.value,
      data = _ref.data,
      errors = _ref.errors,
      state = _ref.state,
      inAuthForm = _ref.inAuthForm,
      location = _ref.location,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  var fieldType = field.getType({
    dataObject: data,
    formState: state
  });
  usePrepopulation(field, onChange, state, value, action, data, errors);
  var fieldError = field.getErrors(errors, state);
  var parsedLocationState = getJSONValue(location === null || location === void 0 ? void 0 : location.state);
  var locationState = useMemo(function () {
    return _extends({}, location, {
      state: parsedLocationState
    });
  }, [location, parsedLocationState]);
  var disabled = field.isDisabled(action, data, locationState, state);
  var required = field.isRequired(action, data, locationState, state);
  return /*#__PURE__*/React__default.createElement(FieldWithDescription, {
    inline: (_field$description = field.description) === null || _field$description === void 0 ? void 0 : _field$description.inline
  }, /*#__PURE__*/React__default.createElement(FieldRenderer$1, _extends({
    action: action,
    field: field,
    onChange: onChange,
    value: value,
    data: data,
    errors: errors,
    state: state,
    inAuthForm: inAuthForm,
    fieldType: fieldType,
    label: field.getLabel(),
    disabled: disabled,
    fieldError: fieldError,
    required: required,
    placeholder: getTranslatedValue(field.placeholder)
  }, props)));
};

var _excluded$a = ["fields", "preventMultiple"],
    _excluded2$1 = ["fields", "identifier", "preventMultiple"];

var formatErrors = function formatErrors(payload) {
  var _errors$full_messages, _payload$payloadKeys$;

  var errors = payload.errors;
  var payloadKeys = Object.keys(payload);
  if (Array.isArray(errors)) return errors[0];
  if (errors !== null && errors !== void 0 && errors.full_messages) return (_errors$full_messages = errors.full_messages) === null || _errors$full_messages === void 0 ? void 0 : _errors$full_messages.join(", ");
  return (i18n.language === "en" ? humanize(payloadKeys === null || payloadKeys === void 0 ? void 0 : payloadKeys[0]) + ":" : "") + " " + (Array.isArray(payload[payloadKeys === null || payloadKeys === void 0 ? void 0 : payloadKeys[0]]) ? (_payload$payloadKeys$ = payload[payloadKeys === null || payloadKeys === void 0 ? void 0 : payloadKeys[0]]) === null || _payload$payloadKeys$ === void 0 ? void 0 : _payload$payloadKeys$[0] : payload[payloadKeys === null || payloadKeys === void 0 ? void 0 : payloadKeys[0]]);
};

var createFields = function createFields(fields, formState, role) {
  return fields.filter(function (field) {
    return !field.isHiddenInCreate(formState, role);
  });
};

var editFields = function editFields(fields, dataObject, formState, role) {
  return fields.filter(function (field) {
    return !field.isHiddenInEdit(dataObject, formState, role);
  });
};

var actionFields = function actionFields(action, fields, dataObject, formState, role) {
  if (dataObject === void 0) {
    dataObject = {};
  }

  if (formState === void 0) {
    formState = {};
  }

  return action === "create" ? createFields(fields, formState, role) : editFields(fields, dataObject, formState, role);
};

var filterFields = function filterFields(action, fields, state, dataObject, role, hideVirtualFields) {
  if (hideVirtualFields === void 0) {
    hideVirtualFields = false;
  }

  return actionFields(action, fields, dataObject, state, role).filter(function (field) {
    return (!hideVirtualFields || !field.isVirtual()) && (!field.dependsOn && !field.dependeeList || (field.dependsOnAny ? isDependeeSet(state, field) : field.hideOnValue ? isDependeeNotHavingDependantValue(state, [].concat(fields, field.getDependeesFields()), field) : isDependeeEqualsDependant(state, [].concat(fields, field.getDependeesFields()), field)));
  });
};

function sanitizeDynamicFieldState(preventMultiple, fields, dataValue) {
  if (preventMultiple) {
    return sanitizeFieldsState(fields, dataValue);
  }

  return dataValue.reduce(function (acc, fieldsValues) {
    var sanitizedFieldValues = _.cloneDeep(fieldsValues);

    fields.map(function (field) {
      if (field.checkMediaRelation()) {
        if (isEmpty(sanitizedFieldValues.media_attributes)) {
          var _sanitizedFieldValues;

          sanitizedFieldValues.media_attributes = (_sanitizedFieldValues = {}, _sanitizedFieldValues[field.identifier] = sanitizedFieldValues[field.identifier], _sanitizedFieldValues);
        } else sanitizedFieldValues.media_attributes[field.identifier] = sanitizedFieldValues[field.identifier];

        delete sanitizedFieldValues[field.identifier];
      }
    });
    var newState = sanitizeFieldsState(fields, sanitizedFieldValues);
    return !isEmpty(newState) ? [].concat(acc, [newState]) : acc;
  }, []);
}

function sanitizeFieldsState(fields, state) {
  state = omit(state, ["formErrors"]);
  fields.map(function (field) {
    var dependantsCheck = field.dependsOnValue ? isDependeeEqualsDependant(state, [].concat(fields, field.getDependeesFields()), field) : isDependeeNotHavingDependantValue(state, [].concat(fields, field.getDependeesFields()), field);

    if (field.isDependant() && !dependantsCheck) {
      state = omit(state, [field.identifier]);
    }
  });
  return fields.reduce(function (acc, _ref) {
    var _extends2;

    var fields = _ref.fields,
        preventMultiple = _ref.preventMultiple,
        field = _objectWithoutPropertiesLoose(_ref, _excluded$a);

    if (!state.hasOwnProperty(field.identifier)) return acc;
    var fieldState = state[field.identifier];
    var fieldType = field.getType({
      formState: state
    });

    if (fieldType === "dynamic") {
      fieldState = sanitizeDynamicFieldState(preventMultiple, fields, fieldState);
    }

    if (field.virtualFields) {
      var invalidVirtualFields = field.virtualFields.filter(function (virtualFieldIdentifier) {
        if (!field.sanitized(state[virtualFieldIdentifier])) return virtualFieldIdentifier;
        return null;
      });
      acc = omit(acc, invalidVirtualFields);
    }

    return field.sanitized(fieldState) ? _extends({}, acc, (_extends2 = {}, _extends2[field.identifier] = fieldState, _extends2)) : omit(acc, [field.identifier]);
  }, state);
}

function removeFieldsToBeRemoved(state) {
  if (!state.fieldsToBeRemoved) {
    return state;
  }

  var newState = _.cloneDeep(state);

  var fieldsToBeRemoved = newState.fieldsToBeRemoved;
  delete newState["fieldsToBeRemoved"];
  Object.keys(newState).map(function (item) {
    if (isArray(newState[item])) {
      newState[item].map(function (element, index) {
        var newElement = _extends({}, element);

        fieldsToBeRemoved === null || fieldsToBeRemoved === void 0 ? void 0 : fieldsToBeRemoved.map(function (field) {
          if (newElement.hasOwnProperty(field.basedOn) && newElement.hasOwnProperty(field.name)) {
            delete newElement[field.name];
            newState[item][index] = newElement;
          }
        });
      });
    }
  });
  return newState;
}

function dynamicFieldValidator(role, field, preventMultiple, accessor, fields, dataValue, prevDataValue, prevErrors, submit, data, action, location) {
  if (prevDataValue === void 0) {
    prevDataValue = [];
  }

  var formData = data && field.getDataValue(data, {
    customAccessor: accessor
  });

  if (preventMultiple) {
    if (isValueEmpty(dataValue)) return {};
    return validator(role, fields, dataValue, prevDataValue, prevErrors, formData, action, fields, location, submit, accessor);
  }

  if (!isArray(dataValue)) return {};

  if (prevDataValue.length > dataValue.length) {
    prevErrors = omitBy(prevErrors, function (_, key) {
      return startsWith(key, accessor);
    });
  }

  return dataValue.reduce(function (acc, fieldsValues, index) {
    var prefix = accessor + "[" + index + "]";
    return validator(role, fields, fieldsValues, prevDataValue[index], acc, formData[index], action, fields, location, submit, prefix);
  }, prevErrors);
}

function validator(role, fields, state, prevState, prevErrors, data, action, entityFields, location, submit, prefix) {
  if (data === void 0) {
    data = {};
  }

  if (submit === void 0) {
    submit = false;
  }

  var parsedLocationState = getJSONValue(location === null || location === void 0 ? void 0 : location.state);
  if (isValueEmpty(prevState) && !submit) return prevErrors;
  var displayedFieldsIdentifiers = filterFields(action, entityFields, state, data, role).map(function (field) {
    return field.identifier;
  });
  return fields.reduce(function (acc, _ref2) {
    var fieldFields = _ref2.fields,
        identifier = _ref2.identifier,
        preventMultiple = _ref2.preventMultiple,
        field = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);

    var fieldType = field.getType({
      formState: state
    });
    var stateWrapperPath = field.getStateWrapperPath();

    var getDataFromState = function getDataFromState(inputState) {
      var _get;

      return stateWrapperPath ? (_get = get$1(inputState, stateWrapperPath)) === null || _get === void 0 ? void 0 : _get[identifier] : inputState[identifier];
    };

    var fieldState = isFileField(fieldType) ? getDataFromState(state) || field.getDataValue(data, {
      constructFileAccessor: true,
      canReturnUndefined: true
    }) : getDataFromState(state);
    var fieldPrevState = prevState && getDataFromState(prevState);

    var locationState = _extends({}, location, {
      state: parsedLocationState
    });

    var disabled = field.isDisabled(action, data, locationState, state);
    if (!isValueEmpty(state) && isValueEmpty(fieldPrevState) && isValueEmpty(fieldState) && !submit && displayedFieldsIdentifiers.includes(identifier)) return acc;
    var key = prefix ? prefix + "." + identifier : identifier;

    if (fieldType === "dynamic") {
      acc[key] = dynamicFieldValidator(role, field, preventMultiple, field.accessor, fieldFields, fieldState, fieldPrevState, prevErrors, submit, data, action, location);
    }

    var isFieldValidObj = field.isValid(fieldState, action, data, locationState, state);

    if (!disabled && !(isFieldValidObj !== null && isFieldValidObj !== void 0 && isFieldValidObj.isValid) && !isValueEmpty(state) && displayedFieldsIdentifiers.includes(identifier)) {
      acc[key] = isFieldValidObj.validationMessage || "Error";
    } else delete acc[key];

    return acc;
  }, prevErrors);
}

var skipTranslationFields = ["select", "reference", "checkbox", "dynamicCheckbox", "radio"];
var _excluded$b = ["type", "field", "fieldValue", "fields", "formType", "errors", "fieldsToBeRemoved", "dataObject", "location", "currentAdminRole", "initialState"],
    _excluded2$2 = ["field", "entity"];

var dataFormReducer = function dataFormReducer(state, action) {
  var type = action.type,
      field = action.field,
      fields = action.fields,
      formType = action.formType,
      errors = action.errors,
      fieldsToBeRemoved = action.fieldsToBeRemoved,
      dataObject = action.dataObject,
      location = action.location,
      currentAdminRole = action.currentAdminRole,
      initialState = action.initialState,
      payload = _objectWithoutPropertiesLoose(action, _excluded$b);

  var inValidFields = state.formErrors;

  if (type === "change" && typeof field === "object") {
    inValidFields = validator(currentAdminRole, [field].concat(field.getDependants()), _extends({}, state, payload), state, state.formErrors, dataObject, formType, fields, location);
  }

  switch (type) {
    case "change":
      return _extends({}, state, payload, {
        formErrors: inValidFields
      });

    case "setErrors":
      return _extends({}, state, {
        formErrors: errors
      });

    case "reset":
      return _extends({}, initialState);

    case "setFieldsToBeRemoved":
      return _extends({}, state, {
        fieldsToBeRemoved: fieldsToBeRemoved
      });

    default:
      return state;
  }
};

var getToggleValue$1 = function getToggleValue(fieldState) {
  if (fieldState === "" || !fieldState) return false;
  return fieldState;
};

var fieldsToState = function fieldsToState(fields, action, data, initialValue) {
  if (data === void 0) {
    data = {};
  }

  if (initialValue === void 0) {
    initialValue = {};
  }

  var dataValueOptions = {
    isForm: true,
    canReturnUndefined: true
  };
  return fields.reduce(function (acc, field) {
    if (field.type === "toggle") {
      var fieldValue = action === "edit" ? field.getDataValue(data, dataValueOptions) : field.defaultValue;
      acc[field.identifier] = getToggleValue$1(fieldValue);
    } else if (field.type === "dynamic") {
      if (field.preventMultiple) {
        var fieldData = field.getDataValue(data, dataValueOptions) || {};
        acc[field.identifier] = action === "create" || Object.keys(fieldData).length === 0 ? {} : fieldsToState(field.fields, action, fieldData);
      } else {
        var _fieldData = field.getDataValue(data, dataValueOptions) || [];

        acc[field.identifier] = action === "create" ? [] : _fieldData.map(function (dynamicFieldData) {
          return fieldsToState(field.fields, action, dynamicFieldData);
        });
      }
    } else {
      if (action === "edit") {
        var fieldType = field.getType(data);

        if (fieldType === "transferList") {
          var transferListConfig = field.transferListConfig;
          acc[field.identifier] = field.getDataValue(data, _extends({}, dataValueOptions, {
            customAccessor: transferListConfig.accessor
          })) || "";
        } else if (fieldType === "reference" && field.multiple && !field.useObjectArray) {
          acc[field.identifier] = field.getDataValue(data, dataValueOptions) === undefined ? "" : field.getDataValue(data, _extends({}, dataValueOptions, {
            skipTranslation: true
          })).map(function (value) {
            var _field$optionsEntity;

            return value[field === null || field === void 0 ? void 0 : (_field$optionsEntity = field.optionsEntity) === null || _field$optionsEntity === void 0 ? void 0 : _field$optionsEntity.valueField];
          });
        } else {
          acc[field.identifier] = field.getDataValue(data, dataValueOptions) === undefined ? "" : field.getDataValue(data, _extends({}, dataValueOptions, {
            skipTranslation: skipTranslationFields.includes(fieldType)
          }));
        }
      } else {
        acc[field.identifier] = field.defaultValue === undefined ? "" : field.defaultValue;
      }
    }

    return acc;
  }, initialValue);
};

var FieldRenderer = function FieldRenderer(_ref) {
  var field = _ref.field,
      entity = _ref.entity,
      props = _objectWithoutPropertiesLoose(_ref, _excluded2$2);

  var lg = useMemo(function () {
    return entity.isFullWidth ? field.lgCol ? field.lgCol * 2 : 8 : 24;
  }, [entity.isFullWidth, field.lgCol]);
  var md = useMemo(function () {
    return entity.isFullWidth ? field.mdCol ? field.mdCol * 2 : 8 : 24;
  }, [entity.isFullWidth, field.mdCol]);
  var xs = useMemo(function () {
    return field.xsCol ? field.xsCol * 2 : 24;
  }, [field.xsCol]);
  return /*#__PURE__*/React__default.createElement(_Col, {
    lg: lg,
    md: md,
    xs: xs,
    key: field.identifier
  }, /*#__PURE__*/React__default.createElement("div", {
    className: field.customFieldClass
  }, /*#__PURE__*/React__default.createElement(Field$1, _extends({
    field: field,
    entity: entity
  }, props))));
};

var DataForm = function DataForm(_ref2, ref) {
  var _auth$authConfig$name;

  var action = _ref2.action,
      data = _ref2.data,
      _ref2$entity = _ref2.entity,
      fields = _ref2$entity.fields,
      customErrorKeys = _ref2$entity.customErrorKeys,
      customDataFormClass = _ref2$entity.customDataFormClass,
      entityName = _ref2$entity.name,
      customErrorsHandler = _ref2$entity.customErrorsHandler,
      entity = _ref2.entity,
      onSubmitAction = _ref2.onSubmit,
      errors = _ref2.errors,
      params = _ref2.params,
      inAuthForm = _ref2.inAuthForm,
      isFullWidth = _ref2.isFullWidth,
      location = _ref2.location,
      loading = _ref2.loading,
      isFormModal = _ref2.isFormModal,
      extraInitialStateData = _ref2.extraInitialStateData;

  var _useTranslation = useTranslation(["general", "dataForm", "notifications"]),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useContext = useContext(AppContext),
      privateRouteURL = _useContext.privateRouteURL,
      authConfig = _useContext.authConfig,
      disableBackBtn = _useContext.disableBackBtn,
      disableFieldsValidations = _useContext.disableFieldsValidations;

  var auth = useSelector(function (state) {
    return getEntity(state, "auth");
  });

  var _ref3 = useSelector(function (state) {
    return getEntity(state, entity.pluralName);
  }) || {},
      loadingState = _ref3.loading;

  var role = (_auth$authConfig$name = auth[authConfig.name]) === null || _auth$authConfig$name === void 0 ? void 0 : _auth$authConfig$name.role;
  var initialState = fieldsToState(actionFields(action, fields, data, {}, role), action, data, {
    formErrors: {}
  });
  initialState = _extends({}, initialState, extraInitialStateData);

  var _useReducer = useReducer(dataFormReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var displayedFields = filterFields(action, fields, state, data, role, true);
  var backButtonIcon = useMemo(function () {
    return i18n.dir() === "rtl" ? /*#__PURE__*/React__default.createElement(ArrowLeftOutlined$2, {
      rotate: 180
    }) : /*#__PURE__*/React__default.createElement(ArrowLeftOutlined$2, null);
  }, [i18n.dir()]);
  var formClassName = useMemo(function () {
    return !inAuthForm ? customDataFormClass : "";
  }, [inAuthForm]);
  var formTitle = useMemo(function () {
    return t("dataForm:" + action, {
      name: entity.getDisplayName()
    });
  }, [action, i18n.language]);
  var storeDispatch = useDispatch();
  var history = useHistory();

  var _useState = useState(""),
      confirmationMessage = _useState[0],
      setConfirmationMessage = _useState[1];

  var onSubmit = function onSubmit(event) {
    if (loadingState) return;
    var filteredState = sanitizeFieldsState(fields, state);
    var finalState = removeFieldsToBeRemoved(filteredState);

    if (disableFieldsValidations) {
      onSubmitAction(finalState);
      return;
    }

    var inValidFields = validator(role, displayedFields, filteredState, {}, {}, data, action, fields, location, true);

    if (isEmpty$1(inValidFields)) {
      onSubmitAction(finalState);
    } else {
      dispatch({
        type: "setErrors",
        errors: inValidFields
      });
      window.scrollTo(0, 0);
      showNotification(null, "error", t("notifications:formError"));
    }
  };

  var getResetOnChangeValues = function getResetOnChangeValues(field) {
    return typeof field === "object" && field.getResetDependantsObject();
  };

  var onChange = useCallback(function (field, fieldValue, _, useObjectPayload) {
    var _extends2;

    var resetOnChangeValues = getResetOnChangeValues(field);
    dispatch(_extends((_extends2 = {
      type: "change",
      field: field,
      fieldValue: fieldValue,
      formType: action,
      fields: fields
    }, _extends2[field.identifier || field] = fieldValue, _extends2.dataObject = data, _extends2.location = location, _extends2.currentAdminRole = role, _extends2), resetOnChangeValues, useObjectPayload && fieldValue));
  }, []);
  var setFieldsToBeRemoved = useCallback(function (field, fieldsToBeRemoved) {
    dispatch({
      type: "setFieldsToBeRemoved",
      field: field,
      fieldsToBeRemoved: fieldsToBeRemoved
    });
  }, []);
  var onDependeeChange = useCallback(function (field) {
    return function (dependeeField, fieldValue) {
      var _extends3;

      var resetValues = generateDependeeValues(fields, field, fieldValue, state, data);
      var resetOnChangeValues = getResetOnChangeValues(dependeeField);
      dispatch(_extends((_extends3 = {
        type: "change",
        field: dependeeField,
        fieldValue: fieldValue,
        formType: action,
        fields: fields,
        dataObject: data,
        location: location
      }, _extends3[dependeeField.identifier || dependeeField] = fieldValue, _extends3.currentAdminRole = role, _extends3), resetValues, resetOnChangeValues));
    };
  }, [fields, state, data]);

  var handleGlobalErrors = function handleGlobalErrors() {
    var globalErrors = pick(errors, customErrorKeys);
    if (customErrorsHandler) return customErrorsHandler(globalErrors);
    Object.keys(globalErrors).forEach(function (key) {
      if (!Array.isArray(globalErrors[key])) globalErrors[key] = [key + ": " + globalErrors[key]];else globalErrors[key] = globalErrors[key].map(function (error) {
        return key + ": " + error;
      });
    });
    return Object.values(globalErrors).flat();
  };

  var handleBack = function handleBack() {
    storeDispatch(goBack());
  };

  var resetError = useCallback(function (newError) {
    if (newError === void 0) {
      newError = {};
    }

    dispatch({
      type: "setErrors",
      errors: newError
    });
  }, []);
  useEffect(function () {
    return function () {
      return !inAuthForm && storeDispatch(entitiesActions[entityName].list.resetErrors());
    };
  }, []);
  useEffect(function () {
    if (inAuthForm) return;
    var methodName = action === "create" ? "canCreate" : "canEdit";

    if (!entity[methodName](role)) {
      history.push(privateRouteURL);
    }
  }, []);
  useEffect(function () {
    var _entity$formConfirmat;

    if ((_entity$formConfirmat = entity.formConfirmationConfig) !== null && _entity$formConfirmat !== void 0 && _entity$formConfirmat.confirmationMessage && state) {
      var _entity$formConfirmat2;

      setConfirmationMessage((_entity$formConfirmat2 = entity.formConfirmationConfig) === null || _entity$formConfirmat2 === void 0 ? void 0 : _entity$formConfirmat2.confirmationMessage(data, state));
    }
  }, [state, data]);
  useImperativeHandle(ref, function () {
    return {
      reset: function reset() {
        return dispatch({
          type: "reset",
          initialState: initialState
        });
      }
    };
  });
  if (inAuthForm && loading) return null;
  return /*#__PURE__*/React__default.createElement(FormContainer, {
    className: "form-wrapper " + formClassName
  }, (!inAuthForm || isFullWidth) && !isFormModal && !disableBackBtn && /*#__PURE__*/React__default.createElement(Link, {
    to: getURL(privateRouteURL, entity.pathName)
  }, /*#__PURE__*/React__default.createElement(_Button, {
    onClick: handleBack,
    type: "text",
    icon: backButtonIcon,
    className: "form-back-button"
  }, t("general:back"))), /*#__PURE__*/React__default.createElement("div", {
    className: "data-form-header"
  }, !inAuthForm && /*#__PURE__*/React__default.createElement(_Typography.Title, {
    level: 2,
    className: "data-form-title"
  }, entity.getDisplayTitle(action)), !inAuthForm && /*#__PURE__*/React__default.createElement(_Typography.Text, {
    strong: true,
    className: "data-form-subtittle"
  }, entity.getDisplaySubTitle(action) || formTitle)), handleGlobalErrors().length > 0 && /*#__PURE__*/React__default.createElement(GlobalErorrs, null, /*#__PURE__*/React__default.createElement(_Alert, {
    type: "error",
    message: handleFormatErrorsObject(handleGlobalErrors())
  })), /*#__PURE__*/React__default.createElement(StyledForm, {
    onSubmit: onSubmit,
    inAuthForm: inAuthForm,
    isFullWidth: entity.isFullWidth,
    id: "dataForm"
  }, /*#__PURE__*/React__default.createElement(_Row, {
    gutter: 24
  }, displayedFields.map(function (field) {
    return /*#__PURE__*/React__default.createElement(FieldRenderer, {
      key: field.identifier,
      entity: entity,
      field: field,
      onChange: field.dependee ? onDependeeChange(field) : onChange,
      value: state[field.identifier],
      action: action,
      data: data,
      state: state,
      errors: _extends({}, errors, state.formErrors),
      resetError: resetError,
      params: params,
      inAuthForm: inAuthForm && !isFullWidth,
      location: location,
      componentConfig: field.componentConfig,
      setFieldsToBeRemoved: setFieldsToBeRemoved
    });
  })), /*#__PURE__*/React__default.createElement(ButtonContainer, {
    className: "form-btns-container"
  }, /*#__PURE__*/React__default.createElement(ActionButton, {
    disabled: !isEmpty$1(state.formErrors) || loadingState,
    type: entity.btnType,
    confirmable: entity.formConfirmationConfig,
    onActionClick: onSubmit,
    formConfirmationConfig: entity.formConfirmationConfig,
    confirmationMessage: confirmationMessage,
    isSubmit: true
  }, entity.getSubmitButtonText(action) || (action === "create" ? t("general:create") : t("dataForm:update"))))));
};

var DataForm$1 = React__default.forwardRef(DataForm);

var _templateObject$7, _templateObject2$6, _templateObject3$5;

var ListContainer = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  padding: 10px 12px;\n"])));
var Container = styled.div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n  padding: 20px;\n  background-color: white;\n  .back-button {\n    margin-bottom: 20px;\n    font-weight: 500;\n  }\n  .custom-img {\n    width: 50%;\n    max-width: 200px;\n  }\n  .dynamic-back-button {\n    float: right;\n  }\n  .dynamic-back-button-rtl {\n    float: left;\n  }\n  .dynamic-container {\n    padding: 10px 12px;\n    max-height: 300px;\n    overflow-y: auto;\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    :empty {\n      padding: 0px;\n      border: none;\n    }\n    .dynamic-value-container:last-child {\n      .ant-divider-horizontal {\n        display: none;\n      }\n    }\n    .virtual-dynamic-value-container {\n      .ant-divider-horizontal {\n        display: block !important;\n      }\n    }\n  }\n\n  .data-page-subtitle {\n    display: block;\n    margin-bottom: 20px;\n  }\n  .data-page-row {\n    padding: 0px 15px;\n  }\n  .data-page-col {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  .data-page-title {\n    color: ", ";\n    text-align: center;\n  }\n  .ant-divider-horizontal {\n    margin: 12px 0;\n  }\n"])), function (props) {
  return props.theme.colors.main;
});
var ExternalComponentWrapper$1 = styled.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n  overflow-x: auto;\n"])));

var DisplayList = function DisplayList(_ref) {
  var items = _ref.items,
      field = _ref.field;
  var valueLabel = field.optionsEntity.valueLabel,
      listSize = field.listSize;
  return /*#__PURE__*/React__default.createElement(ListContainer, null, /*#__PURE__*/React__default.createElement(_List, {
    itemLayout: "horizontal",
    dataSource: items,
    renderItem: function renderItem(value) {
      return /*#__PURE__*/React__default.createElement(_List.Item, {
        key: value[valueLabel]
      }, field.getDisplayValue(value)());
    },
    size: listSize || "small"
  }));
};

var _excluded$c = ["theme", "sendString", "height", "width", "colors"];
var THEME = {
  light: "light_mitsuketa_tribute",
  dark: "dark_vscode_tribute"
};

var JsonField = function JsonField(_ref) {
  var field = _ref.field,
      value = _ref.value,
      onChange = _ref.onChange,
      action = _ref.action;
  var _field$jsonConfig = field.jsonConfig,
      jsonConfig = _field$jsonConfig === void 0 ? {} : _field$jsonConfig;

  var _jsonConfig$theme = jsonConfig.theme,
      theme = _jsonConfig$theme === void 0 ? "light" : _jsonConfig$theme,
      _jsonConfig$sendStrin = jsonConfig.sendString,
      sendString = _jsonConfig$sendStrin === void 0 ? true : _jsonConfig$sendStrin,
      _jsonConfig$height = jsonConfig.height,
      height = _jsonConfig$height === void 0 ? "200px" : _jsonConfig$height,
      width = jsonConfig.width,
      _jsonConfig$colors = jsonConfig.colors,
      colors = _jsonConfig$colors === void 0 ? {} : _jsonConfig$colors,
      jsonProps = _objectWithoutPropertiesLoose(jsonConfig, _excluded$c);

  var parseJSONValue = useCallback(function (value) {
    return sendString ? value.plainText : value.jsObject;
  }, [sendString]);
  var isShow = useMemo(function () {
    return action === "show";
  }, [action]);
  var onJsonChange = useCallback(function (val) {
    onChange(field, parseJSONValue(val));
  }, [onChange, field, parseJSONValue]);
  var changeFn = useMemo(function () {
    return isShow ? false : onJsonChange;
  }, [isShow, onJsonChange]);
  return /*#__PURE__*/React__default.createElement(JSONInput, _extends({
    id: "json-field",
    locale: locale,
    height: height,
    width: width,
    viewOnly: isShow,
    onChange: changeFn,
    theme: THEME[theme],
    confirmGood: false,
    placeholder: getJSONValue(value),
    colors: colors,
    waitAfterKeyPress: 4000
  }, jsonProps));
};

var JsonField$1 = withFieldHandler(JsonField);
var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
    var currentListeners = [];
    var nextListeners = currentListeners;

    function ensureCanMutateNextListeners() {
      if (nextListeners === currentListeners) {
        nextListeners = currentListeners.slice();
      }
    }

    function listen(listener) {
      if (typeof listener !== 'function') {
        throw new Error('Expected listener to be a function.');
      }

      var isSubscribed = true;
      ensureCanMutateNextListeners();
      nextListeners.push(listener);
      return function () {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;
        ensureCanMutateNextListeners();
        var index = nextListeners.indexOf(listener);
        nextListeners.splice(index, 1);
      };
    }

    function emit() {
      currentListeners = nextListeners;
      var listeners = currentListeners;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i].apply(listeners, arguments);
      }
    }

    return {
      listen: listen,
      emit: emit
    };
  };
});
unwrapExports(lib);

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }

    return MapProps;
  };
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends$1({}, props, typeof input === 'function' ? input(props) : input);
  });

  if (process.env.NODE_ENV !== 'production') {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }

  return hoc;
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(Component);

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var _templateObject$8, _templateObject2$7, _templateObject3$6, _templateObject4$4;

var Container$1 = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  font-family: sans-serif;\n  text-align: center;\n  height: auto;\n  .ant-alert,\n  .ant-spin {\n    margin-bottom: 20px;\n  }\n"])));
var ErrorMessage = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n  color: red;\n"])));
var SearchBox = styled.input(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  width: 60%;\n  margin: 0 auto;\n  position: relative;\n  top: -500px;\n  left: 0;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 3px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n  font-size: 14px;\n  outline: none;\n  text-overflow: ellipses;\n"])));
var MapElement = styled.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n  height: 500px;\n  width: 100%;\n  * {\n    -webkit-transition: none !important;\n    transition: none !important;\n    direction: ltr;\n  }\n  div {\n    width: auto;\n  }\n"])));

var GoogleMap = function GoogleMap(_ref) {
  var drawPolygon = _ref.drawPolygon,
      centerCoordinate = _ref.centerCoordinate,
      coordinates = _ref.coordinates,
      onEdit = _ref.onEdit,
      polygonRef = _ref.polygonRef,
      onDoneDrawing = _ref.onDoneDrawing,
      zones = _ref.zones,
      draggable = _ref.draggable,
      onDragEnd = _ref.onDragEnd,
      markerRef = _ref.markerRef,
      drawMarker = _ref.drawMarker,
      searchBoxRef = _ref.searchBoxRef,
      bounds = _ref.bounds,
      onPlacesChanged = _ref.onPlacesChanged,
      isEditable = _ref.isEditable,
      _ref$mapConfig = _ref.mapConfig,
      mapConfig = _ref$mapConfig === void 0 ? {} : _ref$mapConfig,
      onRemoveVertex = _ref.onRemoveVertex,
      action = _ref.action;

  var _useTranslation = useTranslation("maps"),
      t = _useTranslation.t;

  var cairoLocation = {
    lat: 30.04943,
    lng: 31.23095
  };
  var _mapConfig$zoom = mapConfig.zoom,
      zoom = _mapConfig$zoom === void 0 ? 12 : _mapConfig$zoom,
      _mapConfig$initialCen = mapConfig.initialCenterCoordinate,
      initialCenterCoordinate = _mapConfig$initialCen === void 0 ? cairoLocation : _mapConfig$initialCen,
      isPolygonEditable = mapConfig.isPolygonEditable,
      isVertexRemovable = mapConfig.isVertexRemovable;

  var _useState = useState(false),
      showRemoveVertex = _useState[0],
      setShowRemoveVertex = _useState[1];

  var toggleRemoveVertex = useCallback(function () {
    return setShowRemoveVertex(function (showRemoveVertex) {
      return !showRemoveVertex;
    });
  }, []);

  var renderPlaces = function renderPlaces() {
    if (draggable && drawMarker) {
      return /*#__PURE__*/React__default.createElement(StandaloneSearchBox, {
        ref: searchBoxRef,
        bounds: bounds,
        onPlacesChanged: onPlacesChanged,
        style: {
          position: "relative"
        }
      }, /*#__PURE__*/React__default.createElement(SearchBox, {
        type: "text",
        placeholder: t("maps:searchPlaceholder")
      }));
    }
  };

  var renderPolygon = function renderPolygon() {
    var editPolygon = isPolygonEditable && isEditable;
    if (drawPolygon) return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Polygon, {
      options: {
        fillColor: "green",
        zIndex: 15
      },
      geodisk: true,
      editable: editPolygon,
      draggable: editPolygon,
      path: coordinates,
      onMouseUp: editPolygon && onEdit,
      onDragEnd: editPolygon && onEdit,
      ref: polygonRef
    }), isEditable && /*#__PURE__*/React__default.createElement(DrawingManager, {
      defaultDrawingMode: "select",
      defaultOptions: {
        drawingControlOptions: {
          drawingModes: ["polygon"],
          position: google.maps.ControlPosition.LEFT_CENTER
        }
      },
      onPolygonComplete: onDoneDrawing
    }), showRemoveVertex && (coordinates === null || coordinates === void 0 ? void 0 : coordinates.map(function (pos, key) {
      return /*#__PURE__*/React__default.createElement(OverlayView, {
        mapPaneName: OverlayView.OVERLAY_MOUSE_TARGET,
        position: pos,
        key: key
      }, /*#__PURE__*/React__default.createElement(CloseCircleTwoTone$2, {
        style: {
          fontSize: "20px",
          transform: "translateY(-22px) translateX(-5px)"
        },
        twoToneColor: "red",
        onClick: onRemoveVertex(key)
      }));
    })), renderZoneMarkers());
  };

  var getCenterCoordinate = function getCenterCoordinate() {
    if (Array.isArray(centerCoordinate) || !centerCoordinate) return initialCenterCoordinate;
    return centerCoordinate;
  };

  var renderZones = function renderZones() {
    if (zones) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, zones.map(function (zone, key) {
        var coordinates = zone.coordinates.map(function (coordinate) {
          return {
            lng: parseFloat(coordinate.lng),
            lat: parseFloat(coordinate.lat)
          };
        });
        return /*#__PURE__*/React__default.createElement(Polygon, {
          options: {
            fillColor: zone.color,
            zIndex: 1
          },
          path: coordinates,
          key: key
        });
      }));
    }
  };

  var renderZoneMarkers = function renderZoneMarkers() {
    if (zones) return zones.map(function (zone, key) {
      return zone.centroid && /*#__PURE__*/React__default.createElement(Marker, {
        label: {
          text: zone.name,
          color: "white",
          fontSize: "25px"
        },
        position: zone.centroid,
        ref: markerRef,
        key: key
      });
    });
  };

  var renderMarker = function renderMarker() {
    if (drawMarker) {
      if (Array.isArray(centerCoordinate) && action === "show") return /*#__PURE__*/React__default.createElement(Fragment, null, centerCoordinate.map(function (coordinate, key) {
        return /*#__PURE__*/React__default.createElement(Marker, {
          key: key,
          position: coordinate
        });
      }));
      return /*#__PURE__*/React__default.createElement(Marker, {
        draggable: draggable,
        onDragEnd: onDragEnd,
        position: getCenterCoordinate(),
        ref: markerRef
      });
    }
  };

  var removeBtn = function removeBtn() {
    var pos = getCenterCoordinate();
    return {
      lat: pos.lat + 1,
      lng: pos.lng + 0.1
    };
  };

  return /*#__PURE__*/React__default.createElement(GoogleMap$2, {
    center: getCenterCoordinate(),
    defaultZoom: zoom
  }, renderPolygon(), renderZones(), renderMarker(), renderPlaces(), isVertexRemovable && isEditable && coordinates.length > 0 && /*#__PURE__*/React__default.createElement(OverlayView, {
    mapPaneName: OverlayView.OVERLAY_MOUSE_TARGET,
    position: removeBtn(),
    onClick: toggleRemoveVertex
  }, /*#__PURE__*/React__default.createElement(_Button, {
    onClick: toggleRemoveVertex,
    icon: /*#__PURE__*/React__default.createElement(DeleteOutlined$2, null)
  })));
};

var ComposedGoogleMap = compose(withProps({
  loadingElement: /*#__PURE__*/React__default.createElement(MapElement, null, "Loading.."),
  containerElement: /*#__PURE__*/React__default.createElement(MapElement, null),
  mapElement: /*#__PURE__*/React__default.createElement(MapElement, null)
}), withScriptjs, withGoogleMap)(GoogleMap);

var GoogleMap$1 = function GoogleMap$1(props) {
  var _useContext = useContext(AppContext),
      googleApiKey = _useContext.googleApiKey;

  var googleMapURL = "https://maps.googleapis.com/maps/api/js?libraries=geometry,drawing,places&key=" + googleApiKey;
  return /*#__PURE__*/React__default.createElement(ComposedGoogleMap, _extends({
    googleMapURL: googleMapURL
  }, props));
};

var validatePinPoint = createActions$1("validatePinPoint");
var resetPin = createAction("resetPin");

var usePointValidator = function usePointValidator(field, id) {
  var _field$mapConfig;

  var dispatch = useDispatch();

  var _ref = ((_field$mapConfig = field.mapConfig) === null || _field$mapConfig === void 0 ? void 0 : _field$mapConfig.validationConfig) || {},
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? false : _ref$enabled,
      _ref$extraParams = _ref.extraParams,
      extraParams = _ref$extraParams === void 0 ? [] : _ref$extraParams,
      endPoint = _ref.endPoint;

  useEffect(function () {
    if (enabled) return function () {
      return dispatch(resetPin({
        id: id
      }));
    };
  }, [dispatch, id, enabled]);

  var handleValidatePoint = function handleValidatePoint(location, id) {
    if (!enabled) return;

    var data = _extends({}, location, extraParams);

    dispatch(validatePinPoint.request({
      data: data,
      id: id,
      endPoint: endPoint
    }));
  };

  return [handleValidatePoint];
};

var useChangeMarker = function useChangeMarker(field, onChange, id) {
  var dispatch = useDispatch();
  var _field$mapConfig = field.mapConfig,
      mapConfig = _field$mapConfig === void 0 ? {} : _field$mapConfig;
  var lngFieldIdentifier = mapConfig.lngFieldIdentifier,
      latFieldIdentifier = mapConfig.latFieldIdentifier,
      addressFieldIdentifier = mapConfig.addressFieldIdentifier,
      governorateFieldIdentifier = mapConfig.governorateFieldIdentifier,
      onMapChange = mapConfig.onMapChange;

  var _usePointValidator = usePointValidator(field, id),
      handleValidatePoint = _usePointValidator[0];

  var changeMarkerPosition = function changeMarkerPosition(location) {
    onChange(field, location);
    var lng = location.lng,
        lat = location.lat;

    if (lngFieldIdentifier && latFieldIdentifier) {
      onChange(lngFieldIdentifier, lng);
      onChange(latFieldIdentifier, lat);
    }
  };

  var changeAddressField = function changeAddressField(location, address) {
    if (addressFieldIdentifier) {
      if (address) return onChange(addressFieldIdentifier, address);
      var geoCoder = new google.maps.Geocoder();
      geoCoder.geocode({
        location: location
      }, function (places, status) {
        var address = status === "OK" ? places[0].formatted_address : "N/A";
        onChange(addressFieldIdentifier, address);
      });
    }
  };

  var changeGovernorateField = function changeGovernorateField(location) {
    if (governorateFieldIdentifier) {
      var geoCoder = new google.maps.Geocoder();
      geoCoder.geocode({
        location: location
      }, function (places, status) {
        var governorate = status === "OK" ? places[0].address_components.find(function (item) {
          return item.types.includes("administrative_area_level_1");
        }).long_name : "N/A";
        onChange(governorateFieldIdentifier, governorate);
      });
    }
  };

  var onChangeMarker = function onChangeMarker(location, address) {
    changeMarkerPosition(location);
    changeAddressField(location, address);
    changeGovernorateField(location);
    handleValidatePoint(location, id);
    if (onMapChange) onMapChange(dispatch, location, address);
  };

  return [onChangeMarker];
};

var useMarker = function useMarker(onChange, field, id) {
  var markerRef = useRef(null);

  var _useChangeMarker = useChangeMarker(field, onChange, id),
      onChangeMarker = _useChangeMarker[0];

  var onDragEnd = function onDragEnd() {
    var current = markerRef.current;
    var lng = current.getPosition().lng();
    var lat = current.getPosition().lat();
    onChangeMarker({
      lat: lat,
      lng: lng
    });
  };

  return [markerRef, onDragEnd];
};

var usePlaces = function usePlaces(onChange, field, id) {
  var boundsRef = useRef(null);
  var searchBoxRef = useRef(null);

  var _useChangeMarker = useChangeMarker(field, onChange, id),
      onChangeMarker = _useChangeMarker[0];

  var onPlacesChanged = function onPlacesChanged() {
    var places = searchBoxRef.current.getPlaces();
    boundsRef.current = new google.maps.LatLngBounds();

    if (places.length > 0) {
      places.forEach(function (place) {
        if (place.geometry.viewport) {
          boundsRef.current.union(place.geometry.viewport);
        } else {
          boundsRef.current.extend(place.geometry.location);
        }
      });
      var nextMarkers = places.map(function (place) {
        return {
          position: place.geometry.location
        };
      });
      var nextCenter = get$1(nextMarkers, "0.position", field.identifier);
      var location = {
        lat: nextCenter.lat(),
        lng: nextCenter.lng()
      };
      onChangeMarker(location, places[0].formatted_address);
    }
  };

  return [searchBoxRef, boundsRef.current, onPlacesChanged];
};

var MarkerMapField = function MarkerMapField(_ref) {
  var _field$mapConfig, _current$id2;

  var action = _ref.action,
      field = _ref.field,
      onChange = _ref.onChange,
      value = _ref.value,
      disabled = _ref.disabled;

  var _useRef = useRef(uniqueId("Marker_")),
      id = _useRef.current;

  var _useMarker = useMarker(onChange, field, id),
      markerRef = _useMarker[0],
      onDragEnd = _useMarker[1];

  var _usePlaces = usePlaces(onChange, field, id),
      searchBoxRef = _usePlaces[0],
      bounds = _usePlaces[1],
      onPlacesChanged = _usePlaces[2];

  var _ref2 = ((_field$mapConfig = field.mapConfig) === null || _field$mapConfig === void 0 ? void 0 : _field$mapConfig.validationConfig) || {},
      _ref2$alerts = _ref2.alerts,
      alerts = _ref2$alerts === void 0 ? [] : _ref2$alerts;

  var _useSelector = useSelector(function (state) {
    return getEntity(state, "maps");
  }),
      current = _useSelector.current;

  var renderAlerts = function renderAlerts() {
    return alerts.reduce(function (accum, alert) {
      var _current$id;

      var name = alert.name,
          message = alert.message,
          _alert$type = alert.type,
          type = _alert$type === void 0 ? "success" : _alert$type;
      var alertInfoList = (_current$id = current[id]) === null || _current$id === void 0 ? void 0 : _current$id[name];
      if (!alertInfoList) return accum;
      var displayedAlerts = alertInfoList.map(function (info) {
        return /*#__PURE__*/React__default.createElement(_Alert, {
          message: getAccessorValue(info, message, true),
          type: type,
          showIcon: true
        });
      });
      return [].concat(accum, [displayedAlerts]);
    }, []);
  };

  if (typeof value !== "object" && action === "show") return "_";
  return /*#__PURE__*/React__default.createElement(Container$1, null, (_current$id2 = current[id]) !== null && _current$id2 !== void 0 && _current$id2.loading ? /*#__PURE__*/React__default.createElement(_Spin, {
    size: "default"
  }) : renderAlerts(), /*#__PURE__*/React__default.createElement(GoogleMap$1, {
    drawMarker: true,
    draggable: action !== "show" && !disabled,
    centerCoordinate: value,
    markerRef: markerRef,
    onDragEnd: onDragEnd,
    bounds: bounds,
    searchBoxRef: searchBoxRef,
    onPlacesChanged: onPlacesChanged,
    mapConfig: field.mapConfig,
    action: action
  }));
};

var MarkerMapField$1 = withFieldHandler(MarkerMapField);

var getCoordinatesData = function getCoordinatesData(coordinates) {
  var bounds = {};
  if (!coordinates) return {
    parsedCoordinates: [],
    coordinates: coordinates
  };
  var parsedCoordinates = coordinates.map(function (coordinate) {
    var parsedCoordinate = {
      lng: parseFloat(coordinate.lng),
      lat: parseFloat(coordinate.lat)
    };
    var lng = parsedCoordinate.lng,
        lat = parsedCoordinate.lat;
    var minLat = bounds.minLat,
        minLng = bounds.minLng,
        maxLat = bounds.maxLat,
        maxLng = bounds.maxLng;
    if (!minLat || lat < minLat) bounds.minLat = lat;
    if (!maxLat || lat > maxLat) bounds.maxLat = lat;
    if (!minLng || lng < minLng) bounds.minLng = lng;
    if (!maxLng || lng > maxLng) bounds.maxLng = lng;
    return parsedCoordinate;
  });
  var minLat = bounds.minLat,
      minLng = bounds.minLng,
      maxLat = bounds.maxLat,
      maxLng = bounds.maxLng;
  var centerCoordinate = minLat ? {
    lat: (maxLat + minLat) / 2,
    lng: (minLng + maxLng) / 2
  } : null;
  return {
    parsedCoordinates: parsedCoordinates,
    centerCoordinate: centerCoordinate
  };
};

var findNextPath = function findNextPath(polygon) {
  return polygon.getPath().getArray().map(function (latLng) {
    return {
      lat: latLng.lat(),
      lng: latLng.lng()
    };
  });
};

var filterZones = function filterZones(zones, zoneId) {
  return zones.filter(function (zone) {
    return zone.id !== zoneId;
  });
};

var useDrawPolygon = function useDrawPolygon(onChange, field) {
  var dispatch = useDispatch();
  var _field$mapConfig = field.mapConfig,
      mapConfig = _field$mapConfig === void 0 ? {} : _field$mapConfig;
  var callBackOnChange = mapConfig.callBackOnChange;
  var polygonRef = useRef(null);
  var onEdit = useCallback(function () {
    var current = polygonRef.current;

    if (current) {
      var path = findNextPath(current);
      onChange(field.identifier, path);
      if (callBackOnChange) callBackOnChange(dispatch, path);
    }
  }, [field.identifier, onChange, callBackOnChange, dispatch]);
  var onDoneDrawing = useCallback(function (polygon) {
    var path = findNextPath(polygon);
    onChange(field.identifier, path);
    if (callBackOnChange) callBackOnChange(dispatch, path);
    polygon.setMap(null);
  }, [field.identifier, onChange, callBackOnChange, dispatch]);
  var onRemoveVertex = useCallback(function (vertexId) {
    return function () {
      var current = polygonRef.current;

      if (current) {
        var path = findNextPath(current).filter(function (_, index) {
          return index !== vertexId;
        });
        onChange(field.identifier, path);
        if (callBackOnChange) callBackOnChange(dispatch, path);
      }
    };
  }, []);
  return [polygonRef, onEdit, onDoneDrawing, onRemoveVertex];
};

var usePolygonCoordinates = function usePolygonCoordinates(value) {
  var _getCoordinatesData = getCoordinatesData(value),
      parsedCoordinates = _getCoordinatesData.parsedCoordinates,
      centerCoordinate = _getCoordinatesData.centerCoordinate;

  var polygon = [{
    coordinates: value
  }];
  return [parsedCoordinates, centerCoordinate, polygon];
};

var useGetZones = function useGetZones(action, entity, data, requestParams, requiredFilterParam) {
  var _requestParams$curren;

  if (requestParams === void 0) {
    requestParams = {};
  }

  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return getEntity(state, entity.pluralName);
  }),
      storedZones = _useSelector.data;

  var areParamsMissing = !((_requestParams$curren = requestParams.current) !== null && _requestParams$curren !== void 0 && _requestParams$curren[requiredFilterParam]);
  useEffect(function () {
    if (action === "create") dispatch(entitiesActions[entity.name].list.request(_extends({
      entity: entity,
      show_all: true
    }, requestParams.current)));
  }, [action, dispatch, entity, requestParams.current]);
  useEffect(function () {
    if (action === "edit" && storedZones.length === 0 && !areParamsMissing) dispatch(entitiesActions[entity.name].list.request(_extends({
      entity: entity
    }, requestParams.current)));
  }, [action, dispatch, entity, storedZones, requestParams.current]);
  var zones = data !== null && data !== void 0 && data.id ? filterZones(storedZones, data.id) : storedZones;
  return [zones];
};

var PolygonMapField = function PolygonMapField(_ref) {
  var action = _ref.action,
      field = _ref.field,
      onChange = _ref.onChange,
      value = _ref.value,
      disabled = _ref.disabled,
      data = _ref.data;

  var _useDrawPolygon = useDrawPolygon(onChange, field),
      polygonRef = _useDrawPolygon[0],
      onEdit = _useDrawPolygon[1],
      onDoneDrawing = _useDrawPolygon[2],
      onRemoveVertex = _useDrawPolygon[3];

  var _usePolygonCoordinate = usePolygonCoordinates(value),
      parsedCoordinates = _usePolygonCoordinate[0],
      centerCoordinate = _usePolygonCoordinate[1];

  var _useGetZones = useGetZones(action, field.getEntity(), data),
      zones = _useGetZones[0];

  if (!value && action === "show") return "_";
  return /*#__PURE__*/React__default.createElement(Container$1, null, /*#__PURE__*/React__default.createElement(GoogleMap$1, {
    zones: action !== "show" && zones,
    coordinates: parsedCoordinates,
    onEdit: onEdit,
    onDoneDrawing: onDoneDrawing,
    drawPolygon: true,
    polygonRef: polygonRef,
    centerCoordinate: centerCoordinate,
    isEditable: !disabled && action !== "show",
    mapConfig: field.mapConfig,
    onRemoveVertex: onRemoveVertex
  }));
};

var PolygonMapField$1 = withFieldHandler(PolygonMapField);
var _excluded$d = ["field", "field", "entity", "data", "canEditTableField", "onChange", "onDelete", "parentEntityData"];

var StaticTableField = function StaticTableField(_ref) {
  var _ref$field$tableConfi = _ref.field.tableConfig;
  _ref$field$tableConfi = _ref$field$tableConfi === void 0 ? {} : _ref$field$tableConfi;

  var staticDataAccessor = _ref$field$tableConfi.staticDataAccessor,
      stateIdentifier = _ref$field$tableConfi.stateIdentifier,
      field = _ref.field,
      entity = _ref.entity,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      canEditTableField = _ref.canEditTableField,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      parentEntityData = _ref.parentEntityData,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  var dispatch = useDispatch();

  var _useState = useState({
    currentPage: 1,
    rowsPerPage: 10
  }),
      pagination = _useState[0],
      setPagination = _useState[1];

  var entityCustomName = generateReferencedEntityCustomName("table", entity.name, entity.name, field.identifier);

  var _useContext = useContext(AppContext),
      allEntities = _useContext.allEntities;

  var _ref2 = allEntities[entityCustomName] || {},
      fieldsToBeRemoved = _ref2.fieldsToBeRemoved;

  var dataValues = staticDataAccessor ? data === null || data === void 0 ? void 0 : data.map(function (item) {
    return get(item, staticDataAccessor);
  }) : data;
  var referencedState = typeof stateIdentifier === "function" ? stateIdentifier() : stateIdentifier;

  var _ref3 = useSelector(function (state) {
    return getEntity(state, referencedState);
  }) || {},
      referencedReducerValues = _ref3.current;

  dataValues = referencedState ? referencedReducerValues : dataValues;
  var setFieldsToBeRemoved = props.setFieldsToBeRemoved;

  var onPaginationChange = function onPaginationChange(page, pageSize) {
    setPagination({
      currentPage: page,
      rowsPerPage: pageSize
    });
  };

  useEffect(function () {
    setFieldsToBeRemoved === null || setFieldsToBeRemoved === void 0 ? void 0 : setFieldsToBeRemoved(field, fieldsToBeRemoved);
  }, []);

  var onCustomRowActionTriggered = function onCustomRowActionTriggered(action, item) {
    if (action.customFunction) action.customFunction(dispatch, item);else {
      var actionCreator = entitiesActions[entity.name][action.name].request;
      dispatch(actionCreator({
        entity: entity,
        item: item
      }));
    }
  };

  return /*#__PURE__*/React__default.createElement(DataTable, {
    entity: entity,
    staticData: _extends({
      data: dataValues
    }, pagination, {
      totalEntries: dataValues.length
    }),
    onPaginationChange: onPaginationChange,
    isStatic: true,
    disablePagination: true,
    tableConfig: field.tableConfig,
    fields: field.fields,
    canEditTableField: canEditTableField,
    onChange: onChange,
    onDelete: onDelete,
    parentEntityData: parentEntityData,
    onCustomRowActionTriggered: onCustomRowActionTriggered
  });
};

var useFilterParams = function useFilterParams(_ref) {
  var filterParams = _ref.filterParams,
      action = _ref.action,
      state = _ref.state,
      params = _ref.params,
      entity = _ref.entity,
      customEntityName = _ref.customEntityName,
      customConfigs = _ref.customConfigs,
      _ref$authenticated = _ref.authenticated,
      authenticated = _ref$authenticated === void 0 ? true : _ref$authenticated,
      _ref$dispatchAction = _ref.dispatchAction,
      dispatchAction = _ref$dispatchAction === void 0 ? "list" : _ref$dispatchAction,
      field = _ref.field,
      fieldUniqueId = _ref.fieldUniqueId,
      willPerformDispatch = _ref.willPerformDispatch;

  var _useContext = useContext(AppContext),
      globalReferenceFieldFilterParams = _useContext.globalReferenceFieldFilterParams;

  if (filterParams !== undefined && !Array.isArray(filterParams)) return [];
  var dispatch = useDispatch();
  var filters = useMemo(function () {
    return filterParams === null || filterParams === void 0 ? void 0 : filterParams.filter(function (param) {
      return param.type === action || param.type === "both";
    });
  }, [filterParams, action]);
  var filterValues = useMemo(function () {
    return filters === null || filters === void 0 ? void 0 : filters.reduce(function (acc, _ref2) {
      var _extends2;

      var name = _ref2.name,
          value = _ref2.value;
      var newValue = typeof value === "function" ? value() : value;
      return _extends({}, acc, (_extends2 = {}, _extends2[name] = get({
        state: state,
        params: params
      }, newValue, newValue), _extends2));
    }, {});
  }, [filters, state, params]);
  var prevFilterValues = useRef(filterValues);
  var prevConfigs = useRef(null);
  var resetFilterValues = !isEqual(prevFilterValues.current, filterValues);
  useEffect(function () {
    var areNewFilterParamsPresent = resetFilterValues || !isEqual(prevConfigs.current, customConfigs);
    var customExternalCondition = !willPerformDispatch || willPerformDispatch(filterValues);

    if (areNewFilterParamsPresent && customExternalCondition) {
      dispatch(entitiesActions[customEntityName][dispatchAction].request(_extends({
        entity: entity,
        customEntityName: customEntityName,
        authenticated: authenticated
      }, globalReferenceFieldFilterParams, customConfigs, filterValues, field && {
        field: field
      }, fieldUniqueId && {
        fieldUniqueId: fieldUniqueId
      })));
      prevFilterValues.current = filterValues;
      prevConfigs.current = customConfigs;
    }
  }, [customConfigs, dispatch, entity, customEntityName, filterValues, resetFilterValues, willPerformDispatch]);
  return [resetFilterValues, filterValues];
};

var DynamicTableField = function DynamicTableField(_ref) {
  var entity = _ref.entity,
      field = _ref.field,
      customEntityName = _ref.customEntityName,
      dataObject = _ref.dataObject,
      onChange = _ref.onChange,
      _ref$canEditTableFiel = _ref.canEditTableField,
      canEditTableField = _ref$canEditTableFiel === void 0 ? true : _ref$canEditTableFiel;
  var filterParams = field.tableConfig.filterParams;

  var _useFilterParams = useFilterParams({
    filterParams: filterParams,
    action: "show",
    state: dataObject,
    params: {},
    entity: entity,
    customEntityName: customEntityName,
    customConfigs: {}
  }),
      filterValues = _useFilterParams[1];

  return /*#__PURE__*/React__default.createElement(Generator, {
    entity: entity,
    match: {
      params: {}
    },
    history: {
      location: {}
    },
    action: "list",
    additionalParams: filterValues,
    tableConfig: field.tableConfig,
    onChange: onChange,
    canEditTableField: canEditTableField
  });
};

var _excluded$e = ["field", "dataObject", "entity"];

var TableField = function TableField(_ref) {
  var field = _ref.field,
      dataObject = _ref.dataObject,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$e);

  var _useContext = useContext(AppContext),
      entities = _useContext.entities;

  var _field$tableConfig = field.tableConfig,
      entityName = _field$tableConfig.name,
      _field$tableConfig$ty = _field$tableConfig.type,
      type = _field$tableConfig$ty === void 0 ? "static" : _field$tableConfig$ty;
  var customEntityName = generateReferencedEntityCustomName("table", entityName, field.getEntity().name, field.identifier);
  var entity = entities[customEntityName];
  var entityID = entity.getIdentifier();

  switch (type) {
    case "static":
      return /*#__PURE__*/React__default.createElement(StaticTableField, _extends({
        field: field,
        entity: entity,
        rowKey: entityID
      }, props, {
        parentEntityData: dataObject
      }));

    case "dynamic":
      return /*#__PURE__*/React__default.createElement(DynamicTableField, _extends({
        field: field,
        entity: entity,
        rowKey: entityID,
        customEntityName: customEntityName,
        dataObject: dataObject
      }, props));
  }
};

var collectionReducer = function collectionReducer(collectionState, action) {
  var _extends2;

  var type = action.type,
      code = action.code,
      item = action.item,
      entries = action.entries;

  switch (type) {
    case "fetchItems":
      return _extends({}, collectionState, {
        entries: (entries === null || entries === void 0 ? void 0 : entries.reduce(function (acc, obj) {
          acc[obj.code] = obj;
          return acc;
        }, {})) || {}
      });

    case "addItem":
      return {
        entries: _extends({}, entries, (_extends2 = {}, _extends2[code] = item, _extends2))
      };

    case "removeItem":
      return {
        entries: omit(collectionState.entries, code)
      };

    default:
      return collectionState;
  }
};

var _templateObject$9, _templateObject2$8;

var ScannableTableWrapper = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n  .ant-alert {\n    margin-bottom: 20px;\n  }\n"])));
var TableWrapper = styled.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n  margin: 20px 0px;\n  .ant-table-wrapper {\n    margin-top: 10px;\n  }\n"])));

var BarcodeTable = function BarcodeTable(_ref) {
  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      selectKey = _ref.selectKey,
      count = _ref.count,
      countLabel = _ref.countLabel,
      actions = _ref.actions,
      loading = _ref.loading,
      _ref$useBarCode = _ref.useBarCode,
      useBarCode = _ref$useBarCode === void 0 ? true : _ref$useBarCode,
      customAccessor = _ref.customAccessor;
  return /*#__PURE__*/React__default.createElement(TableWrapper, null, /*#__PURE__*/React__default.createElement(_Typography.Text, {
    strong: true
  }, getTranslatedValue(countLabel), " ", count), /*#__PURE__*/React__default.createElement(_Table, {
    dataSource: entries,
    bordered: true,
    scroll: {
      x: 500
    },
    rowKey: selectKey,
    pagination: false,
    loading: loading
  }, fields.map(function (field) {
    return /*#__PURE__*/React__default.createElement(_Table.Column, {
      key: field.identifier,
      title: getTranslatedValue(field.label),
      dataIndex: field.identifier,
      render: function render(_, record) {
        var value = typeof customAccessor === "function" ? customAccessor(record, field) : field.getDataValue(record);
        if (field.type === "barcode" && useBarCode) return /*#__PURE__*/React__default.createElement(Barcode, {
          height: 20,
          value: value
        });
        return value;
      }
    });
  }), actions === null || actions === void 0 ? void 0 : actions.map(function (col) {
    return /*#__PURE__*/React__default.createElement(_Table.Column, {
      key: col.dataIndex,
      title: col.title,
      dataIndex: col.dataIndex,
      render: col.render
    });
  })));
};

var useScanningState = function useScanningState() {
  var _useState = useState({}),
      itemAlerts = _useState[0],
      setItemAlerts = _useState[1];

  var _useState2 = useState(null),
      addCode = _useState2[0],
      setAddCode = _useState2[1];

  var _useState3 = useState(null),
      removeCode = _useState3[0],
      setRemoveCode = _useState3[1];

  var _useState4 = useState(false),
      adding = _useState4[0],
      setAdding = _useState4[1];

  var _useState5 = useState(false),
      removing = _useState5[0],
      setRemoving = _useState5[1];

  return {
    itemAlerts: itemAlerts,
    setItemAlerts: setItemAlerts,
    addCode: addCode,
    setAddCode: setAddCode,
    removeCode: removeCode,
    setRemoveCode: setRemoveCode,
    adding: adding,
    setAdding: setAdding,
    removing: removing,
    setRemoving: setRemoving
  };
};

var DynamicScannableTable = function DynamicScannableTable(_ref) {
  var action = _ref.action,
      field = _ref.field,
      onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      data = _ref.data;
  var reduxDispatch = useDispatch();

  var _useTranslation = useTranslation("scannableTable"),
      t = _useTranslation.t;

  var _useContext = useContext(AppContext),
      entities = _useContext.entities;

  var _useScanningState = useScanningState(),
      itemAlerts = _useScanningState.itemAlerts,
      setItemAlerts = _useScanningState.setItemAlerts,
      addCode = _useScanningState.addCode,
      setAddCode = _useScanningState.setAddCode,
      removeCode = _useScanningState.removeCode,
      setRemoveCode = _useScanningState.setRemoveCode,
      adding = _useScanningState.adding,
      setAdding = _useScanningState.setAdding,
      removing = _useScanningState.removing,
      setRemoving = _useScanningState.setRemoving;

  var entityName = field.tableConfig.name;
  var customEntityName = generateReferencedEntityCustomName("table", entityName, field.getEntity().name, field.identifier);
  var scannableEntity = entities === null || entities === void 0 ? void 0 : entities[customEntityName];

  var _ref2 = useSelector(function (state) {
    return getEntity(state, scannableEntity === null || scannableEntity === void 0 ? void 0 : scannableEntity.pluralName);
  }) || {},
      scannedItem = _ref2.current,
      validatedItemErrors = _ref2.errors,
      entries = _ref2.data,
      loading = _ref2.loading;

  var initialCollectionState = function initialCollectionState() {
    return {
      entries: value.reduce(function (acc, obj) {
        acc[obj.code] = obj;
        return acc;
      }, {})
    };
  };

  var _useReducer = useReducer(collectionReducer, initialCollectionState()),
      collection = _useReducer[0],
      reactDispatch = _useReducer[1];

  useEffect(function () {
    if (!isEmpty$1(validatedItemErrors)) {
      setItemAlerts({
        type: "error",
        message: formatErrors(validatedItemErrors)
      });
    } else if (adding && !loading && isEmpty$1(validatedItemErrors)) setItemAlerts({
      type: "success",
      message: t("feedback.add")
    });else if (removing && !loading && isEmpty$1(validatedItemErrors)) setItemAlerts({
      type: "success",
      message: t("feedback.remove")
    });
  }, [validatedItemErrors]);
  useEffect(function () {
    if (scannableEntity) reduxDispatch(entitiesActions[scannableEntity.name].list.request({
      entity: scannableEntity,
      show_all: true
    }));
  }, [reduxDispatch, scannableEntity]);
  useEffect(function () {
    if (field.reloadAddedEntries && action === "create") collection.entries = {};
    reactDispatch({
      type: "fetchItems",
      entries: entries
    });
  }, [entries]);
  useEffect(function () {
    onChange(field.identifier, Object.values(collection.entries || {}));
  }, [field.identifier, onChange, collection.entries]);
  useEffect(function () {
    if (!collection.entries[scannedItem === null || scannedItem === void 0 ? void 0 : scannedItem.code]) reactDispatch({
      type: "addNewItem",
      scannedItem: scannedItem
    });
  }, [scannedItem]);

  var handleAddCodeChange = function handleAddCodeChange(event) {
    setAddCode(event.target.value);
  };

  var handleRemoveCodeChange = function handleRemoveCodeChange(event) {
    setRemoveCode(event.target.value);
  };

  var handleAddItem = function handleAddItem() {
    var foundItem = collection.entries[addCode];

    if (foundItem) {
      setItemAlerts({
        type: "error",
        message: t("errors.added")
      });
    } else if (addCode) {
      reduxDispatch(entitiesActions[scannableEntity === null || scannableEntity === void 0 ? void 0 : scannableEntity.name].show.request({
        entity: scannableEntity,
        id: addCode
      }));
      setAdding(true);
      setItemAlerts({});
    }

    setAddCode("");
  };

  var handleRemoveItem = function handleRemoveItem() {
    var foundItem = collection.entries[removeCode];

    if (foundItem) {
      reactDispatch({
        type: "removeItem",
        code: removeCode
      });
      reduxDispatch(entitiesActions[scannableEntity === null || scannableEntity === void 0 ? void 0 : scannableEntity.name]["delete"]({
        entity: scannableEntity,
        id: addCode
      }));
      setRemoving(true);
      setItemAlerts({});
    } else if (removeCode) {
      setItemAlerts({
        type: "error",
        message: t("errors.notFound")
      });
    }

    setRemoveCode("");
  };

  var handleRemoveKeyPress = function handleRemoveKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      handleRemoveItem();
    }
  };

  var handleAddKeyPress = function handleAddKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAddItem();
    }
  };

  var addedItemsCount = function addedItemsCount() {
    return Object.keys(collection.entries || {}).length || 0;
  };

  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ScannableTableWrapper, null, /*#__PURE__*/React__default.createElement(_Typography.Title, {
    level: 5
  }, getTranslatedValue(field.label)), !isEmpty$1(itemAlerts) && /*#__PURE__*/React__default.createElement(_Alert, {
    type: itemAlerts.type,
    message: itemAlerts.message
  }), /*#__PURE__*/React__default.createElement(_Row, {
    gutter: [16, 16]
  }, /*#__PURE__*/React__default.createElement(_Col, {
    lg: 12,
    xs: 24
  }, /*#__PURE__*/React__default.createElement(_Input.Search, {
    placeholder: t("labels.add"),
    onSearch: handleAddItem,
    enterButton: /*#__PURE__*/React__default.createElement(AddIcon, null),
    value: addCode,
    onChange: handleAddCodeChange,
    onPressEnter: handleAddKeyPress,
    disabled: field.isDisabled(action, data)
  })), /*#__PURE__*/React__default.createElement(_Col, {
    lg: 12,
    xs: 24
  }, /*#__PURE__*/React__default.createElement(_Input.Search, {
    placeholder: t("labels.remove"),
    onSearch: handleRemoveItem,
    enterButton: /*#__PURE__*/React__default.createElement(MinusOutlined$2, null),
    value: removeCode,
    onChange: handleRemoveCodeChange,
    onPressEnter: handleRemoveKeyPress,
    disabled: field.isDisabled(action, data)
  }))), /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement(BarcodeTable, {
    entries: Object.values(collection.entries),
    field: field,
    fields: scannableEntity === null || scannableEntity === void 0 ? void 0 : scannableEntity.fields,
    selectKey: "id",
    count: addedItemsCount(),
    countLabel: t("labels.count")
  }))));
};

var setInitialData = createAction("setInitialData");
var scanItem = createActions$1("scanItem");
var removeItem = createActions$1("removeItem");

var StaticScannableTable = function StaticScannableTable(_ref) {
  var action = _ref.action,
      _ref$field = _ref.field,
      field = _ref$field === void 0 ? {} : _ref$field,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      data = _ref.data,
      entity = _ref.entity,
      _ref$includeLabel = _ref.includeLabel,
      includeLabel = _ref$includeLabel === void 0 ? true : _ref$includeLabel,
      _ref$canEdit = _ref.canEdit,
      canEdit = _ref$canEdit === void 0 ? true : _ref$canEdit;
  var dispatch = useDispatch();

  var _useTranslation = useTranslation("scannableTable"),
      t = _useTranslation.t;

  var _field$tableConfig = field.tableConfig,
      tableConfig = _field$tableConfig === void 0 ? {} : _field$tableConfig;
  var _tableConfig$response = tableConfig.responseConfig,
      dataAccessor = _tableConfig$response.dataAccessor,
      errorAccessor = _tableConfig$response.errorAccessor;

  var _useScanningState = useScanningState(),
      itemAlerts = _useScanningState.itemAlerts,
      setItemAlerts = _useScanningState.setItemAlerts,
      addCode = _useScanningState.addCode,
      setAddCode = _useScanningState.setAddCode,
      removeCode = _useScanningState.removeCode,
      setRemoveCode = _useScanningState.setRemoveCode,
      adding = _useScanningState.adding,
      setAdding = _useScanningState.setAdding,
      removing = _useScanningState.removing,
      setRemoving = _useScanningState.setRemoving;

  var _ref2 = useSelector(function (state) {
    return getEntity(state, "scan");
  }) || {},
      stateEntries = _ref2.current,
      errors = _ref2.errors,
      loading = _ref2.loading;

  var _useSelector = useSelector(function (state) {
    return getEntity(state, entity.pluralName);
  }),
      current = _useSelector.current;

  var entries = tableConfig !== null && tableConfig !== void 0 && tableConfig.filterFunction ? stateEntries === null || stateEntries === void 0 ? void 0 : stateEntries.filter(tableConfig.filterFunction) : stateEntries;
  useEffect(function () {
    var isErrorsEmpty = isEmpty$1(errors);

    if (!isErrorsEmpty) {
      setItemAlerts({
        type: "error",
        message: formatErrors(errors)
      });
    } else if (adding && !loading && isErrorsEmpty) {
      setItemAlerts({
        type: "success",
        message: t("feedback.add", {
          label: getTranslatedValue(field.label)
        })
      });
      setAddCode(null);
    } else if (removing && !loading && isErrorsEmpty) {
      setItemAlerts({
        type: "success",
        message: t("feedback.remove", {
          label: getTranslatedValue(field.label)
        })
      });
      setRemoveCode(null);
    }
  }, [errors, loading]);
  useEffect(function () {
    if (!isEmpty$1(value) && value !== "_") {
      dispatch(setInitialData({
        current: value
      }));
    }
  }, [value]);

  var requestPayloadHandler = function requestPayloadHandler(value) {
    var _tableConfig$requestC, _tableConfig$requestC2, _tableConfig$requestC3, _tableConfig$requestC4, _tableConfig$requestC5, _ref3, _ref4;

    var endPoint = typeof (tableConfig === null || tableConfig === void 0 ? void 0 : (_tableConfig$requestC = tableConfig.requestConfig) === null || _tableConfig$requestC === void 0 ? void 0 : _tableConfig$requestC.endPoint) === "function" ? tableConfig === null || tableConfig === void 0 ? void 0 : (_tableConfig$requestC2 = tableConfig.requestConfig) === null || _tableConfig$requestC2 === void 0 ? void 0 : _tableConfig$requestC2.endPoint(current, value) : (_tableConfig$requestC3 = tableConfig.requestConfig) === null || _tableConfig$requestC3 === void 0 ? void 0 : _tableConfig$requestC3.endPoint;
    var data = tableConfig !== null && tableConfig !== void 0 && (_tableConfig$requestC4 = tableConfig.requestConfig) !== null && _tableConfig$requestC4 !== void 0 && _tableConfig$requestC4.payloadWrapper ? (_ref3 = {}, _ref3[tableConfig.requestConfig.payloadWrapper] = (_tableConfig$requestC5 = {}, _tableConfig$requestC5[field.identifier] = value, _tableConfig$requestC5), _ref3) : (_ref4 = {}, _ref4[field.identifier] = value, _ref4);
    return {
      endPoint: endPoint,
      data: data
    };
  };

  var handleAddItem = function handleAddItem(value) {
    dispatch(scanItem.request(_extends({}, requestPayloadHandler(value), {
      dataAccessor: dataAccessor,
      errorAccessor: errorAccessor
    })));
    setAdding(true);
    setRemoving(false);
    setItemAlerts({});
  };

  var handleRemoveItem = function handleRemoveItem(value) {
    dispatch(removeItem.request(_extends({}, requestPayloadHandler(value), {
      dataAccessor: dataAccessor,
      errorAccessor: errorAccessor
    })));
    setRemoving(true);
    setAdding(false);
    setItemAlerts({});
  };

  var handleRemoveKeyPress = function handleRemoveKeyPress(event) {
    if (event.key === "Enter") {
      var _event$target;

      event.preventDefault();
      handleRemoveItem((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    }
  };

  var handleAddKeyPress = function handleAddKeyPress(event) {
    if (event.key === "Enter") {
      var _event$target2;

      event.preventDefault();
      handleAddItem((_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value);
    }
  };

  var handleAddCodeChange = function handleAddCodeChange(event) {
    setAddCode(event.target.value);
  };

  var handleRemoveCodeChange = function handleRemoveCodeChange(event) {
    setRemoveCode(event.target.value);
  };

  var addedItemsCount = function addedItemsCount() {
    return tableConfig !== null && tableConfig !== void 0 && tableConfig.customItemCount ? tableConfig === null || tableConfig === void 0 ? void 0 : tableConfig.customItemCount(entries) : (entries === null || entries === void 0 ? void 0 : entries.length) || 0;
  };

  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ScannableTableWrapper, null, includeLabel && /*#__PURE__*/React__default.createElement(_Typography.Title, {
    level: 5
  }, getTranslatedValue(field.label)), !isEmpty$1(itemAlerts) && /*#__PURE__*/React__default.createElement(_Alert, {
    type: itemAlerts.type,
    message: itemAlerts.message
  }), canEdit && /*#__PURE__*/React__default.createElement(_Row, {
    gutter: [16, 16]
  }, /*#__PURE__*/React__default.createElement(_Col, {
    lg: 12,
    xs: 24
  }, /*#__PURE__*/React__default.createElement(_Input.Search, {
    placeholder: t("labels.add"),
    onSearch: handleAddItem,
    enterButton: /*#__PURE__*/React__default.createElement(AddIcon, null),
    value: addCode,
    onChange: handleAddCodeChange,
    onPressEnter: handleAddKeyPress,
    disabled: field.isDisabled(action, data),
    loading: adding && loading
  })), /*#__PURE__*/React__default.createElement(_Col, {
    lg: 12,
    xs: 24
  }, /*#__PURE__*/React__default.createElement(_Input.Search, {
    placeholder: t("labels.remove"),
    onSearch: handleRemoveItem,
    enterButton: /*#__PURE__*/React__default.createElement(MinusOutlined$2, null),
    value: removeCode,
    onChange: handleRemoveCodeChange,
    onPressEnter: handleRemoveKeyPress,
    disabled: field.isDisabled(action, data),
    loading: removing && loading
  }))), /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement(_Col, {
    span: 24
  }, /*#__PURE__*/React__default.createElement(BarcodeTable, {
    entries: entries,
    field: field,
    fields: field.fields,
    selectKey: "id",
    count: addedItemsCount(),
    countLabel: t("labels.count")
  })))));
};

var _excluded$f = ["field", "dataObject"];

var ScannablTableField = function ScannablTableField(_ref) {
  var field = _ref.field,
      dataObject = _ref.dataObject,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$f);

  var _field$tableConfig$ty = field.tableConfig.type,
      type = _field$tableConfig$ty === void 0 ? "static" : _field$tableConfig$ty;

  switch (type) {
    case "static":
      return /*#__PURE__*/React__default.createElement(StaticScannableTable, _extends({
        field: field
      }, props));

    case "dynamic":
      return /*#__PURE__*/React__default.createElement(DynamicScannableTable, _extends({
        field: field,
        dataObject: dataObject
      }, props));
  }
};

var ProfilePicture = function ProfilePicture(_ref) {
  var field = _ref.field,
      onChange = _ref.onChange,
      profilePicturePreview = _ref.profilePicturePreview;
  var entity = field.entity;
  var action = entity.action;

  var _useState = useState(),
      image = _useState[0],
      setImage = _useState[1];

  var accept = "image/*";

  var getBase64 = function getBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        return resolve(reader.result);
      };

      reader.onerror = function (error) {
        return reject(error);
      };
    });
  };

  var handleChange = function handleChange(files) {
    try {
      var file = files.fileList[0];

      var _temp2 = function () {
        if (file) {
          return Promise.resolve(getBase64(file.originFileObj)).then(function (preview) {
            setImage(preview);
            delete file.originFileObj.uid;
            onChange(field, file.originFileObj);
          });
        }
      }();

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleRemoveFile = function handleRemoveFile() {
    onChange(field, false);
  };

  return /*#__PURE__*/React__default.createElement(ProfilePictureWrapper, null, /*#__PURE__*/React__default.createElement(_Avatar, {
    shape: "circle",
    size: 70,
    src: image || profilePicturePreview,
    icon: !image && !profilePicturePreview && /*#__PURE__*/React__default.createElement(UserOutlined$2, null)
  }), action !== "show" && !field.disableUpload && /*#__PURE__*/React__default.createElement(_Upload, {
    accept: accept,
    onChange: handleChange,
    onRemove: handleRemoveFile,
    showUploadList: false,
    listType: "image",
    maxCount: 1
  }, /*#__PURE__*/React__default.createElement(EditIconWrapper, null, /*#__PURE__*/React__default.createElement(EditIcon, null))));
};

var ProfilePicture$1 = withFieldHandler(ProfilePicture);

var DataPageField = function DataPageField(_ref) {
  var field = _ref.field,
      value = _ref.value,
      data = _ref.data,
      role = _ref.role,
      fieldsData = _ref.fieldsData,
      entity = _ref.entity;
  var Component = field.component,
      preventMultiple = field.preventMultiple;

  if (Component) {
    return /*#__PURE__*/React__default.createElement(ExternalComponentWrapper$1, null, /*#__PURE__*/React__default.createElement(Component, {
      value: value,
      field: field
    }));
  }

  var defaultDisplayValue = field.getDisplayValue(fieldsData, {
    value: value,
    inDataPage: true,
    tagsConfig: field.tagsConfig
  });
  var fieldType = field.getType({
    dataObject: data
  });

  switch (fieldType) {
    case "profilePicture":
      return /*#__PURE__*/React__default.createElement(ProfilePicture$1, {
        field: field,
        profilePicturePreview: value
      });

    case "image":
      return /*#__PURE__*/React__default.createElement(Image, {
        customClass: "custom-img",
        src: value
      });

    case "video":
      return value ? /*#__PURE__*/React__default.createElement(ReactPlayer, {
        url: value,
        controls: true
      }) : null;

    case "editor":
      return /*#__PURE__*/React__default.createElement("div", null, ReactHtmlParser(value));

    case "dynamic":
      if (preventMultiple) {
        return Object.keys(value).map(function (key) {
          return /*#__PURE__*/React__default.createElement(DataPageField, _extends({
            key: key
          }, value[key], {
            data: data,
            role: role
          }));
        });
      } else {
        return value.map(function (rowValues) {
          return rowValues.map(function (rowValue, index) {
            return /*#__PURE__*/React__default.createElement(DataPageField, _extends({
              key: index
            }, rowValue, {
              data: data,
              role: role
            }));
          });
        });
      }

    case "transferList":
      return /*#__PURE__*/React__default.createElement(DisplayList, {
        items: value,
        field: field
      });

    case "json":
      return /*#__PURE__*/React__default.createElement(JsonField$1, {
        field: field,
        value: value,
        action: "show"
      });

    case "markerMap":
      return /*#__PURE__*/React__default.createElement(MarkerMapField$1, {
        action: "show",
        field: field,
        value: value
      });

    case "polygonMap":
      return /*#__PURE__*/React__default.createElement(PolygonMapField$1, {
        action: "show",
        field: field,
        value: value
      });

    case "table":
      {
        return /*#__PURE__*/React__default.createElement(TableField, {
          field: field,
          data: value,
          role: role,
          dataObject: data,
          canEditTableField: false
        });
      }

    case "scannableTable":
      return /*#__PURE__*/React__default.createElement(ScannablTableField, {
        entity: entity,
        field: field,
        value: value,
        role: role,
        dataObject: data,
        includeLabel: false,
        canEdit: false
      });

    default:
      return defaultDisplayValue();
  }
};

var DataPage = function DataPage(_ref) {
  var entity = _ref.entity,
      fields = _ref.entity.fields,
      data = _ref.data;

  var _useTranslation = useTranslation("general"),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useContext = useContext(AppContext),
      entities = _useContext.entities,
      authConfig = _useContext.authConfig,
      privateRouteURL = _useContext.privateRouteURL,
      disableBackBtn = _useContext.disableBackBtn;

  var auth = useSelector(function (state) {
    return getEntity(state, "auth");
  });

  var _ref2 = auth[authConfig.name] || {},
      role = _ref2.role;

  var dispatch = useDispatch();

  var isFieldPresentInSchema = function isFieldPresentInSchema(field, dataObject, hideIfWrapped) {
    var parentField = field.getParentField();

    if (field.isVirtual() && (parentField === null || parentField === void 0 ? void 0 : parentField.type) === "api") {
      return parentField.isFieldPresentInSchema(field, dataObject, hideIfWrapped);
    }

    return true;
  };

  var getRowData = function getRowData(dataObject, fields) {
    if (dataObject === void 0) {
      dataObject = {};
    }

    var row = [];
    fields.filter(function (field) {
      return !field.isHiddenInShow(dataObject, role);
    }).forEach(function (field) {
      if (!isFieldPresentInSchema(field, dataObject, true)) return;

      switch (field.getType({
        dataObject: data
      })) {
        case "profilePicture":
        case "file":
        case "image":
        case "video":
          var fieldValue = field.getDataValue(dataObject, {
            constructFileAccessor: true,
            canReturnUndefined: true
          }) || field.getDataValue(dataObject, {
            constructFileAccessor: false
          });
          row.push({
            field: field,
            value: fieldValue
          });
          break;

        case "dynamic":
          if (!isFieldPresentInSchema(field, dataObject)) break;

          if (field.preventMultiple) {
            var fieldsData = field.getDataValue(dataObject, {
              canReturnUndefined: true
            }) || {};
            row.push({
              field: field,
              value: Object.keys(fieldsData).map(function (key) {
                return getRowData(fieldsData, field.fields);
              })
            });
          } else {
            var _fieldsData = field.getDataValue(dataObject, {
              canReturnUndefined: true
            }) || [];

            row.push({
              field: field,
              value: _fieldsData.map(function (fieldData) {
                return getRowData(fieldData, field.fields);
              })
            });
          }

          break;

        case "transferList":
          {
            var _fieldsData2 = dataObject[field.transferListConfig.accessor];
            field.extraLabelData = "(" + _fieldsData2.length + ")";
            row.push({
              field: field,
              value: _fieldsData2
            });
            break;
          }

        case "api":
          {
            var schema = field.getDataValue(dataObject, {
              customAccessor: field.getSchemaShowAccessor()
            });

            if (!schema) {
              console.warn("schema not found for field:" + field.identifier);
              break;
            }

            var _field$getFields = field.getFields(schema, {
              inShow: true
            }),
                groups = _field$getFields.groups;

            if (!groups) break;
            groups.forEach(function (group) {
              if (group.nestedGroups) return;
              var fieldValues = group.fields.map(function (groupField) {
                return groupField.getDataValue(dataObject);
              });
              row.push({
                wrapper: group.label,
                field: field,
                fields: group.fields,
                fieldValues: fieldValues
              });
            });
            break;
          }

        default:
          row.push({
            field: field,
            value: field.getDataValue(dataObject)
          });
      }
    });
    return row;
  };

  var renderFieldsValues = function renderFieldsValues(fieldsData, entityFields, index) {
    if (fieldsData === void 0) {
      fieldsData = data;
    }

    if (entityFields === void 0) {
      entityFields = fields;
    }

    var values = getRowData(fieldsData, entityFields);
    return values.map(function (row) {
      var field = row.field,
          wrapper = row.wrapper;
      var fieldType = field.getType({
        dataObject: data
      });
      var columnProps = {
        lg: entity.isFullWidth ? field.lgCol ? field.lgCol * 2 : 8 : 24,
        md: entity.isFullWidth ? field.mdCol ? field.mdCol * 2 : 8 : 24,
        xs: field.xsCol ? field.xsCol * 2 : 24,
        className: "data-page-col"
      };
      var rowValue = "";

      if (fieldType === "dynamic") {
        if (field.preventMultiple) {
          var dynamicFieldsData = field.getDataValue(fieldsData, {
            canReturnUndefined: true
          }) || {};
          rowValue = renderFieldsValues(dynamicFieldsData, field.fields);
        } else {
          var _dynamicFieldsData = field.getDataValue(fieldsData, {
            canReturnUndefined: true
          }) || [];

          rowValue = _dynamicFieldsData.map(function (fd, index) {
            return renderFieldsValues(fd, field.fields, index);
          });
        }
      } else {
        rowValue = /*#__PURE__*/React__default.createElement(DataPageField, _extends({
          entity: entity
        }, row, {
          fieldsData: fieldsData,
          data: data,
          role: role
        }));
      }

      if (wrapper) {
        return /*#__PURE__*/React__default.createElement(_Col, _extends({}, columnProps, {
          key: field.identifier
        }), /*#__PURE__*/React__default.createElement(_Typography.Title, {
          level: 5
        }, wrapper), /*#__PURE__*/React__default.createElement("div", {
          className: "dynamic-container"
        }, row.fields.map(function (rowField, index) {
          return /*#__PURE__*/React__default.createElement("div", {
            key: rowField.identifier + "-" + index
          }, rowField.hasLabel() && /*#__PURE__*/React__default.createElement(_Typography.Text, {
            strong: true
          }, rowField.getLabel(), ": \xA0"), "" + row.fieldValues[index]);
        })));
      }

      if (field.getType({
        dataObject: data
      }) === "dynamic") {
        var valueContainerClassName = field.isVirtual() ? "virtual-dynamic-value-container" : "dynamic-value-container";
        return /*#__PURE__*/React__default.createElement(_Col, _extends({}, columnProps, {
          key: field.identifier
        }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(_Typography.Title, {
          level: 5
        }, field.getLabel() + " " + (field.extraLabelData ? field.extraLabelData : "")), /*#__PURE__*/React__default.createElement("div", {
          className: "dynamic-container"
        }, field.preventMultiple ? /*#__PURE__*/React__default.createElement("div", {
          className: valueContainerClassName
        }, field.showEditButton && /*#__PURE__*/React__default.createElement(Link, {
          to: getURL(privateRouteURL, entities[field.editEntityName].pluralName + "/" + row.value.find(function (dynamicField) {
            return dynamicField.field.identifier === field.editEntityIdentifier;
          }).value + "/edit")
        }, /*#__PURE__*/React__default.createElement(_Button, {
          className: i18n.dir() === "rtl" ? "dynamic-back-button-rtl" : "dynamic-back-button",
          type: "text"
        }, t("edit"))), /*#__PURE__*/React__default.createElement("div", null, rowValue)) : rowValue.map(function (dynamicFieldRow, index) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: valueContainerClassName,
            key: index
          }, field.showEditButton && /*#__PURE__*/React__default.createElement(Link, {
            to: getURL(privateRouteURL, entities[field.editEntityName].pluralName + "/" + row.value[index].find(function (dynamicField) {
              return dynamicField.field.identifier === field.editEntityIdentifier;
            }).value + "/edit")
          }, /*#__PURE__*/React__default.createElement(_Button, {
            className: i18n.dir() === "rtl" ? "dynamic-back-button-rtl" : "dynamic-back-button",
            type: "text"
          }, t("edit"))), dynamicFieldRow, /*#__PURE__*/React__default.createElement(_Divider, null));
        }))), /*#__PURE__*/React__default.createElement(_Divider, null));
      }

      if (field.getParentField()) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: field.identifier + "-" + index
        }, /*#__PURE__*/React__default.createElement(_Typography.Text, {
          strong: true
        }, field.getLabel(), " ", field.extraLabelData && field.extraLabelData, ": \xA0"), rowValue);
      }

      return /*#__PURE__*/React__default.createElement(_Col, _extends({}, columnProps, {
        key: field.identifier
      }), /*#__PURE__*/React__default.createElement("div", null, field.hasLabel() && /*#__PURE__*/React__default.createElement(_Typography.Title, {
        level: 5
      }, field.getLabel() + " " + (field.extraLabelData ? field.extraLabelData : "")), rowValue), /*#__PURE__*/React__default.createElement(_Divider, null));
    });
  };

  var handleBack = function handleBack() {
    dispatch(goBack());
  };

  return /*#__PURE__*/React__default.createElement(Container, {
    className: entity.customDataPageClass
  }, !disableBackBtn && /*#__PURE__*/React__default.createElement(_Button, {
    className: "back-button",
    onClick: handleBack,
    type: "text",
    icon: i18n.dir() === "rtl" ? /*#__PURE__*/React__default.createElement(ArrowLeftOutlined$2, {
      rotate: 180
    }) : /*#__PURE__*/React__default.createElement(ArrowLeftOutlined$2, null)
  }, t("back")), entity.canEdit(role, data) && /*#__PURE__*/React__default.createElement(Link, {
    to: entity.getIdentifierValue(data) + "/edit"
  }, /*#__PURE__*/React__default.createElement(_Button, {
    className: "back-button",
    type: "text"
  }, t("edit"))), entity.title && /*#__PURE__*/React__default.createElement(_Typography.Title, {
    level: 2,
    className: "data-page-title"
  }, entity.getDisplayTitle("show")), entity.subTitle && /*#__PURE__*/React__default.createElement(_Typography.Text, {
    strong: true,
    className: "data-page-subtitle"
  }, entity.getDisplaySubTitle("show")), /*#__PURE__*/React__default.createElement(_Row, {
    gutter: 24,
    className: "data-page-row"
  }, renderFieldsValues()));
};

var AuthGenerator = function AuthGenerator(_ref) {
  var token = _ref.match.params.token,
      _ref$location = _ref.location,
      pathname = _ref$location.pathname,
      state = _ref$location.state,
      _ref$entity = _ref.entity,
      requestConfig = _ref$entity.requestConfig,
      queryParamName = _ref$entity.queryParamName,
      isFullScreen = _ref$entity.isFullScreen,
      isFullHeight = _ref$entity.isFullHeight,
      hideUpperHeader = _ref$entity.hideUpperHeader,
      customDataFormClass = _ref$entity.customDataFormClass,
      _ref$entity$logoTitle = _ref$entity.logoTitle,
      logoTitle = _ref$entity$logoTitle === void 0 ? "WebOps" : _ref$entity$logoTitle,
      preventAccess = _ref$entity.preventAccess,
      landingSection = _ref$entity.landingSection,
      hideGlobalErrors = _ref$entity.hideGlobalErrors,
      entity = _ref.entity,
      action = _ref.action;

  var _useContext = useContext(AppContext),
      authConfig = _useContext.authConfig,
      availableLanguages = _useContext.availableLanguages,
      logo = _useContext.logo,
      landingImage = _useContext.landingImage,
      privateRouteURL = _useContext.privateRouteURL,
      disableLocalization = _useContext.disableLocalization,
      notificationConfigs = _useContext.notificationConfigs,
      defaultPrivateRouteURL = _useContext.defaultPrivateRouteURL;

  var _useTranslation = useTranslation(["authGenerator", "general", "header"]),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var dispatch = useDispatch();

  var _useFirebasePermissio = useFirebasePermissions(),
      setFirebaseToken = _useFirebasePermissio.setFirebaseToken,
      deleteDeviceToken = _useFirebasePermissio.deleteDeviceToken;

  useEffect(function () {
    if (notificationConfigs.enabled) adminConfigs.setDeleteFirebaseToken(deleteDeviceToken);
  }, [deleteDeviceToken]);
  useEffect(function () {
    if (action !== "create") dispatch(authActionShow.request({
      requestConfig: requestConfig,
      authConfig: authConfig
    }));
  }, [action, dispatch, requestConfig, authConfig, i18n.language]);
  var direction = i18n.dir();
  var initialState = {};
  if (pathname === "/login") initialState.redirectPath = (state === null || state === void 0 ? void 0 : state.from) || defaultPrivateRouteURL || privateRouteURL;
  if (queryParamName) initialState[queryParamName] = token;

  var _useSelector = useSelector(function (state) {
    return getEntity(state, "auth");
  }),
      error = _useSelector.error,
      message = _useSelector.message,
      current = _useSelector.current,
      loading = _useSelector.loading;

  var onSubmit = function onSubmit(state) {
    var redirectPath = initialState.redirectPath;
    var credentials = createCredentials(_extends({}, state, initialState), requestConfig);
    dispatch(authAction.request(_extends({
      config: requestConfig,
      credentials: credentials,
      redirectPath: redirectPath,
      action: action,
      entity: entity
    }, notificationConfigs.enabled && {
      setFirebaseToken: setFirebaseToken
    })));
  };

  useEffect(function () {
    if (message || error) dispatch(resetReducer());
  }, []);

  var handleBackButton = function handleBackButton() {
    return dispatch(goBack());
  };

  var isAuthenticated = action !== "create" || requestConfig.authenticated;
  var isFullWidth = isFullScreen && !isAuthenticated;
  var showLandingSection = !isAuthenticated && !isFullWidth && landingSection;
  var authEntity = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var auth = authEntity === null || authEntity === void 0 ? void 0 : authEntity[authConfig.name];

  if (preventAccess && preventAccess(auth)) {
    showNotification(entity, "error", t("authGenerator:accessDenied"));
    dispatch(push(privateRouteURL));
  }

  var displayLinks = function displayLinks(links) {
    if (pathname === "/login" && authConfig.customLinks && !entity.customLinks) console.warn("Please add customLinks directly to the login entity. The customLinks provided in authConfig will soon be deprecated in the next major release");
    return /*#__PURE__*/React__default.createElement(Fragment, null, links === null || links === void 0 ? void 0 : links.map(function (_ref2, index) {
      var linkTitle = _ref2.linkTitle,
          path = _ref2.path,
          _ref2$prefix = _ref2.prefix,
          prefix = _ref2$prefix === void 0 ? "" : _ref2$prefix;
      return /*#__PURE__*/React__default.createElement(_Typography.Text, {
        key: index,
        className: "auth-extra-links"
      }, getTranslatedValue(prefix), /*#__PURE__*/React__default.createElement(ForgetLink, {
        to: path,
        isfullwidth: isFullWidth
      }, getTranslatedValue(linkTitle)));
    }));
  };

  return action === "show" ? /*#__PURE__*/React__default.createElement(Loadable, {
    entity: entity,
    render: function render(props) {
      return /*#__PURE__*/React__default.createElement(DataPage, props);
    },
    loading: loading,
    data: current
  }) : /*#__PURE__*/React__default.createElement(AuthLayoutWrapper, {
    isAuthenticated: isAuthenticated,
    isFullWidth: isFullWidth,
    isFullHeight: isFullHeight,
    showLandingSection: showLandingSection,
    className: customDataFormClass
  }, !isAuthenticated && !isFullWidth && !landingSection && /*#__PURE__*/React__default.createElement(AuthImage, {
    landing: entity.landingImage || landingImage
  }), showLandingSection && /*#__PURE__*/React__default.createElement("div", {
    className: "auth-landing-section"
  }, /*#__PURE__*/React__default.createElement(_Typography.Title, {
    type: "secondary",
    level: 5
  }, getTranslatedValue(landingSection.title)), /*#__PURE__*/React__default.createElement(_Typography.Text, {
    type: "secondary"
  }, getTranslatedValue(landingSection.description))), /*#__PURE__*/React__default.createElement(AuthFormWrapper, {
    isAuthenticated: isAuthenticated,
    isFullWidth: isFullWidth,
    direction: direction,
    showLandingSection: showLandingSection,
    className: "auth-form-section-wrapper"
  }, !isAuthenticated && !isFullWidth && !hideUpperHeader && /*#__PURE__*/React__default.createElement(HeaderComponent, {
    isFullHeight: isFullHeight
  }, pathname !== "/login" && /*#__PURE__*/React__default.createElement(_Button, {
    icon: /*#__PURE__*/React__default.createElement(ArrowLeftOutlined$2, null),
    onClick: handleBackButton,
    type: "text",
    shape: "circle",
    size: "large"
  }), !disableLocalization && availableLanguages.length > 1 && /*#__PURE__*/React__default.createElement(_Button, {
    type: "text",
    shape: "circle",
    size: "large",
    className: "lng-btn",
    onClick: toggleLanguage
  }, t("header:language"))), /*#__PURE__*/React__default.createElement(AuthContainer, {
    isFullWidth: isFullWidth,
    className: "auth-form-container"
  }, !isAuthenticated && !isFullWidth && !hideUpperHeader && /*#__PURE__*/React__default.createElement(TitleWrapper, null, /*#__PURE__*/React__default.createElement(AuthLogo, {
    logo: logo
  }), /*#__PURE__*/React__default.createElement(Title$1, null, /*#__PURE__*/React__default.createElement(_Typography.Title, {
    type: "secondary",
    level: 2
  }, logoTitle), /*#__PURE__*/React__default.createElement(_Typography.Title, {
    type: "secondary",
    level: 4
  }, authConfig.displayName))), /*#__PURE__*/React__default.createElement(_Typography.Title, {
    type: "secondary",
    level: 2
  }, entity.getDisplayTitle(action)), /*#__PURE__*/React__default.createElement(_Typography.Text, {
    type: "secondary"
  }, entity.getDisplaySubTitle(action)), !entity.showAuthFormNotification && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Popups, null, error && !hideGlobalErrors && /*#__PURE__*/React__default.createElement(_Typography.Text, {
    type: "danger",
    strong: true
  }, formatErrors(error))), /*#__PURE__*/React__default.createElement(Popups, null, message && /*#__PURE__*/React__default.createElement(_Typography.Text, {
    type: "success",
    strong: true
  }, message))), /*#__PURE__*/React__default.createElement(Loadable, {
    entity: entity,
    action: action,
    onSubmit: onSubmit,
    errors: error,
    loading: loading,
    data: current,
    isFullWidth: isFullWidth,
    inAuthForm: true,
    render: function render(props) {
      return /*#__PURE__*/React__default.createElement(DataForm$1, _extends({
        inAuthForm: true
      }, props));
    }
  }), displayLinks(entity.customLinks || pathname === "/login" && authConfig.customLinks || []))));
};

var _templateObject$a;

var ChatWrapper = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n  height: calc(100vh - 100px);\n  background-color: #f0f2f5;\n  @media only screen and (max-width: ", ") {\n    height: ", "px;\n    overflow: hidden;\n    margin-top: -20px;\n    transition: all 0.3s ease;\n    border: 1px solid gray;\n  }\n"])), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.height - 90;
});

var Chat = function Chat() {
  var size = useWindowSize();

  var _useContext = useContext(AppContext),
      chatConfigs = _useContext.chatConfigs,
      authConfig = _useContext.authConfig,
      url = _useContext.url,
      allEntities = _useContext.allEntities;

  var chatOpsWeb = chatConfigs.chatOpsWeb,
      isObserver = chatConfigs.isObserver,
      cableURL = chatConfigs.cableURL,
      senderType = chatConfigs.senderType,
      nameSpace = chatConfigs.nameSpace,
      filters = chatConfigs.filters;

  var _useState = useState({}),
      filterValues = _useState[0],
      setFilterValues = _useState[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var authEntity = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var auth = authEntity === null || authEntity === void 0 ? void 0 : authEntity[authConfig.name];

  var _useState2 = useState(function () {
    return loadFromLocalStorage("authHeaders");
  }),
      headers = _useState2[0];

  var authenticatedCableURL = cableURL + "?provider=" + senderType + "&token=" + headers.token + "&client=" + headers.client + "&uid=" + headers.uid;
  var apiBaseURL = url + "/" + nameSpace + "/";
  var chatopsOptions = useMemo(function () {
    var newBroadcastUserList = chatOpsWeb.broadcastUserList && chatOpsWeb.broadcastUserList.map(function (userType) {
      return _extends({}, userType, {
        label: getTranslatedValue(userType.label)
      });
    });
    return _extends({}, chatOpsWeb, {
      footer: !isObserver,
      broadcastUserList: newBroadcastUserList,
      text: {
        selectConversation: t("chat:selectConversation"),
        searchConversations: t("chat:searchConversations"),
        send: t("chat:send"),
        firstMessage: t("chat:firstMessage"),
        sentAttachment: "sent an attachment",
        isTyping: t("chat:isTyping"),
        areTyping: t("chat:areTyping"),
        writeMessage: t("chat:writeMessage"),
        broadcast: t("chat:broadcast"),
        noContactsFound: t("chat:noContactsFound"),
        contactsTitle: t("chat:contactsTitle"),
        selectAll: t("chat:selectAll")
      },
      direction: i18n.dir(),
      locale: function locale(defaultDateFNSLocale) {
        return _extends({}, defaultDateFNSLocale[i18n.language === "ar" ? "arDZ" : "enUS"], {
          formatRelative: function formatRelative(token) {
            return {
              today: "'Today'",
              yesterday: "'Yesterday'",
              lastWeek: "eeee",
              other: "MMM dd, yyyy"
            }[token];
          }
        });
      }
    });
  }, [t]);
  var onDependeeFilter = useCallback(function () {}, []);
  var onFilter = useCallback(function (identifier, value) {
    setFilterValues(function (values) {
      var _extends2;

      return _extends({}, values, (_extends2 = {}, _extends2[identifier] = value, _extends2));
    });
  }, []);
  var dataFilters = filters && /*#__PURE__*/React__default.createElement(Fragment, null, filters.map(function (filter) {
    var entity = allEntities[filter.entity];
    return /*#__PURE__*/React__default.createElement(DataFilter, {
      key: filter.name,
      filter: filter,
      onFilter: onFilter,
      onDependeeFilter: onDependeeFilter,
      entityName: entity.pluralName,
      getLabel: entity.getDisplayName,
      entity: entity,
      isMulti: false
    });
  }));
  return /*#__PURE__*/React__default.createElement(ChatWrapper, {
    height: size.height
  }, /*#__PURE__*/React__default.createElement(ChatopsOnActioncable, {
    user: _extends({
      type: senderType
    }, auth),
    cableURL: authenticatedCableURL,
    authHeaders: headers,
    apiBaseURL: apiBaseURL,
    chatopsOptions: chatopsOptions,
    isGeneralChannelEnabled: false,
    isObserver: chatConfigs.isObserver,
    dataFilters: dataFilters,
    filterValues: filterValues
  }));
};

var generateRoutes = function generateRoutes(role, configs) {
  var entities = configs.entities,
      privateRouteURL = configs.privateRouteURL,
      publicRouteURL = configs.publicRouteURL,
      authEntities = configs.authEntities,
      appCustomRoutes = configs.customRoutes,
      chatConfigs = configs.chatConfigs;

  var generatePrivateRoutesHelper = function generatePrivateRoutesHelper(_ref) {
    var entity = _ref.entity,
        accum = _ref.accum,
        parent = _ref.parent;
    if (!entity.canUse(role) || entity.isPassive || entity.isChild && !parent) return accum;
    if (entity.canCreate(role)) accum.push({
      path: getURL(privateRouteURL, entity.getPathnameForAction("create")),
      renderer: function renderer(props) {
        return /*#__PURE__*/React__default.createElement(Generator, _extends({}, props, {
          entity: entity,
          action: "create"
        }));
      }
    });
    if (entity.canEdit(role)) accum.push({
      path: getURL(privateRouteURL, entity.getPathnameForAction("edit")),
      renderer: function renderer(props) {
        return /*#__PURE__*/React__default.createElement(Generator, _extends({}, props, {
          entity: entity,
          action: "edit"
        }));
      }
    });
    if (entity.canList(role)) accum.push({
      path: getURL(privateRouteURL, entity.getPathnameForAction("list")),
      renderer: function renderer(props) {
        return /*#__PURE__*/React__default.createElement(Generator, _extends({}, props, {
          entity: entity,
          action: "list"
        }));
      }
    });
    if (entity.canShow(role)) accum.push({
      path: getURL(privateRouteURL, entity.getPathnameForAction("show")),
      renderer: function renderer(props) {
        return /*#__PURE__*/React__default.createElement(Generator, _extends({}, props, {
          entity: entity,
          action: "show"
        }));
      }
    });
    return accum;
  };

  var generatePrivateRoutes = function generatePrivateRoutes() {
    var entityRoutes = Object.values(entities).reduce(function (accum, entity) {
      accum = generatePrivateRoutesHelper({
        entity: entity,
        accum: accum
      });

      if (entity.childEntities) {
        entity.childEntities.map(function (child) {
          accum = generatePrivateRoutesHelper({
            entity: child,
            accum: accum,
            parent: entity
          });
        });
      }

      var _entity$customRoutes = entity.customRoutes,
          customRoutes = _entity$customRoutes === void 0 ? [] : _entity$customRoutes;
      customRoutes.forEach(function (route, index) {
        var path = route.path,
            RouteComponent = route.component,
            _route$customProps = route.customProps,
            customProps = _route$customProps === void 0 ? {} : _route$customProps;
        if (entity.canRolePerformAction(role, ["customRoutes", index, "authorizedRoles"])) accum.push({
          path: getURL(privateRouteURL, path),
          renderer: function renderer(props) {
            return /*#__PURE__*/React__default.createElement(RouteComponent, _extends({}, props, {
              entity: entity,
              customProps: customProps
            }));
          }
        });
      });
      return accum;
    }, []);
    if (!chatConfigs.enabled) return entityRoutes;
    var chatRoute = {
      path: getURL(privateRouteURL, "chat"),
      renderer: function renderer() {
        return /*#__PURE__*/React__default.createElement(Chat, null);
      }
    };
    entityRoutes.push(chatRoute);
    return entityRoutes;
  };

  var generateAuthRoutes = function generateAuthRoutes() {
    return Object.values(authEntities).reduce(function (accum, entity) {
      if (entity.action !== "create" || entity.requestConfig.authenticated) {
        accum.privateAuthRoutes.push({
          path: getURL(privateRouteURL, entity.path),
          renderer: function renderer(props) {
            return /*#__PURE__*/React__default.createElement(AuthGenerator, _extends({}, props, {
              entity: entity,
              action: entity.action
            }));
          }
        });
        return accum;
      }

      accum.publicAuthRoutes.push({
        path: getURL(publicRouteURL, entity.path),
        publicRoutes: true,
        renderer: function renderer(props) {
          return /*#__PURE__*/React__default.createElement(Fragment, null, entity.isFullScreen && /*#__PURE__*/React__default.createElement(Header$1, {
            disableActionsMenu: true,
            disableMenu: true
          }), /*#__PURE__*/React__default.createElement(AuthGenerator, _extends({}, props, {
            entity: entity,
            action: entity.action
          })));
        }
      });
      return accum;
    }, {
      privateAuthRoutes: [],
      publicAuthRoutes: []
    });
  };

  var generateAppCustomRoutes = function generateAppCustomRoutes() {
    return appCustomRoutes === null || appCustomRoutes === void 0 ? void 0 : appCustomRoutes.reduce(function (accum, route) {
      if (route.authorizedRoles && role && !route.authorizedRoles.includes(role)) return accum;
      if (route.isPrivate) accum.privateCustomRoutes.push(route);else accum.publicCustomRoutes.push(route);
      return accum;
    }, {
      privateCustomRoutes: [],
      publicCustomRoutes: []
    });
  };

  var privateRoutes = generatePrivateRoutes();

  var _generateAuthRoutes = generateAuthRoutes(),
      privateAuthRoutes = _generateAuthRoutes.privateAuthRoutes,
      publicAuthRoutes = _generateAuthRoutes.publicAuthRoutes;

  var _generateAppCustomRou = generateAppCustomRoutes(),
      privateCustomRoutes = _generateAppCustomRou.privateCustomRoutes,
      publicCustomRoutes = _generateAppCustomRou.publicCustomRoutes;

  return {
    privateRoutes: [].concat(privateRoutes, privateAuthRoutes),
    publicRoutes: publicAuthRoutes,
    privateCustomRoutes: privateCustomRoutes,
    publicCustomRoutes: publicCustomRoutes
  };
};

var defaultTheme = {
  breakpoints: {
    xxs: "360px",
    xs: "480px",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
    xxl: "1600px"
  },
  colors: {
    primary: "#131313",
    background: "#131313",
    main: "#fff",
    secondary: "#131313",
    tableBorder: "#c7c7c7"
  },
  sidebar: {
    fixed: true,
    theme: "dark"
  },
  header: {
    fixed: true,
    height: 60
  },
  footer: {},
  authLogo: {
    width: "150px",
    height: "90px"
  }
};
var defaultAuthConfig = {
  name: "admin",
  pluralName: "admins",
  pathName: "admins",
  serverName: "admin",
  serverPluralName: "admins",
  displayName: "Admin",
  endpoint: "admin/admins",
  customShowEndpoint: "self",
  saveAuthHeadersOnce: false,
  enableAccountCreation: false
};
var defaultDashboardConfig = {
  groups: [{
    components: [{
      type: "welcome",
      config: {}
    }, {
      type: "entityGroups",
      config: {}
    }]
  }]
};
var defaultApiEntitiesConfig = {
  enabled: false,
  endpoint: "admin/content_types",
  serverName: "content_types",
  entitiesConfig: {
    endpointPrefix: "site/content",
    serverPluralName: "content_entries",
    serverName: "content_entry",
    valueAccessorName: "values"
  }
};

var addAbsolutePathToImage = function addAbsolutePathToImage(imageUrl) {
  if (!imageUrl) return null;
  return imageUrl.startsWith("http") ? imageUrl : "//" + imageUrl;
};

var defaulChatConfigs = {
  chatOpsWeb: {
    conversationName: function conversationName(conversation) {
      return conversation.target_participation.participant.name;
    },
    conversationNameInChat: function conversationNameInChat(conversation) {
      return conversation.target_participation.participant.name;
    },
    getIdFromConversation: function getIdFromConversation(conversation) {
      var _conversation$target_, _conversation$target_2;

      return conversation === null || conversation === void 0 ? void 0 : (_conversation$target_ = conversation.target_participation) === null || _conversation$target_ === void 0 ? void 0 : (_conversation$target_2 = _conversation$target_.participant) === null || _conversation$target_2 === void 0 ? void 0 : _conversation$target_2.id;
    },
    resolveImageMessageURL: function resolveImageMessageURL(attachment) {
      var imageFields = ["large", "medium", "thumbnail"];

      var adjustedAttachment = _extends({}, attachment);

      imageFields.forEach(function (field) {
        if (!adjustedAttachment[field]) return;
        if (adjustedAttachment[field].startsWith("http")) return;
        adjustedAttachment[field] = "//" + attachment[field];
      });
      return adjustedAttachment;
    },
    resolveUserImage: function resolveUserImage(user) {
      return addAbsolutePathToImage(user.image_url);
    },
    senderName: function senderName(sender, users) {
      var _users$sender;

      return (_users$sender = users[sender]) === null || _users$sender === void 0 ? void 0 : _users$sender.name;
    },
    theme: {
      primaryColor: "#131313",
      background: "https://res.cloudinary.com/thewebops/image/upload/v1600629686/background_jvg2z3.jpg"
    },
    resolveConversationTargetImage: function resolveConversationTargetImage(conversation) {
      return addAbsolutePathToImage(conversation.target_participation.participant.image_url);
    },
    resolveBroadcastContactName: function resolveBroadcastContactName(contact) {
      return contact.name;
    },
    isBroadcastEnabled: false
  },
  chatopsActionCable: {},
  isObserver: false,
  cableURL: "http://localhost:3000/chat_engine/cable",
  senderType: "Admin",
  nameSpace: "admins",
  enabled: false
};
var defaultHiddenBreadCrumbsPaths = ["chat"];
var defaultapiFieldsConfig = {
  supportedLanguages: ["en", "ar"]
};

var loginCustomLinks = function loginCustomLinks(enableAccountCreation) {
  if (enableAccountCreation) console.warn("enableAccountCreation config in authConfig will soon be deprecated in the next major release.");
  return [{
    linkTitle: {
      en: "Forgot Password?",
      ar: "هل نسيت كلمة السر؟"
    },
    path: "/forgetPassword"
  }, {
    linkTitle: {
      en: "Resend Confirmation Link",
      ar: "اعادة ارسال رابط التأكيداستلمت كود التفعيل؟ فعل الاكونت الخاص بك الان"
    },
    path: "/resendConfirmationEmail"
  }].concat(enableAccountCreation ? [{
    linkTitle: {
      en: "Not a user? register now",
      ar: "لست عميل؟ سجل الان"
    },
    path: "/register"
  }] : []);
};

var adminConfigs = function () {
  var configs;
  return {
    customAuthConfigs: function customAuthConfigs(newAuthConfigs) {
      return _extends({}, defaultAuthConfig, {
        customLinks: loginCustomLinks(newAuthConfigs === null || newAuthConfigs === void 0 ? void 0 : newAuthConfigs.enableAccountCreation)
      }, newAuthConfigs);
    },
    customEntities: function customEntities(entities, authEntities, authConfig, dashboardConfig) {
      configs.authEntities = authEntities === null || authEntities === void 0 ? void 0 : authEntities.map(function (entity) {
        return entity(authConfig);
      });
      configs.allEntities = _extends({}, entities, setReferencedEntities(_extends({}, entities, configs.authEntities)), setDashBoardEntities(entities, dashboardConfig));
      configs.entities = configs.allEntities;
      return configs.allEntities;
    },
    init: function init(appConfigs) {
      var _this = this;

      if (configs) {
        return configs;
      } else {
        var _loadFromLocalStorage, _configs$authConfig;

        configs = {
          authConfig: defaultAuthConfig,
          theme: defaultTheme,
          entities: {},
          publicRouteURL: "/",
          privateRouteURL: "/app",
          disableLocalization: false,
          resources: resources,
          googleApiKey: GOOGLE_API_KEY,
          disableFooter: true,
          disableAuthHeader: true,
          notificationConfigs: {
            enabled: false,
            enableMapSelectors: true
          },
          chatConfigs: defaulChatConfigs,
          apiEntities: {}
        };
        configs.authConfig = this.customAuthConfigs(appConfigs.authConfig);
        configs.availableLanguages = Object.keys(_extends({}, resources, appConfigs.languageResources));
        configs.storedRole = (_loadFromLocalStorage = loadFromLocalStorage((_configs$authConfig = configs.authConfig) === null || _configs$authConfig === void 0 ? void 0 : _configs$authConfig.name)) === null || _loadFromLocalStorage === void 0 ? void 0 : _loadFromLocalStorage.role;
        configs.dashboardConfig = defaultDashboardConfig;
        configs.customRoutes = [];
        configs.globalReferenceFieldFilterParams = {};
        configs.globalPaginationMode = "standard";
        configs.hiddenBreadCrumbsPaths = defaultHiddenBreadCrumbsPaths;
        configs.apiEntitiesConfig = defaultApiEntitiesConfig;
        configs.apiFieldsConfig = defaultapiFieldsConfig;
        Object.keys(appConfigs).map(function (key) {
          switch (key) {
            case "theme":
              return configs[key] = merge(defaultTheme, appConfigs[key]);

            case "groups":
              configs.allGroups = appConfigs[key];
              return configs[key] = appConfigs[key];

            case "userDefinedEntities":
              return configs.entities = _this.customEntities(appConfigs[key], appConfigs.authUserDefinedEntities, configs.authConfig, appConfigs.dashboardConfig);

            case "languageResources":
              return configs.resources = merge(resources, appConfigs.languageResources);

            case "authConfig":
              return null;

            case "notificationConfigs":
              configs.notificationConfigs = merge(configs.notificationConfigs, appConfigs.notificationConfigs);
              return notificationsConfigs.initialize(configs.notificationConfigs);

            case "chatConfigs":
              configs.chatConfigs = merge(configs.chatConfigs, appConfigs.chatConfigs);
              configs.chatConfigs.isInitiallyEnabled = configs.chatConfigs.enabled;
              return chatConfigs.initialize(configs.chatConfigs.chatopsActionCable);

            case "apiEntitiesConfigs":
              configs.apiEntitiesConfig = merge(configs.apiEntitiesConfig, appConfigs.apiEntitiesConfig);
              return configs.apiEntitiesConfig;

            default:
              return configs[key] = appConfigs[key];
          }
        });
        initTranslation(configs.resources);
      }
    },
    getConfigs: function getConfigs() {
      return configs || {};
    },
    addApiEntities: function addApiEntities(apiEntities) {
      configs.allEntities = _extends({}, configs.allEntities, apiEntities);
      configs.apiEntities = apiEntities;
    },
    setAuthorization: function setAuthorization(role) {
      var _configs = configs,
          chatConfigs = _configs.chatConfigs;
      var authorizedRoles = chatConfigs.authorizedRoles,
          isInitiallyEnabled = chatConfigs.isInitiallyEnabled;

      if (authorizedRoles && isInitiallyEnabled) {
        chatConfigs.enabled = authorizedRoles.includes(role);
      }

      configs.entities = generateEntities(configs.allEntities, role);
      configs.groups = generateGroups(configs.allGroups, role);
      configs.routes = generateRoutes(role, configs);
      return [configs.entities, configs.groups, configs.routes];
    },
    setDeleteFirebaseToken: function setDeleteFirebaseToken(deleteFirebaseToken) {
      configs.deleteFirebaseToken = deleteFirebaseToken;
    }
  };
}();

var MediaModal = function MediaModal(_ref) {
  var props = _extends({}, _ref);

  var _useContext = useContext(AppContext),
      allEntities = _useContext.allEntities,
      theme = _useContext.theme;

  var mediaEntity = useSelector(function (state) {
    return getEntity(state, adminConfigs.getConfigs().mediaEntity);
  });
  var entity = allEntities[adminConfigs.getConfigs().mediaEntity];
  var actions = {
    list: entitiesActions[adminConfigs.getConfigs().mediaEntity].list
  };
  return /*#__PURE__*/React__default.createElement(MediaEntry, _extends({
    DataPagination: DataPagination,
    mediaEntity: mediaEntity,
    entity: entity,
    actions: actions,
    theme: theme
  }, props));
};

var _excluded$g = ["field"];

var FileField = function FileField(_ref) {
  var _field$usesGallery;

  var field = _ref.field,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  return (_field$usesGallery = field.usesGallery) !== null && _field$usesGallery !== void 0 && _field$usesGallery.call(field) ? /*#__PURE__*/React__default.createElement(MediaModal, _extends({
    field: field
  }, props)) : /*#__PURE__*/React__default.createElement(Uploader, _extends({
    field: field
  }, props));
};

var FileField$1 = withFieldHandler(FileField);

var useSelectedValue = function useSelectedValue(_ref) {
  var isMulti = _ref.isMulti,
      selected = _ref.selected,
      selectedLabel = _ref.selectedLabel,
      options = _ref.options,
      onChange = _ref.onChange;

  var _useState = useState(function () {
    var initialValue;

    if (isMulti && Array.isArray(selected)) {
      initialValue = [];
      selected.map(function (item, key) {
        return selectedLabel ? initialValue.push({
          label: selectedLabel[key],
          value: item
        }) : initialValue.push(options.find(function (option) {
          return option.value === item;
        }) || undefined);
      });
    } else if (!isValueEmpty(selected) && !isMulti) initialValue = selectedLabel ? {
      label: selectedLabel,
      value: selected
    } : options.find(function (option) {
      return option.value === selected;
    }) || undefined;

    if (Array.isArray(initialValue)) return initialValue.filter(function (value) {
      return value;
    });
    return initialValue;
  }),
      values = _useState[0],
      setValues = _useState[1];

  useEffect(function () {
    var firstOption = options[0];

    if (selected === "first" && firstOption) {
      var value = isMulti ? [firstOption] : firstOption;
      if (onChange) onChange(value);
      setValues(value);
    } else if (selected === null) {
      setValues(undefined);
    }
  }, [options, selected, onChange, isMulti]);
  var onSelectChange = useCallback(function (selectedOption) {
    setValues(selectedOption);
    if (onChange) onChange(selectedOption);
  }, [onChange]);
  useEffect(function () {
    if (values) return;
    if (selectedLabel && selected) return onSelectChange({
      label: selectedLabel,
      value: selected
    });
  }, [selectedLabel, selected, onSelectChange, values]);
  return {
    values: values,
    onSelectChange: onSelectChange
  };
};

var not = function not(itemsA, itemsB, valueField) {
  return itemsA.filter(function (itemA) {
    return itemsB.findIndex(function (itemB) {
      return itemB[valueField] === itemA[valueField];
    }) === -1;
  });
};

var intersection = function intersection(itemsA, itemsB, valueField) {
  return itemsA.filter(function (itemA) {
    return itemsB.findIndex(function (itemB) {
      return itemB[valueField] === itemA[valueField];
    }) !== -1;
  });
};

var union = function union(itemsA, itemsB, valueField) {
  return [].concat(itemsA, not(itemsB, itemsA, valueField));
};

var _templateObject$b;

var SelectWrapper = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  .ant-select {\n    width: 100%;\n    .ant-select-selection-overflow-item {\n      width: auto;\n    }\n  }\n"])));
var _excluded$h = ["name", "selected", "onChange", "options", "label", "disabled", "isSearchable", "inAuthForm", "isMulti", "placeholder"],
    _excluded2$3 = ["config", "name", "selected", "selectedLabel", "onChange", "disabled", "isSearchable", "action", "state", "params", "inAuthForm", "entity", "isFilter", "isColumnFilter", "isMulti", "placeholder"];
var Select = withFieldHandler(function (_ref) {
  var selected = _ref.selected,
      onChange = _ref.onChange,
      options = _ref.options,
      disabled = _ref.disabled,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? false : _ref$isSearchable,
      isMulti = _ref.isMulti,
      placeholder = _ref.placeholder,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$h);

  var _useTranslation = useTranslation("select"),
      t = _useTranslation.t;

  var _useSelectedValue = useSelectedValue({
    isMulti: isMulti,
    selected: selected,
    options: options,
    onChange: onChange
  }),
      values = _useSelectedValue.values,
      onSelectChange = _useSelectedValue.onSelectChange;

  var mode = useMemo(function () {
    return isMulti ? "multiple" : "";
  }, [isMulti]);
  var selectPlaceholder = useMemo(function () {
    return placeholder || t("selectPlaceholder");
  }, [placeholder, t]);
  return /*#__PURE__*/React__default.createElement(SelectWrapper, null, /*#__PURE__*/React__default.createElement(_Select, _extends({
    value: values,
    onChange: onSelectChange,
    disabled: disabled,
    options: options,
    showSearch: isSearchable,
    placeholder: selectPlaceholder,
    mode: mode,
    showArrow: true,
    labelInValue: true,
    optionFilterProp: "label"
  }, props)));
});
var EntitySelect = withFieldHandler(function (_ref2) {
  var _extends2, _field$isAuthenticate;

  var field = _ref2.config,
      name = _ref2.name,
      selected = _ref2.selected,
      selectedLabel = _ref2.selectedLabel,
      onChange = _ref2.onChange,
      disabled = _ref2.disabled,
      _ref2$isSearchable = _ref2.isSearchable,
      isSearchable = _ref2$isSearchable === void 0 ? false : _ref2$isSearchable,
      action = _ref2.action,
      state = _ref2.state,
      params = _ref2.params,
      parentEntity = _ref2.entity,
      isFilter = _ref2.isFilter,
      isColumnFilter = _ref2.isColumnFilter,
      isMulti = _ref2.isMulti,
      placeholder = _ref2.placeholder,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$3);

  var dispatch = useDispatch();

  var _useContext = useContext(AppContext),
      entities = _useContext.entities;

  var _useTranslation2 = useTranslation(["select", "dataForm"]),
      t = _useTranslation2.t;

  var mode = useMemo(function () {
    return isMulti ? "multiple" : "";
  }, [isMulti]);
  var selectPlaceholder = useMemo(function () {
    return placeholder || t("select:selectPlaceholder");
  }, [placeholder, t]);
  var _field$optionsEntity = field.optionsEntity,
      entityName = _field$optionsEntity.name,
      labelField = _field$optionsEntity.labelField,
      valueField = _field$optionsEntity.valueField,
      requestParams = _field$optionsEntity.requestParams,
      filterParams = _field$optionsEntity.filterParams,
      _field$optionsEntity$ = _field$optionsEntity.queryParamName,
      queryParamName = _field$optionsEntity$ === void 0 ? "query" : _field$optionsEntity$;
  var filterPrefix = isColumnFilter ? "columnFilter" : "filter";
  var customEntityName = isFilter ? generateReferencedEntityCustomName(filterPrefix, entityName, parentEntity.name, name) : generateReferencedEntityCustomName("field", entityName, field.getEntity().name, name);
  var entity = entities[customEntityName];

  var _useSelector = useSelector(function (state) {
    return getEntity(state, customEntityName);
  }),
      entityData = _useSelector.data,
      loading = _useSelector.loading,
      nextPage = _useSelector.nextPage;

  var _useState = useState([]),
      options = _useState[0],
      setOptions = _useState[1];

  var _useState2 = useState([]),
      searchOptions = _useState2[0],
      setSearchOptions = _useState2[1];

  var _useState3 = useState(false),
      isSearched = _useState3[0],
      setIsSearched = _useState3[1];

  var prevOptionsPage = useRef(1);
  var prevOptions = usePrevious(options);

  var _useState4 = useState(_extends((_extends2 = {
    page: 1
  }, _extends2[queryParamName] = "", _extends2.rowsPerPage = 10, _extends2), requestParams)),
      customConfigs = _useState4[0],
      setCustomConfigs = _useState4[1];

  var _useSelectedValue2 = useSelectedValue({
    isMulti: isMulti,
    selected: selected,
    selectedLabel: selectedLabel,
    options: options,
    onChange: onChange
  }),
      values = _useSelectedValue2.values,
      onSelectChange = _useSelectedValue2.onSelectChange;

  var _useFilterParams = useFilterParams({
    filterParams: filterParams,
    action: action,
    state: state,
    params: params,
    entity: entity,
    customEntityName: customEntityName,
    customConfigs: customConfigs,
    authenticated: field === null || field === void 0 ? void 0 : (_field$isAuthenticate = field.isAuthenticated) === null || _field$isAuthenticate === void 0 ? void 0 : _field$isAuthenticate.call(field)
  }),
      resetFilterValues = _useFilterParams[0];

  useEffect(function () {
    var newOptions = entityData ? entityData.reduce(function (data, record) {
      return [].concat(data, [{
        label: getAccessorValue(record, labelField),
        value: getAccessorValue(record, valueField)
      }]);
    }, []) : [];
    if (isSearched) setSearchOptions(union(searchOptions, newOptions, "value"));else setOptions(union(options, newOptions, "value"));
  }, [entityData]);
  useEffect(function () {
    if (resetFilterValues) {
      setOptions([]);
      setIsSearched(false);
      setCustomConfigs(function (customConfigs) {
        return _extends({}, customConfigs, {
          page: 1
        });
      });
      onSelectChange();
    }
  }, [resetFilterValues, onSelectChange]);
  useEffect(function () {
    return function () {
      dispatch(entitiesActions[customEntityName].list.reset());
    };
  }, []);

  var onSearch = function onSearch(search) {
    if (search !== customConfigs[queryParamName]) {
      var _extends3;

      var newPage = 1;

      if (search === "") {
        setIsSearched(false);
        newPage = prevOptionsPage.current;
      } else if (!isSearched) {
        setIsSearched(true);
        prevOptionsPage.current = customConfigs.page;
      }

      setSearchOptions([]);
      setCustomConfigs(_extends({}, customConfigs, (_extends3 = {}, _extends3[queryParamName] = search, _extends3.page = newPage, _extends3)));
    }
  };

  var onScroll = function onScroll(event) {
    var _event$target = event.target,
        scrollTop = _event$target.scrollTop,
        scrollHeight = _event$target.scrollHeight,
        offsetHeight = _event$target.offsetHeight;

    if (Math.ceil(scrollTop + offsetHeight) >= scrollHeight && (nextPage || entity.isReducedPaginationMode())) {
      setCustomConfigs(_extends({}, customConfigs, {
        page: customConfigs.page + 1
      }));
    }
  };

  var onBlur = function onBlur() {
    onSearch("");
  };

  useEffect(function () {
    if (isFilter && field.defaultValue === "first" && prevOptions && prevOptions.length === 0 && options && options.length !== 0) onSelectChange(options[0]);
  }, [prevOptions, options]);
  return /*#__PURE__*/React__default.createElement(SelectWrapper, null, /*#__PURE__*/React__default.createElement(_Select, _extends({
    value: values,
    onChange: onSelectChange,
    showSearch: isSearchable,
    disabled: disabled,
    allowClear: true,
    notFoundContent: /*#__PURE__*/React__default.createElement(_Typography.Text, null, t("select:noOptions")),
    placeholder: selectPlaceholder,
    mode: mode,
    showArrow: true,
    labelInValue: true,
    optionFilterProp: "label",
    loading: loading,
    options: isSearched ? searchOptions : options,
    onSearch: isSearchable && debounce(onSearch, 500),
    onPopupScroll: onScroll,
    dropdownRender: function dropdownRender(menu) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, menu, loading && nextPage && /*#__PURE__*/React__default.createElement(_Typography.Text, null, t("dataForm:loading")));
    },
    filterOption: false,
    onBlur: onBlur
  }, props)));
});

var SingleSelect = function SingleSelect(_ref) {
  var field = _ref.field,
      value = _ref.value,
      valueLabel = _ref.valueLabel,
      onChange = _ref.onChange,
      error = _ref.error,
      params = _ref.params,
      action = _ref.action,
      state = _ref.state,
      inAuthForm = _ref.inAuthForm,
      disabled = _ref.disabled,
      isMulti = _ref.isMulti,
      placeholder = _ref.placeholder,
      removeLabel = _ref.removeLabel;

  var handleChange = function handleChange(selectedOption) {
    var _ref2 = selectedOption || {},
        _ref2$value = _ref2.value,
        value = _ref2$value === void 0 ? "" : _ref2$value;

    onChange(field, value, selectedOption);
  };

  return /*#__PURE__*/React__default.createElement(EntitySelect, {
    onChange: handleChange,
    name: field.identifier,
    selected: value,
    selectedLabel: valueLabel,
    config: field,
    label: removeLabel ? undefined : field.getLabel(),
    error: error,
    isSearchable: field.isSearchable,
    params: params,
    action: action,
    state: state,
    inAuthForm: inAuthForm,
    disabled: disabled,
    isMulti: isMulti,
    required: field.required,
    placeholder: placeholder
  });
};

var MultiSelect = function MultiSelect(_ref) {
  var field = _ref.field,
      value = _ref.value,
      onChange = _ref.onChange,
      error = _ref.error,
      params = _ref.params,
      action = _ref.action,
      state = _ref.state,
      inAuthForm = _ref.inAuthForm,
      disabled = _ref.disabled,
      isMulti = _ref.isMulti,
      data = _ref.data,
      placeholder = _ref.placeholder,
      removeLabel = _ref.removeLabel;
  var selectedLabel = useMemo(function () {
    var _field$getDataValue;

    return (_field$getDataValue = field.getDataValue(data, {
      canReturnUndefined: true
    })) === null || _field$getDataValue === void 0 ? void 0 : _field$getDataValue.map(function (item) {
      return getAccessorValue(item, field.optionsEntity.labelField);
    });
  }, [field, data]);

  var handleChange = function handleChange(selectedOption) {
    var values = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.map(function (option) {
      return option.value;
    });
    onChange(field, values);
  };

  return /*#__PURE__*/React__default.createElement(EntitySelect, {
    onChange: handleChange,
    name: field.identifier,
    selected: value,
    selectedLabel: selectedLabel,
    config: field,
    label: removeLabel ? undefined : field.getLabel(),
    error: error,
    isSearchable: field.isSearchable,
    params: params,
    action: action,
    state: state,
    inAuthForm: inAuthForm,
    disabled: disabled,
    isMulti: isMulti,
    required: field.required,
    placeholder: placeholder
  });
};

var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = {};
  }

  var type = action.type,
      valueLabel = action.valueLabel,
      selectedOption = action.selectedOption,
      initiallySelectedOptions = action.initiallySelectedOptions,
      _destroy = action._destroy;

  switch (type) {
    case "update":
      {
        var _extends2, _extends3;

        return _extends({}, state, (_extends3 = {}, _extends3[selectedOption] = _extends({}, state[selectedOption], (_extends2 = {}, _extends2[valueLabel] = selectedOption, _extends2._destroy = _destroy, _extends2)), _extends3));
      }

    case "remove":
      {
        delete state[selectedOption];
        return _extends({}, state);
      }

    case "markAllForDestroy":
      {
        return (initiallySelectedOptions === null || initiallySelectedOptions === void 0 ? void 0 : initiallySelectedOptions.reduce(function (acc, item) {
          var _extends4;

          return _extends({}, acc, (_extends4 = {}, _extends4[item[valueLabel]] = _extends({}, item, {
            _destroy: true
          }), _extends4));
        }, {})) || {};
      }

    default:
      return state;
  }
};

var StatefulMultiSelect = function StatefulMultiSelect(_ref) {
  var field = _ref.field,
      value = _ref.value,
      onChange = _ref.onChange,
      error = _ref.error,
      params = _ref.params,
      action = _ref.action,
      state = _ref.state,
      inAuthForm = _ref.inAuthForm,
      disabled = _ref.disabled,
      isMulti = _ref.isMulti,
      data = _ref.data,
      placeholder = _ref.placeholder;
  var _field$optionsEntity = field.optionsEntity;
  _field$optionsEntity = _field$optionsEntity === void 0 ? {} : _field$optionsEntity;
  var valueLabel = _field$optionsEntity.valueLabel,
      labelField = _field$optionsEntity.labelField;
  var initialData = useMemo(function () {
    return field.getDataValue(data, {
      canReturnUndefined: true
    });
  }, [field, data]);
  var initiallySelectedValues = useMemo(function () {
    return keyBy(initialData, valueLabel);
  }, [valueLabel, initialData]);
  var initiallySelectedLabel = useMemo(function () {
    return initialData === null || initialData === void 0 ? void 0 : initialData.map(function (item) {
      return getAccessorValue(item, labelField);
    });
  }, [initialData, labelField]);
  var selected = useMemo(function () {
    return Array.isArray(value) ? value === null || value === void 0 ? void 0 : value.map(function (item) {
      return item[valueLabel];
    }) : value;
  }, [valueLabel, value]);

  var _useReducer = useReducer(reducer, initiallySelectedValues),
      selectedOptions = _useReducer[0],
      dispatch = _useReducer[1];

  useEffect(function () {
    onChange(field, Object.values(selectedOptions));
  }, [selectedOptions]);

  var onClear = function onClear() {
    return dispatch({
      type: "markAllForDestroy",
      initiallySelectedOptions: initialData,
      valueLabel: valueLabel
    });
  };

  var onSelect = function onSelect(_ref2) {
    var value = _ref2.value;
    return dispatch({
      type: "update",
      selectedOption: value,
      valueLabel: valueLabel,
      _destroy: false
    });
  };

  var onDeselect = function onDeselect(_ref3) {
    var value = _ref3.value;
    var type = initiallySelectedValues[value] ? "update" : "remove";
    dispatch({
      type: type,
      selectedOption: value,
      valueLabel: valueLabel,
      _destroy: true
    });
  };

  return /*#__PURE__*/React__default.createElement(EntitySelect, {
    name: field.identifier,
    selected: selected,
    selectedLabel: initiallySelectedLabel,
    config: field,
    label: field.getLabel(),
    error: error,
    isSearchable: field.isSearchable,
    params: params,
    action: action,
    state: state,
    inAuthForm: inAuthForm,
    disabled: disabled,
    isMulti: isMulti,
    required: field.required,
    onClear: onClear,
    onDeselect: onDeselect,
    onSelect: onSelect,
    placeholder: placeholder
  });
};

var ReferenceField = function ReferenceField(props) {
  if (props.isMulti && props.field.useObjectArray) return /*#__PURE__*/React__default.createElement(StatefulMultiSelect, props);else if (props.isMulti) return /*#__PURE__*/React__default.createElement(MultiSelect, props);else return /*#__PURE__*/React__default.createElement(SingleSelect, props);
};

var _excluded$i = ["action", "params", "field", "state", "onChange", "disabled", "values", "inAuthForm"];
var CheckboxField = withFieldHandler(function (_ref) {
  var field = _ref.field,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      values = _ref.values,
      dynamicOptions = _ref.dynamicOptions,
      reset = _ref.reset,
      data = _ref.data,
      state = _ref.state,
      action = _ref.action;
  var staticOptions = field.getStaticOptions(data, state, action);

  var _useCheckboxState = useCheckboxState(field, values, onChange),
      checked = _useCheckboxState[0],
      handleChange = _useCheckboxState[1],
      resetCheckedValues = _useCheckboxState[2];

  var options = dynamicOptions || staticOptions;
  useEffect(function () {
    if (reset) {
      resetCheckedValues();
    }
  }, [reset, resetCheckedValues]);
  return /*#__PURE__*/React__default.createElement(_Row, null, options === null || options === void 0 ? void 0 : options.map(function (_ref2) {
    var value = _ref2.value,
        optionLabel = _ref2.label;
    return /*#__PURE__*/React__default.createElement(_Col, {
      key: value
    }, /*#__PURE__*/React__default.createElement(_Checkbox, {
      key: value,
      checked: !!checked[value],
      value: value,
      disabled: disabled,
      onChange: handleChange(value)
    }, getTranslatedValue(optionLabel)));
  }));
});

var useCheckboxState = function useCheckboxState(field, values, onChange) {
  var _field$checkboxConfig = field.checkboxConfig,
      checkboxConfig = _field$checkboxConfig === void 0 ? {} : _field$checkboxConfig;
  var isArrayFormat = checkboxConfig.format === "array";

  var getCheckboxValues = function getCheckboxValues() {
    if (!values) return [];
    return isArrayFormat ? values : values.toString().split(",");
  };

  var getParsedValues = function getParsedValues(checkedValues) {
    var initialAccumulator = isArrayFormat ? [] : "";
    return Object.keys(checkedValues).reduce(function (acc, val) {
      if (checkedValues[val]) {
        if (isArrayFormat) return [].concat(acc, [val]);
        return "" + acc + val + ",";
      }

      return acc;
    }, initialAccumulator);
  };

  var parseCheckboxValues = function parseCheckboxValues(checkboxValues) {
    return checkboxValues.reduce(function (acc, val) {
      var _extends2;

      return _extends({}, acc, (_extends2 = {}, _extends2[val] = true, _extends2));
    }, {});
  };

  var checkboxValues = getCheckboxValues();

  var _useState = useState(parseCheckboxValues(checkboxValues)),
      checked = _useState[0],
      setChecked = _useState[1];

  useEffect(function () {
    setChecked(parseCheckboxValues(checkboxValues));
  }, [values]);

  var handleChange = function handleChange(name) {
    return function (event) {
      var _extends3;

      var newChecked = _extends({}, checked, (_extends3 = {}, _extends3[name] = event.target.checked, _extends3));

      var parsedValues = getParsedValues(newChecked);
      setChecked(newChecked);
      onChange(field, parsedValues);
    };
  };

  var resetCheckedValues = function resetCheckedValues() {
    setChecked("");
    onChange(field, "");
  };

  return [checked, handleChange, resetCheckedValues];
};

var DynamicCheckboxField = function DynamicCheckboxField(_ref3) {
  var action = _ref3.action,
      params = _ref3.params,
      field = _ref3.field,
      state = _ref3.state,
      onChange = _ref3.onChange,
      disabled = _ref3.disabled,
      values = _ref3.values,
      inAuthForm = _ref3.inAuthForm,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded$i);

  var optionsEntity = field.optionsEntity,
      identifier = field.identifier;

  var _useContext = useContext(AppContext),
      entities = _useContext.entities;

  var entityName = optionsEntity.name,
      filterParams = optionsEntity.filterParams,
      valueField = optionsEntity.valueField,
      labelField = optionsEntity.labelField;
  var customEntityName = generateReferencedEntityCustomName("field", entityName, field.getEntity().name, identifier);
  var entity = entities[customEntityName];

  var _useState2 = useState({
    page: 1,
    show_all: true
  }),
      customConfigs = _useState2[0];

  var _useFilterParams = useFilterParams({
    filterParams: filterParams,
    action: action,
    state: state,
    params: params,
    entity: entity,
    customEntityName: customEntityName,
    customConfigs: customConfigs
  }),
      resetFilterValues = _useFilterParams[0];

  var _useSelector = useSelector(function (state) {
    return getEntity(state, customEntityName);
  }),
      entityData = _useSelector.data;

  var options = entityData.reduce(function (data, record) {
    return [].concat(data, [{
      label: record[labelField],
      value: record[valueField]
    }]);
  }, []);
  return /*#__PURE__*/React__default.createElement(CheckboxField, _extends({
    values: values,
    field: field,
    disabled: disabled,
    onChange: onChange,
    inAuthForm: inAuthForm,
    dynamicOptions: options,
    reset: resetFilterValues
  }, props));
};

var RadioField = function RadioField(_ref) {
  var field = _ref.field,
      onChange = _ref.onChange,
      value = _ref.value,
      disabled = _ref.disabled,
      data = _ref.data,
      state = _ref.state,
      action = _ref.action;
  var options = field.getStaticOptions(data, state, action);

  var _useRadioState = useRadioState(field, value, onChange),
      selected = _useRadioState[0],
      handleChange = _useRadioState[1];

  return /*#__PURE__*/React__default.createElement(_Radio.Group, {
    value: selected,
    onChange: handleChange
  }, options === null || options === void 0 ? void 0 : options.map(function (_ref2) {
    var value = _ref2.value,
        optionLabel = _ref2.label;
    return /*#__PURE__*/React__default.createElement(_Radio, {
      key: value,
      value: value,
      disabled: disabled
    }, getTranslatedValue(optionLabel));
  }));
};

var useRadioState = function useRadioState(field, initialValue, onChange) {
  var _useState = useState(initialValue),
      value = _useState[0],
      setValue = _useState[1];

  var handleChange = function handleChange(event) {
    setValue(event.target.value);
    onChange(field, event.target.value);
  };

  return [value, handleChange];
};

var RadioField$1 = withFieldHandler(RadioField);

var SelectField = function SelectField(_ref) {
  var field = _ref.field,
      value = _ref.value,
      onChange = _ref.onChange,
      error = _ref.error,
      disabled = _ref.disabled,
      label = _ref.label,
      inAuthForm = _ref.inAuthForm,
      placeholder = _ref.placeholder,
      data = _ref.data,
      state = _ref.state,
      isMulti = _ref.isMulti,
      action = _ref.action;
  var identifier = field.identifier,
      isSearchable = field.isSearchable;

  var handleChange = function handleChange(newValue) {
    if (isMulti && newValue) {
      var values = newValue.map(function (option) {
        return option.value;
      });
      onChange(field, values);
    } else onChange(field, newValue === null || newValue === void 0 ? void 0 : newValue.value);
  };

  var selectOptions = field.getStaticOptions(data, state, action);
  return /*#__PURE__*/React__default.createElement(Select, {
    disabled: disabled,
    label: label || field.getLabel(),
    selected: value,
    onChange: handleChange,
    name: identifier,
    options: selectOptions.map(function (option) {
      return _extends({}, option, {
        label: getTranslatedValue(option.label)
      });
    }),
    error: error,
    isSearchable: isSearchable,
    inAuthForm: inAuthForm,
    required: field.required,
    placeholder: placeholder,
    allowClear: true,
    isMulti: isMulti
  });
};

var countries = [{
  code: "AD",
  name: "أندورا",
  dial_code: "+376"
}, {
  code: "AE",
  name: "الامارات العربية المتحدة",
  dial_code: "+971"
}, {
  code: "AF",
  name: "أفغانستان",
  dial_code: "+93"
}, {
  code: "AG",
  name: "أنتيجوا وبربودا",
  dial_code: "+1"
}, {
  code: "AI",
  name: "أنجويلا",
  dial_code: "+1"
}, {
  code: "AL",
  name: "ألبانيا",
  dial_code: "+355"
}, {
  code: "AM",
  name: "أرمينيا",
  dial_code: "+374"
}, {
  code: "AO",
  name: "أنجولا",
  dial_code: "+244"
}, {
  code: "AQ",
  name: "القطب الجنوبي",
  dial_code: "+672"
}, {
  code: "AR",
  name: "الأرجنتين",
  dial_code: "+54"
}, {
  code: "AS",
  name: "ساموا الأمريكية",
  dial_code: "+1"
}, {
  code: "AT",
  name: "النمسا",
  dial_code: "+43"
}, {
  code: "AU",
  name: "أستراليا",
  dial_code: "+61"
}, {
  code: "AW",
  name: "آروبا",
  dial_code: "+297"
}, {
  code: "AX",
  name: "جزر أولان",
  dial_code: "+358"
}, {
  code: "AZ",
  name: "أذربيجان",
  dial_code: "+994"
}, {
  code: "BA",
  name: "البوسنة والهرسك",
  dial_code: "+387"
}, {
  code: "BB",
  name: "بربادوس",
  dial_code: "+1"
}, {
  code: "BD",
  name: "بنجلاديش",
  dial_code: "+880"
}, {
  code: "BE",
  name: "بلجيكا",
  dial_code: "+32"
}, {
  code: "BF",
  name: "بوركينا فاسو",
  dial_code: "+226"
}, {
  code: "BG",
  name: "بلغاريا",
  dial_code: "+359"
}, {
  code: "BH",
  name: "البحرين",
  dial_code: "+973"
}, {
  code: "BI",
  name: "بوروندي",
  dial_code: "+257"
}, {
  code: "BJ",
  name: "بنين",
  dial_code: "+229"
}, {
  code: "BL",
  name: "سان بارتيلمي",
  dial_code: "+590"
}, {
  code: "BM",
  name: "برمودا",
  dial_code: "+1"
}, {
  code: "BN",
  name: "بروناي",
  dial_code: "+673"
}, {
  code: "BO",
  name: "بوليفيا",
  dial_code: "+591"
}, {
  code: "BQ",
  name: "بونير",
  dial_code: "+599"
}, {
  code: "BR",
  name: "البرازيل",
  dial_code: "+55"
}, {
  code: "BS",
  name: "الباهاما",
  dial_code: "+1"
}, {
  code: "BT",
  name: "بوتان",
  dial_code: "+975"
}, {
  code: "BV",
  name: "جزيرة بوفيه",
  dial_code: "+47"
}, {
  code: "BW",
  name: "بتسوانا",
  dial_code: "+267"
}, {
  code: "BY",
  name: "روسيا البيضاء",
  dial_code: "+375"
}, {
  code: "BZ",
  name: "بليز",
  dial_code: "+501"
}, {
  code: "CA",
  name: "كندا",
  dial_code: "+1"
}, {
  code: "CC",
  name: "جزر كوكوس",
  dial_code: "+61"
}, {
  code: "CD",
  name: "جمهورية الكونغو الديمقراطية",
  dial_code: "+243"
}, {
  code: "CF",
  name: "جمهورية افريقيا الوسطى",
  dial_code: "+236"
}, {
  code: "CG",
  name: "الكونغو - برازافيل",
  dial_code: "+242"
}, {
  code: "CH",
  name: "سويسرا",
  dial_code: "+41"
}, {
  code: "CI",
  name: "ساحل العاج",
  dial_code: "+225"
}, {
  code: "CK",
  name: "جزر كوك",
  dial_code: "+682"
}, {
  code: "CL",
  name: "شيلي",
  dial_code: "+56"
}, {
  code: "CM",
  name: "الكاميرون",
  dial_code: "+237"
}, {
  code: "CN",
  name: "الصين",
  dial_code: "+86"
}, {
  code: "CO",
  name: "كولومبيا",
  dial_code: "+57"
}, {
  code: "CR",
  name: "كوستاريكا",
  dial_code: "+506"
}, {
  code: "CU",
  name: "كوبا",
  dial_code: "+53"
}, {
  code: "CV",
  name: "الرأس الأخضر",
  dial_code: "+238"
}, {
  code: "CW",
  name: "كوراساو",
  dial_code: "+599"
}, {
  code: "CX",
  name: "جزيرة الكريسماس",
  dial_code: "+61"
}, {
  code: "CY",
  name: "قبرص",
  dial_code: "+357"
}, {
  code: "CZ",
  name: "جمهورية التشيك",
  dial_code: "+420"
}, {
  code: "DE",
  name: "ألمانيا",
  dial_code: "+49"
}, {
  code: "DJ",
  name: "جيبوتي",
  dial_code: "+253"
}, {
  code: "DK",
  name: "الدانمرك",
  dial_code: "+45"
}, {
  code: "DM",
  name: "دومينيكا",
  dial_code: "+1"
}, {
  code: "DO",
  name: "جمهورية الدومينيك",
  dial_code: "+1"
}, {
  code: "DZ",
  name: "الجزائر",
  dial_code: "+213"
}, {
  code: "EC",
  name: "الاكوادور",
  dial_code: "+593"
}, {
  code: "EE",
  name: "استونيا",
  dial_code: "+372"
}, {
  code: "EG",
  name: "مصر",
  dial_code: "+20"
}, {
  code: "EH",
  name: "الصحراء الغربية",
  dial_code: "+212"
}, {
  code: "ER",
  name: "اريتريا",
  dial_code: "+291"
}, {
  code: "ES",
  name: "أسبانيا",
  dial_code: "+34"
}, {
  code: "ET",
  name: "اثيوبيا",
  dial_code: "+251"
}, {
  code: "FI",
  name: "فنلندا",
  dial_code: "+358"
}, {
  code: "FJ",
  name: "فيجي",
  dial_code: "+679"
}, {
  code: "FK",
  name: "جزر فوكلاند",
  dial_code: "+500"
}, {
  code: "FM",
  name: "ميكرونيزيا",
  dial_code: "+691"
}, {
  code: "FO",
  name: "جزر فارو",
  dial_code: "+298"
}, {
  code: "FR",
  name: "فرنسا",
  dial_code: "+33"
}, {
  code: "GA",
  name: "الجابون",
  dial_code: "+241"
}, {
  code: "GB",
  name: "المملكة المتحدة",
  dial_code: "+44"
}, {
  code: "GD",
  name: "جرينادا",
  dial_code: "+1"
}, {
  code: "GE",
  name: "جورجيا",
  dial_code: "+995"
}, {
  code: "GF",
  name: "غويانا",
  dial_code: "+594"
}, {
  code: "GG",
  name: "غيرنزي",
  dial_code: "+44"
}, {
  code: "GH",
  name: "غانا",
  dial_code: "+233"
}, {
  code: "GI",
  name: "جبل طارق",
  dial_code: "+350"
}, {
  code: "GL",
  name: "جرينلاند",
  dial_code: "+299"
}, {
  code: "GM",
  name: "غامبيا",
  dial_code: "+220"
}, {
  code: "GN",
  name: "غينيا",
  dial_code: "+224"
}, {
  code: "GP",
  name: "جوادلوب",
  dial_code: "+590"
}, {
  code: "GQ",
  name: "غينيا الاستوائية",
  dial_code: "+240"
}, {
  code: "GR",
  name: "اليونان",
  dial_code: "+30"
}, {
  code: "GS",
  name: "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  dial_code: "+500"
}, {
  code: "GT",
  name: "جواتيمالا",
  dial_code: "+502"
}, {
  code: "GU",
  name: "جوام",
  dial_code: "+1"
}, {
  code: "GW",
  name: "غينيا بيساو",
  dial_code: "+245"
}, {
  code: "GY",
  name: "غيانا",
  dial_code: "+595"
}, {
  code: "HK",
  name: "هونج كونج الصينية",
  dial_code: "+852"
}, {
  code: "HN",
  name: "هندوراس",
  dial_code: "+504"
}, {
  code: "HR",
  name: "كرواتيا",
  dial_code: "+385"
}, {
  code: "HT",
  name: "هايتي",
  dial_code: "+509"
}, {
  code: "HU",
  name: "المجر",
  dial_code: "+36"
}, {
  code: "ID",
  name: "اندونيسيا",
  dial_code: "+62"
}, {
  code: "IE",
  name: "أيرلندا",
  dial_code: "+353"
}, {
  code: "IL",
  name: "اسرائيل",
  dial_code: "+972"
}, {
  code: "IM",
  name: "جزيرة مان",
  dial_code: "+44"
}, {
  code: "IN",
  name: "الهند",
  dial_code: "+91"
}, {
  code: "IO",
  name: "المحيط الهندي البريطاني",
  dial_code: "+246"
}, {
  code: "IQ",
  name: "العراق",
  dial_code: "+964"
}, {
  code: "IR",
  name: "ايران",
  dial_code: "+98"
}, {
  code: "IS",
  name: "أيسلندا",
  dial_code: "+354"
}, {
  code: "IT",
  name: "ايطاليا",
  dial_code: "+39"
}, {
  code: "JE",
  name: "جيرسي",
  dial_code: "+44"
}, {
  code: "JM",
  name: "جامايكا",
  dial_code: "+1"
}, {
  code: "JO",
  name: "الأردن",
  dial_code: "+962"
}, {
  code: "JP",
  name: "اليابان",
  dial_code: "+81"
}, {
  code: "KE",
  name: "كينيا",
  dial_code: "+254"
}, {
  code: "KG",
  name: "قرغيزستان",
  dial_code: "+996"
}, {
  code: "KH",
  name: "كمبوديا",
  dial_code: "+855"
}, {
  code: "KI",
  name: "كيريباتي",
  dial_code: "+686"
}, {
  code: "KM",
  name: "جزر القمر",
  dial_code: "+269"
}, {
  code: "KN",
  name: "سانت كيتس ونيفيس",
  dial_code: "+1"
}, {
  code: "KP",
  name: "كوريا الشمالية",
  dial_code: "+850"
}, {
  code: "KR",
  name: "كوريا الجنوبية",
  dial_code: "+82"
}, {
  code: "KW",
  name: "الكويت",
  dial_code: "+965"
}, {
  code: "KY",
  name: "جزر الكايمن",
  dial_code: "+345"
}, {
  code: "KZ",
  name: "كازاخستان",
  dial_code: "+7"
}, {
  code: "LA",
  name: "لاوس",
  dial_code: "+856"
}, {
  code: "LB",
  name: "لبنان",
  dial_code: "+961"
}, {
  code: "LC",
  name: "سانت لوسيا",
  dial_code: "+1"
}, {
  code: "LI",
  name: "ليختنشتاين",
  dial_code: "+423"
}, {
  code: "LK",
  name: "سريلانكا",
  dial_code: "+94"
}, {
  code: "LR",
  name: "ليبيريا",
  dial_code: "+231"
}, {
  code: "LS",
  name: "ليسوتو",
  dial_code: "+266"
}, {
  code: "LT",
  name: "ليتوانيا",
  dial_code: "+370"
}, {
  code: "LU",
  name: "لوكسمبورج",
  dial_code: "+352"
}, {
  code: "LV",
  name: "لاتفيا",
  dial_code: "+371"
}, {
  code: "LY",
  name: "ليبيا",
  dial_code: "+218"
}, {
  code: "MA",
  name: "المغرب",
  dial_code: "+212"
}, {
  code: "MC",
  name: "موناكو",
  dial_code: "+377"
}, {
  code: "MD",
  name: "مولدافيا",
  dial_code: "+373"
}, {
  code: "ME",
  name: "الجبل الأسود",
  dial_code: "+382"
}, {
  code: "MF",
  name: "سانت مارتين",
  dial_code: "+590"
}, {
  code: "MG",
  name: "مدغشقر",
  dial_code: "+261"
}, {
  code: "MH",
  name: "جزر المارشال",
  dial_code: "+692"
}, {
  code: "MK",
  name: "مقدونيا",
  dial_code: "+389"
}, {
  code: "ML",
  name: "مالي",
  dial_code: "+223"
}, {
  code: "MM",
  name: "ميانمار",
  dial_code: "+95"
}, {
  code: "MN",
  name: "منغوليا",
  dial_code: "+976"
}, {
  code: "MO",
  name: "ماكاو الصينية",
  dial_code: "+853"
}, {
  code: "MP",
  name: "جزر ماريانا الشمالية",
  dial_code: "+1"
}, {
  code: "MQ",
  name: "مارتينيك",
  dial_code: "+596"
}, {
  code: "MR",
  name: "موريتانيا",
  dial_code: "+222"
}, {
  code: "MS",
  name: "مونتسرات",
  dial_code: "+1"
}, {
  code: "MT",
  name: "مالطا",
  dial_code: "+356"
}, {
  code: "MU",
  name: "موريشيوس",
  dial_code: "+230"
}, {
  code: "MV",
  name: "جزر الملديف",
  dial_code: "+960"
}, {
  code: "MW",
  name: "ملاوي",
  dial_code: "+265"
}, {
  code: "MX",
  name: "المكسيك",
  dial_code: "+52"
}, {
  code: "MY",
  name: "ماليزيا",
  dial_code: "+60"
}, {
  code: "MZ",
  name: "موزمبيق",
  dial_code: "+258"
}, {
  code: "NA",
  name: "ناميبيا",
  dial_code: "+264"
}, {
  code: "NC",
  name: "كاليدونيا الجديدة",
  dial_code: "+687"
}, {
  code: "NE",
  name: "النيجر",
  dial_code: "+227"
}, {
  code: "NF",
  name: "جزيرة نورفوك",
  dial_code: "+672"
}, {
  code: "NG",
  name: "نيجيريا",
  dial_code: "+234"
}, {
  code: "NI",
  name: "نيكاراجوا",
  dial_code: "+505"
}, {
  code: "NL",
  name: "هولندا",
  dial_code: "+31"
}, {
  code: "NO",
  name: "النرويج",
  dial_code: "+47"
}, {
  code: "NP",
  name: "نيبال",
  dial_code: "+977"
}, {
  code: "NR",
  name: "نورو",
  dial_code: "+674"
}, {
  code: "NU",
  name: "نيوي",
  dial_code: "+683"
}, {
  code: "NZ",
  name: "نيوزيلاندا",
  dial_code: "+64"
}, {
  code: "OM",
  name: "عمان",
  dial_code: "+968"
}, {
  code: "PA",
  name: "بنما",
  dial_code: "+507"
}, {
  code: "PE",
  name: "بيرو",
  dial_code: "+51"
}, {
  code: "PF",
  name: "بولينيزيا الفرنسية",
  dial_code: "+689"
}, {
  code: "PG",
  name: "بابوا غينيا الجديدة",
  dial_code: "+675"
}, {
  code: "PH",
  name: "الفيلبين",
  dial_code: "+63"
}, {
  code: "PK",
  name: "باكستان",
  dial_code: "+92"
}, {
  code: "PL",
  name: "بولندا",
  dial_code: "+48"
}, {
  code: "PM",
  name: "سانت بيير وميكولون",
  dial_code: "+508"
}, {
  code: "PN",
  name: "بتكايرن",
  dial_code: "+872"
}, {
  code: "PR",
  name: "بورتوريكو",
  dial_code: "+1"
}, {
  code: "PS",
  name: "فلسطين",
  dial_code: "+970"
}, {
  code: "PT",
  name: "البرتغال",
  dial_code: "+351"
}, {
  code: "PW",
  name: "بالاو",
  dial_code: "+680"
}, {
  code: "PY",
  name: "باراجواي",
  dial_code: "+595"
}, {
  code: "QA",
  name: "قطر",
  dial_code: "+974"
}, {
  code: "RE",
  name: "روينيون",
  dial_code: "+262"
}, {
  code: "RO",
  name: "رومانيا",
  dial_code: "+40"
}, {
  code: "RS",
  name: "صربيا",
  dial_code: "+381"
}, {
  code: "RU",
  name: "روسيا",
  dial_code: "+7"
}, {
  code: "RW",
  name: "رواندا",
  dial_code: "+250"
}, {
  code: "SA",
  name: "المملكة العربية السعودية",
  dial_code: "+966"
}, {
  code: "SB",
  name: "جزر سليمان",
  dial_code: "+677"
}, {
  code: "SC",
  name: "سيشل",
  dial_code: "+248"
}, {
  code: "SD",
  name: "السودان",
  dial_code: "+249"
}, {
  code: "SE",
  name: "السويد",
  dial_code: "+46"
}, {
  code: "SG",
  name: "سنغافورة",
  dial_code: "+65"
}, {
  code: "SH",
  name: "سانت هيلنا",
  dial_code: "+290"
}, {
  code: "SI",
  name: "سلوفينيا",
  dial_code: "+386"
}, {
  code: "SJ",
  name: "سفالبارد وجان مايان",
  dial_code: "+47"
}, {
  code: "SK",
  name: "سلوفاكيا",
  dial_code: "+421"
}, {
  code: "SL",
  name: "سيراليون",
  dial_code: "+232"
}, {
  code: "SM",
  name: "سان مارينو",
  dial_code: "+378"
}, {
  code: "SN",
  name: "السنغال",
  dial_code: "+221"
}, {
  code: "SO",
  name: "الصومال",
  dial_code: "+252"
}, {
  code: "SR",
  name: "سورينام",
  dial_code: "+597"
}, {
  code: "SS",
  name: "جنوب السودان",
  dial_code: "+211"
}, {
  code: "ST",
  name: "ساو تومي وبرينسيبي",
  dial_code: "+239"
}, {
  code: "SV",
  name: "السلفادور",
  dial_code: "+503"
}, {
  code: "SX",
  name: "سينت مارتن",
  dial_code: "+1"
}, {
  code: "SY",
  name: "سوريا",
  dial_code: "+963"
}, {
  code: "SZ",
  name: "سوازيلاند",
  dial_code: "+268"
}, {
  code: "TC",
  name: "جزر الترك وجايكوس",
  dial_code: "+1"
}, {
  code: "TD",
  name: "تشاد",
  dial_code: "+235"
}, {
  code: "TF",
  name: "المقاطعات الجنوبية الفرنسية",
  dial_code: "+262"
}, {
  code: "TG",
  name: "توجو",
  dial_code: "+228"
}, {
  code: "TH",
  name: "تايلند",
  dial_code: "+66"
}, {
  code: "TJ",
  name: "طاجكستان",
  dial_code: "+992"
}, {
  code: "TK",
  name: "توكيلو",
  dial_code: "+690"
}, {
  code: "TL",
  name: "تيمور الشرقية",
  dial_code: "+670"
}, {
  code: "TM",
  name: "تركمانستان",
  dial_code: "+993"
}, {
  code: "TN",
  name: "تونس",
  dial_code: "+216"
}, {
  code: "TO",
  name: "تونجا",
  dial_code: "+676"
}, {
  code: "TR",
  name: "تركيا",
  dial_code: "+90"
}, {
  code: "TT",
  name: "ترينيداد وتوباغو",
  dial_code: "+1"
}, {
  code: "TV",
  name: "توفالو",
  dial_code: "+688"
}, {
  code: "TW",
  name: "تايوان",
  dial_code: "+886"
}, {
  code: "TZ",
  name: "تانزانيا",
  dial_code: "+255"
}, {
  code: "UA",
  name: "أوكرانيا",
  dial_code: "+380"
}, {
  code: "UG",
  name: "أوغندا",
  dial_code: "+256"
}, {
  code: "US",
  name: "الولايات المتحدة الأمريكية",
  dial_code: "+1"
}, {
  code: "UY",
  name: "أورجواي",
  dial_code: "+598"
}, {
  code: "UZ",
  name: "أوزبكستان",
  dial_code: "+998"
}, {
  code: "VA",
  name: "الفاتيكان",
  dial_code: "+379"
}, {
  code: "VC",
  name: "سانت فنسنت وغرنادين",
  dial_code: "+1"
}, {
  code: "VE",
  name: "فنزويلا",
  dial_code: "+58"
}, {
  code: "VG",
  name: "جزر فرجين البريطانية",
  dial_code: "+1"
}, {
  code: "VI",
  name: "جزر فرجين الأمريكية",
  dial_code: "+1"
}, {
  code: "VN",
  name: "فيتنام",
  dial_code: "+84"
}, {
  code: "VU",
  name: "فانواتو",
  dial_code: "+678"
}, {
  code: "WF",
  name: "جزر والس وفوتونا",
  dial_code: "+681"
}, {
  code: "WS",
  name: "ساموا",
  dial_code: "+685"
}, {
  code: "XK",
  name: "كوسوفو",
  dial_code: "+383"
}, {
  code: "YE",
  name: "اليمن",
  dial_code: "+967"
}, {
  code: "YT",
  name: "مايوت",
  dial_code: "+262"
}, {
  code: "ZA",
  name: "جمهورية جنوب افريقيا",
  dial_code: "+27"
}, {
  code: "ZM",
  name: "زامبيا",
  dial_code: "+260"
}, {
  code: "ZW",
  name: "زيمبابوي",
  dial_code: "+263"
}];
var countries_ar = {
  countries: countries
};
var countries$1 = [{
  name: "Afghanistan",
  dial_code: "+93",
  code: "AF"
}, {
  name: "Albania",
  dial_code: "+355",
  code: "AL"
}, {
  name: "Algeria",
  dial_code: "+213",
  code: "DZ"
}, {
  name: "AmericanSamoa",
  dial_code: "+1 684",
  code: "AS"
}, {
  name: "Andorra",
  dial_code: "+376",
  code: "AD"
}, {
  name: "Angola",
  dial_code: "+244",
  code: "AO"
}, {
  name: "Anguilla",
  dial_code: "+1 264",
  code: "AI"
}, {
  name: "Antigua and Barbuda",
  dial_code: "+1268",
  code: "AG"
}, {
  name: "Argentina",
  dial_code: "+54",
  code: "AR"
}, {
  name: "Armenia",
  dial_code: "+374",
  code: "AM"
}, {
  name: "Aruba",
  dial_code: "+297",
  code: "AW"
}, {
  name: "Australia",
  dial_code: "+61",
  code: "AU"
}, {
  name: "Austria",
  dial_code: "+43",
  code: "AT"
}, {
  name: "Azerbaijan",
  dial_code: "+994",
  code: "AZ"
}, {
  name: "Bahamas",
  dial_code: "+1 242",
  code: "BS"
}, {
  name: "Bahrain",
  dial_code: "+973",
  code: "BH"
}, {
  name: "Bangladesh",
  dial_code: "+880",
  code: "BD"
}, {
  name: "Barbados",
  dial_code: "+1 246",
  code: "BB"
}, {
  name: "Belarus",
  dial_code: "+375",
  code: "BY"
}, {
  name: "Belgium",
  dial_code: "+32",
  code: "BE"
}, {
  name: "Belize",
  dial_code: "+501",
  code: "BZ"
}, {
  name: "Benin",
  dial_code: "+229",
  code: "BJ"
}, {
  name: "Bermuda",
  dial_code: "+1 441",
  code: "BM"
}, {
  name: "Bhutan",
  dial_code: "+975",
  code: "BT"
}, {
  name: "Bosnia and Herzegovina",
  dial_code: "+387",
  code: "BA"
}, {
  name: "Botswana",
  dial_code: "+267",
  code: "BW"
}, {
  name: "Brazil",
  dial_code: "+55",
  code: "BR"
}, {
  name: "British Indian Ocean Territory",
  dial_code: "+246",
  code: "IO"
}, {
  name: "Bulgaria",
  dial_code: "+359",
  code: "BG"
}, {
  name: "Burkina Faso",
  dial_code: "+226",
  code: "BF"
}, {
  name: "Burundi",
  dial_code: "+257",
  code: "BI"
}, {
  name: "Cambodia",
  dial_code: "+855",
  code: "KH"
}, {
  name: "Cameroon",
  dial_code: "+237",
  code: "CM"
}, {
  name: "Canada",
  dial_code: "+1",
  code: "CA"
}, {
  name: "Cape Verde",
  dial_code: "+238",
  code: "CV"
}, {
  name: "Cayman Islands",
  dial_code: "+ 345",
  code: "KY"
}, {
  name: "Central African Republic",
  dial_code: "+236",
  code: "CF"
}, {
  name: "Chad",
  dial_code: "+235",
  code: "TD"
}, {
  name: "Chile",
  dial_code: "+56",
  code: "CL"
}, {
  name: "China",
  dial_code: "+86",
  code: "CN"
}, {
  name: "Christmas Island",
  dial_code: "+61",
  code: "CX"
}, {
  name: "Colombia",
  dial_code: "+57",
  code: "CO"
}, {
  name: "Comoros",
  dial_code: "+269",
  code: "KM"
}, {
  name: "Congo",
  dial_code: "+242",
  code: "CG"
}, {
  name: "Cook Islands",
  dial_code: "+682",
  code: "CK"
}, {
  name: "Costa Rica",
  dial_code: "+506",
  code: "CR"
}, {
  name: "Croatia",
  dial_code: "+385",
  code: "HR"
}, {
  name: "Cuba",
  dial_code: "+53",
  code: "CU"
}, {
  name: "Cyprus",
  dial_code: "+537",
  code: "CY"
}, {
  name: "Czech Republic",
  dial_code: "+420",
  code: "CZ"
}, {
  name: "Denmark",
  dial_code: "+45",
  code: "DK"
}, {
  name: "Djibouti",
  dial_code: "+253",
  code: "DJ"
}, {
  name: "Dominica",
  dial_code: "+1 767",
  code: "DM"
}, {
  name: "Dominican Republic",
  dial_code: "+1 849",
  code: "DO"
}, {
  name: "Ecuador",
  dial_code: "+593",
  code: "EC"
}, {
  name: "Egypt",
  dial_code: "+20",
  code: "EG"
}, {
  name: "El Salvador",
  dial_code: "+503",
  code: "SV"
}, {
  name: "Equatorial Guinea",
  dial_code: "+240",
  code: "GQ"
}, {
  name: "Eritrea",
  dial_code: "+291",
  code: "ER"
}, {
  name: "Estonia",
  dial_code: "+372",
  code: "EE"
}, {
  name: "Ethiopia",
  dial_code: "+251",
  code: "ET"
}, {
  name: "Faroe Islands",
  dial_code: "+298",
  code: "FO"
}, {
  name: "Fiji",
  dial_code: "+679",
  code: "FJ"
}, {
  name: "Finland",
  dial_code: "+358",
  code: "FI"
}, {
  name: "France",
  dial_code: "+33",
  code: "FR"
}, {
  name: "French Guiana",
  dial_code: "+594",
  code: "GF"
}, {
  name: "French Polynesia",
  dial_code: "+689",
  code: "PF"
}, {
  name: "Gabon",
  dial_code: "+241",
  code: "GA"
}, {
  name: "Gambia",
  dial_code: "+220",
  code: "GM"
}, {
  name: "Georgia",
  dial_code: "+995",
  code: "GE"
}, {
  name: "Germany",
  dial_code: "+49",
  code: "DE"
}, {
  name: "Ghana",
  dial_code: "+233",
  code: "GH"
}, {
  name: "Gibraltar",
  dial_code: "+350",
  code: "GI"
}, {
  name: "Greece",
  dial_code: "+30",
  code: "GR"
}, {
  name: "Greenland",
  dial_code: "+299",
  code: "GL"
}, {
  name: "Grenada",
  dial_code: "+1 473",
  code: "GD"
}, {
  name: "Guadeloupe",
  dial_code: "+590",
  code: "GP"
}, {
  name: "Guam",
  dial_code: "+1 671",
  code: "GU"
}, {
  name: "Guatemala",
  dial_code: "+502",
  code: "GT"
}, {
  name: "Guinea",
  dial_code: "+224",
  code: "GN"
}, {
  name: "Guinea-Bissau",
  dial_code: "+245",
  code: "GW"
}, {
  name: "Guyana",
  dial_code: "+595",
  code: "GY"
}, {
  name: "Haiti",
  dial_code: "+509",
  code: "HT"
}, {
  name: "Honduras",
  dial_code: "+504",
  code: "HN"
}, {
  name: "Hungary",
  dial_code: "+36",
  code: "HU"
}, {
  name: "Iceland",
  dial_code: "+354",
  code: "IS"
}, {
  name: "India",
  dial_code: "+91",
  code: "IN"
}, {
  name: "Indonesia",
  dial_code: "+62",
  code: "ID"
}, {
  name: "Iraq",
  dial_code: "+964",
  code: "IQ"
}, {
  name: "Ireland",
  dial_code: "+353",
  code: "IE"
}, {
  name: "Israel",
  dial_code: "+972",
  code: "IL"
}, {
  name: "Italy",
  dial_code: "+39",
  code: "IT"
}, {
  name: "Jamaica",
  dial_code: "+1 876",
  code: "JM"
}, {
  name: "Japan",
  dial_code: "+81",
  code: "JP"
}, {
  name: "Jordan",
  dial_code: "+962",
  code: "JO"
}, {
  name: "Kazakhstan",
  dial_code: "+7 7",
  code: "KZ"
}, {
  name: "Kenya",
  dial_code: "+254",
  code: "KE"
}, {
  name: "Kiribati",
  dial_code: "+686",
  code: "KI"
}, {
  name: "Kuwait",
  dial_code: "+965",
  code: "KW"
}, {
  name: "Kyrgyzstan",
  dial_code: "+996",
  code: "KG"
}, {
  name: "Latvia",
  dial_code: "+371",
  code: "LV"
}, {
  name: "Lebanon",
  dial_code: "+961",
  code: "LB"
}, {
  name: "Lesotho",
  dial_code: "+266",
  code: "LS"
}, {
  name: "Liberia",
  dial_code: "+231",
  code: "LR"
}, {
  name: "Liechtenstein",
  dial_code: "+423",
  code: "LI"
}, {
  name: "Lithuania",
  dial_code: "+370",
  code: "LT"
}, {
  name: "Luxembourg",
  dial_code: "+352",
  code: "LU"
}, {
  name: "Madagascar",
  dial_code: "+261",
  code: "MG"
}, {
  name: "Malawi",
  dial_code: "+265",
  code: "MW"
}, {
  name: "Malaysia",
  dial_code: "+60",
  code: "MY"
}, {
  name: "Maldives",
  dial_code: "+960",
  code: "MV"
}, {
  name: "Mali",
  dial_code: "+223",
  code: "ML"
}, {
  name: "Malta",
  dial_code: "+356",
  code: "MT"
}, {
  name: "Marshall Islands",
  dial_code: "+692",
  code: "MH"
}, {
  name: "Martinique",
  dial_code: "+596",
  code: "MQ"
}, {
  name: "Mauritania",
  dial_code: "+222",
  code: "MR"
}, {
  name: "Mauritius",
  dial_code: "+230",
  code: "MU"
}, {
  name: "Mayotte",
  dial_code: "+262",
  code: "YT"
}, {
  name: "Mexico",
  dial_code: "+52",
  code: "MX"
}, {
  name: "Monaco",
  dial_code: "+377",
  code: "MC"
}, {
  name: "Mongolia",
  dial_code: "+976",
  code: "MN"
}, {
  name: "Montenegro",
  dial_code: "+382",
  code: "ME"
}, {
  name: "Montserrat",
  dial_code: "+1664",
  code: "MS"
}, {
  name: "Morocco",
  dial_code: "+212",
  code: "MA"
}, {
  name: "Myanmar",
  dial_code: "+95",
  code: "MM"
}, {
  name: "Namibia",
  dial_code: "+264",
  code: "NA"
}, {
  name: "Nauru",
  dial_code: "+674",
  code: "NR"
}, {
  name: "Nepal",
  dial_code: "+977",
  code: "NP"
}, {
  name: "Netherlands",
  dial_code: "+31",
  code: "NL"
}, {
  name: "Netherlands Antilles",
  dial_code: "+599",
  code: "AN"
}, {
  name: "New Caledonia",
  dial_code: "+687",
  code: "NC"
}, {
  name: "New Zealand",
  dial_code: "+64",
  code: "NZ"
}, {
  name: "Nicaragua",
  dial_code: "+505",
  code: "NI"
}, {
  name: "Niger",
  dial_code: "+227",
  code: "NE"
}, {
  name: "Nigeria",
  dial_code: "+234",
  code: "NG"
}, {
  name: "Niue",
  dial_code: "+683",
  code: "NU"
}, {
  name: "Norfolk Island",
  dial_code: "+672",
  code: "NF"
}, {
  name: "Northern Mariana Islands",
  dial_code: "+1 670",
  code: "MP"
}, {
  name: "Norway",
  dial_code: "+47",
  code: "NO"
}, {
  name: "Oman",
  dial_code: "+968",
  code: "OM"
}, {
  name: "Pakistan",
  dial_code: "+92",
  code: "PK"
}, {
  name: "Palau",
  dial_code: "+680",
  code: "PW"
}, {
  name: "Panama",
  dial_code: "+507",
  code: "PA"
}, {
  name: "Papua New Guinea",
  dial_code: "+675",
  code: "PG"
}, {
  name: "Paraguay",
  dial_code: "+595",
  code: "PY"
}, {
  name: "Peru",
  dial_code: "+51",
  code: "PE"
}, {
  name: "Philippines",
  dial_code: "+63",
  code: "PH"
}, {
  name: "Poland",
  dial_code: "+48",
  code: "PL"
}, {
  name: "Portugal",
  dial_code: "+351",
  code: "PT"
}, {
  name: "Puerto Rico",
  dial_code: "+1 939",
  code: "PR"
}, {
  name: "Qatar",
  dial_code: "+974",
  code: "QA"
}, {
  name: "Romania",
  dial_code: "+40",
  code: "RO"
}, {
  name: "Rwanda",
  dial_code: "+250",
  code: "RW"
}, {
  name: "Samoa",
  dial_code: "+685",
  code: "WS"
}, {
  name: "San Marino",
  dial_code: "+378",
  code: "SM"
}, {
  name: "Saudi Arabia",
  dial_code: "+966",
  code: "SA"
}, {
  name: "Senegal",
  dial_code: "+221",
  code: "SN"
}, {
  name: "Serbia",
  dial_code: "+381",
  code: "RS"
}, {
  name: "Seychelles",
  dial_code: "+248",
  code: "SC"
}, {
  name: "Sierra Leone",
  dial_code: "+232",
  code: "SL"
}, {
  name: "Singapore",
  dial_code: "+65",
  code: "SG"
}, {
  name: "Slovakia",
  dial_code: "+421",
  code: "SK"
}, {
  name: "Slovenia",
  dial_code: "+386",
  code: "SI"
}, {
  name: "Solomon Islands",
  dial_code: "+677",
  code: "SB"
}, {
  name: "South Africa",
  dial_code: "+27",
  code: "ZA"
}, {
  name: "South Georgia and the South Sandwich Islands",
  dial_code: "+500",
  code: "GS"
}, {
  name: "Spain",
  dial_code: "+34",
  code: "ES"
}, {
  name: "Sri Lanka",
  dial_code: "+94",
  code: "LK"
}, {
  name: "Sudan",
  dial_code: "+249",
  code: "SD"
}, {
  name: "Suriname",
  dial_code: "+597",
  code: "SR"
}, {
  name: "Swaziland",
  dial_code: "+268",
  code: "SZ"
}, {
  name: "Sweden",
  dial_code: "+46",
  code: "SE"
}, {
  name: "Switzerland",
  dial_code: "+41",
  code: "CH"
}, {
  name: "Tajikistan",
  dial_code: "+992",
  code: "TJ"
}, {
  name: "Thailand",
  dial_code: "+66",
  code: "TH"
}, {
  name: "Togo",
  dial_code: "+228",
  code: "TG"
}, {
  name: "Tokelau",
  dial_code: "+690",
  code: "TK"
}, {
  name: "Tonga",
  dial_code: "+676",
  code: "TO"
}, {
  name: "Trinidad and Tobago",
  dial_code: "+1 868",
  code: "TT"
}, {
  name: "Tunisia",
  dial_code: "+216",
  code: "TN"
}, {
  name: "Turkey",
  dial_code: "+90",
  code: "TR"
}, {
  name: "Turkmenistan",
  dial_code: "+993",
  code: "TM"
}, {
  name: "Turks and Caicos Islands",
  dial_code: "+1 649",
  code: "TC"
}, {
  name: "Tuvalu",
  dial_code: "+688",
  code: "TV"
}, {
  name: "Uganda",
  dial_code: "+256",
  code: "UG"
}, {
  name: "Ukraine",
  dial_code: "+380",
  code: "UA"
}, {
  name: "United Arab Emirates",
  dial_code: "+971",
  code: "AE"
}, {
  name: "United Kingdom",
  dial_code: "+44",
  code: "GB"
}, {
  name: "United States",
  dial_code: "+1",
  code: "US"
}, {
  name: "Uruguay",
  dial_code: "+598",
  code: "UY"
}, {
  name: "Uzbekistan",
  dial_code: "+998",
  code: "UZ"
}, {
  name: "Vanuatu",
  dial_code: "+678",
  code: "VU"
}, {
  name: "Wallis and Futuna",
  dial_code: "+681",
  code: "WF"
}, {
  name: "Yemen",
  dial_code: "+967",
  code: "YE"
}, {
  name: "Zambia",
  dial_code: "+260",
  code: "ZM"
}, {
  name: "Zimbabwe",
  dial_code: "+263",
  code: "ZW"
}, {
  name: "Antarctica",
  dial_code: null,
  code: "AQ"
}, {
  name: "Bolivia, Plurinational State of",
  dial_code: "+591",
  code: "BO"
}, {
  name: "Brunei Darussalam",
  dial_code: "+673",
  code: "BN"
}, {
  name: "Cocos (Keeling) Islands",
  dial_code: "+61",
  code: "CC"
}, {
  name: "Congo, The Democratic Republic of the",
  dial_code: "+243",
  code: "CD"
}, {
  name: "Cote d'Ivoire",
  dial_code: "+225",
  code: "CI"
}, {
  name: "Falkland Islands (Malvinas)",
  dial_code: "+500",
  code: "FK"
}, {
  name: "Guernsey",
  dial_code: "+44",
  code: "GG"
}, {
  name: "Holy See (Vatican City State)",
  dial_code: "+379",
  code: "VA"
}, {
  name: "Hong Kong",
  dial_code: "+852",
  code: "HK"
}, {
  name: "Iran, Islamic Republic of",
  dial_code: "+98",
  code: "IR"
}, {
  name: "Isle of Man",
  dial_code: "+44",
  code: "IM"
}, {
  name: "Jersey",
  dial_code: "+44",
  code: "JE"
}, {
  name: "Korea, Democratic People's Republic of",
  dial_code: "+850",
  code: "KP"
}, {
  name: "Korea, Republic of",
  dial_code: "+82",
  code: "KR"
}, {
  name: "Lao People's Democratic Republic",
  dial_code: "+856",
  code: "LA"
}, {
  name: "Libyan Arab Jamahiriya",
  dial_code: "+218",
  code: "LY"
}, {
  name: "Macao",
  dial_code: "+853",
  code: "MO"
}, {
  name: "Macedonia, The Former Yugoslav Republic of",
  dial_code: "+389",
  code: "MK"
}, {
  name: "Micronesia, Federated States of",
  dial_code: "+691",
  code: "FM"
}, {
  name: "Moldova, Republic of",
  dial_code: "+373",
  code: "MD"
}, {
  name: "Mozambique",
  dial_code: "+258",
  code: "MZ"
}, {
  name: "Palestinian Territory, Occupied",
  dial_code: "+970",
  code: "PS"
}, {
  name: "Pitcairn",
  dial_code: "+872",
  code: "PN"
}, {
  name: "Réunion",
  dial_code: "+262",
  code: "RE"
}, {
  name: "Russia",
  dial_code: "+7",
  code: "RU"
}, {
  name: "Saint Barthélemy",
  dial_code: "+590",
  code: "BL"
}, {
  name: "Saint Helena, Ascension and Tristan Da Cunha",
  dial_code: "+290",
  code: "SH"
}, {
  name: "Saint Kitts and Nevis",
  dial_code: "+1 869",
  code: "KN"
}, {
  name: "Saint Lucia",
  dial_code: "+1 758",
  code: "LC"
}, {
  name: "Saint Martin",
  dial_code: "+590",
  code: "MF"
}, {
  name: "Saint Pierre and Miquelon",
  dial_code: "+508",
  code: "PM"
}, {
  name: "Saint Vincent and the Grenadines",
  dial_code: "+1 784",
  code: "VC"
}, {
  name: "Sao Tome and Principe",
  dial_code: "+239",
  code: "ST"
}, {
  name: "Somalia",
  dial_code: "+252",
  code: "SO"
}, {
  name: "Svalbard and Jan Mayen",
  dial_code: "+47",
  code: "SJ"
}, {
  name: "Syrian Arab Republic",
  dial_code: "+963",
  code: "SY"
}, {
  name: "Taiwan, Province of China",
  dial_code: "+886",
  code: "TW"
}, {
  name: "Tanzania, United Republic of",
  dial_code: "+255",
  code: "TZ"
}, {
  name: "Timor-Leste",
  dial_code: "+670",
  code: "TL"
}, {
  name: "Venezuela, Bolivarian Republic of",
  dial_code: "+58",
  code: "VE"
}, {
  name: "Viet Nam",
  dial_code: "+84",
  code: "VN"
}, {
  name: "Virgin Islands, British",
  dial_code: "+1 284",
  code: "VG"
}, {
  name: "Virgin Islands, U.S.",
  dial_code: "+1 340",
  code: "VI"
}];
var countries_en = {
  countries: countries$1
};
var _excluded$j = ["field", "value", "onChange", "disabled", "inAuthForm"];

var CountryCodeField = function CountryCodeField(_ref) {
  var field = _ref.field,
      value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      inAuthForm = _ref.inAuthForm,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$j);

  var phoneNumberWhitelistedCountries = field.phoneNumberWhitelistedCountries;

  var _useTranslation = useTranslation(["dataForm"]),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var countries = {
    countries_ar: countries_ar,
    countries_en: countries_en
  };
  var countriesList = countries["countries_" + language];

  var handleChange = function handleChange(_ref2) {
    var value = _ref2.value;
    onChange(field, value);
  };

  var filterCountries = function filterCountries() {
    var filteredCountries = phoneNumberWhitelistedCountries ? countriesList.countries.filter(function (country) {
      return phoneNumberWhitelistedCountries.includes(country.code);
    }) : countriesList.countries;
    return filteredCountries.map(function (country) {
      return {
        value: country.dial_code,
        label: country.name + " (" + country.dial_code + ")"
      };
    });
  };

  return /*#__PURE__*/React__default.createElement(Select, _extends({
    disabled: disabled,
    label: t("countryCode"),
    selected: value,
    onChange: handleChange,
    options: filterCountries(),
    inAuthForm: inAuthForm,
    placeholder: t("countryCode"),
    isSearchable: true
  }, props));
};

var PhoneNumberField = function PhoneNumberField(_ref) {
  var field = _ref.field,
      value = _ref.value,
      onChange = _ref.onChange,
      error = _ref.error,
      disabled = _ref.disabled,
      inAuthForm = _ref.inAuthForm;
  var disableCountryCode = field.disableCountryCode;

  var handlePhoneNumberChange = function handlePhoneNumberChange(event) {
    var _event$target;

    var newValue = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;
    disableCountryCode ? onChange(field, newValue) : onChange(field, (value.split("-")[0] || "") + "-" + newValue);
  };

  var handleCountryCodeChange = function handleCountryCodeChange(_, newValue) {
    onChange(field, newValue + "-" + (value.split("-")[1] || ""));
  };

  return /*#__PURE__*/React__default.createElement(StyledField, {
    inAuthForm: inAuthForm,
    label: inAuthForm ? getTranslatedValue(field.label) : field.getLabel(),
    onChange: handlePhoneNumberChange,
    value: disableCountryCode ? value : value.split("-")[1] || "",
    type: "string",
    disabled: disabled,
    required: field.required,
    error: error,
    addonBefore: !disableCountryCode && /*#__PURE__*/React__default.createElement(CountryCodeWrapper, null, /*#__PURE__*/React__default.createElement(CountryCodeField, {
      field: field,
      value: value.split("-")[0],
      onChange: handleCountryCodeChange,
      disabled: disabled,
      inAuthForm: inAuthForm,
      withoutWrapper: true
    }))
  });
};

var dynamicFieldGroupReducer = function dynamicFieldGroupReducer(isSingle) {
  if (isSingle === void 0) {
    isSingle = true;
  }

  return function (state, action) {
    var _extends2, _extends3, _extends4;

    if (state === void 0) {
      state = {};
    }

    var identifier = action.identifier,
        fields = action.fields,
        fieldsGroupIndex = action.fieldsGroupIndex,
        key = action.key,
        value = action.value,
        dependantsValuesOverrides = action.dependantsValuesOverrides,
        emptyState = action.emptyState,
        resetOnChangeValues = action.resetOnChangeValues,
        useObjectPayload = action.useObjectPayload;

    if (!isSingle) {
      state.isPrePopulationChange = false;
      state.isUpdateChange = false;
    }

    switch (action.type) {
      case "addSingle":
        return actionFields(identifier, fields).reduce(function (acc, field) {
          acc[field.identifier] = field.getDefaultValue();
          return acc;
        }, {});

      case "removeSingle":
        return {};

      case "unmarkForDestroySingle":
        return _extends({}, emptyState, (_extends2 = {}, _extends2[key] = value, _extends2));

      case "markForDestroySingle":
      case "updateSingle":
        return _extends({}, state, (_extends3 = {}, _extends3[key] = value, _extends3), resetOnChangeValues);

      case "updateDependantsValuesSingle":
        return _extends({}, state, (_extends4 = {}, _extends4[key] = value, _extends4), dependantsValuesOverrides, resetOnChangeValues);

      case "add":
        var newFieldState = actionFields(identifier, fields).reduce(function (acc, field) {
          acc[field.identifier] = field.getDefaultValue();
          return acc;
        }, {});
        return [].concat(state, [newFieldState]);

      case "remove":
        return state.filter(function (_, index) {
          return fieldsGroupIndex !== index;
        });

      case "markForDestroy":
      case "update":
        state.isUpdateChange = true;
        return state.map(function (item, index) {
          if (index === fieldsGroupIndex) {
            if (useObjectPayload) item = _extends({}, value);else {
              item[key] = value;
              item = _extends({}, item, resetOnChangeValues);
            }
          }

          return item;
        });

      case "updateDependantsValues":
        return state.map(function (item, index) {
          if (index === fieldsGroupIndex) {
            var _extends5;

            item[key] = value;
            item = _extends({}, item, (_extends5 = {}, _extends5[key] = value, _extends5), dependantsValuesOverrides, resetOnChangeValues);
          }

          return item;
        });

      case "resetPrepopulationValues":
        var resetValue = [];
        resetValue.isPrePopulationChange = true;
        return resetValue;

      case "updatePrepopulationValues":
        value.isPrePopulationChange = true;
        return value;

      default:
        return state;
    }
  };
};

var Single = function Single(_ref) {
  var _ref$field = _ref.field,
      identifier = _ref$field.identifier,
      fields = _ref$field.fields,
      accessor = _ref$field.accessor,
      initiallySet = _ref$field.initiallySet,
      field = _ref.field,
      onChange = _ref.onChange,
      action = _ref.action,
      data = _ref.data,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values,
      errors = _ref.errors,
      inAuthForm = _ref.inAuthForm,
      disabled = _ref.disabled;

  var _useTranslation = useTranslation("dataForm"),
      t = _useTranslation.t;

  var emptyState = fieldsToState(fields, action, data);
  var initialState = initiallySet && Object.keys(values).length === 0 ? emptyState : values;

  var _useReducer = useReducer(dynamicFieldGroupReducer(true), initialState),
      fieldsState = _useReducer[0],
      dispatch = _useReducer[1];

  useEffect(function () {
    if (!isEqual(fieldsState, values)) {
      onChange(field, fieldsState);
    }
  }, [fieldsState, field, onChange]);

  var handleAdd = function handleAdd() {
    if (fieldsState._destroy) dispatch({
      type: "unmarkForDestroySingle",
      key: "_destroy",
      value: false,
      emptyState: emptyState
    });else dispatch({
      type: "addSingle",
      identifier: identifier,
      fields: fields
    });
  };

  var handleRemove = function handleRemove() {
    if (field.getDynamicFieldsIdentifierValue(fieldsState)) {
      dispatch({
        type: "markForDestroySingle",
        key: "_destroy",
        value: true
      });
    } else {
      dispatch({
        type: "removeSingle"
      });
    }
  };

  var handleChange = useCallback(function (field, value) {
    var resetOnChangeValues = field.getResetDependantsObject && field.getResetDependantsObject();
    dispatch({
      type: "updateSingle",
      key: field.identifier || field,
      value: value,
      resetOnChangeValues: resetOnChangeValues
    });
  }, [dispatch]);
  var handleDependeeChange = useCallback(function (field, value) {
    var _field$getParentField;

    var resetOnChangeValues = field.getResetDependantsObject && field.getResetDependantsObject();
    var dataObject = (_field$getParentField = field.getParentField) === null || _field$getParentField === void 0 ? void 0 : _field$getParentField.call(field).getDataValue(data, {
      isForm: true
    });
    dispatch({
      type: "updateDependantsValuesSingle",
      key: field.identifier || field,
      value: value,
      dependantsValuesOverrides: generateDependeeValues(fields, field, value, fieldsState, dataObject),
      resetOnChangeValues: resetOnChangeValues
    });
  }, [fields, data, fieldsState]);
  var onFieldChange = useCallback(function (field, value) {
    if (field.hasDependants || field.dependee) handleDependeeChange(field, value);else handleChange(field, value);
  }, []);
  return /*#__PURE__*/React__default.createElement(DynamicFieldWrapper, null, Object.keys(fieldsState).length > 0 && !fieldsState._destroy && /*#__PURE__*/React__default.createElement("div", {
    className: "dynamic-record"
  }, filterFields(action, fields, fieldsState, undefined, undefined, true).map(function (field) {
    var _extends2;

    return /*#__PURE__*/React__default.createElement(Field$1, {
      key: field.identifier,
      field: field,
      onChange: onFieldChange,
      value: fieldsState[field.identifier],
      action: action,
      data: data && field.getDataValue(data, {
        customAccessor: accessor
      }),
      errors: _extends((_extends2 = {}, _extends2[field.identifier] = errors[accessor + "." + field.identifier], _extends2), errors),
      state: fieldsState,
      inAuthForm: inAuthForm
    });
  }), field.getBooleanPropertyValue("allowRemove", data) && /*#__PURE__*/React__default.createElement(_Button, {
    icon: /*#__PURE__*/React__default.createElement(MinusCircleOutlined$2, null),
    onClick: handleRemove,
    disabled: disabled
  }, t("remove"))), (Object.keys(fieldsState).length === 0 || fieldsState._destroy) && /*#__PURE__*/React__default.createElement(_Button, {
    type: "dashed",
    onClick: handleAdd,
    icon: /*#__PURE__*/React__default.createElement(AddIcon, null),
    disabled: disabled
  }, t("add")));
};

var Single$1 = withFieldHandler(Single);

var Multiple = function Multiple(_ref) {
  var _ref$field = _ref.field,
      identifier = _ref$field.identifier,
      fields = _ref$field.fields,
      accessor = _ref$field.accessor,
      field = _ref.field,
      onChange = _ref.onChange,
      action = _ref.action,
      data = _ref.data,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? [] : _ref$values,
      errors = _ref.errors,
      inAuthForm = _ref.inAuthForm,
      disabled = _ref.disabled,
      resetError = _ref.resetError;

  var _useTranslation = useTranslation("dataForm"),
      t = _useTranslation.t;

  var reset = field.getPrepopulaterValueNotSet();

  var _useReducer = useReducer(dynamicFieldGroupReducer(false), values),
      fieldsState = _useReducer[0],
      dispatch = _useReducer[1];

  var isFirstVirtualUpdatePending = useRef(field.isVirtual());
  useEffect(function () {
    var newState = !fieldsState.isPrePopulationChange && !isEqual(fieldsState, values);
    var virtualFieldsUpdate = isFirstVirtualUpdatePending.current && values.isUpdateChange;
    if (virtualFieldsUpdate) isFirstVirtualUpdatePending.current = false;

    if (virtualFieldsUpdate || newState) {
      var nextState = cloneDeep([].concat(fieldsState));
      delete nextState.isPrePopulationChange;
      delete nextState.isUpdateChange;
      onChange(field, nextState);
    }
  }, [fieldsState, field, onChange]);
  useEffect(function () {
    values && !reset && field.isPrepopulated(action) && dispatch({
      type: "updatePrepopulationValues",
      value: cloneDeep([].concat(values))
    });
  }, [values, field, action, reset]);
  useEffect(function () {
    reset && field.isPrepopulated(action) && action !== "edit" && dispatch({
      type: "resetPrepopulationValues"
    });
  }, [field, action, reset]);

  var handleAdd = function handleAdd() {
    dispatch({
      type: "add",
      identifier: identifier,
      fields: fields
    });
  };

  var handleRemove = useCallback(function (fieldsGroupIndex) {
    return function () {
      var fieldToRemove = fieldsState[fieldsGroupIndex];

      if (field.getDynamicFieldsIdentifierValue(fieldToRemove)) {
        dispatch({
          type: "markForDestroy",
          fieldsGroupIndex: fieldsGroupIndex,
          key: "_destroy",
          value: true
        });
      } else {
        dispatch({
          type: "remove",
          fieldsGroupIndex: fieldsGroupIndex
        });
      }
    };
  }, [dispatch, field, fieldsState]);
  var handleChange = useCallback(function (fieldsGroupIndex) {
    return function (field, value, _, useObjectPayload) {
      var resetOnChangeValues = field.getResetDependantsObject && field.getResetDependantsObject();
      dispatch({
        type: "update",
        fieldsGroupIndex: fieldsGroupIndex,
        key: field.identifier || field,
        value: value,
        resetOnChangeValues: resetOnChangeValues,
        useObjectPayload: useObjectPayload,
        field: field
      });
    };
  }, [dispatch]);
  var handleDependeeChange = useCallback(function (fieldsGroupIndex, field) {
    return function (dependeeField, value) {
      var dataObject = field.getParentField().getDataValue(data, {
        isForm: true
      });
      var dependantsValuesOverrides = generateDependeeValues(fields, field, value, fieldsState, dataObject[fieldsGroupIndex]);
      var resetOnChangeValues = dependeeField.getResetDependantsObject && dependeeField.getResetDependantsObject();
      dispatch({
        type: "updateDependantsValues",
        fieldsGroupIndex: fieldsGroupIndex,
        key: dependeeField.identifier || dependeeField,
        value: value,
        dependantsValuesOverrides: dependantsValuesOverrides,
        resetOnChangeValues: resetOnChangeValues
      });
    };
  }, [fields, fieldsState, data]);

  var showAddButton = function showAddButton() {
    var _field$entity;

    if ((_field$entity = field.entity) !== null && _field$entity !== void 0 && _field$entity.disableAdd) return false;
    if (!field.maxNumberOfFields) return true;
    return fieldsState.length < field.maxNumberOfFields;
  };

  return /*#__PURE__*/React__default.createElement(DynamicFieldWrapper, null, Array.isArray(fieldsState) && fieldsState.map(function (fieldsGroup, index) {
    return !fieldsGroup["_destroy"] && /*#__PURE__*/React__default.createElement("div", {
      className: "dynamic-record",
      key: index
    }, filterFields(action, fields, fieldsState[index], undefined, undefined, true).map(function (field) {
      var _extends2;

      return /*#__PURE__*/React__default.createElement(Field$1, {
        key: field.identifier,
        field: field,
        onChange: field.dependee ? handleDependeeChange(index, field) : handleChange(index),
        value: fieldsState[index][field.identifier],
        action: action,
        data: data && field.getDataValue(data, {
          customAccessor: accessor
        })[index],
        errors: _extends((_extends2 = {}, _extends2[field.identifier] = errors[accessor + "[" + index + "]." + field.identifier], _extends2), errors),
        state: fieldsState[index],
        inAuthForm: inAuthForm,
        index: index,
        resetError: resetError
      });
    }), /*#__PURE__*/React__default.createElement(_Button, {
      icon: /*#__PURE__*/React__default.createElement(MinusCircleOutlined$2, null),
      onClick: handleRemove(index),
      disabled: disabled
    }, t("remove")));
  }), showAddButton() && /*#__PURE__*/React__default.createElement(_Button, {
    type: "dashed",
    onClick: handleAdd,
    icon: /*#__PURE__*/React__default.createElement(AddIcon, null),
    disabled: disabled
  }, t("add")));
};

var Multiple$1 = withFieldHandler(Multiple);

var DynamicFieldsGroup = function DynamicFieldsGroup(props) {
  return props.field.preventMultiple ? /*#__PURE__*/React__default.createElement(Single$1, props) : /*#__PURE__*/React__default.createElement(Multiple$1, props);
};

var _templateObject$c, _templateObject2$9, _templateObject3$7;

var SearchWrapper = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  margin-top: 15px;\n"])), function (props) {
  return props.isSearchBarVisible ? "" : "none";
});
var TitleWrapper$1 = styled.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var StyledHighlightableWrapper = styled.span(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteralLoose(["\n  .highlight {\n    color: #f9cc02;\n    background: none;\n    margin: 0;\n    padding: 0;\n  }\n"])));

var DataList = function DataList(_ref) {
  var _field$transferListCo;

  var items = _ref.items,
      checked = _ref.checked,
      handleToggle = _ref.handleToggle,
      loading = _ref.loading,
      reference = _ref.reference,
      scroll = _ref.scroll,
      handleToggleAll = _ref.handleToggleAll,
      valueLabel = _ref.valueLabel,
      field = _ref.field,
      onSearch = _ref.onSearch,
      isRight = _ref.isRight;

  var _useState = useState([]),
      searchList = _useState[0],
      setSearchList = _useState[1];

  var _useTranslation = useTranslation("dataForm"),
      t = _useTranslation.t;

  var checkedMap = new Map();
  checked.forEach(function (option) {
    return checkedMap.set(option[valueLabel], true);
  });

  var updateSearch = function updateSearch(key) {
    setSearchList(key.split(" "));
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(key);
  };

  var delayedSearch = debounce(useCallback(function (value) {
    updateSearch(value);
  }, []), 500);

  var onPressEnter = function onPressEnter(event) {
    var _event$target;

    if (event.key === "Enter") event.preventDefault();
    updateSearch(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
  };

  var onChange = function onChange(event) {
    var _event$target2, _event$target3;

    isRight ? updateSearch(event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value) : delayedSearch(event === null || event === void 0 ? void 0 : (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.value);
  };

  return /*#__PURE__*/React__default.createElement(ListWrapper, null, /*#__PURE__*/React__default.createElement(_Card, {
    bordered: true,
    title: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TitleWrapper$1, null, /*#__PURE__*/React__default.createElement(_Checkbox, {
      onChange: handleToggleAll(items),
      checked: checked.length === items.length && items.length !== 0,
      disabled: items.length === 0
    }, t("choices")), /*#__PURE__*/React__default.createElement(_Typography.Text, {
      type: "secondary",
      className: "number-selected"
    }, checked.length + "/" + items.length + " " + t("selected"))), /*#__PURE__*/React__default.createElement(SearchWrapper, {
      isSearchBarVisible: (_field$transferListCo = field.transferListConfig) === null || _field$transferListCo === void 0 ? void 0 : _field$transferListCo.showSearch
    }, /*#__PURE__*/React__default.createElement(_Input, {
      placeholder: t("search"),
      onChange: onChange,
      onPressEnter: onPressEnter,
      size: "small"
    })))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "options-wrapper",
    ref: reference,
    onScroll: scroll
  }, /*#__PURE__*/React__default.createElement(_List, null, loading && /*#__PURE__*/React__default.createElement(_Spin, null), items.map(function (item) {
    return /*#__PURE__*/React__default.createElement(_List.Item, {
      key: item[valueLabel]
    }, /*#__PURE__*/React__default.createElement(_Checkbox, {
      checked: checkedMap.has(item[valueLabel]),
      onChange: handleToggle(item)
    }, /*#__PURE__*/React__default.createElement(StyledHighlightableWrapper, null, /*#__PURE__*/React__default.createElement(Highlighter, {
      highlightClassName: "highlight",
      searchWords: searchList,
      textToHighlight: field.getDisplayValue(item.value, {
        enableLink: false
      })() || "",
      autoEscape: true
    }))));
  }), loading && items.length > 0 && /*#__PURE__*/React__default.createElement(_List.Item, null, t("loading"))))));
};

var _excluded$k = ["type"];

var reducer$1 = function reducer(state, action) {
  var type = action.type,
      payload = _objectWithoutPropertiesLoose(action, _excluded$k);

  switch (type) {
    case "change":
      return _extends({}, state, payload);

    case "appendLeftOptions":
      {
        var leftOptions = union(state.leftOptions, payload.leftOptions, state.valueLabel);
        return _extends({}, state, {
          leftOptions: leftOptions
        });
      }

    default:
      return state;
  }
};

var useInfiniteScroll = function useInfiniteScroll(_ref, loading) {
  var current = _ref.current;

  var _useState = useState({
    page: 1,
    pageHeight: 1
  }),
      scrollPage = _useState[0],
      setScrollPage = _useState[1];

  var page = scrollPage.page,
      pageHeight = scrollPage.pageHeight;

  var onScroll = function onScroll() {
    var clientHeight = current.clientHeight,
        scrollTop = current.scrollTop,
        scrollHeight = current.scrollHeight;
    var bottom = scrollHeight - clientHeight;

    if (Math.ceil(scrollTop) >= bottom && !loading && scrollHeight > pageHeight) {
      setScrollPage({
        page: page + 1,
        pageHeight: scrollHeight + 5
      });
    }
  };

  var forceChange = function forceChange(incrementPage) {
    if (incrementPage) setScrollPage({
      page: page + 1,
      pageHeight: 0
    });else setScrollPage(_extends({}, scrollPage, {
      pageHeight: 0
    }));
  };

  var resetPage = function resetPage() {
    setScrollPage({
      page: 1,
      pageHeight: 1
    });
  };

  return {
    page: page,
    onScroll: onScroll,
    forceChange: forceChange,
    resetPage: resetPage
  };
};

var useListMovement = function useListMovement(checkedOptions, checkedLeftOptions, checkedRightOptions, leftOptions, rightOptions, valueLabel, actionName, dispatch, destroyedOptions) {
  var handleToggle = function handleToggle(value) {
    return function () {
      var currentIndex = checkedOptions.findIndex(function (element) {
        return element[valueLabel] === value[valueLabel];
      });
      var newChecked = [].concat(checkedOptions);

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      dispatch({
        type: "change",
        checkedOptions: newChecked
      });
    };
  };

  var handleChecked = function handleChecked(source) {
    var newState = {};

    if (source === "right") {
      if (actionName === "edit") {
        checkedLeftOptions.forEach(function (option) {
          option._destroy = false;
        });
      }

      newState.rightOptions = rightOptions.concat(checkedLeftOptions);
      newState.leftOptions = not(leftOptions, checkedLeftOptions, valueLabel);
      newState.checkedOptions = not(checkedOptions, checkedLeftOptions, valueLabel);
      newState.destroyedOptions = not(destroyedOptions, checkedLeftOptions, valueLabel);
    } else {
      if (actionName === "edit") {
        checkedRightOptions.forEach(function (option) {
          option._destroy = true;
        });
      }

      newState.leftOptions = leftOptions.concat(checkedRightOptions);
      newState.rightOptions = not(rightOptions, checkedRightOptions, valueLabel);
      newState.checkedOptions = not(checkedOptions, checkedRightOptions, valueLabel);
      newState.destroyedOptions = destroyedOptions.concat(checkedRightOptions);
    }

    dispatch(_extends({
      type: "change"
    }, newState));
  };

  var numberOfChecked = function numberOfChecked(items) {
    return intersection(checkedOptions, items, valueLabel).length;
  };

  var handleToggleAll = function handleToggleAll(items) {
    return function () {
      var newState = {};

      if (numberOfChecked(items) === items.length) {
        newState.checkedOptions = not(checkedOptions, items, valueLabel);
      } else {
        newState.checkedOptions = union(checkedOptions, items, valueLabel);
      }

      dispatch(_extends({
        type: "change"
      }, newState));
    };
  };

  return [handleToggle, handleChecked, handleToggleAll];
};

var rankedSearch = function rankedSearch(arr, searchKey, searchField, uniqueId) {
  if (searchField === void 0) {
    searchField = "name";
  }

  if (uniqueId === void 0) {
    uniqueId = "path";
  }

  if (searchKey.length === 0) return null;
  var keys = searchKey.split(" ");
  var filteredArray = arr.reduce(function (acc, element) {
    var searchData = element.children || [element];
    searchData.forEach(function (child) {
      var name = child[searchField];
      keys.forEach(function (key) {
        if (!key) return;

        if (name.toUpperCase().includes(key.toUpperCase())) {
          if (child.matchCount) child.matchCount++;else child.matchCount = 1;
        }
      });
      if (child.matchCount) acc.push(child);
    });
    return acc;
  }, []);
  var sortedArray = filteredArray.sort(function (a, b) {
    return b.matchCount - a.matchCount;
  }).map(function (element) {
    delete element.matchCount;
    return element;
  });
  var uniquePathIterator = sortedArray.reduce(function (map, object) {
    return map.set(object[uniqueId], object);
  }, new Map()).values();
  return Array.from(uniquePathIterator);
};

var rowsPerPage = 10;
var TransferList = withFieldHandler(function (_ref) {
  var field = _ref.field,
      onChange = _ref.onChange,
      values = _ref.values,
      action = _ref.action,
      params = _ref.params,
      formState = _ref.state;
  var optionsEntity = field.optionsEntity,
      identifier = field.identifier;

  var _useContext = useContext(AppContext),
      entities = _useContext.entities;

  var name = optionsEntity.name,
      labelField = optionsEntity.labelField,
      valueField = optionsEntity.valueField,
      valueLabel = optionsEntity.valueLabel,
      filterParams = optionsEntity.filterParams;
  var entity = entities[name];
  var customEntityName = generateReferencedEntityCustomName("field", name, field.getEntity().name, identifier);
  var customEntity = entities[customEntityName];
  var leftOptionsRef = useRef(null);
  var reduxDispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return getEntity(state, customEntityName);
  }),
      entityData = _useSelector.data,
      loading = _useSelector.loading,
      totalEntries = _useSelector.totalEntries;

  var _useInfiniteScroll = useInfiniteScroll(leftOptionsRef, loading),
      page = _useInfiniteScroll.page,
      onScroll = _useInfiniteScroll.onScroll,
      forceChange = _useInfiniteScroll.forceChange,
      resetPage = _useInfiniteScroll.resetPage;

  var valuesRef = useRef(null);

  var constructOptions = function constructOptions(values, isRight) {
    if (isRight === void 0) {
      isRight = false;
    }

    var identifier = customEntity.getIdentifier();
    return values.map(function (value) {
      var _extends2, _ref2;

      return _extends((_extends2 = {}, _extends2[valueLabel] = value[valueLabel] || field.getDataValue(value, {
        customAccessor: valueField
      }), _extends2), isRight && (_ref2 = {}, _ref2[identifier] = value[identifier], _ref2), {
        value: value
      });
    });
  };

  var initialRightOptions = values ? constructOptions(values, true) : [];
  var initialState = {
    leftOptions: [],
    rightOptions: initialRightOptions,
    checkedOptions: [],
    destroyedOptions: [],
    valueLabel: valueLabel
  };

  var _useReducer = useReducer(reducer$1, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var leftOptions = state.leftOptions,
      rightOptions = state.rightOptions,
      checkedOptions = state.checkedOptions,
      destroyedOptions = state.destroyedOptions;
  var checkedLeftOptions = intersection(checkedOptions, leftOptions, valueLabel);
  var checkedRightOptions = intersection(checkedOptions, rightOptions, valueLabel);
  var isLeftButtonDisabled = useMemo(function () {
    return checkedLeftOptions.length === 0;
  }, [checkedLeftOptions]);
  var isRightButtonDisabled = useMemo(function () {
    return checkedRightOptions.length === 0;
  }, [checkedRightOptions]);

  var _useState = useState(),
      filteredRightOptions = _useState[0],
      setFilteredRightOption = _useState[1];

  var _useListMovement = useListMovement(checkedOptions, checkedLeftOptions, checkedRightOptions, leftOptions, rightOptions, valueLabel, action, dispatch, destroyedOptions),
      handleToggle = _useListMovement[0],
      handleChecked = _useListMovement[1],
      handleToggleAll = _useListMovement[2];

  var checkRatio = function checkRatio(checkedLength) {
    var ratioPerPage = (leftOptions.length - checkedLength) / rowsPerPage;
    var isDone = leftOptions.length + rightOptions.length === totalEntries;
    forceChange(ratioPerPage < 0.5 && !isDone);
  };

  var _useState2 = useState({
    page: page,
    rowsPerPage: rowsPerPage
  }),
      customConfigs = _useState2[0],
      setCustomConfigs = _useState2[1];

  var _useFilterParams = useFilterParams({
    filterParams: filterParams,
    action: action,
    state: formState,
    params: params,
    entity: entity,
    customEntityName: customEntityName,
    customConfigs: customConfigs
  }),
      resetFilterValues = _useFilterParams[0];

  useEffect(function () {
    var nextPage = page;

    if (resetFilterValues) {
      resetPage();
      reduxDispatch(entitiesActions[customEntityName].list.reset({
        entity: entity
      }));
      nextPage = 1;
      dispatch({
        type: "change",
        leftOptions: [],
        rightOptions: [],
        checkedOptions: [],
        destroyedOptions: [],
        valueLabel: valueLabel
      });
    }

    setCustomConfigs(function (customConfigs) {
      return _extends({}, customConfigs, {
        page: nextPage,
        query: undefined
      });
    });
  }, [page, resetFilterValues]);
  useEffect(function () {
    return function () {
      return reduxDispatch(entitiesActions[customEntityName].list.reset({
        entity: entity
      }));
    };
  }, []);
  useEffect(function () {
    var filteredData = entityData.filter(function (option) {
      return !(values || []).find(function (value) {
        return value[valueLabel] === field.getDataValue(option, {
          customAccessor: valueField
        }) && !value._remove;
      }) || destroyedOptions.find(function (value) {
        return value[valueLabel] === field.getDataValue(option, {
          customAccessor: valueField
        });
      });
    });
    var options = constructOptions(filteredData);
    if (page === 1) dispatch({
      type: "change",
      leftOptions: options
    });else if (options.length > 0) dispatch({
      type: "appendLeftOptions",
      leftOptions: options
    });
  }, [entityData, labelField, valueField, valueLabel, dispatch]);
  useEffect(function () {
    var values = rightOptions.map(function (option) {
      var _formedOption;

      var formedOption = (_formedOption = {}, _formedOption[valueLabel] = option[valueLabel], _formedOption.id = option.id, _formedOption);
      return formedOption;
    });

    if (action === "edit") {
      var destroyedLeftOptions = destroyedOptions.reduce(function (destroyedOptions, option) {
        if (option._destroy) {
          var _destroyedOptions$pus;

          destroyedOptions.push((_destroyedOptions$pus = {}, _destroyedOptions$pus[valueLabel] = option[valueLabel], _destroyedOptions$pus._destroy = true, _destroyedOptions$pus.id = option.id, _destroyedOptions$pus));
        }

        return destroyedOptions;
      }, []);
      values = values.concat(destroyedLeftOptions);
    }

    if (!isEqual(valuesRef.current, values)) {
      onChange(field, values);
      valuesRef.current = values;
    }
  }, [rightOptions, field, valueField, valueLabel, action, leftOptions, onChange]);
  var onButtonClick = useCallback(function (dir) {
    return function () {
      handleChecked(dir);
      if (dir === "right") checkRatio(checkedLeftOptions.length);
    };
  }, [handleChecked, checkRatio, checkedLeftOptions]);
  var rightOptionsValues = useMemo(function () {
    return rightOptions.map(function (item) {
      return item.value;
    });
  }, [rightOptions]);

  var onSearch = function onSearch(isRight) {
    return function (value) {
      if (isRight) {
        var filteredValues = rankedSearch(rightOptionsValues, value, labelField, valueField);
        setFilteredRightOption(filteredValues ? constructOptions(filteredValues, true) : null);
      } else {
        var _leftOptionsRef$curre;

        leftOptionsRef === null || leftOptionsRef === void 0 ? void 0 : (_leftOptionsRef$curre = leftOptionsRef.current) === null || _leftOptionsRef$curre === void 0 ? void 0 : _leftOptionsRef$curre.scrollTo(0, 0);
        setCustomConfigs(function (customConfigs) {
          return _extends({}, customConfigs, {
            query: value,
            page: 1
          });
        });
        resetPage();
      }
    };
  };

  return /*#__PURE__*/React__default.createElement(TransferListWrapper, null, /*#__PURE__*/React__default.createElement(DataList, {
    items: leftOptions,
    checked: checkedLeftOptions,
    handleToggle: handleToggle,
    handleToggleAll: handleToggleAll,
    valueLabel: valueLabel,
    loading: loading,
    reference: leftOptionsRef,
    scroll: onScroll,
    labelField: labelField,
    field: field,
    onSearch: onSearch()
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "transferList-buttons"
  }, /*#__PURE__*/React__default.createElement(_Button, {
    onClick: onButtonClick("right"),
    disabled: isLeftButtonDisabled
  }, ">"), /*#__PURE__*/React__default.createElement(_Button, {
    onClick: onButtonClick("left"),
    disabled: isRightButtonDisabled
  }, "<")), /*#__PURE__*/React__default.createElement(DataList, {
    items: filteredRightOptions || rightOptions,
    checked: checkedRightOptions,
    valueLabel: valueLabel,
    handleToggle: handleToggle,
    handleToggleAll: handleToggleAll,
    labelField: labelField,
    field: field,
    onSearch: onSearch(true),
    isRight: true
  }));
});

var SelectFilter = function SelectFilter(_ref) {
  var name = _ref.name,
      label = _ref.label,
      config = _ref.config,
      state = _ref.state,
      handleFilter = _ref.handleFilter,
      value = _ref.value,
      selectedLabel = _ref.selectedLabel,
      entity = _ref.entity,
      isMulti = _ref.isMulti,
      placeholder = _ref.placeholder,
      isColumnFilter = _ref.isColumnFilter;

  var handleChange = function handleChange(selectedOption) {
    if (isMulti && selectedOption) {
      var values = selectedOption.map(function (option) {
        return option.value;
      });
      var labels = selectedOption.map(function (option) {
        return option.label;
      });
      handleFilter(name, values, labels);
    } else {
      var _ref2 = selectedOption || {},
          _ref2$value = _ref2.value,
          _value = _ref2$value === void 0 ? null : _ref2$value,
          _label = _ref2.label;

      handleFilter(name, _value, _label);
    }
  };

  return config.optionsType === "static" ? /*#__PURE__*/React__default.createElement(Select, {
    options: config.optionsArray.map(function (option) {
      return _extends({}, option, {
        label: getTranslatedValue(option.label)
      });
    }),
    onChange: handleChange,
    name: name,
    selected: value,
    label: label,
    isSearchable: config.isSearchable || false,
    isMulti: isMulti,
    placeholder: placeholder,
    isColumnFilter: isColumnFilter
  }) : /*#__PURE__*/React__default.createElement(EntitySelect, {
    onChange: handleChange,
    name: name,
    selected: value,
    selectedLabel: selectedLabel,
    config: config,
    label: label,
    entity: entity,
    isSearchable: config.isSearchable || false,
    isFilter: true,
    isColumnFilter: isColumnFilter,
    isMulti: isMulti,
    state: state,
    placeholder: placeholder
  });
};

var EditorField = function EditorField(_ref) {
  var label = _ref.label,
      required = _ref.required,
      error = _ref.error,
      field = _ref.field,
      disabled = _ref.disabled,
      value = _ref.value,
      onFieldChange = _ref.onFieldChange;
  var _field$editorConfig = field.editorConfig,
      editorConfig = _field$editorConfig === void 0 ? {} : _field$editorConfig;
  var imageUploadType = editorConfig.imageUploadType,
      endpoint = editorConfig.endpoint,
      _editorConfig$jsonURL = editorConfig.jsonURLPath,
      jsonURLPath = _editorConfig$jsonURL === void 0 ? ["image", "image_url"] : _editorConfig$jsonURL,
      _editorConfig$formDat = editorConfig.formDataKey,
      formDataKey = _editorConfig$formDat === void 0 ? "image[image]" : _editorConfig$formDat;

  var base64Uploader = function base64Uploader(blobInfo, success) {
    success("data:" + blobInfo.blob().type + ";base64," + blobInfo.base64());
  };

  var externalUploader = function externalUploader(blobInfo, success, failure) {
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open("POST", API_BASE_URL + "/" + endpoint);
    var authHeaders = loadFromLocalStorage("authHeaders");
    Object.keys(authHeaders).map(function (key) {
      xhr.setRequestHeader(key, authHeaders[key]);
    });
    var formData = new FormData();
    formData.append(formDataKey, blobInfo.blob(), blobInfo.filename());
    xhr.send(formData);

    xhr.onload = function () {
      if (xhr.status !== 201) {
        failure("HTTP Error:  " + xhr.status);
        return;
      }

      var json = JSON.parse(xhr.responseText);
      var imageUrl = get$1(json, jsonURLPath);

      if (typeof imageUrl !== "string") {
        failure("Invalid JSON: " + xhr.responseText);
        return;
      }

      success(imageUrl);
    };
  };

  var imageUploadHandler = imageUploadType === "external" ? externalUploader : base64Uploader;
  return /*#__PURE__*/React__default.createElement(FieldHandler, {
    label: label,
    required: required,
    error: error,
    field: field
  }, /*#__PURE__*/React__default.createElement(Editor, {
    init: {
      branding: false,
      plugins: "image link table paste wordcount lists advlist autolink visualblocks visualblocks insertdatetime directionality",
      toolbar: "undo redo | image code | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | ltr rtl",
      images_upload_handler: imageUploadHandler
    },
    disabled: disabled,
    value: value,
    onEditorChange: onFieldChange
  }));
};

var useSchemaToFieldsTransformation = function useSchemaToFieldsTransformation(_ref) {
  var apiField = _ref.apiField,
      schema = _ref.schema,
      loading = _ref.loading,
      storedData = _ref.storedData,
      action = _ref.action,
      state = _ref.state,
      errors = _ref.errors,
      onFormChange = _ref.onChange,
      index = _ref.index;
  var parentField = apiField.getParentField();
  var isInDynamicField = (parentField === null || parentField === void 0 ? void 0 : parentField.getType()) === "dynamic";
  var entity = apiField.getEntity();
  var previousFields = useRef(null);
  var onChange = useCallback(function (wrapper) {
    return function (apiField, value) {
      if (wrapper) {
        var _extends2;

        var previousState = get$1(state, wrapper);
        onFormChange(wrapper, _extends({}, previousState, (_extends2 = {}, _extends2[apiField.identifier || apiField] = value, _extends2)));
      } else {
        onFormChange(apiField, value);
      }
    };
  }, [state, onFormChange]);

  var cleanUp = function cleanUp(previousFields) {
    if (!previousFields.current) return;
    apiField.removeSchemaFieldsFromParent(previousFields.current);
    previousFields.current.forEach(function (previousField) {
      return onChange(null)(previousField, undefined);
    });
  };

  useEffect(function () {
    return function () {
      cleanUp(previousFields);
    };
  }, []);

  var _useMemo = useMemo(function () {
    var _schemaFields$groups;

    var schemaFields = apiField.getFields(schema) || {};
    cleanUp(previousFields);
    previousFields.current = schemaFields.fields || ((_schemaFields$groups = schemaFields.groups) === null || _schemaFields$groups === void 0 ? void 0 : _schemaFields$groups.map(function (group) {
      return group.fields;
    }).flatMap(function (fields) {
      return fields;
    }));
    return schemaFields;
  }, [schema]),
      fields = _useMemo.fields,
      groups = _useMemo.groups;

  var transformFieldObjectToFieldComponent = function transformFieldObjectToFieldComponent(fieldObject) {
    var _get;

    var fieldErrors = _extends({}, errors, state.formErrors);

    if (isInDynamicField) {
      var _extends3;

      fieldErrors = _extends({}, errors, (_extends3 = {}, _extends3[fieldObject.identifier] = errors[parentField.accessor + "[" + index + "]." + fieldObject.identifier], _extends3));
    }

    var wrapper = fieldObject.getStateWrapperPath();
    var fieldValue = wrapper ? (_get = get$1(state, wrapper)) === null || _get === void 0 ? void 0 : _get[fieldObject.identifier] : state[fieldObject.identifier];
    return /*#__PURE__*/React__default.createElement(Field$1, {
      errors: _extends({}, fieldErrors) || {},
      data: storedData,
      action: action,
      state: state,
      onChange: onChange(wrapper),
      value: fieldValue,
      key: fieldObject.identifier,
      entity: entity,
      field: fieldObject,
      required: fieldObject.isRequired()
    });
  };

  var transformNestedGroupToDynamicField = function transformNestedGroupToDynamicField(group, nestedGroup) {
    var getValuesFromSource = function getValuesFromSource(source) {
      var _source$group$identif;

      return source === null || source === void 0 ? void 0 : (_source$group$identif = source[group.identifier]) === null || _source$group$identif === void 0 ? void 0 : _source$group$identif[nestedGroup.field.identifier];
    };

    return _extends({}, nestedGroup, {
      apiField: /*#__PURE__*/React__default.createElement(DynamicFieldsGroup, {
        errors: errors,
        values: getValuesFromSource(state) || getValuesFromSource(storedData) || [],
        data: storedData,
        field: nestedGroup.field,
        onChange: onChange(group.identifier),
        action: action
      })
    });
  };

  var transformToFieldComponents = function transformToFieldComponents() {
    if (loading || !schema) return {};
    if (fields) return {
      fields: fields.map(function (fieldObject) {
        return transformFieldObjectToFieldComponent(fieldObject);
      })
    };

    if (groups) {
      return {
        groups: groups.map(function (group) {
          return _extends({}, group, {
            fields: group.fields.map(function (fieldObject) {
              return transformFieldObjectToFieldComponent(fieldObject);
            })
          }, group.nestedGroups && {
            nestedGroups: group.nestedGroups.map(function (nestedGroup) {
              return transformNestedGroupToDynamicField(group, nestedGroup);
            })
          });
        })
      };
    }
  };

  return transformToFieldComponents;
};

var _templateObject$d, _templateObject2$a, _templateObject3$8;

var GroupWrapper = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  return props.isNested && "border: 1px solid rgba(0, 0, 0, 0.06);\n    padding:10px;\n    margin-bottom:10px;\n    ";
});
var FieldGroupWrapper = styled.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  margin-bottom: 10px;\n"])));
var GroupLabel = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose(["\n  white-space: normal;\n  font-weight: 600;\n  height: -webkit-fit-content !important;\n  height: -moz-fit-content !important;\n  height: fit-content !important;\n  margin-bottom: 5px;\n"])));
var loadingIcon = /*#__PURE__*/React__default.createElement(LoadingOutlined$2, {
  style: {
    fontSize: 28
  },
  spin: true
});

var APIField = function APIField(_ref) {
  var _apiField$isAuthentic;

  var apiField = _ref.field,
      onChange = _ref.onChange,
      storedData = _ref.data,
      action = _ref.action,
      state = _ref.state,
      errors = _ref.errors,
      params = _ref.params,
      index = _ref.index,
      resetError = _ref.resetError;

  var _useRef = useRef(uniqueId("api_field_")),
      fieldUniqueId = _useRef.current;

  var _useContext = useContext(AppContext),
      entities = _useContext.entities;

  var _apiField$apiFieldCon = apiField.apiFieldConfig,
      filterParams = _apiField$apiFieldCon.filterParams,
      filterParamInEndpoint = _apiField$apiFieldCon.filterParamInEndpoint,
      groups = _apiField$apiFieldCon.groups,
      schemaAccessor = _apiField$apiFieldCon.schemaAccessor;
  useEffect(function () {
    if (action !== "edit" || !storedData) return;

    if (groups) {
      groups.forEach(function (group) {
        onChange(group.identifier, getAccessorValue(storedData, group.formAccessor || group.accessor));
      });
    } else {
      onChange(apiField.identifier, storedData, null, true);
    }
  }, []);
  var sourceEntityName = apiField.getAPIFieldReferencedEntityName();

  var _useSelector = useSelector(function (reduxState) {
    var entityState = getEntity(reduxState, sourceEntityName);
    var data = entityState.data;
    var schema = filterParamInEndpoint ? data[state[filterParamInEndpoint]] : entityState.current;
    var loading = entityState.loading[fieldUniqueId];
    return {
      loading: loading,
      schema: schema,
      data: data
    };
  }),
      schema = _useSelector.schema,
      loading = _useSelector.loading,
      data = _useSelector.data;

  var willPerformDispatch = useCallback(function (filterParams) {
    if (!schema) return true;
    if (!filterParamInEndpoint) return false;
    return true;
  }, [data, filterParamInEndpoint, schema]);
  var sourceEntity = entities[sourceEntityName];

  var _useFilterParams = useFilterParams({
    filterParams: filterParams,
    action: action,
    state: state,
    params: params,
    entity: sourceEntity,
    customEntityName: sourceEntityName,
    authenticated: apiField === null || apiField === void 0 ? void 0 : (_apiField$isAuthentic = apiField.isAuthenticated) === null || _apiField$isAuthentic === void 0 ? void 0 : _apiField$isAuthentic.call(apiField),
    dispatchAction: "apiFieldsSource",
    field: apiField,
    fieldUniqueId: fieldUniqueId,
    willPerformDispatch: willPerformDispatch,
    customConfigs: {
      schemaAccessor: schemaAccessor
    }
  }),
      resetFilterValues = _useFilterParams[0];

  useEffect(function () {
    if (resetFilterValues && action === "edit") {
      if (!storedData) return;

      if (groups) {
        groups.forEach(function (group) {
          onChange(group.identifier, {});
        });
      } else {
        onChange(apiField.identifier, undefined);
      }
    }
  }, [resetFilterValues]);
  useEffect(function () {
    if (schema) resetError === null || resetError === void 0 ? void 0 : resetError({});
  }, [schema]);
  var transformToFieldComponents = useSchemaToFieldsTransformation({
    apiField: apiField,
    schema: schema,
    loading: loading,
    storedData: storedData,
    action: action,
    state: state,
    errors: errors,
    onChange: onChange,
    index: index
  });

  var renderGroup = function renderGroup(_ref2) {
    var label = _ref2.label,
        fields = _ref2.fields;
    return /*#__PURE__*/React__default.createElement(Fragment, null, label && /*#__PURE__*/React__default.createElement(GroupLabel, null, label), /*#__PURE__*/React__default.createElement(FieldGroupWrapper, null, fields));
  };

  var renderFields = function renderFields() {
    var _transformToFieldComp = transformToFieldComponents(),
        groups = _transformToFieldComp.groups,
        fields = _transformToFieldComp.fields;

    if (fields) return fields;

    if (groups) {
      return groups.map(function (group) {
        return /*#__PURE__*/React__default.createElement(GroupWrapper, {
          key: group.identifier
        }, /*#__PURE__*/React__default.createElement(GroupLabel, null, group.label), group.nestedGroups ? group.nestedGroups.map(function (nestedGroup, index) {
          return /*#__PURE__*/React__default.createElement(GroupWrapper, {
            isNested: true,
            key: index
          }, /*#__PURE__*/React__default.createElement(GroupLabel, null, nestedGroup.label), renderGroup({
            fields: nestedGroup.apiField
          }));
        }) : renderGroup({
          fields: group.fields
        }));
      });
    }
  };

  return /*#__PURE__*/React__default.createElement(_Spin, {
    indicator: loadingIcon,
    spinning: !!loading
  }, renderFields());
};

var _excluded$l = ["action", "field", "onChange", "value", "data", "errors", "state", "inAuthForm", "fieldType", "label", "disabled", "fieldError", "isFilter", "isColumnFilter", "valueLabel", "required", "entity", "componentConfig", "index", "resetError"];

var FieldRenderer$1 = function FieldRenderer(_ref) {
  var _field$isNotAutoFilla, _field$getListType, _field$getListType2, _field$selectConfig, _field$toggleConfig;

  var action = _ref.action,
      field = _ref.field,
      onChange = _ref.onChange,
      value = _ref.value,
      data = _ref.data,
      errors = _ref.errors,
      state = _ref.state,
      inAuthForm = _ref.inAuthForm,
      fieldType = _ref.fieldType,
      label = _ref.label,
      disabled = _ref.disabled,
      fieldError = _ref.fieldError,
      isFilter = _ref.isFilter,
      isColumnFilter = _ref.isColumnFilter,
      valueLabel = _ref.valueLabel,
      required = _ref.required,
      entity = _ref.entity,
      componentConfig = _ref.componentConfig,
      index = _ref.index,
      resetError = _ref.resetError,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$l);

  var getFileFieldValue = function getFileFieldValue() {
    if (isFilter || !data) return;
    return field.getDataValue(data, {
      constructFileAccessor: true,
      canReturnUndefined: true
    }) || field.getDataValue(data, {
      constructFileAccessor: false,
      canReturnUndefined: true
    }) || value;
  };

  var _useTranslation = useTranslation(["general", "dataForm"]),
      t = _useTranslation.t;

  var fileFieldValue = getFileFieldValue();
  var isFieldPresentInData = fileFieldValue && fileFieldValue !== "_";
  var onFieldChange = useCallback(function (event, identifier, newValue) {
    switch (fieldType) {
      case "number":
      case "editor":
        onChange(field, event);
        break;

      case "datetime":
      case "time":
        onChange(field, moment(event));
        break;

      case "date":
        {
          var date = field.excludeDay && field.sendFullDate ? moment(event).startOf("month") : moment(event);
          onChange(field, date.format(field.excludeDay && !field.sendFullDate ? "YYYY-MM" : moment.HTML5_FMT.DATE));
          break;
        }

      case "toggle":
        {
          var toggleValue = getToggleValue(field.toggleConfig, event);
          onChange(field, toggleValue);
          break;
        }

      case "table":
        {
          var newTableEntries = value;
          var recordIndex = value.findIndex(function (recordValue) {
            return recordValue.id === event.id;
          });

          if (recordIndex === -1) {
            newTableEntries.push(_extends({}, event));
          } else {
            var _extends2;

            var newEvent = _extends({}, value[recordIndex]);

            newEvent = identifier ? _extends({}, value[recordIndex], (_extends2 = {}, _extends2[identifier] = newValue, _extends2)) : event;
            newTableEntries[recordIndex] = _extends({}, value[recordIndex], newEvent);
          }

          onChange(field, [].concat(newTableEntries));
          break;
        }

      default:
        onChange(field, event.target.value);
    }
  }, [field, fieldType, onChange]);

  var onDeleteFromTable = function onDeleteFromTable(event) {
    var recordIndex = value.findIndex(function (recordValue) {
      return recordValue.id === event;
    });

    if (!value[recordIndex]["new"]) {
      value[recordIndex]._destroy = true;
    } else {
      value.splice(recordIndex, 1);
    }

    onChange(field, [].concat(value));
  };

  var disabledDate = function disabledDate(current) {
    var disbaled = false;
    if (field.disablePast) disbaled = disbaled || current < moment().startOf("day");
    if (field.disableFuture) disbaled = disbaled || current > moment().endOf("day");
    return disbaled;
  };

  if (field.formComponent) {
    var FormComponent = field.formComponent;
    return /*#__PURE__*/React__default.createElement(ExternalComponentWrapper, null, /*#__PURE__*/React__default.createElement(FormComponent, _extends({
      field: field,
      value: value,
      onChange: onChange,
      data: data,
      errors: errors,
      action: action,
      state: state,
      inAuthForm: inAuthForm,
      required: required,
      disabled: disabled,
      error: fieldError,
      resetError: resetError
    }, componentConfig, props)));
  }

  switch (fieldType) {
    case "string":
    case "email":
    case "password":
    case "text":
      return /*#__PURE__*/React__default.createElement(StyledField, _extends({
        field: field,
        inAuthForm: inAuthForm,
        label: label,
        onChange: onFieldChange,
        value: value === undefined ? field.defaultValue : value,
        required: required,
        type: fieldType,
        disabled: disabled,
        rows: fieldType === "text" ? 5 : undefined,
        error: fieldError,
        autoComplete: (_field$isNotAutoFilla = field.isNotAutoFillable) === null || _field$isNotAutoFilla === void 0 ? void 0 : _field$isNotAutoFilla.call(field)
      }, componentConfig, props));

    case "number":
      return /*#__PURE__*/React__default.createElement(StyledField, _extends({
        field: field,
        inAuthForm: inAuthForm,
        label: label,
        onChange: onFieldChange,
        value: value === undefined ? field.defaultValue : value,
        required: required,
        type: fieldType,
        disabled: disabled,
        error: fieldError,
        parser: convertToEnglishNumbers
      }, componentConfig, props));

    case "profilePicture":
      return /*#__PURE__*/React__default.createElement(ProfilePicture$1, _extends({
        state: state,
        field: field,
        label: label,
        onChange: onChange,
        required: required,
        type: fieldType,
        disabled: disabled,
        error: fieldError,
        profilePicturePreview: fileFieldValue
      }, componentConfig, props));

    case "image":
      return /*#__PURE__*/React__default.createElement(FileField$1, {
        field: field,
        file: value,
        onChange: onChange,
        action: action,
        error: fieldError,
        type: fieldType,
        required: required,
        label: label || t("dataForm:upload") + " " + t("dataForm:" + fieldType),
        listType: ((_field$getListType = field.getListType) === null || _field$getListType === void 0 ? void 0 : _field$getListType.call(field)) || "image",
        disabled: disabled,
        filePreview: isFieldPresentInData ? fileFieldValue : null
      });

    case "video":
      return /*#__PURE__*/React__default.createElement(FileField$1, {
        field: field,
        file: value,
        onChange: onChange,
        action: action,
        error: fieldError,
        type: fieldType,
        required: required,
        label: label || t("dataForm:upload") + " " + t("dataForm:" + fieldType),
        disabled: disabled,
        listType: ((_field$getListType2 = field.getListType) === null || _field$getListType2 === void 0 ? void 0 : _field$getListType2.call(field)) || "video",
        filePreview: isFieldPresentInData ? fileFieldValue : null
      });

    case "pdf":
      return /*#__PURE__*/React__default.createElement(FileField$1, {
        field: field,
        file: value,
        onChange: onChange,
        action: action,
        error: fieldError,
        type: fieldType,
        listType: "pdf",
        required: required,
        label: label || t("dataForm:upload") + " " + t("dataForm:" + fieldType),
        disabled: disabled,
        filePreview: isFieldPresentInData ? fileFieldValue : null
      });

    case "file":
      return /*#__PURE__*/React__default.createElement(FileField$1, {
        field: field,
        file: value,
        onChange: onChange,
        action: action,
        error: fieldError,
        type: fieldType,
        listType: "other",
        required: required,
        label: label || t("dataForm:upload") + " " + t("dataForm:" + fieldType),
        disabled: disabled,
        filePreview: isFieldPresentInData ? fileFieldValue : null
      });

    case "datetime":
      return /*#__PURE__*/React__default.createElement(StyledField, _extends({
        field: field,
        inAuthForm: inAuthForm,
        type: fieldType,
        label: label,
        value: value ? moment(value) : null,
        onChange: onFieldChange,
        required: required,
        error: fieldError,
        disabledDate: disabledDate,
        format: field.format,
        allowClear: false,
        disabled: disabled
      }, componentConfig));

    case "date":
      return /*#__PURE__*/React__default.createElement(StyledField, _extends({
        field: field,
        inAuthForm: inAuthForm,
        type: fieldType,
        label: label,
        value: value || field.defaultValue ? moment(value || field.defaultValue) : null,
        onChange: onFieldChange,
        required: required,
        error: fieldError,
        disabledDate: disabledDate,
        format: field.format || (field.excludeDay ? "MMMM, YYYY" : "MMMM Do, YYYY"),
        picker: field.excludeDay ? "month" : "date",
        allowClear: false,
        disabled: disabled
      }, componentConfig));

    case "time":
      return /*#__PURE__*/React__default.createElement(StyledField, _extends({
        field: field,
        inAuthForm: inAuthForm,
        type: fieldType,
        label: label,
        value: value ? moment(value) : null,
        onChange: onFieldChange,
        required: required,
        error: fieldError,
        allowClear: false,
        disabled: disabled
      }, componentConfig));

    case "editor":
      return /*#__PURE__*/React__default.createElement(EditorField, {
        label: label,
        required: required,
        error: fieldError,
        field: field,
        disabled: disabled,
        value: value,
        onFieldChange: onFieldChange
      });

    case "checkbox":
      return /*#__PURE__*/React__default.createElement(CheckboxField, {
        values: value,
        field: field,
        data: data,
        state: state,
        disabled: disabled,
        onChange: onChange,
        error: fieldError,
        inAuthForm: inAuthForm,
        label: label,
        required: required,
        action: action
      });

    case "dynamicCheckbox":
      return /*#__PURE__*/React__default.createElement(DynamicCheckboxField, {
        values: value,
        field: field,
        disabled: disabled,
        onChange: onChange,
        state: state,
        params: props.params,
        action: action,
        error: fieldError,
        inAuthForm: inAuthForm,
        label: label,
        required: required
      });

    case "radio":
      return /*#__PURE__*/React__default.createElement(RadioField$1, {
        value: value,
        field: field,
        disabled: disabled,
        onChange: onChange,
        error: fieldError,
        inAuthForm: inAuthForm,
        required: required,
        label: label,
        data: data,
        state: state,
        action: action
      });

    case "select":
      if (isFilter) return /*#__PURE__*/React__default.createElement(SelectFilter, {
        name: field.name,
        label: label,
        config: field.selectConfig,
        handleFilter: onChange,
        value: value === undefined ? (_field$selectConfig = field.selectConfig) === null || _field$selectConfig === void 0 ? void 0 : _field$selectConfig.defaultValue : value,
        selectedLabel: valueLabel,
        entity: entity,
        isMulti: field.multiple,
        state: state,
        placeholder: props.placeholder,
        isColumnFilter: isColumnFilter
      });
      return /*#__PURE__*/React__default.createElement(SelectField, _extends({
        field: field,
        value: value,
        onChange: onChange,
        disabled: disabled,
        error: fieldError,
        inAuthForm: inAuthForm,
        isFilter: isFilter,
        isMulti: field.multiple,
        data: data,
        state: state,
        action: action
      }, props));

    case "reference":
      return /*#__PURE__*/React__default.createElement(ReferenceField, _extends({
        field: field,
        value: value,
        valueLabel: isFilter ? valueLabel : field.getDataValue(data, {
          canReturnUndefined: true
        }) || field.getPrepopulationLabel(),
        onChange: onChange,
        disabled: disabled,
        error: fieldError,
        params: props.params,
        action: action,
        state: state,
        inAuthForm: inAuthForm,
        isMulti: field.multiple,
        data: data,
        isFilter: isFilter
      }, props));

    case "dynamic":
      return /*#__PURE__*/React__default.createElement(DynamicFieldsGroup, {
        field: field,
        onChange: onChange,
        action: action,
        data: data,
        values: value,
        errors: errors,
        inAuthForm: inAuthForm,
        label: label,
        required: required,
        error: fieldError,
        disabled: disabled,
        resetError: resetError
      });

    case "transferList":
      return /*#__PURE__*/React__default.createElement(TransferList, {
        onChange: onChange,
        field: field,
        values: value,
        action: action,
        params: props.params,
        state: state,
        inAuthForm: inAuthForm,
        label: label,
        required: required,
        error: fieldError
      });

    case "phoneNumber":
      return /*#__PURE__*/React__default.createElement(PhoneNumberField, {
        field: field,
        value: value,
        onChange: onChange,
        disabled: disabled,
        error: fieldError,
        inAuthForm: inAuthForm
      });

    case "countryCode":
      return /*#__PURE__*/React__default.createElement(CountryCodeField, {
        field: field,
        value: value,
        onChange: onChange,
        disabled: disabled,
        error: fieldError,
        inAuthForm: inAuthForm,
        required: required
      });

    case "json":
      return /*#__PURE__*/React__default.createElement(JsonField$1, {
        field: field,
        value: value,
        onChange: onChange,
        action: action,
        error: fieldError,
        label: label,
        required: required
      });

    case "markerMap":
      return /*#__PURE__*/React__default.createElement(MarkerMapField$1, {
        field: field,
        value: value,
        onChange: onChange,
        action: action,
        inAuthForm: inAuthForm,
        disabled: disabled,
        label: label,
        required: required,
        error: fieldError
      });

    case "polygonMap":
      return /*#__PURE__*/React__default.createElement(PolygonMapField$1, {
        field: field,
        value: value,
        onChange: onChange,
        action: action,
        inAuthForm: inAuthForm,
        disabled: disabled,
        data: data,
        label: label,
        required: required,
        error: fieldError
      });

    case "toggle":
      return /*#__PURE__*/React__default.createElement(FieldHandler, {
        label: label,
        required: required,
        error: fieldError,
        field: field
      }, /*#__PURE__*/React__default.createElement(_Switch, {
        onChange: onFieldChange,
        checked: (_field$toggleConfig = field.toggleConfig) !== null && _field$toggleConfig !== void 0 && _field$toggleConfig.on ? field.toggleConfig.on === value : value,
        disabled: disabled
      }));

    case "api":
      return /*#__PURE__*/React__default.createElement(APIField, {
        value: value,
        field: field,
        disabled: disabled,
        onChange: onChange,
        errors: errors,
        inAuthForm: inAuthForm,
        required: required,
        label: label,
        data: data,
        state: state,
        action: action,
        params: props.params,
        index: index,
        resetError: resetError
      });

    case "table":
      {
        var _field$tableConfig;

        var editableConfig = (_field$tableConfig = field.tableConfig) === null || _field$tableConfig === void 0 ? void 0 : _field$tableConfig.editable;
        return /*#__PURE__*/React__default.createElement(FieldHandler, {
          label: label,
          required: required,
          error: fieldError,
          field: field
        }, /*#__PURE__*/React__default.createElement(TableField, _extends({
          field: field,
          dataObject: data,
          data: value,
          onChange: onFieldChange,
          canEditTableField: typeof editableConfig === "function" ? editableConfig() : editableConfig,
          entity: entity,
          onDelete: onDeleteFromTable
        }, props)));
      }

    case "scannableTable":
      return /*#__PURE__*/React__default.createElement(ScannablTableField, _extends({
        field: field,
        value: value,
        onChange: onChange,
        data: data,
        errors: errors,
        action: action,
        state: state,
        inAuthForm: inAuthForm,
        required: required,
        disabled: disabled,
        error: fieldError,
        entity: entity
      }, componentConfig, props));

    default:
      return null;
  }
};

var DataFilter = function DataFilter(_ref) {
  var _ref$filter = _ref.filter,
      name = _ref$filter.name,
      label = _ref$filter.label,
      type = _ref$filter.type,
      dependee = _ref$filter.dependee,
      prepopulationConfig = _ref$filter.prepopulationConfig,
      placeholder = _ref$filter.placeholder,
      filter = _ref.filter,
      onFilter = _ref.onFilter,
      onDependeeFilter = _ref.onDependeeFilter,
      getLabel = _ref.getLabel,
      entityName = _ref.entityName,
      entity = _ref.entity,
      currentValue = _ref.currentValue,
      isColumnFilter = _ref.isColumnFilter,
      currentSelectedlabel = _ref.currentSelectedlabel;
  var location = useLocation$1();
  var storedEntity = useSelector(function (state) {
    return getEntity(state, entityName);
  }, shallowEqual);
  var selectedLabel = useMemo(function () {
    return currentSelectedlabel || storedEntity[name + "_label"];
  }, [currentSelectedlabel, storedEntity, name]);
  var value = useMemo(function () {
    return currentValue === undefined ? storedEntity[name] : currentValue;
  }, [currentValue, storedEntity, name]);

  var _useTranslation = useTranslation("dataTable"),
      t = _useTranslation.t;

  var handleChange = useCallback(function (_, value, label) {
    if (dependee) onDependeeFilter(name, value, label);else onFilter(name, value, label);
  }, [dependee, name, onDependeeFilter, onFilter]);
  useEffect(function () {
    var parsedLocationState = getJSONValue(location === null || location === void 0 ? void 0 : location.state);
    var prepopulatedValue = prepopulationConfig && getValue(prepopulationConfig, parsedLocationState, "valueKey");
    var prepopulatedLabel = prepopulationConfig && getValue(prepopulationConfig, parsedLocationState, "labelField");

    if (prepopulatedValue && !value) {
      handleChange(null, prepopulatedValue, prepopulatedLabel);
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(FieldRenderer$1, {
    field: filter,
    onChange: handleChange,
    state: storedEntity,
    value: value,
    fieldType: type,
    label: getLabel(label),
    valueLabel: selectedLabel,
    isFilter: true,
    isColumnFilter: isColumnFilter,
    entity: entity,
    placeholder: type === "string" ? t("searchField", {
      label: getLabel(placeholder || label)
    }) : getLabel(placeholder || label)
  });
};

var SearchBar = function SearchBar(_ref) {
  var onSearch = _ref.onSearch,
      value = _ref.value,
      placeHolder = _ref.placeHolder;

  var _useTranslation = useTranslation("general"),
      t = _useTranslation.t;

  var onChange = useCallback(function (e) {
    var _e$target;

    onSearch(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
  }, [onSearch]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(_Input.Search, {
    placeholder: placeHolder || t("search"),
    onChange: onChange,
    onSearch: onChange,
    value: value
  }));
};

SearchBar.propTypes = {
  placeHolder: propTypes.string,
  onSearch: propTypes.func.isRequired,
  value: propTypes.string
};

var FiltersToolbar = function FiltersToolbar(_ref) {
  var entity = _ref.entity,
      onFilter = _ref.onFilter,
      onDependeeFilter = _ref.onDependeeFilter,
      checkDependeeFilter = _ref.checkDependeeFilter,
      role = _ref.role,
      onResetFilter = _ref.onResetFilter,
      onSearch = _ref.onSearch,
      query = _ref.query,
      setEmptyFilters = _ref.setEmptyFilters;

  var _useTranslation = useTranslation("dataTable"),
      t = _useTranslation.t;

  var _useState = useState(false),
      expand = _useState[0],
      setExpand = _useState[1];

  var filters = useMemo(function () {
    var _entity$filters;

    return entity === null || entity === void 0 ? void 0 : (_entity$filters = entity.filters) === null || _entity$filters === void 0 ? void 0 : _entity$filters.filter(function (filter, index) {
      var _extends2;

      var showFilter = entity.canRolePerformAction(role, ["filters", index, "authorizedRoles"]);
      if (showFilter && filter.type === "select" && filter.selectConfig.optionsType === "dynamic" && filter.selectConfig.defaultValue === "first") entity.dynamicFilters = _extends({}, entity.dynamicFilters, (_extends2 = {}, _extends2[filter.name] = false, _extends2));
      return showFilter;
    });
  }, [entity, role]);
  var rotate = useMemo(function () {
    return expand ? 180 : 0;
  }, [expand]);
  useEffect(function () {
    setEmptyFilters(isEmpty(filters));
  }, [filters]);
  return /*#__PURE__*/React__default.createElement(FiltersToolbarWrapper, null, filters && /*#__PURE__*/React__default.createElement(_Row, {
    gutter: 24,
    className: "row-wrapper"
  }, filters.map(function (filter, index) {
    return checkDependeeFilter(filter) && /*#__PURE__*/React__default.createElement(_Col, {
      className: "col-wrapper",
      key: filter.name,
      style: {
        display: !expand && index > 3 ? "none" : "block"
      }
    }, /*#__PURE__*/React__default.createElement(DataFilter, {
      filter: filter,
      onFilter: onFilter,
      onDependeeFilter: onDependeeFilter,
      entityName: entity.pluralName,
      getLabel: entity.getDisplayName,
      entity: entity,
      isMulti: filter.multiple
    }));
  }), /*#__PURE__*/React__default.createElement(_Col, {
    className: "col-wrapper button-wrapper"
  }, /*#__PURE__*/React__default.createElement(_Button, {
    onClick: onResetFilter,
    className: "btn-custom"
  }, t("reset")), filters.length > 4 && /*#__PURE__*/React__default.createElement(_Button, {
    icon: /*#__PURE__*/React__default.createElement(DropDownIcon, {
      rotate: rotate
    }),
    type: "link",
    onClick: function onClick() {
      return setExpand(!expand);
    }
  }, expand ? t("collapse") : t("expand")))), entity.showSearch && /*#__PURE__*/React__default.createElement(_Row, {
    gutter: 24,
    className: "row-wrapper"
  }, /*#__PURE__*/React__default.createElement(_Col, {
    className: "col-wrapper"
  }, /*#__PURE__*/React__default.createElement(SearchBar, {
    onSearch: onSearch,
    value: query
  }))));
};

var FiltersDrawer = function FiltersDrawer(_ref) {
  var entity = _ref.entity,
      onFilter = _ref.onFilter,
      onDependeeFilter = _ref.onDependeeFilter,
      checkDependeeFilter = _ref.checkDependeeFilter,
      role = _ref.role,
      onResetFilter = _ref.onResetFilter,
      onSearch = _ref.onSearch,
      query = _ref.query,
      resize = _ref.resize;

  var _useTranslation = useTranslation("dataTable"),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useState = useState(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var filters = useMemo(function () {
    var _entity$filters;

    return entity === null || entity === void 0 ? void 0 : (_entity$filters = entity.filters) === null || _entity$filters === void 0 ? void 0 : _entity$filters.filter(function (_, index) {
      return entity.canRolePerformAction(role, ["filters", index, "authorizedRoles"]);
    });
  }, [entity, role]);
  var width = useMemo(function () {
    return resize ? 250 : 520;
  }, [resize]);
  var placement = useMemo(function () {
    return i18n.language === "ar" ? "left" : "right";
  }, [i18n.language]);

  var showDrawer = function showDrawer() {
    setVisible(true);
  };

  var onClose = function onClose() {
    setVisible(false);
  };

  if (!filters) return /*#__PURE__*/React__default.createElement(Fragment, null);
  return /*#__PURE__*/React__default.createElement(FiltersDrawerWrapper, null, /*#__PURE__*/React__default.createElement(_Button, {
    type: "link",
    onClick: showDrawer,
    icon: /*#__PURE__*/React__default.createElement(BarsOutlined$2, null)
  }, t("Filters")), /*#__PURE__*/React__default.createElement(_Drawer, {
    key: placement,
    title: t("Filters"),
    placement: placement,
    onClose: onClose,
    visible: visible,
    width: width,
    footer: filters && /*#__PURE__*/React__default.createElement(_Button, {
      onClick: onResetFilter,
      className: "btn-custom"
    }, t("reset")),
    footerStyle: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React__default.createElement(FiltersWrapper, null, /*#__PURE__*/React__default.createElement(_Row, {
    gutter: [16, 16]
  }, entity.showSearch && /*#__PURE__*/React__default.createElement(_Col, {
    span: 24
  }, /*#__PURE__*/React__default.createElement(SearchBar, {
    onSearch: onSearch,
    value: query
  })), filters === null || filters === void 0 ? void 0 : filters.map(function (filter) {
    return checkDependeeFilter(filter) && /*#__PURE__*/React__default.createElement(_Col, {
      lg: 12,
      xs: 24,
      key: filter.name
    }, /*#__PURE__*/React__default.createElement(DataFilter, {
      filter: filter,
      onFilter: onFilter,
      onDependeeFilter: onDependeeFilter,
      entityName: entity.pluralName,
      getLabel: entity.getDisplayName,
      entity: entity,
      isMulti: filter.multiple
    }));
  })))));
};

var isDependeeFilterEqualsDependant = function isDependeeFilterEqualsDependant(filter, dependeeValue) {
  return typeof filter.dependsOnValue === "string" ? dependeeValue === filter.dependsOnValue : filter.dependsOnValue.includes(dependeeValue);
};

var onDependeeFilterChange = function onDependeeFilterChange(field, value, label, filters) {
  var _extends3;

  var dependantFilters = filters.filter(function (filter) {
    return filter.dependsOn === field;
  }).reduce(function (acc, current) {
    var _extends2;

    if (current.dependsOnAny && !Boolean(value) || !current.dependsOnAny && !isDependeeFilterEqualsDependant(current, value)) return _extends({}, acc, (_extends2 = {}, _extends2[current.name] = null, _extends2[current.name + "_label"] = null, _extends2));else return acc;
  }, {});
  return _extends((_extends3 = {}, _extends3[field] = value, _extends3[field + "_label"] = label, _extends3), dependantFilters);
};

var onFilterChange = function onFilterChange(field, value, label) {
  var _ref;

  return _ref = {}, _ref[field] = value, _ref[field + "_label"] = label, _ref;
};

var resetFilters = function resetFilters(filters, extraParams) {
  var resetFilters = filters.reduce(function (filtersObject, filter) {
    var _extends4;

    return _extends({}, filtersObject, (_extends4 = {}, _extends4[filter.name] = null, _extends4[filter.name + "_label"] = null, _extends4));
  }, _extends({}, extraParams));
  return resetFilters;
};

var ColumnHeaderFilters = function ColumnHeaderFilters(_ref) {
  var identifier = _ref.identifier,
      columnFilters = _ref.columnFilters,
      entity = _ref.entity,
      filterEntity = _ref.filterEntity,
      role = _ref.role;

  var _useState = useState({}),
      filters = _useState[0],
      setFilters = _useState[1];

  var _useTranslation = useTranslation("dataTable"),
      t = _useTranslation.t;

  var storeEntity = useSelector(function (state) {
    return getEntity(state, entity.pluralName);
  });
  var checkDependeeFilter = useCallback(function (filter) {
    if (filter.dependsOn) {
      return filter.dependsOnAny ? Boolean(filters[filter.dependsOn] || storeEntity[filter.dependsOn]) : isDependeeFilterEqualsDependant(filter, filters[filter.dependsOn] || storeEntity[filter.dependsOn]);
    }

    return true;
  }, [filters, storeEntity]);
  var renderedFilters = useMemo(function () {
    return columnFilters === null || columnFilters === void 0 ? void 0 : columnFilters.filter(function (filter, index) {
      return checkDependeeFilter(filter) && entity.canRolePerformAction(role, ["fieldsfilters", index, "authorizedRoles"]);
    });
  }, [columnFilters, entity, role]);

  var isAllFiltersNotSet = function isAllFiltersNotSet() {
    var _Object$values;

    return (_Object$values = Object.values(filters)) === null || _Object$values === void 0 ? void 0 : _Object$values.reduce(function (acc, filter) {
      return acc && (filter === null || filter === undefined);
    }, true);
  };

  var onDependeeFilter = function onDependeeFilter(field, value, label) {
    setFilters(function (filters) {
      return _extends({}, filters, onDependeeFilterChange(field, value, label, columnFilters));
    });
  };

  var onFilter = function onFilter(field, value, label) {
    setFilters(function (filters) {
      return _extends({}, filters, onFilterChange(field, value, label));
    });
  };

  var onResetFilters = useCallback(function () {
    var resetedFilters = resetFilters(columnFilters, {
      query: ""
    });
    setFilters({});
    filterEntity(resetedFilters, false, {
      key: identifier,
      value: false
    });
  }, [columnFilters, identifier]);
  var onFilterColumn = useCallback(function () {
    if (!isEmpty$1(filters)) {
      filterEntity(filters, false, {
        key: identifier,
        value: !isAllFiltersNotSet()
      });
    }
  }, [filters, identifier]);
  if (!renderedFilters || renderedFilters.length === 0) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  return /*#__PURE__*/React__default.createElement(ColumnFiltersWrapper, null, /*#__PURE__*/React__default.createElement(_Row, {
    gutter: [8, 8]
  }, columnFilters === null || columnFilters === void 0 ? void 0 : columnFilters.map(function (filter) {
    return /*#__PURE__*/React__default.createElement(_Col, {
      span: 24,
      key: filter.name
    }, /*#__PURE__*/React__default.createElement(DataFilter, {
      filter: filter,
      onFilter: onFilter,
      onDependeeFilter: onDependeeFilter,
      entityName: entity.pluralName,
      getLabel: entity.getDisplayName,
      entity: entity,
      isMulti: filter.multiple,
      currentValue: filters[filter.name],
      currentSelectedlabel: filters[filter.name + "_label"],
      isColumnFilter: true
    }));
  })), /*#__PURE__*/React__default.createElement(_Divider, null), /*#__PURE__*/React__default.createElement(_Space, {
    className: "filter-buttons-wrapper"
  }, /*#__PURE__*/React__default.createElement(_Button, {
    className: "btn-custom",
    onClick: onFilterColumn,
    icon: /*#__PURE__*/React__default.createElement(FilterOutlined$2, null),
    size: "small"
  }, t("filter")), /*#__PURE__*/React__default.createElement(_Button, {
    onClick: onResetFilters,
    size: "small"
  }, t("reset"))));
};

var transformExtensionsArray = function transformExtensionsArray(config) {
  var _partition = partition(config.extensions, function (ext) {
    return ext.indexOf("/") === -1;
  }),
      extensionsToJoinWithDot = _partition[0],
      extensionsToJoinWithoutDot = _partition[1];

  return "" + extensionsToJoinWithoutDot.join(", ") + (extensionsToJoinWithDot.length && ", ." + extensionsToJoinWithDot.join(", ."));
};

function ImportDialog(_ref) {
  var entity = _ref.entity,
      openStatus = _ref.openStatus,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      onOpenStatusChange = _ref.onOpenStatusChange,
      onImport = _ref.onImport,
      errors = _ref.errors,
      loading = _ref.loading;

  var _useTranslation = useTranslation(["actionButton", "dataTable"]),
      t = _useTranslation.t;

  var _useState = useState(),
      file = _useState[0],
      setFile = _useState[1];

  var dispatch = useDispatch();

  var handleClose = function handleClose() {
    setFile({});
    dispatch(entitiesActions[entity.name].list.resetErrors());
    onOpenStatusChange(false);
  };

  var fieldObject = new Field({
    field: {
      label: {
        en: "File",
        ar: "الملف"
      },
      identifier: config === null || config === void 0 ? void 0 : config.paramName,
      type: "file",
      allowedExtensions: transformExtensionsArray(config)
    },
    entity: entity
  });
  var onChange = useCallback(function (_, target) {
    setFile(target);
  }, []);

  var handleImport = function handleImport() {
    var _onImport;

    return onImport((_onImport = {}, _onImport[config.paramName] = file, _onImport), config);
  };

  return /*#__PURE__*/React__default.createElement(_Modal, {
    title: entity.getDisplayName() + " - " + getTranslatedValue(config.label),
    visible: openStatus,
    onCancel: handleClose,
    centered: true,
    destroyOnClose: true,
    footer: [/*#__PURE__*/React__default.createElement(_Button, {
      onClick: handleClose,
      key: "import-cancel"
    }, t("actionButton:cancel")), /*#__PURE__*/React__default.createElement(_Button, {
      onClick: handleImport,
      className: "btn-custom",
      key: "import-save",
      disabled: loading
    }, t("dataTable:save"))]
  }, /*#__PURE__*/React__default.createElement(Field$1, {
    field: fieldObject,
    onChange: onChange,
    value: file,
    data: file,
    errors: errors
  }));
}

var Import = function Import(_ref) {
  var entity = _ref.entity,
      onImport = _ref.onImport,
      errors = _ref.errors,
      modalOpenStatus = _ref.modalOpenStatus,
      handleOpen = _ref.handleOpen,
      className = _ref.className,
      role = _ref.role,
      loading = _ref.loading;

  var _useTranslation = useTranslation("dataTable"),
      t = _useTranslation.t;

  var selected = useRef();
  var importList = useMemo(function () {
    var _entity$import;

    return (_entity$import = entity["import"]) === null || _entity$import === void 0 ? void 0 : _entity$import.filter(function (_, index) {
      return entity.canRolePerformAction(role, ["import", index, "authorizedRoles"]);
    });
  }, [entity["import"]]);

  var toggleModal = function toggleModal(_ref2) {
    var key = _ref2.key;
    selected.current = importList[key];
    handleOpen(true);
  };

  var menu = /*#__PURE__*/React__default.createElement(_Menu, {
    onClick: toggleModal
  }, importList === null || importList === void 0 ? void 0 : importList.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(_Menu.Item, {
      key: index
    }, getTranslatedValue(item.label));
  }));
  if (importList.length < 1) return /*#__PURE__*/React__default.createElement(Fragment, null);
  return /*#__PURE__*/React__default.createElement("div", null, (importList === null || importList === void 0 ? void 0 : importList.length) > 1 ? /*#__PURE__*/React__default.createElement(_Dropdown, {
    overlay: menu
  }, /*#__PURE__*/React__default.createElement(_Button, {
    className: className
  }, t("import"), " ", /*#__PURE__*/React__default.createElement(DropDownIcon, null))) : /*#__PURE__*/React__default.createElement(_Button, {
    className: className,
    onClick: function onClick() {
      return toggleModal({
        key: "0"
      });
    },
    icon: /*#__PURE__*/React__default.createElement(ImportIcon, null)
  }, getTranslatedValue(importList[0].label) || t("import")), /*#__PURE__*/React__default.createElement(ImportDialog, {
    entity: entity,
    config: selected.current,
    onOpenStatusChange: handleOpen,
    openStatus: modalOpenStatus,
    onImport: onImport,
    errors: errors,
    loading: loading
  }));
};

var useChildEntity = function useChildEntity(_ref) {
  var entity = _ref.entity;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var params = useParams();

  var getParentRecordId = function getParentRecordId() {
    return params === null || params === void 0 ? void 0 : params.id;
  };

  var getChildId = function getChildId() {
    return params.childId;
  };

  var getParentPathname = function getParentPathname() {
    if (entity.isChild) return entity.parentEntity.pathName;
    return null;
  };

  var renderChildEntities = function renderChildEntities(_ref2) {
    var _entity$childEntities;

    var recordId = _ref2.recordId;
    return (_entity$childEntities = entity.childEntities) === null || _entity$childEntities === void 0 ? void 0 : _entity$childEntities.map(function (child) {
      return /*#__PURE__*/React__default.createElement(Link, {
        to: child.parentEntity.pathName + "/" + recordId + "/" + child.pathName
      }, child.getDisplayName());
    });
  };

  var constructCreatePath = function constructCreatePath() {
    return pathname + "/create";
  };

  var constructEditPath = function constructEditPath(_ref3) {
    var recordId = _ref3.recordId;
    return getParentPathname() + "/" + getParentRecordId() + "/" + entity.pathName + "/" + recordId + "/edit";
  };

  return {
    currentUrl: pathname,
    parentRecordId: getParentRecordId(),
    childRecordId: getChildId(),
    parentPathname: getParentPathname(),
    renderChildEntities: renderChildEntities,
    constructCreatePath: constructCreatePath,
    constructEditPath: constructEditPath
  };
};

var RowActions = function RowActions(_ref) {
  var _auth$authConfig$name;

  var record = _ref.record,
      recordId = _ref.recordId,
      entity = _ref.entity,
      onCustomRowActionTriggered = _ref.onCustomRowActionTriggered,
      onDelete = _ref.onDelete,
      onFormModalActionClick = _ref.onFormModalActionClick;

  var _useChildEntity = useChildEntity({
    entity: entity
  }),
      renderChildEntities = _useChildEntity.renderChildEntities,
      constructEditPath = _useChildEntity.constructEditPath;

  var _useContext = useContext(AppContext),
      authConfig = _useContext.authConfig,
      privateRouteURL = _useContext.privateRouteURL;

  var auth = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var role = (_auth$authConfig$name = auth[authConfig.name]) === null || _auth$authConfig$name === void 0 ? void 0 : _auth$authConfig$name.role;
  var rowActions = entity.rowActions,
      pathName = entity.pathName;

  var _useTranslation = useTranslation(["dataTable"]),
      t = _useTranslation.t;

  var onFormModalOpen = function onFormModalOpen(configs) {
    return onFormModalActionClick && onFormModalActionClick(_extends({}, configs, {
      entity: entity
    }));
  };

  return /*#__PURE__*/React__default.createElement(Fragment, null, entity.canEdit(role, record) && !entity.hideEditButton && /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: getURL(privateRouteURL, entity.isChild ? constructEditPath({
        recordId: recordId
      }) : pathName + "/" + recordId + "/edit")
    }
  }, /*#__PURE__*/React__default.createElement(_Button, {
    type: "text",
    key: "edit"
  }, renderComponent(entity.editBtn, EditIcon))), entity.canDelete(role, record) && /*#__PURE__*/React__default.createElement(ActionButton, {
    onActionClick: function onActionClick() {
      return onDelete(recordId);
    },
    confirmable: true,
    confirmationMessage: t("dataTable:deleteConfirmationMessage"),
    key: "delete",
    type: "text"
  }, renderComponent(entity.deleteBtn, DeleteIcon)), renderChildEntities === null || renderChildEntities === void 0 ? void 0 : renderChildEntities({
    recordId: recordId
  }), rowActions && rowActions.filter(function (_action, index) {
    return entity.canRolePerformAction(role, ["rowActions", index, "authorizedRoles"]);
  }).filter(function (action) {
    return !action.active || action.active(record);
  }).map(function (action, index) {
    return action.type === "formModal" ? /*#__PURE__*/React__default.createElement(_Button, {
      onClick: function onClick() {
        return onFormModalOpen({
          id: record[action.entityConfig.referencedEntityField] || recordId,
          action: action.formAction,
          entityConfig: action.entityConfig,
          formIdentifier: action.identifier
        });
      },
      type: "text",
      key: index
    }, entity.getDisplayName(action.label)) : /*#__PURE__*/React__default.createElement(ActionButton, {
      onActionClick: function onActionClick() {
        return onCustomRowActionTriggered(action, record);
      },
      confirmable: action.requireConfirmation,
      confirmationMessage: action.confirmationMessage,
      key: index,
      type: "text"
    }, entity.getDisplayName(action.label));
  }));
};

var _templateObject$e;

var ModalBody$1 = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var antIcon$1 = /*#__PURE__*/React__default.createElement(LoadingOutlined$2, {
  spin: true
});

var FormModalAction = function FormModalAction(_ref, ref) {
  var parentEntity = _ref.entity;

  var _useState = useState(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useState2 = useState({}),
      formModalConfig = _useState2[0],
      setFormModalConfig = _useState2[1];

  var id = formModalConfig.id,
      action = formModalConfig.action,
      customEntityName = formModalConfig.customEntityName,
      entity = formModalConfig.entity;

  var _useContext = useContext(AppContext),
      entities = _useContext.entities;

  var dispatch = useDispatch();
  var dataFormRef = useRef();

  var _ref2 = useSelector(function (state) {
    return getEntity(state, customEntityName);
  }) || {},
      loading = _ref2.loading,
      current = _ref2.current,
      errors = _ref2.errors,
      isFormModalOpen = _ref2.isFormModalOpen;

  var dispatchRequest = useCallback(function (entityName, payload, actionName) {
    if (actionName === void 0) {
      actionName = action;
    }

    dispatch(entitiesActions[entityName][actionName].request(payload));
  }, [action, dispatch]);

  var handleCancel = function handleCancel() {
    var _dataFormRef$current;

    setIsVisible(false);
    (_dataFormRef$current = dataFormRef.current) === null || _dataFormRef$current === void 0 ? void 0 : _dataFormRef$current.reset();
    dispatch(entitiesActions[customEntityName].form.cancelFormModal());
  };

  var onModalOpen = function onModalOpen(_ref3) {
    var id = _ref3.id,
        action = _ref3.action,
        entityConfig = _ref3.entityConfig,
        formIdentifier = _ref3.formIdentifier;
    var customEntityName = generateReferencedEntityCustomName("rowAction", entityConfig.name, parentEntity.name, formIdentifier);
    var entity = entities[customEntityName];
    setFormModalConfig({
      id: id,
      parentEntity: parentEntity,
      action: action,
      entityConfig: entityConfig,
      entity: entity,
      customEntityName: customEntityName
    });
    if (action === "edit") dispatchRequest(customEntityName, {
      entity: entity,
      id: id,
      customEntityName: customEntityName
    }, "show");
    setIsVisible(true);
    dispatch(entitiesActions[customEntityName].form.openFormModal());
  };

  var onSubmit = function onSubmit(data) {
    dispatchRequest(customEntityName, {
      entity: entity,
      data: data,
      id: id,
      customEntityName: customEntityName,
      refetch: true
    });
  };

  useEffect(function () {
    if (isVisible !== isFormModalOpen) setIsVisible(isFormModalOpen);
  }, [isFormModalOpen]);
  useImperativeHandle(ref, function () {
    return {
      onModalOpen: onModalOpen
    };
  });
  return /*#__PURE__*/React__default.createElement(_Modal, {
    visible: isVisible,
    onCancel: handleCancel,
    footer: null
  }, isVisible && (!loading ? /*#__PURE__*/React__default.createElement(DataForm$1, {
    location: history.location,
    ref: dataFormRef,
    entity: entity,
    action: action,
    onSubmit: onSubmit,
    errors: errors,
    loading: loading,
    data: current,
    extraInitialStateData: current,
    isFormModal: true
  }) : /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement(_Spin, {
    indicator: antIcon$1
  }))));
};

var FormModalAction$1 = React__default.forwardRef(FormModalAction);

var CardList = function CardList(_ref) {
  var entity = _ref.entity,
      role = _ref.role,
      data = _ref.data,
      isSelected = _ref.isSelected,
      handleSelect = _ref.handleSelect,
      renderRowActions = _ref.renderRowActions,
      privateRouteURL = _ref.privateRouteURL;

  var _useTranslation = useTranslation("general"),
      t = _useTranslation.t;

  var _useMemo = useMemo(function () {
    return entity.fields.reduce(function (acc, field) {
      if (field.isHiddenInList(role)) return acc;
      if (field.usedAsAvatar) acc.avatar = field;else acc.fieldsToShow = [].concat(acc.fieldsToShow, [field]);
      return acc;
    }, {
      fieldsToShow: []
    });
  }, [entity.fields, role]),
      fieldsToShow = _useMemo.fieldsToShow,
      avatar = _useMemo.avatar;

  var groupID = useRef();

  var checkCurrentGroup = function checkCurrentGroup(item, index) {
    var itemGroupId = entity.getGroupFormat(item);

    if (groupID.current !== itemGroupId || index === 0) {
      groupID.current = itemGroupId;
      return /*#__PURE__*/React__default.createElement(_Typography.Text, {
        className: "data-card-group-name"
      }, itemGroupId);
    }

    return /*#__PURE__*/React__default.createElement(Fragment, null);
  };

  return /*#__PURE__*/React__default.createElement(_List, {
    itemLayout: "vertical",
    dataSource: data,
    rowKey: entity.getIdentifier(),
    renderItem: function renderItem(item, index) {
      var id = entity.getIdentifierValue(item);
      return /*#__PURE__*/React__default.createElement(CardListWrapper, null, entity.isDataGrouped() && checkCurrentGroup(item, index), /*#__PURE__*/React__default.createElement(_List.Item, null, /*#__PURE__*/React__default.createElement(_Card, null, /*#__PURE__*/React__default.createElement(_Row, {
        gutter: [8, 8]
      }, entity.isBulkActionsEnabled() && /*#__PURE__*/React__default.createElement(_Col, null, /*#__PURE__*/React__default.createElement(_Checkbox, {
        checked: isSelected(item),
        onClick: handleSelect(item)
      })), avatar && /*#__PURE__*/React__default.createElement(_Col, null, /*#__PURE__*/React__default.createElement(_Avatar, {
        src: avatar.getDataValue(item, {
          constructFileAccessor: true
        }),
        shape: "square"
      })), /*#__PURE__*/React__default.createElement(_Col, {
        flex: "1"
      }, fieldsToShow === null || fieldsToShow === void 0 ? void 0 : fieldsToShow.map(function (field, index) {
        var displayValue = field.getDisplayValue(item, {
          value: field.getDataValue(item, {
            constructFileAccessor: true
          }),
          id: id,
          tagsConfig: field.tagsConfig
        });
        return /*#__PURE__*/React__default.createElement(_Row, {
          key: id + "-" + index,
          gutter: 6
        }, !entity.hideLabelInCard && !field.hideLabelInCard && /*#__PURE__*/React__default.createElement(_Col, null, /*#__PURE__*/React__default.createElement("strong", null, field.getLabel() + ":")), /*#__PURE__*/React__default.createElement(_Col, null, displayValue()));
      })), entity.showRowActions && /*#__PURE__*/React__default.createElement(_Dropdown, {
        overlay: /*#__PURE__*/React__default.createElement(CardRowActionsMenu, null, renderRowActions(entity.getIdentifierValue(item), item)),
        placement: entity.rowActionDropdownPlacement || "bottomCenter",
        overlayClassName: "data-card-row-actions"
      }, /*#__PURE__*/React__default.createElement(_Button, {
        type: "link"
      }, /*#__PURE__*/React__default.createElement(EllipsisOutlined$2, null))), entity.showViewButtonInCard && /*#__PURE__*/React__default.createElement(_Col, {
        className: "data-card-view-button-col"
      }, /*#__PURE__*/React__default.createElement(Link, {
        to: getURL(privateRouteURL, entity.pathName + "/" + id)
      }, /*#__PURE__*/React__default.createElement(_Button, {
        type: "primary",
        className: "data-card-view-button"
      }, t("view"))))))));
    }
  });
};

var _excluded$m = ["editable", "handleSave", "field", "record", "entity", "onChange"];

var Cell = function Cell(_ref) {
  var editable = _ref.editable,
      field = _ref.field,
      record = _ref.record,
      entity = _ref.entity,
      onChange = _ref.onChange,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$m);

  var _useChildEntity = useChildEntity({
    entity: entity
  }),
      parentPathname = _useChildEntity.parentPathname,
      parentRecordId = _useChildEntity.parentRecordId;

  var _useState = useState(false),
      editing = _useState[0],
      setEditing = _useState[1];

  var _useState2 = useState(field.getDataValue(record)),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var toggleEdit = function toggleEdit() {
    setEditing(!editing);
  };

  var _useState3 = useState(false),
      disabled = _useState3[0],
      setDisabled = _useState3[1];

  var _useState4 = useState(false),
      newRecord = _useState4[0],
      setNewRecord = _useState4[1];

  var save = function save() {
    if (editing && !newRecord) {
      var _extends2;

      toggleEdit();
      onChange === null || onChange === void 0 ? void 0 : onChange(_extends({}, record, (_extends2 = {}, _extends2[field.identifier] = currentValue.value || currentValue, _extends2)));
    }
  };

  var onChangeValue = function onChangeValue(_, value, selectedOption) {
    setCurrentValue(selectedOption || value);
    onChange === null || onChange === void 0 ? void 0 : onChange(_extends({}, record), field.identifier, value);
  };

  var displayValue = field.getDisplayValue(record, {
    value: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.label) || currentValue,
    id: entity.getIdentifierValue(record),
    parentPathname: parentPathname,
    parentRecordId: parentRecordId
  });

  var handleAddKeyPress = function handleAddKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      save();
    }
  };

  useEffect(function () {
    var newValue = field.getDataValue(record);
    setCurrentValue(newValue);
    setNewRecord(record["new"]);
  }, [record]);
  useEffect(function () {
    setNewRecord(record["new"]);
  }, [record["new"]]);
  useEffect(function () {
    var _field$getParentField, _field$getParentField2;

    var disabledFunction = (_field$getParentField = field.getParentField()) === null || _field$getParentField === void 0 ? void 0 : (_field$getParentField2 = _field$getParentField.tableConfig) === null || _field$getParentField2 === void 0 ? void 0 : _field$getParentField2.disabledRows;

    if (disabledFunction) {
      setDisabled(disabledFunction(record));
    }
  }, []);
  if (!editable && newRecord === undefined || disabled) return displayValue() || null;
  return editing || newRecord ? /*#__PURE__*/React__default.createElement(EditableFieldWrapper, {
    onBlur: save
  }, /*#__PURE__*/React__default.createElement(FieldRenderer$1, {
    data: record,
    field: field,
    fieldType: field.getType(),
    value: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.label) || currentValue,
    onChange: onChangeValue,
    removelabel: true,
    onPressEnter: handleAddKeyPress
  }), editing && !newRecord && /*#__PURE__*/React__default.createElement(CheckOutlined$2, {
    onClick: save
  })) : /*#__PURE__*/React__default.createElement(EditableCell, {
    onClick: toggleEdit
  }, /*#__PURE__*/React__default.createElement("span", null, displayValue()), /*#__PURE__*/React__default.createElement(EditIndication, null, /*#__PURE__*/React__default.createElement(EditIcon, null)));
};

var useEditableDataTable = function useEditableDataTable(_ref) {
  var canEditTableField = _ref.canEditTableField,
      tableConfig = _ref.tableConfig,
      role = _ref.role,
      entity = _ref.entity;

  var _useState = useState(false),
      emptyFilters = _useState[0],
      setEmptyFilters = _useState[1];

  var canRoleEditTable = function canRoleEditTable() {
    var authorizedRoles = get(tableConfig, ["authorizedRoles"]);
    if (!authorizedRoles) return true;
    return authorizedRoles.includes(role);
  };

  var isEditableTableField = function isEditableTableField(field) {
    var isEditable = canEditTableField && canRoleEditTable();
    return tableConfig !== null && tableConfig !== void 0 && tableConfig.editableFields ? isEditable && (tableConfig === null || tableConfig === void 0 ? void 0 : tableConfig.editableFields.includes(field === null || field === void 0 ? void 0 : field.identifier)) : isEditable;
  };

  var canAddRows = useCallback(function () {
    return tableConfig === null || tableConfig === void 0 ? void 0 : tableConfig.addRows;
  });
  var entityShowGlobalActions = useMemo(function () {
    var _entity$globalActions;

    var hasGlobalActions = (_entity$globalActions = entity.globalActions) === null || _entity$globalActions === void 0 ? void 0 : _entity$globalActions.filter(function (action) {
      return action.type === undefined || ["global", "both"].includes(action.type);
    });
    return !isEmpty$1(hasGlobalActions) && hasGlobalActions.reduce(function (acc, _, index) {
      return acc && entity.canRolePerformAction(role, ["rowActions", index, "authorizedRoles"]);
    }, true);
  }, [entity.globalActions]);
  var hasFiltersToolbar = useMemo(function () {
    return entity.canCreate(role) && !entity.hideCreateButton || entity.canExport(role) || entity.canImport(role) || entity.showSearch || entityShowGlobalActions || !emptyFilters;
  }, [emptyFilters, role]);
  return {
    isEditableTableField: isEditableTableField,
    hasFiltersToolbar: hasFiltersToolbar,
    setEmptyFilters: setEmptyFilters,
    canAddRows: canAddRows
  };
};

var _templateObject$f, _templateObject2$b;

var StyledWidthWrapper$1 = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n  ", "\n\n  @media only screen and (max-width: ", ") {\n    padding: 0px 0px 10px 0px;\n  }\n"])), function (props) {
  return generateWidthMediaQueries(props, {
    desktop: "100%",
    mobile: "100%",
    tablet: "100%"
  });
}, function (props) {
  return props.theme.breakpoints.xs;
});
var DisplayInfoWrapper = styled.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteralLoose(["\n  margin-bottom: 10px;\n"])));
var displayInfoData = createActions$1("displayInfoData");

var DisplayCard$1 = function DisplayCard(_ref) {
  var config = _ref.config,
      _ref$dataObject = _ref.dataObject,
      dataObject = _ref$dataObject === void 0 ? {} : _ref$dataObject;

  var _ref2 = config || {},
      width = _ref2.width,
      _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? {} : _ref2$data,
      style = _ref2.style;

  var title = data.title,
      body = data.body;
  var titleContent = getDataValue(dataObject, title, null, {
    config: config
  });
  var bodyContent = getDataValue(dataObject, body, null, {
    config: config
  });
  return /*#__PURE__*/React__default.createElement(StyledWidthWrapper$1, {
    widthConfig: width
  }, /*#__PURE__*/React__default.createElement(_Col, null, /*#__PURE__*/React__default.createElement(_Card, {
    style: _extends({}, style),
    title: titleContent
  }, dataObject !== null && dataObject !== void 0 && dataObject.loading ? /*#__PURE__*/React__default.createElement(_Skeleton, {
    active: true
  }) : bodyContent)));
};

var _excluded$n = ["dataSource", "accessor"];

var DisplayGroup = function DisplayGroup(_ref) {
  var endpoint = _ref.endpoint,
      components = _ref.components,
      entity = _ref.entity;
  var dispatch = useDispatch();

  var _useRef = useRef(uniqueId("display_group_")),
      id = _useRef.current;

  var displayData = useSelector(function (state) {
    return getEntity(state, "displayInfo");
  });
  var storeEntity = useSelector(function (state) {
    return getEntity(state, entity.pluralName);
  });

  var getData = function getData(_ref2) {
    var dataSource = _ref2.dataSource;
    return dataSource === "endpoint" ? displayData[id] : storeEntity;
  };

  useEffect(function () {
    if (endpoint) dispatch(displayInfoData.request({
      id: id,
      endpoint: endpoint
    }));
  }, [dispatch, endpoint, id, i18n.language]);
  return components.map(function (_ref3, index) {
    var dataSource = _ref3.dataSource,
        card = _objectWithoutPropertiesLoose(_ref3, _excluded$n);

    return /*#__PURE__*/React__default.createElement(DisplayCard$1, _extends({
      key: index,
      id: id
    }, card, {
      dataObject: getData({
        dataSource: dataSource
      })
    }));
  });
};

var DisplayInfo = function DisplayInfo(_ref) {
  var entity = _ref.entity;
  var infoDataList = entity.infoDataList;
  if (isEmpty$1(infoDataList)) return null;
  return /*#__PURE__*/React__default.createElement(DisplayInfoWrapper, null, /*#__PURE__*/React__default.createElement(_Row, {
    gutter: [16, 16]
  }, infoDataList.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(DisplayGroup, _extends({
      key: index,
      entity: entity
    }, item));
  })));
};

var DataTable = function DataTable(_ref) {
  var _auth$authConfig$name;

  var entity = _ref.entity,
      loading = _ref.loading,
      onDelete = _ref.onDelete,
      onSearch = _ref.onSearch,
      onFilter = _ref.onFilter,
      onResetFilter = _ref.onResetFilter,
      onDependeeFilter = _ref.onDependeeFilter,
      isDependeeFilterEqualsDependant = _ref.isDependeeFilterEqualsDependant,
      onExport = _ref.onExport,
      onImport = _ref.onImport,
      onCustomRowActionTriggered = _ref.onCustomRowActionTriggered,
      onCustomGlobalActionTriggered = _ref.onCustomGlobalActionTriggered,
      onCustomBulkActionTriggered = _ref.onCustomBulkActionTriggered,
      onBulkDelete = _ref.onBulkDelete,
      disablePagination = _ref.disablePagination,
      onPaginationChange = _ref.onPaginationChange,
      filterEntity = _ref.filterEntity,
      isStatic = _ref.isStatic,
      _ref$staticData = _ref.staticData,
      staticData = _ref$staticData === void 0 ? {} : _ref$staticData,
      tableConfig = _ref.tableConfig,
      onChange = _ref.onChange,
      canEditTableField = _ref.canEditTableField,
      fields = _ref.fields,
      parentEntityData = _ref.parentEntityData;

  var _useTranslation = useTranslation(["general", "dataTable"]),
      t = _useTranslation.t;

  var dispatch = useDispatch();

  var _useContext = useContext(AppContext),
      authConfig = _useContext.authConfig,
      privateRouteURL = _useContext.privateRouteURL,
      theme = _useContext.theme;

  var _useChildEntity = useChildEntity({
    entity: entity
  }),
      constructCreatePath = _useChildEntity.constructCreatePath;

  var resize = useMedia("(max-width:" + theme.breakpoints.md + ")");
  var storeEntity = useSelector(function (state) {
    return getEntity(state, entity.pluralName);
  });
  var auth = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var role = (_auth$authConfig$name = auth[authConfig.name]) === null || _auth$authConfig$name === void 0 ? void 0 : _auth$authConfig$name.role;
  var query = storeEntity.query,
      errors = storeEntity.errors,
      modalOpenStatus = storeEntity.modalOpenStatus;

  var _ref2 = isStatic ? staticData : storeEntity,
      currentPage = _ref2.currentPage,
      rowsPerPage = _ref2.rowsPerPage,
      totalEntries = _ref2.totalEntries,
      _ref2$data = _ref2.data,
      dataObject = _ref2$data === void 0 ? [] : _ref2$data;

  var _useState = useState(1),
      currentPageReduced = _useState[0],
      setCurrentPageReduced = _useState[1];

  var data = !isStatic && tableConfig !== null && tableConfig !== void 0 && tableConfig.dataAccessor ? dataObject === null || dataObject === void 0 ? void 0 : dataObject.map(function (item) {
    return get(item, tableConfig === null || tableConfig === void 0 ? void 0 : tableConfig.dataAccessor);
  }) : dataObject;

  var _useState2 = useState(false),
      extraRows = _useState2[0],
      setExtraRows = _useState2[1];

  var _useEditableDataTable = useEditableDataTable({
    canEditTableField: canEditTableField,
    tableConfig: tableConfig,
    role: role,
    entity: entity
  }),
      hasFiltersToolbar = _useEditableDataTable.hasFiltersToolbar,
      setEmptyFilters = _useEditableDataTable.setEmptyFilters,
      canAddRows = _useEditableDataTable.canAddRows;

  var formModalRef = useRef();

  var _useBulkActions = useBulkActions({
    entity: entity,
    resize: resize
  }),
      selectedItemsMap = _useBulkActions.selectedItemsMap,
      selectedKeys = _useBulkActions.selectedKeys,
      numberOfSelectedItems = _useBulkActions.numberOfSelectedItems,
      isSelected = _useBulkActions.isSelected,
      handleSelect = _useBulkActions.handleSelect,
      setSelectedKeys = _useBulkActions.setSelectedKeys,
      clearSelected = _useBulkActions.clearSelected;

  var onOpenStatusChange = function onOpenStatusChange(status) {
    dispatch(entitiesActions[entity.name]["import"].toggleDialogStatus({
      open: status
    }));
  };

  var getRowData = function getRowData(dataObject, fields) {
    var row = [];
    fields.filter(function (field) {
      return !field.isHiddenInList(role);
    }).forEach(function (field) {
      row.push({
        field: field,
        value: field.getDataValue(dataObject, {
          constructFileAccessor: true
        })
      });
    });
    return row;
  };

  var getRowsData = function getRowsData(data, fields) {
    var rowsData = {};
    data.forEach(function (dataObject) {
      return rowsData["0" + entity.getIdentifierValue(dataObject)] = {
        row: getRowData(dataObject, fields),
        data: dataObject,
        selected: isSelected(dataObject)
      };
    });
    return rowsData;
  };

  var renderRowActions = function renderRowActions(recordId, record) {
    var _formModalRef$current;

    return /*#__PURE__*/React__default.createElement(RowActions, {
      entity: entity,
      record: record,
      recordId: recordId,
      onDelete: onDelete,
      onCustomRowActionTriggered: onCustomRowActionTriggered,
      onFormModalActionClick: (_formModalRef$current = formModalRef.current) === null || _formModalRef$current === void 0 ? void 0 : _formModalRef$current.onModalOpen
    });
  };

  var renderExpandables = function renderExpandables() {
    var rowsData = getRowsData(data, entity.fields);
    return Object.keys(rowsData).map(function (key) {
      return /*#__PURE__*/React__default.createElement(Expandable, {
        key: key,
        item: rowsData[key].row,
        itemId: key.slice(1),
        dataObject: rowsData[key].data,
        renderRowActions: renderRowActions,
        entity: entity,
        selected: rowsData[key].selected,
        handleSelect: handleSelect
      });
    });
  };

  var renderTableColumns = function renderTableColumns() {
    var columns = isEmpty(fields) ? entity.fields : fields;
    var tableColumns = columns.filter(function (field) {
      return !field.isHiddenInList(role, parentEntityData || dataObject);
    }).map(function (field) {
      var isEditable = false;
      var renderedCol = {
        title: field.getLabel(),
        dataIndex: field.identifier,
        align: "center",
        render: function render(_, record) {
          return /*#__PURE__*/React__default.createElement(Cell, {
            record: record,
            entity: entity,
            field: field,
            editable: isEditable,
            onChange: onChange
          });
        }
      };

      if (field.filters) {
        var _storeEntity$filtered;

        renderedCol = _extends({}, renderedCol, {
          filterDropdown: function filterDropdown() {
            return /*#__PURE__*/React__default.createElement(ColumnHeaderFilters, {
              entity: entity,
              columnFilters: field.filters,
              filterEntity: filterEntity,
              identifier: field.identifier,
              role: role
            });
          },
          filtered: ((_storeEntity$filtered = storeEntity.filteredColumns) === null || _storeEntity$filtered === void 0 ? void 0 : _storeEntity$filtered[field.identifier]) && storeEntity[field.identifier]
        });
      }

      return renderedCol;
    });
    if (entity.showRowActions) tableColumns.push({
      title: t("dataTable:actions"),
      key: "action",
      align: "center",
      render: function render(_, record) {
        return renderRowActions(entity.getIdentifierValue(record), record);
      }
    });
    return tableColumns;
  };

  var onPaginate = function onPaginate(page, pageSize) {
    if (entity.isReducedPaginationMode()) setCurrentPageReduced(page);
    onPaginationChange === null || onPaginationChange === void 0 ? void 0 : onPaginationChange(page, pageSize);
  };

  var rowSelection = {
    selectedRowKeys: selectedKeys,
    preserveSelectedRowKeys: true,
    onChange: function onChange(selectedRowKeys) {
      setSelectedKeys(selectedRowKeys);
    }
  };

  var addNewRow = function addNewRow() {
    var newRowKeys = {};
    fields.map(function (field) {
      newRowKeys[field.identifier] = field.identifier === "id" ? uniqueId() : field.getDefaultValue();
    });
    newRowKeys["new"] = true;
    onChange === null || onChange === void 0 ? void 0 : onChange(newRowKeys);
    setExtraRows(true);
  };

  var saveAndExitEdit = function saveAndExitEdit() {
    setExtraRows(false);
    data.map(function (element) {
      if (element["new"] !== undefined) {
        onChange === null || onChange === void 0 ? void 0 : onChange(_extends({}, element, {
          "new": false
        }));
      }
    });
  };

  var renderedData = useMemo(function () {
    return isArray(data) ? data === null || data === void 0 ? void 0 : data.filter(function (item) {
      return !item._destroy;
    }) : data;
  }, [data]);

  var renderTable = function renderTable() {
    return /*#__PURE__*/React__default.createElement(_Col, null, /*#__PURE__*/React__default.createElement(CellWrapper, null, /*#__PURE__*/React__default.createElement(_Table, {
      expandable: {
        expandIcon: function expandIcon() {
          return null;
        }
      },
      columns: renderTableColumns(),
      dataSource: renderedData,
      bordered: true,
      rowSelection: entity.isBulkActionsEnabled() && rowSelection,
      rowKey: entity.getIdentifier(),
      scroll: {
        x: 400
      },
      pagination: false,
      rowClassName: function rowClassName(record) {
        if (record["new"] !== undefined) return "newRow " + entity.getCustomDataTableRowClass(record);else return entity.getCustomDataTableRowClass(record);
      }
    })), canAddRows() && canEditTableField && /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement(ButtonsWrapper, null, /*#__PURE__*/React__default.createElement(_Button, {
      className: "btn-custom data-list-create-btn",
      onClick: addNewRow
    }, /*#__PURE__*/React__default.createElement(AddIcon, null), " ", t("dataTable:insert_row")), extraRows && /*#__PURE__*/React__default.createElement(_Button, {
      className: "btn-custom data-list-create-btn",
      onClick: saveAndExitEdit
    }, t("dataTable:save")))));
  };

  var renderBulkActions = function renderBulkActions() {
    return entity.isBulkActionsEnabled() && /*#__PURE__*/React__default.createElement(BulkActionsToolbar, {
      entity: entity,
      role: role,
      numberOfSelectedItems: numberOfSelectedItems,
      selectedItems: selectedItemsMap,
      onBulkDelete: onBulkDelete,
      onCustomBulkActionTriggered: onCustomBulkActionTriggered,
      clearSelected: clearSelected
    });
  };

  var checkDependeeFilter = function checkDependeeFilter(filter) {
    if (filter.dependsOn) {
      return filter.dependsOnAny ? Boolean(storeEntity[filter.dependsOn]) : isDependeeFilterEqualsDependant(filter, storeEntity[filter.dependsOn]);
    }

    return true;
  };

  var renderFiltersDrawer = function renderFiltersDrawer() {
    return /*#__PURE__*/React__default.createElement(FiltersDrawer, {
      entity: entity,
      onFilter: onFilter,
      onDependeeFilter: onDependeeFilter,
      checkDependeeFilter: checkDependeeFilter,
      role: role,
      onResetFilter: onResetFilter,
      onSearch: onSearch,
      query: query,
      resize: resize
    });
  };

  var renderFiltersToolbar = function renderFiltersToolbar() {
    return /*#__PURE__*/React__default.createElement(FiltersToolbar, {
      entity: entity,
      onFilter: onFilter,
      onDependeeFilter: onDependeeFilter,
      checkDependeeFilter: checkDependeeFilter,
      role: role,
      onResetFilter: onResetFilter,
      onSearch: onSearch,
      query: query,
      setEmptyFilters: setEmptyFilters
    });
  };

  var renderCardList = function renderCardList() {
    return /*#__PURE__*/React__default.createElement(CardList, {
      entity: entity,
      role: role,
      data: data,
      isSelected: isSelected,
      handleSelect: handleSelect,
      renderRowActions: renderRowActions,
      privateRouteURL: privateRouteURL
    });
  };

  var renderDataList = function renderDataList() {
    var componentRenderer;
    if (entity.listType === "card") componentRenderer = renderCardList;else componentRenderer = resize && !tableConfig ? renderExpandables : renderTable;
    if (entity.emptyText && isEmpty(data)) return renderComponent(entity.emptyText);
    return /*#__PURE__*/React__default.createElement(Fragment, null, entity.subTitle && /*#__PURE__*/React__default.createElement(_Typography.Text, {
      strong: true,
      className: "data-list-subtitle"
    }, entity.getDisplaySubTitle("list")), componentRenderer(), !disablePagination && (currentPage || entity.isReducedPaginationMode()) && /*#__PURE__*/React__default.createElement(DataPagination, {
      currentPage: currentPage || currentPageReduced,
      rowsPerPage: rowsPerPage,
      totalEntries: totalEntries,
      entityRowsPerPage: entity.rowsPerPage,
      onPaginationChange: onPaginate,
      isReduced: entity.isReducedPaginationMode()
    }));
  };

  return /*#__PURE__*/React__default.createElement(ContainerWrapper, {
    className: entity.customDataListClass
  }, /*#__PURE__*/React__default.createElement(ToolbarContainer, {
    hasFiltersToolbar: hasFiltersToolbar
  }, /*#__PURE__*/React__default.createElement(ButtonsContainer, {
    className: "btns-container"
  }, entity.canCreate(role) && !entity.hideCreateButton && /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: entity.isChild ? constructCreatePath() : getURL(privateRouteURL, entity.pathName + "/create")
    }
  }, /*#__PURE__*/React__default.createElement(_Button, {
    className: "btn-custom data-list-create-btn"
  }, renderComponent(entity.createBtn, function () {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(AddIcon, null), " ", t("general:create"));
  }))), entity.canExport(role) && /*#__PURE__*/React__default.createElement(_Button, {
    className: "btn-custom",
    onClick: onExport,
    icon: /*#__PURE__*/React__default.createElement(ExportIcon, null)
  }, entity.getExportLabel().toLowerCase()), entity.canImport(role) && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Import, {
    entity: entity,
    onImport: onImport,
    errors: errors,
    role: role,
    modalOpenStatus: modalOpenStatus,
    handleOpen: onOpenStatusChange,
    className: "btn-custom",
    loading: loading
  })), entity.globalActions && entity.globalActions.filter(function (action) {
    return action.type === undefined || ["global", "both"].includes(action.type);
  }).map(function (action, index) {
    return entity.canRolePerformAction(role, ["globalActions", index, "authorizedRoles"]) && /*#__PURE__*/React__default.createElement(ActionButton, {
      key: index,
      onActionClick: function onActionClick() {
        return onCustomGlobalActionTriggered(action);
      },
      confirmable: action.requireConfirmation,
      confirmationMessage: action.confirmationMessage,
      className: "btn-custom"
    }, entity.getDisplayName(action.label).toLowerCase());
  })), entity.showFiltersInDrawer ? renderFiltersDrawer() : renderFiltersToolbar()), entity.title && /*#__PURE__*/React__default.createElement(_Typography.Title, {
    level: 2,
    className: "data-list-title"
  }, entity.getDisplayTitle("list")), /*#__PURE__*/React__default.createElement(DisplayInfo, {
    entity: entity
  }), /*#__PURE__*/React__default.createElement(Loadable, {
    loading: loading,
    render: function render() {
      return /*#__PURE__*/React__default.createElement(Fragment, null, renderBulkActions(), renderDataList());
    }
  }), /*#__PURE__*/React__default.createElement(FormModalAction$1, {
    entity: entity,
    ref: formModalRef
  }));
};

var Generator = function Generator(_ref) {
  var action = _ref.action,
      entity = _ref.entity,
      params = _ref.match.params,
      history = _ref.history,
      disablePagination = _ref.disablePagination,
      additionalParams = _ref.additionalParams,
      tableConfig = _ref.tableConfig,
      canEditTableField = _ref.canEditTableField,
      onChange = _ref.onChange;

  var _useChildEntity = useChildEntity({
    entity: entity
  }),
      parentPathname = _useChildEntity.parentPathname,
      parentRecordId = _useChildEntity.parentRecordId;

  var _useSelector = useSelector(function (state) {
    return getEntity(state, entity.pluralName);
  }),
      loading = _useSelector.loading,
      current = _useSelector.current,
      errors = _useSelector.errors,
      filtersFetched = _useSelector.filtersFetched;

  var _useContext = useContext(AppContext),
      privateRouteURL = _useContext.privateRouteURL;

  var currentLocation = useRef(history.location.pathname);
  var dispatch = useDispatch();
  var dispatchRequest = useCallback(function (payload, actionName) {
    if (actionName === void 0) {
      actionName = action;
    }

    dispatch(entitiesActions[entity.name][actionName].request(payload));
  }, [action, dispatch, entity.name]);
  useEffect(function () {
    var _history$location;

    switch (action) {
      case "list":
        dispatchRequest(_extends({
          entity: entity,
          routeState: history === null || history === void 0 ? void 0 : (_history$location = history.location) === null || _history$location === void 0 ? void 0 : _history$location.state
        }, additionalParams || {}, {
          parentRecordId: parentRecordId,
          parentPathname: parentPathname
        }));
        break;

      case "show":
      case "edit":
        dispatchRequest({
          entity: entity,
          id: entity.isChild ? params.childId : params.id,
          parentRecordId: parentRecordId,
          parentPathname: parentPathname
        }, "show");
        break;
    }
  }, [action, dispatchRequest, entity, params.id, i18n.language]);
  useEffect(function () {
    if (action === "list" && filtersFetched) dispatchRequest({
      entity: entity,
      page: 1
    });
  }, [filtersFetched, dispatchRequest, action, entity]);
  useEffect(function () {
    if (action === "list" && history !== null && history !== void 0 && history.replace) history.replace({
      state: {}
    });
    return function () {
      var _currentLocation$curr, _location$pathname;

      var location = history.location;
      if (location.pathname === privateRouteURL || !((_currentLocation$curr = currentLocation.current) !== null && _currentLocation$curr !== void 0 && _currentLocation$curr.includes(location.pathname) || (_location$pathname = location.pathname) !== null && _location$pathname !== void 0 && _location$pathname.includes(currentLocation.current))) dispatch(entitiesActions[entity.name].list.reset({
        entity: entity
      }));else dispatch(entitiesActions[entity.name].list.filtersFetched({
        fetched: false
      }));
    };
  }, []);

  var onCreate = function onCreate(data) {
    dispatchRequest({
      entity: entity,
      data: data,
      parentRecordId: parentRecordId,
      parentPathname: parentPathname
    });
  };

  var onEdit = function onEdit(id) {
    return function (data) {
      dispatchRequest({
        entity: entity,
        data: data,
        id: id,
        parentRecordId: parentRecordId,
        parentPathname: parentPathname
      });
    };
  };

  var onDelete = function onDelete(id) {
    dispatchRequest({
      entity: entity,
      id: id,
      parentRecordId: parentRecordId,
      parentPathname: parentPathname
    }, "delete");
  };

  var onBulkDelete = function onBulkDelete(selected) {
    dispatchRequest({
      entity: entity,
      data: selected,
      sagaConfigs: {
        actionName: "deleteMultiple",
        success: "deleteSuccess",
        error: "deleteError"
      },
      bulkConfigs: {
        endpoint: "delete",
        method: "delete"
      }
    }, "deleteMultiple");
  };

  var onExport = function onExport() {
    dispatchRequest({
      entity: entity,
      isExporting: true
    }, "export");
  };

  var onImport = function onImport(data, config) {
    dispatchRequest({
      entity: entity,
      data: data,
      config: config
    }, "import");
  };

  var onChangePage = function onChangePage(page) {
    dispatchRequest({
      entity: entity,
      page: page
    });
  };

  var onChangeRowsPerPage = function onChangeRowsPerPage(newRowsPerPage) {
    dispatchRequest({
      entity: entity,
      rowsPerPage: newRowsPerPage
    });
  };

  var onPaginationChange = function onPaginationChange(page, rowsPerPage) {
    dispatchRequest({
      entity: entity,
      page: page,
      rowsPerPage: rowsPerPage,
      parentRecordId: parentRecordId,
      parentPathname: parentPathname
    });
  };

  var onSearch = function onSearch(query) {
    dispatchRequest({
      entity: entity,
      query: query,
      page: 1,
      parentRecordId: parentRecordId,
      parentPathname: parentPathname
    });
  };

  var filterEntity = useCallback(function (filters, resetFilters, column) {
    history.replace(history.location.pathname, {});
    dispatchRequest(_extends({
      entity: entity
    }, filters, {
      page: 1,
      resetFilters: resetFilters,
      column: column
    }));
  }, [dispatchRequest, entity]);
  var onFilter = useCallback(function (field, value, label) {
    filterEntity(onFilterChange(field, value, label), false);
  }, [filterEntity]);
  var onDependeeFilter = useCallback(function (field, value, label) {
    filterEntity(onDependeeFilterChange(field, value, label, entity.filters));
  }, [filterEntity, entity]);
  var onResetFilter = useCallback(function () {
    filterEntity(resetFilters([].concat(entity.filters || [], entity.fieldsFilters || [])), true);
  }, [filterEntity, entity]);

  var onCustomRowActionTriggered = function onCustomRowActionTriggered(action, item) {
    if (action.customFunction) action.customFunction(dispatch, item);else {
      var actionCreator = entitiesActions[entity.name][action.name].request;
      dispatch(actionCreator({
        entity: entity,
        item: item
      }));
    }
  };

  var onCustomGlobalActionTriggered = function onCustomGlobalActionTriggered(action) {
    if (action.customFunction) action.customFunction(dispatch);else {
      var actionCreator = entitiesActions[entity.name][action.name].request;
      dispatch(actionCreator({
        entity: entity
      }));
    }
  };

  var onCustomBulkActionTriggered = function onCustomBulkActionTriggered(action, selected) {
    if (action.customFunction) action.customFunction(dispatch, selected);else {
      var actionCreator = entitiesActions[entity.name].bulkActions.request;
      var bulkConfigs = action.bulkConfigs;
      dispatch(actionCreator({
        entity: entity,
        data: selected,
        bulkConfigs: bulkConfigs,
        sagaConfigs: {
          actionName: "bulkActions",
          success: "success",
          error: "error"
        }
      }));
    }
  };

  var renderEntityAction = function renderEntityAction() {
    switch (action) {
      case "list":
        {
          var ListComponent = entity.customListComponent;
          return ListComponent ? /*#__PURE__*/React__default.createElement(ListComponent, {
            dispatch: dispatch,
            loading: loading,
            entity: entity,
            onImport: onImport,
            onExport: onExport,
            onDelete: onDelete,
            onSearch: onSearch,
            onFilter: onFilter,
            onResetFilter: onResetFilter,
            onDependeeFilter: onDependeeFilter,
            isDependeeFilterEqualsDependant: isDependeeFilterEqualsDependant,
            onChangePage: onChangePage,
            onChangeRowsPerPage: onChangeRowsPerPage,
            onCustomRowActionTriggered: onCustomRowActionTriggered,
            onCustomGlobalActionTriggered: onCustomGlobalActionTriggered
          }) : /*#__PURE__*/React__default.createElement(DataTable, {
            dispatch: dispatch,
            loading: loading,
            entity: entity,
            onImport: onImport,
            onExport: onExport,
            onDelete: onDelete,
            onSearch: onSearch,
            onFilter: onFilter,
            onResetFilter: onResetFilter,
            onDependeeFilter: onDependeeFilter,
            isDependeeFilterEqualsDependant: isDependeeFilterEqualsDependant,
            onCustomRowActionTriggered: onCustomRowActionTriggered,
            onCustomGlobalActionTriggered: onCustomGlobalActionTriggered,
            onCustomBulkActionTriggered: onCustomBulkActionTriggered,
            onBulkDelete: onBulkDelete,
            disablePagination: entity.disablePagination || disablePagination,
            onPaginationChange: onPaginationChange,
            filterEntity: filterEntity,
            tableConfig: tableConfig,
            onChange: onChange,
            canEditTableField: canEditTableField
          });
        }

      case "show":
        {
          var ShowComponent = entity.customShowComponent;
          return /*#__PURE__*/React__default.createElement(Loadable, {
            entity: entity,
            render: function render(props) {
              return ShowComponent ? /*#__PURE__*/React__default.createElement(ShowComponent, props) : /*#__PURE__*/React__default.createElement(DataPage, props);
            },
            loading: loading,
            data: current
          });
        }

      case "create":
        {
          var CreateFormComponent = entity.customFormComponent;
          return /*#__PURE__*/React__default.createElement(Loadable, {
            entity: entity,
            render: function render(props) {
              return CreateFormComponent ? /*#__PURE__*/React__default.createElement(CreateFormComponent, props) : /*#__PURE__*/React__default.createElement(DataForm$1, _extends({
                location: history.location
              }, props));
            },
            action: action,
            onSubmit: onCreate,
            errors: errors,
            loading: loading
          });
        }

      case "edit":
        {
          var EditFormComponent = entity.customFormComponent;
          return /*#__PURE__*/React__default.createElement(Loadable, {
            entity: entity,
            render: function render(props) {
              return EditFormComponent ? /*#__PURE__*/React__default.createElement(EditFormComponent, props) : /*#__PURE__*/React__default.createElement(DataForm$1, _extends({
                params: params,
                location: history.location
              }, props));
            },
            loading: loading,
            errors: errors,
            data: current,
            action: action,
            onSubmit: onEdit(entity.getIdentifierValue(current))
          });
        }
    }
  };

  return renderEntityAction();
};

var Table = function Table(_ref) {
  var _config$data;

  var config = _ref.config,
      authData = _ref.authData;

  var _useContext = useContext(AppContext),
      entities = _useContext.entities;

  var identifier = config.identifier,
      entityName = config.entity,
      disablePagination = config.disablePagination;
  var entityCustomName = generateReferencedEntityCustomName("dashboard", entityName, null, identifier);
  var entity = entities[entityCustomName];

  var generator = function generator() {
    return /*#__PURE__*/React__default.createElement(Generator, {
      entity: entity,
      match: {
        params: {}
      },
      history: {
        location: {}
      },
      action: "list",
      disablePagination: disablePagination
    });
  };

  config.data = {
    title: ((_config$data = config.data) === null || _config$data === void 0 ? void 0 : _config$data.title) || {
      staticValue: entity.getDisplayName()
    },
    body: {
      customComponent: generator
    }
  };
  return /*#__PURE__*/React__default.createElement(DisplayCard, {
    authData: authData,
    isTable: true,
    config: config
  });
};

var dashboardComponents = {
  __proto__: null,
  welcome: Welcome,
  entityGroups: EntityGroups,
  displayCard: DisplayCard,
  graph: Graph,
  table: Table
};
var dashboardData = createActions$1("dashboardData");
var dashboardGroupData = createActions$1("dashboardGroupData");

var DashboardGroup = function DashboardGroup(_ref) {
  var _ref$group = _ref.group,
      endpoint = _ref$group.endpoint,
      components = _ref$group.components;
  var dispatch = useDispatch();

  var _useRef = useRef(uniqueId("group_")),
      id = _useRef.current;

  var _useContext = useContext(AppContext),
      authConfig = _useContext.authConfig,
      groups = _useContext.groups,
      privateRouteURL = _useContext.privateRouteURL;

  var _useTranslation = useTranslation("dashboard"),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var auth = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var authData = auth[authConfig.name];
  var dashboardData = useSelector(function (state) {
    return getEntity(state, "dashboard");
  });
  useEffect(function () {
    if (endpoint) dispatch(dashboardGroupData.request({
      id: id,
      endpoint: endpoint
    }));
  }, [dispatch, endpoint, id, i18n.language]);

  var getData = function getData(dataSource) {
    var _dashboardData$dashbo;

    if (dataSource === "auth") return authData;
    return (endpoint ? dashboardData[id] : (_dashboardData$dashbo = dashboardData.dashboard) === null || _dashboardData$dashbo === void 0 ? void 0 : _dashboardData$dashbo.current) || {};
  };

  return components.map(function (_ref2, index) {
    var _dashboardData$id;

    var _ref2$config = _ref2.config,
        config = _ref2$config === void 0 ? {} : _ref2$config,
        customComponent = _ref2.customComponent,
        type = _ref2.type,
        dataSource = _ref2.dataSource;
    var isLoading = dataSource === "server" && (endpoint ? (_dashboardData$id = dashboardData[id]) === null || _dashboardData$id === void 0 ? void 0 : _dashboardData$id.loading : dashboardData.loading);
    var data = getData(dataSource);

    if (customComponent) {
      var _Component = customComponent;
      return /*#__PURE__*/React__default.createElement(StyledWidthWrapper, {
        key: index,
        widthConfig: config.width
      }, /*#__PURE__*/React__default.createElement(_Col, null, /*#__PURE__*/React__default.createElement(_Component, {
        isLoading: isLoading,
        authData: authData,
        t: t,
        privateRouteURL: privateRouteURL,
        config: config,
        dashboardData: dashboardData,
        data: data
      })));
    }

    var Component = dashboardComponents[type];
    if (!Component) throw new Error("Unsupported component, choose one of " + Object.keys(dashboardComponents));
    return /*#__PURE__*/React__default.createElement(Component, {
      key: index,
      groups: groups,
      t: t,
      authData: authData,
      privateRouteURL: privateRouteURL,
      config: config,
      isLoading: isLoading,
      data: data
    });
  });
};

var Dashboard = function Dashboard() {
  var _useContext = useContext(AppContext),
      dashboardConfig = _useContext.dashboardConfig;

  var dispatch = useDispatch();
  useEffect(function () {
    var endpoint = dashboardConfig.endpoint;
    if (endpoint) dispatch(dashboardData.request({
      endpoint: endpoint
    }));
  }, [i18n.language]);

  if (dashboardConfig.customComponent) {
    var Component = dashboardConfig.customComponent;
    return /*#__PURE__*/React__default.createElement(Component, null);
  }

  return /*#__PURE__*/React__default.createElement(_Row, {
    gutter: [16, 16]
  }, dashboardConfig.groups.map(function (group, index) {
    return /*#__PURE__*/React__default.createElement(DashboardGroup, {
      group: group,
      key: index
    });
  }));
};

var _templateObject$g, _templateObject2$c, _templateObject3$9, _templateObject4$5, _templateObject5$3, _templateObject6$3, _templateObject7$3, _templateObject8$3, _templateObject9$3, _templateObject10$3;

var GlobalLayoutStyle = createGlobalStyle(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n"])));
var StyledHighlightableWrapper$1 = styled.span(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteralLoose(["\n  .highlight {\n    color: ", ";\n    background: none;\n    margin: 0;\n    padding: 0;\n  }\n  * {\n    font-weight: ", ";\n  }\n"])), function (props) {
  return props.searchHighlightColor || "#f9a602";
}, function (props) {
  return props.isSelected ? "bold" : "normal";
});
var StyledSiderHeader = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  .user-name-wrapper {\n    display: flex;\n    align-items: baseline;\n    h1 {\n      height: auto;\n    }\n  }\n"])));
var StyledName = styled.h1(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n  margin-right: 10px !important;\n"])));
var StyledAvatarName = styled.span(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n  vertical-align: middle;\n  & > * {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (props) {
  return props.background || "#f56a00";
}, function (props) {
  return props.color || "";
});
var StyledInputContainer = styled.span(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["\n  & > input {\n    border-radius: 5px;\n    text-indent: 5px;\n    padding: 1px;\n  }\n  margin-left: 5px;\n  margin-right: 5px;\n  visibility: ", ";\n"])), function (props) {
  return props.isSearchBarVisible ? "visible" : "hidden";
});
var StyledGroupIcon = styled.div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n  ", "\n  & > * {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (props) {
  return props.isCollapsed ? "\n  display: flex;\n  float: left;\n  margin-left: -5px;\n  margin-right: 0\n  " : "\n   display : inline;\n   float: none;\n   margin-left: 3px;\n   margin-right: 3px;\n   position: relative;\n\n";
}, function (props) {
  return props.background || "";
}, function (props) {
  return props.color || "";
});
var StyledGroupName = styled.span(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteralLoose(["\n  margin-left: 10px;\n  margin-right: 10px;\n"])));
var StyledSearchContainer = styled.div(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteralLoose(["\n  padding-top: 10px;\n"])));
var StyledLayoutWrapper = styled.div(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteralLoose(["\n  .ant-pro-sider-fixed {\n    right: 0;\n  }\n  .ant-menu {\n    text-align: start;\n  }\n  .ant-pro-fixed-header {\n    position: fixed;\n    top: 0;\n    ", "\n  }\n  .ant-layout-header {\n    background: ", ";\n  }\n  .sider-btn > span {\n    color: ", ";\n  }\n  ", "\n   \n   ", "\n\n  \n"])), function (props) {
  return props.direction === "rtl" && "right:auto !important;left:0 ";
}, function (props) {
  return props.theme.header.background || props.theme.colors.background;
}, function (props) {
  return props.siderThemeMode === "dark" ? "white" : "";
}, function (props) {
  return props.isNotAuthenticated && ".auth-header {\n      justify-content: flex-start;\n      height: inherit;\n    }\n    .ant-pro-basicLayout-content {\n      margin: 0;\n      }\n    .logo {\n      @media only screen and (max-width: " + function (props) {
    return props.theme.breakpoints.md;
  } + ") {\n        position: relative;\n      }\n   }";
}, function (props) {
  return props.siderCustomTheme && "\n    .ant-layout-sider {\n      position: relative;\n      background: " + props.siderCustomTheme.background + ";\n    }\n  \n    .ant-pro-sider-logo {\n      background: " + props.siderCustomTheme.background + ";\n    }\n  \n    .ant-pro-sider-logo h1, .sider-btn > span {\n      color: " + props.siderCustomTheme.textColor + ";\n    }\n  \n    .ant-menu-dark {\n      color: " + props.siderCustomTheme.textColor + " !important;\n      background:" + props.siderCustomTheme.background + " !important;\n      .ant-menu-item-active:hover,\n      .ant-menu-item:hover,\n      .ant-menu-item-active,\n      .ant-menu-submenu-title:hover,\n  \n      .ant-menu-submenu-open {\n        color: " + props.siderCustomTheme.textActiveColor + " !important;\n      }\n  \n      .ant-menu-item,\n      .ant-menu-item-group-title,\n      .ant-menu-item > a,\n      .ant-menu-item > span > a {\n        color:  " + props.siderCustomTheme.textColor + " !important;\n      }\n  \n    }\n  \n  \n    }\n    .ant-menu.ant-menu-dark .ant-menu-sub {\n      background:" + props.siderCustomTheme.subMenuColor + " !important;\n    }\n    .ant-menu-item a:hover {\n      color: " + props.siderCustomTheme.textActiveColor + " !important;\n    }\n  \n    .ant-menu-submenu-arrow::after,\n    .ant-menu-submenu-arrow::before {\n      background: " + props.siderCustomTheme.textColor + " !important;\n    }";
});

var SiderHeader = function SiderHeader(_ref) {
  var _auth$authConfig$name;

  var collapsed = _ref.collapsed,
      authConfig = _ref.authConfig,
      onSearch = _ref.onSearch,
      translate = _ref.translate,
      onPressEnter = _ref.onPressEnter,
      authNameIcon = _ref.authNameIcon,
      disableSidebarSearch = _ref.disableSidebarSearch;
  var auth = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var name = capitalizeString((_auth$authConfig$name = auth[authConfig.name]) === null || _auth$authConfig$name === void 0 ? void 0 : _auth$authConfig$name.name) || "Admin";

  var _useState = useState(false),
      isSearchBarVisible = _useState[0],
      setSearchBarVisibility = _useState[1];

  var onSearchClick = function onSearchClick() {
    return setSearchBarVisibility(!isSearchBarVisible);
  };

  var onKeyDown = function onKeyDown(_ref2) {
    var key = _ref2.key;
    if (key === "Enter") onPressEnter();
  };

  return /*#__PURE__*/React__default.createElement(StyledSiderHeader, null, /*#__PURE__*/React__default.createElement("div", {
    className: "user-name-wrapper"
  }, /*#__PURE__*/React__default.createElement(StyledAvatarName, authNameIcon, /*#__PURE__*/React__default.createElement(_Avatar, {
    size: "medium"
  }, name.charAt(0))), !collapsed && /*#__PURE__*/React__default.createElement(StyledName, null, name)), !collapsed && !disableSidebarSearch && /*#__PURE__*/React__default.createElement(StyledSearchContainer, null, /*#__PURE__*/React__default.createElement(_Button, {
    onClick: onSearchClick,
    shape: "circle",
    icon: /*#__PURE__*/React__default.createElement(SearchOutlined$2, null),
    type: "text",
    className: "sider-btn"
  }), /*#__PURE__*/React__default.createElement(StyledInputContainer, {
    isSearchBarVisible: isSearchBarVisible
  }, /*#__PURE__*/React__default.createElement(_Input, {
    onKeyDown: onKeyDown,
    placeholder: translate("searchEntities"),
    onChange: onSearch,
    style: {
      width: isSearchBarVisible ? "75%" : "0"
    },
    size: "small"
  }))));
};

var breadcrumbs = function breadcrumbs(path) {
  var splitted = path.split("/");
  splitted.shift();
  var breadcrumb = [];
  var constructedPath = "";
  splitted.forEach(function (path) {
    constructedPath += "/" + path;
    breadcrumb.push({
      path: path,
      constructedPath: constructedPath
    });
  });
  return breadcrumb;
};

var _path;

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$2.apply(this, arguments);
}

function SvgLanguageGlobe(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 30"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M13.484.3a13.184 13.184 0 1013.185 13.184A13.184 13.184 0 0013.484.3zm11.4 17.8l-3.75.647a19.675 19.675 0 00.69-4.826h3.951a12.224 12.224 0 01-.888 4.179zM1.19 13.924h3.951a19.675 19.675 0 00.69 4.826l-3.749-.65a12.224 12.224 0 01-.892-4.176zm.892-5.058l3.75-.647a19.675 19.675 0 00-.69 4.826H1.19a12.224 12.224 0 01.892-4.179zm11.842-1.51a30.233 30.233 0 014.711.43l1.551.268a18.864 18.864 0 01.762 4.991h-7.024zm4.861-.436a31.152 31.152 0 00-4.861-.443V1.2c2.519.242 4.708 2.549 5.948 5.906zm-5.74-.443a31.146 31.146 0 00-4.861.443L7.1 7.108C8.337 3.75 10.525 1.443 13.045 1.2zm-4.711 1.31a30.225 30.225 0 014.711-.43v5.689H6.02a18.864 18.864 0 01.762-4.991zM6.02 13.924h7.025v5.689a30.233 30.233 0 01-4.711-.43l-1.551-.268a18.864 18.864 0 01-.763-4.991zm2.164 6.125a31.256 31.256 0 004.861.445v5.274c-2.519-.242-4.708-2.549-5.948-5.906zm5.74.445a31.253 31.253 0 004.861-.445l1.088-.188c-1.24 3.358-3.429 5.666-5.948 5.907zm4.711-1.312a30.225 30.225 0 01-4.711.43v-5.688h7.025a18.864 18.864 0 01-.762 4.991zm3.193-6.137a19.675 19.675 0 00-.69-4.826l3.75.647a12.224 12.224 0 01.892 4.179zM24.442 7.9l-3.594-.62a12.119 12.119 0 00-3.5-5.472A12.364 12.364 0 0124.442 7.9zM9.617 1.805a12.119 12.119 0 00-3.5 5.472L2.526 7.9a12.364 12.364 0 017.091-6.095zM2.526 19.072l3.594.62a12.119 12.119 0 003.5 5.472 12.364 12.364 0 01-7.094-6.092zm14.825 6.092a12.119 12.119 0 003.5-5.472l3.594-.62a12.364 12.364 0 01-7.093 6.092zm0 0"
  })));
}

var _templateObject$h;

var FooterWrapper = styled.footer(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 1.5rem 2.5rem;\n  position: relative;\n  background-color: white;\n  font-size: 12px;\n  text-transform: capitalize;\n  .footer-col > div:not(:last-child) {\n    margin-bottom: 8px;\n  }\n  .footer-col {\n    .ant-typography {\n      color: ", ";\n    }\n    .footer-extra-links {\n      text-align: end;\n      a {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .footer-links-wrapper {\n    display: flex;\n    li {\n      display: flex;\n\n      ", ";\n      align-content: center;\n      a {\n        width: 1.25rem;\n        height: 1.25rem;\n        display: flex;\n        align-items: center;\n        svg {\n          fill: currentColor;\n        }\n      }\n      :hover {\n        opacity: 70%;\n      }\n    }\n  }\n\n  .logo {\n    ", ";\n    ", ";\n    display: inline-block;\n    img {\n      ", ";\n      ", ";\n    }\n  }\n  .footer-dropdown {\n    .ant-dropdown-menu-title-content {\n      text-transform: capitalize;\n    }\n  }\n\n  @media only screen and (max-width: ", ") {\n    .footer-col {\n      width: 100%;\n      margin: auto;\n      text-align: center;\n      .footer-extra-links {\n        text-align: center;\n      }\n    }\n    .footer-links-wrapper {\n      justify-content: center;\n    }\n\n    .logo {\n      margin: 15px auto;\n    }\n  }\n"])), function (props) {
  return props.theme.colors.main;
}, function (props) {
  return props.theme.direction === "rtl" ? "margin-left: 0.75rem;" : "margin-right: 0.75rem;";
}, function (props) {
  return props.theme.footer.logoWidth ? "width: " + props.theme.footer.logoWidth : "max-width: 150px";
}, function (props) {
  return props.theme.footer.logoHeight && "height: " + props.theme.footer.logoHeight;
}, function (props) {
  return props.theme.footer.logoWidth ? "width: " + props.theme.footer.logoWidth : "max-width: 150px";
}, function (props) {
  return props.theme.footer.logoHeight && "height: " + props.theme.footer.logoHeight;
}, function (props) {
  return props.theme.breakpoints.md;
});

var Footer = function Footer(_ref) {
  var _footerConfig$socialM, _footerConfig$extraLi;

  var styles = _ref.styles;

  var _useContext = useContext(AppContext),
      fullLogo = _useContext.fullLogo,
      _useContext$footerCon = _useContext.footerConfig,
      footerConfig = _useContext$footerCon === void 0 ? {} : _useContext$footerCon,
      availableLanguages = _useContext.availableLanguages,
      disableLocalization = _useContext.disableLocalization,
      logoLink = _useContext.logoLink,
      disableFooter = _useContext.disableFooter;

  var _useTranslation = useTranslation("footer"),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language,
      i18n = _useTranslation.i18n;

  if (disableFooter) return /*#__PURE__*/React__default.createElement(Fragment, null);
  return /*#__PURE__*/React__default.createElement(FooterWrapper, {
    className: "footer " + (footerConfig.className || ""),
    style: styles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "footer-col"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "footer-links-wrapper"
  }, (_footerConfig$socialM = footerConfig.socialMedia) === null || _footerConfig$socialM === void 0 ? void 0 : _footerConfig$socialM.map(function (link, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: link.url + "-" + index
    }, /*#__PURE__*/React__default.createElement("a", {
      href: link.url,
      style: {
        backgroundImage: "url(" + link.icon + ")"
      }
    }, getTranslatedValue(link.label)));
  }), !disableLocalization && availableLanguages && /*#__PURE__*/React__default.createElement(_Dropdown, {
    placement: "bottomCenter",
    overlay: /*#__PURE__*/React__default.createElement(_Menu, {
      className: "footer-dropdown",
      selectedKeys: [language]
    }, availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages.map(function (item) {
      return /*#__PURE__*/React__default.createElement(_Menu.Item, {
        key: item,
        onClick: function onClick() {
          return i18n.changeLanguage(item);
        }
      }, item);
    }))
  }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", null, /*#__PURE__*/React__default.createElement(SvgLanguageGlobe, null))))), /*#__PURE__*/React__default.createElement(_Typography.Text, null, getTranslatedValue(footerConfig.disclaimer))), fullLogo && /*#__PURE__*/React__default.createElement("a", {
    href: footerConfig.logoLink || logoLink,
    className: "logo"
  }, /*#__PURE__*/React__default.createElement(Image, {
    src: footerConfig.logo || fullLogo
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "footer-col"
  }, (_footerConfig$extraLi = footerConfig.extraLinks) === null || _footerConfig$extraLi === void 0 ? void 0 : _footerConfig$extraLi.map(function (link) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: link.url,
      className: "footer-extra-links"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: link.url
    }, getTranslatedValue(link.label)));
  }), /*#__PURE__*/React__default.createElement(_Typography.Text, null, t("contactNumber", {
    number: footerConfig.contactNumber
  }))));
};

var Layout = function Layout(_ref) {
  var isNotAuthenticated = _ref.isNotAuthenticated,
      children = _ref.children;

  var _useContext = useContext(AppContext),
      authEntities = _useContext.authEntities,
      authConfig = _useContext.authConfig,
      groups = _useContext.groups,
      privateRouteURL = _useContext.privateRouteURL,
      theme = _useContext.theme,
      rtlLanguages = _useContext.rtlLanguages,
      routes = _useContext.routes,
      removeDashboardSidebar = _useContext.removeDashboardSidebar,
      disableBreadcrumbs = _useContext.disableBreadcrumbs,
      disableSidebarSearch = _useContext.disableSidebarSearch,
      disableAuthHeader = _useContext.disableAuthHeader,
      chatConfigs = _useContext.chatConfigs,
      _useContext$hiddenBre = _useContext.hiddenBreadCrumbsPaths,
      hiddenBreadCrumbsPaths = _useContext$hiddenBre === void 0 ? [] : _useContext$hiddenBre,
      apiEntities = _useContext.apiEntities;

  var sidebar = theme.sidebar,
      header = theme.header;
  var dispatch = useDispatch();

  var _useState = useState({
    searchList: []
  }),
      searchedEntities = _useState[0],
      setSearchedEntities = _useState[1];

  var _useTranslation = useTranslation("layout"),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var language = i18n.language;

  var _useState2 = useState(false),
      isCollapsed = _useState2[0],
      setIsCollapsed = _useState2[1];

  var location = useLocation$1();
  var breadcrumbLinks = useMemo(function () {
    return breadcrumbs(location.pathname);
  }, [location.pathname]);
  var direction = getDirection(rtlLanguages, language);
  var authEntity = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var auth = authEntity === null || authEntity === void 0 ? void 0 : authEntity[authConfig.name];

  var renderBreadCrumbs = function renderBreadCrumbs() {
    var pathHidden = hiddenBreadCrumbsPaths.some(function (path) {
      return location.pathname.includes(path);
    });
    if (location.pathname === privateRouteURL || disableBreadcrumbs || isNotAuthenticated || pathHidden) return null;
    return /*#__PURE__*/React__default.createElement(_Breadcrumb, null, breadcrumbLinks.map(function (link, index) {
      return /*#__PURE__*/React__default.createElement(_Breadcrumb.Item, {
        key: link.path
      }, /*#__PURE__*/React__default.createElement(Link, {
        to: link.constructedPath
      }, index === 0 ? t("mainRouteName") : humanize(link.path)));
    }));
  };

  var headerRender = function headerRender(_ref2) {
    var collapsed = _ref2.collapsed,
        onCollapse = _ref2.onCollapse;

    var toggleCollapse = function toggleCollapse() {
      setIsCollapsed(!collapsed);
      onCollapse(!collapsed);
    };

    return /*#__PURE__*/React__default.createElement(Header$1, {
      toggleCollapse: toggleCollapse,
      isNotAuthenticated: isNotAuthenticated,
      isCollapsed: collapsed,
      className: isNotAuthenticated ? "auth-header" : "",
      disableMenu: removeDashboardSidebar
    });
  };

  var transformEntitiesToMenuData = function transformEntitiesToMenuData(entities) {
    return entities.map(function (entity) {
      return {
        path: getURL(privateRouteURL, entity.pathName),
        name: entity.getDisplayName()
      };
    });
  };

  var transformEntitiesToMenuCollapsed = function transformEntitiesToMenuCollapsed(entities) {
    return entities.map(function (entity) {
      return {
        name: entity.getDisplayName(),
        children: [{
          path: getURL(privateRouteURL, entity.pathName),
          name: entity.getDisplayName()
        }]
      };
    });
  };

  var getSingularEntities = function getSingularEntities(path, translatableName) {
    var data = {
      path: path,
      name: t(translatableName)
    };
    return isCollapsed ? {
      name: t(translatableName),
      children: [data]
    } : data;
  };

  var transformAuthEntitiesLinks = function transformAuthEntitiesLinks(entities, visibleInCollapsed) {
    var _entities$filter;

    return (_entities$filter = entities.filter(function (entity) {
      return entity.showInSidebar && entity.showInCollapsedSideBar === visibleInCollapsed && (entity.action !== "create" || entity.requestConfig.authenticated) && (!entity.preventAccess || !entity.preventAccess(auth));
    })) === null || _entities$filter === void 0 ? void 0 : _entities$filter.reduce(function (acc, _ref3) {
      var title = _ref3.title,
          path = _ref3.path;
      if (isCollapsed && visibleInCollapsed) return [].concat(acc, [{
        name: getTranslatedValue(title),
        children: [{
          path: getURL(privateRouteURL, path),
          name: getTranslatedValue(title)
        }]
      }]);
      return [].concat(acc, [{
        path: getURL(privateRouteURL, path),
        name: getTranslatedValue(title)
      }]);
    }, []);
  };

  var getExtraMenuData = function getExtraMenuData() {
    var dashboardMenuData = removeDashboardSidebar ? [] : [getSingularEntities(privateRouteURL, "mainRouteName")];
    var visibleInCollapse = transformAuthEntitiesLinks(Object.values(authEntities), true);
    var restAuthEntitiesLinks = transformAuthEntitiesLinks(Object.values(authEntities));
    var apiEntitiesMenuData = Object.keys(apiEntities).map(function (entityName) {
      var entity = apiEntities[entityName];
      return getSingularEntities(privateRouteURL + "/" + entity.pluralName, entity.getDisplayName());
    });
    var menuData = [].concat(apiEntitiesMenuData, dashboardMenuData, chatConfigs.enabled ? [getSingularEntities(privateRouteURL + "/chat", "chat")] : [], visibleInCollapse);
    if (isCollapsed && (routes === null || routes === void 0 ? void 0 : routes.privateCustomRoutes.length) === 0 && restAuthEntitiesLinks.length === 0) return menuData;
    var customRoutesData = routes === null || routes === void 0 ? void 0 : routes.privateCustomRoutes.reduce(function (acc, _ref4) {
      var name = _ref4.name,
          path = _ref4.path;
      return [].concat(acc, [{
        path: path,
        name: getTranslatedValue(name)
      }]);
    }, []);
    return isCollapsed ? [].concat(menuData, [{
      name: t("extra"),
      children: [].concat(customRoutesData, restAuthEntitiesLinks)
    }]) : [].concat(menuData, customRoutesData, restAuthEntitiesLinks);
  };

  var transformCollapsed = function transformCollapsed(group, entities) {
    var visibleEntities = transformEntitiesToMenuCollapsed(entities.filter(function (entity) {
      return entity.showInCollapsedSideBar;
    }));
    var groupedEntities = entities.filter(function (entity) {
      return !entity.showInCollapsedSideBar;
    });
    if (!isEmpty$1(groupedEntities)) visibleEntities.push({
      name: group === "ungrouped" ? t("ungrouped") : getTranslatedValue(group),
      children: transformEntitiesToMenuData(groupedEntities)
    });
    return visibleEntities;
  };

  var menuData = useMemo(function () {
    return groups.reduce(function (acc, _ref5) {
      var name = _ref5.name,
          entities = _ref5.entities;
      if (entities.length === 0) return acc;

      if (name === "ungrouped" && !isCollapsed) {
        var unGroupedEntities = transformEntitiesToMenuData(entities);
        return [].concat(acc, unGroupedEntities);
      }

      if (name === "ungrouped" && isCollapsed) {
        var transformedCollapsedEntities = transformCollapsed("ungrouped", entities);
        return [].concat(acc, transformedCollapsedEntities);
      }

      acc.push({
        name: getTranslatedValue(name),
        children: transformEntitiesToMenuData(entities)
      });
      return acc;
    }, [].concat(getExtraMenuData()));
  }, [groups, language, isCollapsed, apiEntities]);

  var onSearch = function onSearch(_ref6) {
    var value = _ref6.target.value;
    if (!value) return setSearchedEntities({
      entities: null,
      searchList: []
    });
    var filteredEntities = rankedSearch(menuData, value);
    setSearchedEntities({
      entities: filteredEntities,
      searchList: value.split(" ")
    });
  };

  var onPressEnter = function onPressEnter() {
    var _searchedEntities$ent, _searchedEntities$ent2;

    var path = (_searchedEntities$ent = searchedEntities.entities) === null || _searchedEntities$ent === void 0 ? void 0 : (_searchedEntities$ent2 = _searchedEntities$ent[0]) === null || _searchedEntities$ent2 === void 0 ? void 0 : _searchedEntities$ent2.path;
    if (path) dispatch(push(path));
  };

  var menuHeaderRender = function menuHeaderRender(_, __, _ref7) {
    var collapsed = _ref7.collapsed;
    return /*#__PURE__*/React__default.createElement(SiderHeader, {
      translate: t,
      renderBreadCrumbs: renderBreadCrumbs,
      collapsed: collapsed,
      onSearch: onSearch,
      authConfig: authConfig,
      onPressEnter: onPressEnter,
      authNameIcon: sidebar === null || sidebar === void 0 ? void 0 : sidebar.authNameIcon,
      siderTheme: sidebar.theme,
      disableSidebarSearch: disableSidebarSearch
    });
  };

  var subMenuItemRender = function subMenuItemRender(_ref8) {
    var name = _ref8.name;
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledGroupIcon, _extends({}, sidebar === null || sidebar === void 0 ? void 0 : sidebar.groupIcons, {
      isCollapsed: isCollapsed
    }), /*#__PURE__*/React__default.createElement(_Avatar, {
      size: "small"
    }, name.charAt(0))), /*#__PURE__*/React__default.createElement(StyledGroupName, null, !isCollapsed && name));
  };

  var postMenuData = function postMenuData() {
    return searchedEntities.entities || menuData;
  };

  var menuItemRender = function menuItemRender(item) {
    var path = item.path,
        name = item.name;
    return /*#__PURE__*/React__default.createElement(Link, {
      to: path
    }, /*#__PURE__*/React__default.createElement(StyledHighlightableWrapper$1, {
      searchHighlightColor: sidebar === null || sidebar === void 0 ? void 0 : sidebar.searchHighlightColor,
      isSelected: location.pathname === path,
      className: "test-highlighter"
    }, /*#__PURE__*/React__default.createElement(Highlighter, {
      highlightClassName: "highlight",
      searchWords: searchedEntities.searchList,
      textToHighlight: name || "",
      autoEscape: true
    })));
  };

  var onCollapse = function onCollapse(collapsed) {
    setSearchedEntities({
      searchList: []
    });
    setIsCollapsed(collapsed);
  };

  return /*#__PURE__*/React__default.createElement(StyledLayoutWrapper, {
    isNotAuthenticated: isNotAuthenticated,
    direction: direction,
    siderCustomTheme: sidebar === null || sidebar === void 0 ? void 0 : sidebar.customTheme,
    siderThemeMode: sidebar === null || sidebar === void 0 ? void 0 : sidebar.theme
  }, /*#__PURE__*/React__default.createElement(ProLayout, _extends({
    pageTitleRender: function pageTitleRender() {
      return "";
    },
    style: {
      minHeight: "100vh"
    },
    footerRender: function footerRender() {
      return /*#__PURE__*/React__default.createElement(Footer, null);
    },
    headerRender: isNotAuthenticated && disableAuthHeader ? false : headerRender,
    collapsedButtonRender: false,
    fixedHeader: header === null || header === void 0 ? void 0 : header.fixed,
    headerHeight: header === null || header === void 0 ? void 0 : header.height,
    className: (isNotAuthenticated ? theme.authLayoutClassName : theme.defaultLayoutClassName) || ""
  }, isNotAuthenticated || removeDashboardSidebar ? {
    siderWidth: 0,
    hide: true
  } : {
    menuItemRender: menuItemRender,
    subMenuItemRender: subMenuItemRender,
    menuHeaderRender: menuHeaderRender,
    postMenuData: postMenuData,
    onCollapse: onCollapse,
    fixSiderbar: sidebar === null || sidebar === void 0 ? void 0 : sidebar.fixed,
    navTheme: sidebar === null || sidebar === void 0 ? void 0 : sidebar.theme
  }), renderBreadCrumbs(), children));
};

var ProtectedRouter = function ProtectedRouter(_ref) {
  var routes = _ref.routes,
      customRoutes = _ref.customRoutes;

  var _useContext = useContext(AppContext),
      privateRouteURL = _useContext.privateRouteURL,
      defaultPrivateRouteURL = _useContext.defaultPrivateRouteURL;

  var fallbackRenderer = useMemo(function () {
    var _routes$find;

    return (_routes$find = routes.find(function (route) {
      return route.path === defaultPrivateRouteURL;
    })) === null || _routes$find === void 0 ? void 0 : _routes$find.renderer;
  }, [routes]);
  return /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Switch, null, routes.map(function (route) {
    return /*#__PURE__*/React__default.createElement(PrivateRoute, {
      exact: true,
      key: route.path,
      path: route.path,
      render: route.renderer
    });
  }), customRoutes.map(function (route) {
    return /*#__PURE__*/React__default.createElement(PrivateRoute, {
      exact: true,
      key: route.path,
      path: route.path,
      component: route.component
    });
  }), fallbackRenderer && /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: "/",
    component: fallbackRenderer
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: privateRouteURL,
    component: Dashboard
  })));
};

var PublicRouter = function PublicRouter(_ref) {
  var routes = _ref.routes,
      customRoutes = _ref.customRoutes;

  var _useContext = useContext(AppContext),
      privateRouteURL = _useContext.privateRouteURL,
      publicRouteURL = _useContext.publicRouteURL,
      defaultPrivateRouteURL = _useContext.defaultPrivateRouteURL;

  return /*#__PURE__*/React__default.createElement(Layout, {
    isNotAuthenticated: true
  }, /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route$1, {
    exact: true,
    path: publicRouteURL,
    render: function render() {
      return /*#__PURE__*/React__default.createElement(Redirect$1, {
        to: defaultPrivateRouteURL || privateRouteURL
      });
    }
  }), routes.map(function (route) {
    return /*#__PURE__*/React__default.createElement(Route$1, {
      exact: true,
      key: route.path,
      path: route.path,
      render: route.renderer
    });
  }), customRoutes.map(function (route) {
    return /*#__PURE__*/React__default.createElement(Route$1, {
      exact: true,
      key: route.path,
      path: route.path,
      component: route.component
    });
  }), /*#__PURE__*/React__default.createElement(Route$1, {
    render: function render() {
      return /*#__PURE__*/React__default.createElement(Redirect$1, {
        to: defaultPrivateRouteURL || privateRouteURL
      });
    }
  })));
};

var Router = function Router(_ref) {
  var publicRouteURL = _ref.publicRouteURL,
      privateRouteURL = _ref.privateRouteURL,
      routes = _ref.routes;
  var location = useLocation();
  var privateRoutes = routes.privateRoutes,
      publicRoutes = routes.publicRoutes,
      privateCustomRoutes = routes.privateCustomRoutes,
      publicCustomRoutes = routes.publicCustomRoutes;

  var protectedRouter = function protectedRouter() {
    return /*#__PURE__*/React__default.createElement(ProtectedRouter, {
      routes: privateRoutes,
      customRoutes: privateCustomRoutes
    });
  };

  var publicRouter = function publicRouter() {
    return /*#__PURE__*/React__default.createElement(PublicRouter, {
      routes: publicRoutes,
      customRoutes: publicCustomRoutes
    });
  };

  var _useContext = useContext(AppContext),
      theme = _useContext.theme;

  var isSmall = useMedia("(max-width:" + theme.breakpoints.md + ")");
  useEffect(function () {
    if (isSmall) window.scrollTo(0, 0);
  }, [location.pathname]);
  return /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route$1, {
    path: privateRouteURL,
    render: protectedRouter
  }), /*#__PURE__*/React__default.createElement(Route$1, {
    path: publicRouteURL,
    render: publicRouter
  }));
};

var _templateObject$i, _templateObject2$d;

var StyledNotificationWrapper = styled.span(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n  h4 {\n    color: #fff;\n  }\n"])));
var AppWrapper = styled.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteralLoose(["\n  button.ant-btn.btn-custom {\n    color: ", ";\n    background-color: ", ";\n  }\n  button.ant-btn.btn-custom:hover,\n  button.ant-btn.btn-custom:active {\n    background-color: ", ";\n    border-color: ", ";\n  }\n  button.ant-btn.btn-custom > .anticon {\n    margin-right: 8px;\n  }\n  button.ant-btn-rtl.btn-custom > .anticon {\n    margin-left: 8px;\n    margin-right: 0;\n  }\n"])), function (props) {
  return props.theme.colors.main;
}, function (props) {
  return props.theme.colors.background;
}, function (props) {
  return Color(props.theme.colors.background).isLight() ? Color(props.theme.colors.background).darken(0.1).toString() : Color(props.theme.colors.background).fade(0.2).toString();
}, function (props) {
  return Color(props.theme.colors.background).isLight() ? Color(props.theme.colors.background).darken(0.2).toString() : Color(props.theme.colors.background).fade(0.2).toString();
});

var App = function App() {
  var _useContext = useContext(AppContext),
      theme = _useContext.theme,
      rtlLanguages = _useContext.rtlLanguages,
      publicRouteURL = _useContext.publicRouteURL,
      privateRouteURL = _useContext.privateRouteURL,
      routes = _useContext.routes;

  var _useTranslation = useTranslation(),
      language = _useTranslation.i18n.language;

  var direction = getDirection(rtlLanguages, language);
  document.body.style.direction = direction === "ltr" ? "ltr" : "rtl";
  return /*#__PURE__*/React__default.createElement(_ConfigProvider, {
    direction: direction
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: _extends({}, theme, {
      direction: direction
    })
  }, /*#__PURE__*/React__default.createElement(AppWrapper, null, /*#__PURE__*/React__default.createElement(Router, {
    routes: routes,
    publicRouteURL: publicRouteURL,
    privateRouteURL: privateRouteURL
  }), /*#__PURE__*/React__default.createElement(StyledNotificationWrapper, null, /*#__PURE__*/React__default.createElement(NotificationContainer, null)))));
};

var _excluded$o = ["authenticated", "isDownloading", "skipSaveAuthHeader", "enableRedirects"];

var isAbsoluteUrl = function isAbsoluteUrl(url) {
  return url.includes("http");
};

var injectLocale = function injectLocale(request) {
  set(request, ["params", "locale"], i18n.language);
  return request;
};

axios.interceptors.request.use(injectLocale);

var request = function request(customConfig) {
  if (customConfig === void 0) {
    customConfig = {};
  }

  var _customConfig = customConfig,
      authenticated = _customConfig.authenticated,
      _customConfig$isDownl = _customConfig.isDownloading,
      isDownloading = _customConfig$isDownl === void 0 ? false : _customConfig$isDownl,
      enableRedirects = _customConfig.enableRedirects,
      modifiedCustomConfig = _objectWithoutPropertiesLoose(_customConfig, _excluded$o);

  var _adminConfigs$getConf = adminConfigs.getConfigs(),
      url = _adminConfigs$getConf.url,
      authConfig = _adminConfigs$getConf.authConfig,
      authEntities = _adminConfigs$getConf.authEntities,
      storeDispatcher = _adminConfigs$getConf.storeDispatcher;

  var entitiesSavingTokensUrls = Object.values(authEntities).reduce(function (urls, entity) {
    if (entity.requestConfig && entity.requestConfig.saveToLocalStorage) {
      return [].concat(urls, [entity.requestConfig.url + entity.requestConfig.method]);
    }

    return urls;
  }, []);

  var config = _extends({
    headers: {}
  }, modifiedCustomConfig);

  if (!enableRedirects) {
    axios.interceptors.response.use(function (response) {
      if (isAbsoluteUrl(response.config.url)) return response;
      if (!authConfig.saveAuthHeadersOnce || entitiesSavingTokensUrls.includes(response.config.url + response.config.method)) addToLocalStorage("authHeaders", pick(response.headers, ["client", "expiry", "token", "uid"]));
      return response;
    }, function (error) {
      if (error.response.status === 401) {
        storeDispatcher("logout");
      }

      return Promise.reject(error);
    });
  }

  if (authenticated) {
    var authHeaders = loadFromLocalStorage("authHeaders");

    if (!authHeaders) {
      var error = new Error("Missing authentication headers");
      throw error;
    }

    config.headers = _extends({}, config.headers, authHeaders);
  }

  if (enableRedirects) {
    return fetch("" + url + config.url, _extends({}, config, {
      body: JSON.stringify(config.data)
    }));
  }

  return axios(_extends({
    baseURL: url,
    responseType: isDownloading ? "blob" : "json"
  }, config));
};

var getActionsArrayOf = function getActionsArrayOf(type, actions) {
  return Object.values(actions).filter(function (entity) {
    return entity[type];
  }).map(function (entity) {
    return entity[type].request;
  });
};

var isEmptyObject = function isEmptyObject(value) {
  if (typeof value !== "object" || !value || value.constructor !== Object) return false;
  return isEmpty(value);
};

var jsonToFormData = function jsonToFormData(object, prependedFieldName, formData, base) {
  if (formData === void 0) {
    formData = new FormData();
  }

  if (base === void 0) {
    base = true;
  }

  Object.keys(object).forEach(function (key) {
    if (Array.isArray(object[key])) {
      object[key].forEach(function (field, index) {
        if (typeof field === "object") {
          prependedFieldName ? jsonToFormData(field, prependedFieldName + "[" + key + "[" + index + "]", formData, false) : jsonToFormData(field, key + "[" + index + "]", formData, true);
        } else {
          prependedFieldName ? formData.append(prependedFieldName + "[" + key + "][]", field) : formData.append(key + "[]", field);
        }
      });
    } else if (object[key] && object[key] instanceof moment) {
      prependedFieldName ? formData.append(prependedFieldName + "[" + key + "]" + (base ? "" : "]"), object[key].format()) : formData.append("" + key, object[key].format());
    } else if (object[key] && typeof object[key] === "object" && Object.keys(object[key]).length > 0) {
      prependedFieldName ? jsonToFormData(object[key], prependedFieldName + "[" + key, formData, false) : jsonToFormData(object[key], "" + key, formData, true);
    } else if (object[key] !== null && object[key] !== undefined) {
      if (isEmptyObject(object[key])) return;
      prependedFieldName ? formData.append(prependedFieldName + "[" + key + "]" + (base ? "" : "]"), object[key]) : formData.append("" + key, object[key]);
    }
  });
  return formData;
};

var fetch$1 = createActions$1("APIEntities");
var createSuccess = createAction("createSuccess");
var updateSuccess = createAction("updateSuccess");
var deleteSuccess = createAction("deleteSuccess");
var _excluded$p = ["entity", "page", "rowsPerPage", "query", "showAll", "isExporting", "customEntityName", "routeState", "authenticated"],
    _excluded2$4 = ["entity", "id", "customEntityName"],
    _excluded3$1 = ["entity", "id", "customEntityName", "endpoint", "field", "fieldUniqueId", "schemaAccessor"];

var _marked = /*#__PURE__*/_regeneratorRuntime().mark(importSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(listSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(showSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(createSaga),
    _marked5 = /*#__PURE__*/_regeneratorRuntime().mark(editSaga),
    _marked6 = /*#__PURE__*/_regeneratorRuntime().mark(deleteSaga),
    _marked7 = /*#__PURE__*/_regeneratorRuntime().mark(bulkActionsSaga),
    _marked8 = /*#__PURE__*/_regeneratorRuntime().mark(apiFieldsSourceSaga);

var entitiesCustomSagas = function entitiesCustomSagas(entities) {
  var customSagas = [];
  Object.keys(entities).filter(function (entityName) {
    return entities[entityName].customSagas && !entities[entityName].isReferenced;
  }).forEach(function (entityName) {
    return customSagas = [].concat(customSagas, entities[entityName].customSagas);
  });
  return customSagas;
};

function importSaga(action) {
  var _action$payload, entity, data, config, endpoint, method, requestParams, afterImportRedirectPath, _adminConfigs$getConf, privateRouteURL, params, globalState, _error$response;

  return _regeneratorRuntime().wrap(function importSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, entity = _action$payload.entity, data = _action$payload.data, config = _action$payload.config;
          endpoint = config.endpoint, method = config.method, requestParams = config.requestParams, afterImportRedirectPath = config.afterImportRedirectPath;
          _adminConfigs$getConf = adminConfigs.getConfigs(), privateRouteURL = _adminConfigs$getConf.privateRouteURL;
          params = entity.applyCustomRequestParams("entity", requestParams);
          _context.prev = 4;
          _context.next = 7;
          return call$1(request, {
            url: endpoint,
            method: method,
            authenticated: true,
            data: jsonToFormData(data, entity.serverName),
            params: params
          });

        case 7:
          _context.next = 9;
          return put(entitiesActions[entity.name]["import"].success());

        case 9:
          entity.handleNotification("importSuccess");
          _context.next = 12;
          return select$2();

        case 12:
          globalState = _context.sent;
          _context.next = 15;
          return put(push(afterImportRedirectPath ? afterImportRedirectPath(globalState) : getURL(privateRouteURL, entity.pathName)));

        case 15:
          _context.next = 22;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](4);
          _context.next = 21;
          return put(entitiesActions[entity.name]["import"].failure());

        case 21:
          entity.handleNotification("importError", (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data);

        case 22:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[4, 17]]);
}

function listSaga(action) {
  var _action$payload2, entity, page, rowsPerPage, query, showAll, isExporting, customEntityName, routeState, _action$payload2$auth, authenticated, additionalParams, storeEntity, params, endpoint, response, _error$response2, errorMessage, _entity$parentEntity, _entity$parentEntity2, _entity$parentEntity3;

  return _regeneratorRuntime().wrap(function listSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload2 = action.payload, entity = _action$payload2.entity, page = _action$payload2.page, rowsPerPage = _action$payload2.rowsPerPage, query = _action$payload2.query, showAll = _action$payload2.showAll, isExporting = _action$payload2.isExporting, customEntityName = _action$payload2.customEntityName, routeState = _action$payload2.routeState, _action$payload2$auth = _action$payload2.authenticated, authenticated = _action$payload2$auth === void 0 ? true : _action$payload2$auth, additionalParams = _objectWithoutPropertiesLoose(_action$payload2, _excluded$p);
          _context2.prev = 1;
          _context2.next = 4;
          return select$2(getEntity, customEntityName || entity.pluralName);

        case 4:
          storeEntity = _context2.sent;
          params = _extends({
            page: page || storeEntity.currentPage,
            per_page: rowsPerPage || storeEntity.rowsPerPage,
            show_all: showAll
          }, filtersToAttributes(entity, _extends({}, storeEntity, action.payload)), additionalParams);

          if (entity.showSearch) {
            params.query = query === "" || query ? query : storeEntity.query;
          }

          params = entity.applyCustomRequestParams(isExporting ? "export" : "list", params, routeState);

          if (isEmpty$1(entity.dynamicFilters)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 11;
          return cancel();

        case 11:
          endpoint = entity.getEndpointForAction("list", action.payload);
          _context2.next = 14;
          return call$1(request, {
            url: endpoint,
            method: "get",
            authenticated: authenticated,
            isDownloading: isExporting,
            params: params
          });

        case 14:
          response = _context2.sent;

          if (!isExporting) {
            _context2.next = 22;
            break;
          }

          _context2.next = 18;
          return put(entitiesActions[entity.name]["export"].success());

        case 18:
          _context2.next = 20;
          return call$1(saveAs, response.data, entity.get(["export", "fileName"]) + "." + entity.get(["export", "extension"]));

        case 20:
          _context2.next = 24;
          break;

        case 22:
          _context2.next = 24;
          return put(entitiesActions[customEntityName || entity.name].list.success({
            data: response.data[entity.serverPluralName],
            meta: response.data.meta
          }));

        case 24:
          _context2.next = 38;
          break;

        case 26:
          _context2.prev = 26;
          _context2.t0 = _context2["catch"](1);
          errorMessage = (_error$response2 = _context2.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data;

          if (!isExporting) {
            _context2.next = 35;
            break;
          }

          _context2.next = 32;
          return put(entitiesActions[entity.name]["export"].failure());

        case 32:
          entity.handleNotification("exportError", errorMessage);
          _context2.next = 38;
          break;

        case 35:
          _context2.next = 37;
          return put(entitiesActions[customEntityName || entity.name].list.failure());

        case 37:
          entity.handleNotification("listError", errorMessage);

        case 38:
          _context2.prev = 38;

          if (!(entity.isFilter && (_entity$parentEntity = entity.parentEntity) !== null && _entity$parentEntity !== void 0 && _entity$parentEntity.dynamicFilters && !((_entity$parentEntity2 = entity.parentEntity) !== null && _entity$parentEntity2 !== void 0 && (_entity$parentEntity3 = _entity$parentEntity2.dynamicFilters) !== null && _entity$parentEntity3 !== void 0 && _entity$parentEntity3[entity.filterName]))) {
            _context2.next = 44;
            break;
          }

          delete entity.parentEntity.dynamicFilters[entity.filterName];

          if (!isEmpty$1(entity.parentEntity.dynamicFilters)) {
            _context2.next = 44;
            break;
          }

          _context2.next = 44;
          return put(entitiesActions[entity.parentEntity.name].list.filtersFetched({
            fetched: true
          }));

        case 44:
          return _context2.finish(38);

        case 45:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 26, 38, 45]]);
}

function showSaga(action) {
  var _action$payload3, entity, customEntityName, additionalParams, params, endpoint, response;

  return _regeneratorRuntime().wrap(function showSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload3 = action.payload, entity = _action$payload3.entity, customEntityName = _action$payload3.customEntityName, additionalParams = _objectWithoutPropertiesLoose(_action$payload3, _excluded2$4);
          params = entity.applyCustomRequestParams("show", additionalParams);
          endpoint = entity.getEndpointForAction("show", action.payload);
          _context3.prev = 3;
          _context3.next = 6;
          return call$1(request, {
            url: endpoint,
            method: "get",
            authenticated: true,
            params: params
          });

        case 6:
          response = _context3.sent;
          _context3.next = 9;
          return put(entitiesActions[customEntityName || entity.name].show.success(response.data[entity.serverName]));

        case 9:
          _context3.next = 16;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](3);
          _context3.next = 15;
          return put(entitiesActions[customEntityName || entity.name].show.failure(_context3.t0.response.data));

        case 15:
          entity.handleNotification("showError", _context3.t0.response.data);

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[3, 11]]);
}

function createSaga(action) {
  var _action$payload4, entity, data, customEntityName, refetch, _adminConfigs$getConf2, privateRouteURL, params, endpoint, _ref, response, responseData, globalState;

  return _regeneratorRuntime().wrap(function createSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _action$payload4 = action.payload, entity = _action$payload4.entity, data = _action$payload4.data, customEntityName = _action$payload4.customEntityName, refetch = _action$payload4.refetch;
          _adminConfigs$getConf2 = adminConfigs.getConfigs(), privateRouteURL = _adminConfigs$getConf2.privateRouteURL;
          params = entity.applyCustomRequestParams("create");
          endpoint = entity.getEndpointForAction("create", action.payload);
          _context4.prev = 4;
          _context4.next = 7;
          return call$1(request, {
            url: endpoint,
            method: "post",
            authenticated: true,
            data: entity.useFormData ? jsonToFormData(data, entity.serverName) : (_ref = {}, _ref[entity.serverName] = data, _ref),
            params: params
          });

        case 7:
          response = _context4.sent;
          responseData = response.data[entity.serverName] || {};
          _context4.next = 11;
          return put(entitiesActions[customEntityName || entity.name].create.success(responseData));

        case 11:
          if (!refetch) {
            _context4.next = 14;
            break;
          }

          _context4.next = 14;
          return put(entitiesActions[entity.name].list.request({
            entity: entity
          }));

        case 14:
          if (!entity.isAPIEntitiesSource()) {
            _context4.next = 17;
            break;
          }

          _context4.next = 17;
          return put(createSuccess(responseData));

        case 17:
          entity.handleNotification("createSuccess", responseData);
          _context4.next = 20;
          return select$2();

        case 20:
          globalState = _context4.sent;

          if (entity.isPassive) {
            _context4.next = 24;
            break;
          }

          _context4.next = 24;
          return put(push(entity.afterCreateRedirectPath ? entity.afterCreateRedirectPath(globalState) : getURL(privateRouteURL, entity.pathName)));

        case 24:
          _context4.next = 31;
          break;

        case 26:
          _context4.prev = 26;
          _context4.t0 = _context4["catch"](4);
          _context4.next = 30;
          return put(entitiesActions[customEntityName || entity.name].create.failure(_context4.t0.response.data));

        case 30:
          entity.handleNotification("createError", _context4.t0.response.data);

        case 31:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[4, 26]]);
}

function editSaga(action) {
  var _action$payload5, entity, id, data, customEntityName, refetch, _adminConfigs$getConf3, privateRouteURL, params, endpoint, _ref2, response, responseData, globalState;

  return _regeneratorRuntime().wrap(function editSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _action$payload5 = action.payload, entity = _action$payload5.entity, id = _action$payload5.id, data = _action$payload5.data, customEntityName = _action$payload5.customEntityName, refetch = _action$payload5.refetch;
          _adminConfigs$getConf3 = adminConfigs.getConfigs(), privateRouteURL = _adminConfigs$getConf3.privateRouteURL;
          params = entity.applyCustomRequestParams("edit");
          endpoint = entity.getEndpointForAction("edit", action.payload);
          _context5.prev = 4;
          _context5.next = 7;
          return call$1(request, {
            url: endpoint,
            method: "put",
            authenticated: true,
            data: entity.useFormData ? jsonToFormData(data, entity.serverName) : (_ref2 = {}, _ref2[entity.serverName] = data, _ref2),
            params: params
          });

        case 7:
          response = _context5.sent;
          responseData = response.data[entity.serverName];
          _context5.next = 11;
          return put(entitiesActions[customEntityName || entity.name].edit.success(responseData));

        case 11:
          if (!refetch) {
            _context5.next = 14;
            break;
          }

          _context5.next = 14;
          return put(entitiesActions[entity.name].list.request({
            entity: entity
          }));

        case 14:
          if (!entity.isAPIEntitiesSource()) {
            _context5.next = 17;
            break;
          }

          _context5.next = 17;
          return put(updateSuccess(responseData));

        case 17:
          entity.handleNotification("editSuccess", responseData);
          _context5.next = 20;
          return select$2();

        case 20:
          globalState = _context5.sent;

          if (entity.isPassive) {
            _context5.next = 24;
            break;
          }

          _context5.next = 24;
          return put(push(entity.afterEditRedirectPath ? entity.afterEditRedirectPath(globalState) : getURL(privateRouteURL, entity.pathName)));

        case 24:
          _context5.next = 31;
          break;

        case 26:
          _context5.prev = 26;
          _context5.t0 = _context5["catch"](4);
          _context5.next = 30;
          return put(entitiesActions[customEntityName || entity.name].edit.failure({
            errors: _context5.t0.response.data,
            current: _extends({
              id: id
            }, data)
          }));

        case 30:
          entity.handleNotification("editError", _context5.t0.response.data);

        case 31:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[4, 26]]);
}

function deleteSaga(action) {
  var _action$payload6, entity, id, params, endpoint, _error$response3;

  return _regeneratorRuntime().wrap(function deleteSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _action$payload6 = action.payload, entity = _action$payload6.entity, id = _action$payload6.id;
          params = entity.applyCustomRequestParams("delete");
          endpoint = entity.getEndpointForAction("delete", action.payload);
          _context6.prev = 3;
          _context6.next = 6;
          return call$1(request, {
            url: endpoint,
            method: "delete",
            authenticated: true,
            params: params
          });

        case 6:
          _context6.next = 8;
          return put(entitiesActions[entity.name]["delete"].success(id));

        case 8:
          if (!entity.isAPIEntitiesSource()) {
            _context6.next = 11;
            break;
          }

          _context6.next = 11;
          return put(deleteSuccess({
            id: id
          }));

        case 11:
          entity.handleNotification("deleteSuccess", {
            id: id
          });
          _context6.next = 19;
          break;

        case 14:
          _context6.prev = 14;
          _context6.t0 = _context6["catch"](3);
          _context6.next = 18;
          return put(entitiesActions[entity.name]["delete"].failure());

        case 18:
          entity.handleNotification("deleteError", (_error$response3 = _context6.t0.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data);

        case 19:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[3, 14]]);
}

function bulkActionsSaga(action) {
  var _action$payload7, entity, data, bulkConfigs, sagaConfigs, _ref3;

  return _regeneratorRuntime().wrap(function bulkActionsSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _action$payload7 = action.payload, entity = _action$payload7.entity, data = _action$payload7.data, bulkConfigs = _action$payload7.bulkConfigs, sagaConfigs = _action$payload7.sagaConfigs;
          _context7.prev = 1;
          _context7.next = 4;
          return call$1(request, {
            url: "" + bulkConfigs.endpoint,
            method: bulkConfigs.method,
            authenticated: true,
            data: entity.useFormData ? jsonToFormData(data, entity.serverName) : (_ref3 = {}, _ref3[entity.serverName] = data, _ref3)
          });

        case 4:
          _context7.next = 6;
          return put(entitiesActions[entity.name][sagaConfigs.actionName].success(data));

        case 6:
          entity.handleNotification(sagaConfigs.success);
          _context7.next = 14;
          break;

        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](1);
          _context7.next = 13;
          return put(entitiesActions[entity.name][sagaConfigs.actionName].failure());

        case 13:
          entity.handleNotification(sagaConfigs.error);

        case 14:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[1, 9]]);
}

function apiFieldsSourceSaga(action) {
  var _action$payload8, entity, customEntityName, field, fieldUniqueId, schemaAccessor, additionalParams, params, url, response, firstKey;

  return _regeneratorRuntime().wrap(function apiFieldsSourceSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _action$payload8 = action.payload, entity = _action$payload8.entity, customEntityName = _action$payload8.customEntityName, field = _action$payload8.field, fieldUniqueId = _action$payload8.fieldUniqueId, schemaAccessor = _action$payload8.schemaAccessor, additionalParams = _objectWithoutPropertiesLoose(_action$payload8, _excluded3$1);
          params = entity.applyCustomRequestParams("apiFieldsSource", additionalParams);
          _context8.prev = 2;
          url = entity.getApiFieldsSourceEndpoint(field, params);

          if (!url) {
            _context8.next = 13;
            break;
          }

          _context8.next = 7;
          return call$1(request, {
            url: url,
            method: "get",
            authenticated: true,
            params: params
          });

        case 7:
          response = _context8.sent;
          firstKey = Object.keys(response.data)[0];
          _context8.next = 11;
          return put(entitiesActions[customEntityName || entity.name].apiFieldsSource.success(_extends({}, response.data[entity.serverName || firstKey], {
            fieldUniqueId: fieldUniqueId,
            schemaAccessor: schemaAccessor
          })));

        case 11:
          _context8.next = 15;
          break;

        case 13:
          _context8.next = 15;
          return put(entitiesActions[customEntityName || entity.name].apiFieldsSource.failure({
            fieldUniqueId: fieldUniqueId
          }));

        case 15:
          _context8.next = 21;
          break;

        case 17:
          _context8.prev = 17;
          _context8.t0 = _context8["catch"](2);
          _context8.next = 21;
          return put(entitiesActions[customEntityName || entity.name].apiFieldsSource.failure(_extends({}, _context8.t0.response.data, {
            fieldUniqueId: fieldUniqueId
          })));

        case 21:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[2, 17]]);
}

var generatorSagas = function generatorSagas(actions) {
  return [/*#__PURE__*/_regeneratorRuntime().mark(function watchEntityFetchAll() {
    return _regeneratorRuntime().wrap(function watchEntityFetchAll$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return takeEvery(getActionsArrayOf("list", actions), listSaga);

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, watchEntityFetchAll);
  }), /*#__PURE__*/_regeneratorRuntime().mark(function watchEntityFetchOne() {
    return _regeneratorRuntime().wrap(function watchEntityFetchOne$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return takeEvery(getActionsArrayOf("show", actions), showSaga);

          case 2:
          case "end":
            return _context10.stop();
        }
      }
    }, watchEntityFetchOne);
  }), /*#__PURE__*/_regeneratorRuntime().mark(function watchEntityCreate() {
    return _regeneratorRuntime().wrap(function watchEntityCreate$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return takeLatest(getActionsArrayOf("create", actions), createSaga);

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, watchEntityCreate);
  }), /*#__PURE__*/_regeneratorRuntime().mark(function watchEntityEdit() {
    return _regeneratorRuntime().wrap(function watchEntityEdit$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return takeLatest(getActionsArrayOf("edit", actions), editSaga);

          case 2:
          case "end":
            return _context12.stop();
        }
      }
    }, watchEntityEdit);
  }), /*#__PURE__*/_regeneratorRuntime().mark(function watchEntityDelete() {
    return _regeneratorRuntime().wrap(function watchEntityDelete$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return takeLatest(getActionsArrayOf("delete", actions), deleteSaga);

          case 2:
          case "end":
            return _context13.stop();
        }
      }
    }, watchEntityDelete);
  }), /*#__PURE__*/_regeneratorRuntime().mark(function watchEntityExport() {
    return _regeneratorRuntime().wrap(function watchEntityExport$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return takeLatest(getActionsArrayOf("export", actions), listSaga);

          case 2:
          case "end":
            return _context14.stop();
        }
      }
    }, watchEntityExport);
  }), /*#__PURE__*/_regeneratorRuntime().mark(function watchEntityImport() {
    return _regeneratorRuntime().wrap(function watchEntityImport$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return takeLatest(getActionsArrayOf("import", actions), importSaga);

          case 2:
          case "end":
            return _context15.stop();
        }
      }
    }, watchEntityImport);
  }), /*#__PURE__*/_regeneratorRuntime().mark(function watchEntityBulkAction() {
    return _regeneratorRuntime().wrap(function watchEntityBulkAction$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return takeLatest([].concat(getActionsArrayOf("bulkActions", actions), [getActionsArrayOf("deleteMultiple", actions)]), bulkActionsSaga);

          case 2:
          case "end":
            return _context16.stop();
        }
      }
    }, watchEntityBulkAction);
  }), /*#__PURE__*/_regeneratorRuntime().mark(function watchApiFieldsSource() {
    return _regeneratorRuntime().wrap(function watchApiFieldsSource$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return takeEvery(getActionsArrayOf("apiFieldsSource", actions), apiFieldsSourceSaga);

          case 2:
          case "end":
            return _context17.stop();
        }
      }
    }, watchApiFieldsSource);
  })];
};

var useProfileAuthorizationCheck = function useProfileAuthorizationCheck(currentProfile, storedRole, authConfig) {
  var dispatch = useDispatch();
  var willDoProfileAuthorizationCheck = useRef(authConfig.enableProfileAuthorizationCheck);
  useEffect(function () {
    if (willDoProfileAuthorizationCheck.current && storedRole) {
      dispatch(authActionShow.request({
        authConfig: authConfig,
        isProfileAuthorizationCheck: true
      }));
    }
  }, [dispatch, storedRole, authConfig]);
  useEffect(function () {
    if (currentProfile !== null && currentProfile !== void 0 && currentProfile.role && willDoProfileAuthorizationCheck.current) {
      willDoProfileAuthorizationCheck.current = false;

      if (currentProfile.role !== storedRole) {
        addToLocalStorage(authConfig.name, currentProfile);
        dispatch(updateAuth(currentProfile));
      }
    }
  }, [currentProfile, storedRole, dispatch, authConfig]);
};

var _excluded$q = ["current_page", "total_entries", "per_page", "next_page"],
    _excluded2$5 = ["fieldUniqueId", "schemaAccessor"];

var preloadedState = function preloadedState(entity) {
  if (entity.isApiFieldsSource()) {
    return {
      current: null,
      data: {},
      loading: {}
    };
  }

  return _extends({
    data: [],
    current: {},
    loading: false,
    errors: {},
    currentPage: 1,
    rowsPerPage: entity.rowsPerPage || 10,
    totalEntries: 0,
    filtersFetched: false,
    filteredColumns: {},
    isFormModalOpen: false
  }, getFiltersDefaultValues(entity.filters), entity.showSearch && {
    query: ""
  });
};

var generatorReducers = function generatorReducers(role, entities) {
  var reducers = Object.keys(entitiesActions).reduce(function (accum, entityName) {
    var _entityReducers;

    var currentEntity = entities[entityName];
    if (!currentEntity.canUse(role)) return accum;
    var actions = entitiesActions[entityName];
    var entityReducers = (_entityReducers = {}, _entityReducers[actions.list.request] = function (state, action) {
      state.loading = true;
      var _action$payload = action.payload,
          entity = _action$payload.entity,
          query = _action$payload.query,
          resetFilters = _action$payload.resetFilters,
          column = _action$payload.column;
      state.resetFilters = resetFilters;
      delete action.payload.resetFilters;
      if (resetFilters) state.filteredColumns = {};else if (column) {
        state.filteredColumns[column.key] = column.value;
        delete action.payload.column;
      }

      if (entity.showSearch) {
        if (query === "" || query) state.query = query;
      }

      Object.keys(filtersToAttributes(entity, action.payload)).forEach(function (key) {
        if (action.payload[key] === null) state[key] = null;else if (action.payload[key] || action.payload[key] === "") state[key] = action.payload[key];else state[key] = state[key] || null;
        state[key + "_label"] = action.payload[key + "_label"] === null ? null : action.payload[key + "_label"] || state[key + "_label"];
        delete action.payload[key + "_label"];
      });
    }, _entityReducers[actions.list.success] = function (state, action) {
      var _action$payload2 = action.payload,
          data = _action$payload2.data,
          _action$payload2$meta = _action$payload2.meta,
          meta = _action$payload2$meta === void 0 ? {} : _action$payload2$meta;
      state.loading = false;
      state.data = data;

      var current_page = meta.current_page,
          total_entries = meta.total_entries,
          per_page = meta.per_page,
          next_page = meta.next_page,
          restMeta = _objectWithoutPropertiesLoose(meta, _excluded$q);

      state.currentPage = current_page;
      state.totalEntries = total_entries;
      state.rowsPerPage = per_page || 10;
      state.nextPage = next_page;
      Object.keys(restMeta).map(function (key) {
        state[key] = restMeta[key];
      });
    }, _entityReducers[actions.list.reset] = function () {
      return preloadedState(currentEntity);
    }, _entityReducers[actions.list.resetErrors] = function (state) {
      state.errors = {};
    }, _entityReducers[actions.list.filtersFetched] = function (state, action) {
      state.filtersFetched = action.payload.fetched;
    }, _entityReducers[actions.list.failure] = function (state, action) {
      state.loading = false;
      state.errors = action.payload || {
        message: "there was an error"
      };
    }, _entityReducers[actions.show.request] = function (state, action) {
      state.loading = true;
      state.current = {};
    }, _entityReducers[actions.show.success] = function (state, action) {
      state.loading = false;
      state.current = action.payload;
    }, _entityReducers[actions.show.failure] = function (state, action) {
      state.loading = false;
      state.errors = action.payload || {
        message: "there was an error"
      };
    }, _entityReducers[actions.form.reset] = function () {
      return preloadedState(currentEntity);
    }, _entityReducers[actions.form.resetErrors] = function (state) {
      state.errors = {};
    }, _entityReducers[actions.form.openFormModal] = function (state) {
      state.isFormModalOpen = true;
    }, _entityReducers[actions.form.closeFormModal] = function (state) {
      state.isFormModalOpen = false;
    }, _entityReducers[actions.form.cancelFormModal] = function (state) {
      preloadedState(currentEntity);
      state.errors = {};
      state.isFormModalOpen = false;
    }, _entityReducers);

    if (currentEntity.canCreate(role)) {
      var _extends2;

      entityReducers = _extends({}, entityReducers, (_extends2 = {}, _extends2[actions.create.request] = function (state, action) {
        state.loading = true;
        state.errors = {};
      }, _extends2[actions.create.success] = function (state, action) {
        state.loading = false;
        state.errors = {};
        state.data.push(action.payload);
        state.isFormModalOpen = false;
      }, _extends2[actions.create.failure] = function (state, action) {
        state.loading = false;
        state.errors = action.payload || {
          message: "there was an error"
        };
      }, _extends2));
    }

    if (currentEntity.canEdit(role)) {
      var _extends3;

      entityReducers = _extends({}, entityReducers, (_extends3 = {}, _extends3[actions.edit.request] = function (state, action) {
        state.loading = true;
        state.errors = {};
      }, _extends3[actions.edit.success] = function (state, action) {
        state.loading = false;
        state.errors = {};
        var index = state.data.findIndex(function (el) {
          return currentEntity.compareIdentifierValue(el, action.payload.id);
        });
        state.data[index] = action.payload;
        state.isFormModalOpen = false;
      }, _extends3[actions.edit.failure] = function (state, action) {
        state.loading = false;
        state.current = _extends({}, state.current, action.payload.current);
        state.errors = action.payload.errors || {
          message: "there was an error"
        };
      }, _extends3));
    }

    if (currentEntity.canDelete(role)) {
      var _extends4;

      entityReducers = _extends({}, entityReducers, (_extends4 = {}, _extends4[actions["delete"].request] = function (state, action) {
        state.loading = true;
      }, _extends4[actions["delete"].success] = function (state, action) {
        state.loading = false;
        var index = state.data.findIndex(function (el) {
          return currentEntity.compareIdentifierValue(el, action.payload);
        });
        state.data.splice(index, 1);
        state.totalEntries -= 1;
      }, _extends4[actions["delete"].failure] = function (state, action) {
        state.loading = false;
        state.errors = action.payload || {
          message: "there was an error"
        };
      }, _extends4));
    }

    if (currentEntity.canExport(role)) {
      var _extends5;

      entityReducers = _extends({}, entityReducers, (_extends5 = {}, _extends5[actions["export"].request] = function (state, action) {
        state.loading = true;
      }, _extends5[actions["export"].success] = function (state, action) {
        state.loading = false;
      }, _extends5[actions["export"].failure] = function (state, action) {
        state.loading = false;
        state.errors = action.payload || {
          message: "there was an error"
        };
      }, _extends5));
    }

    if (currentEntity.canImport(role)) {
      var _extends6;

      entityReducers = _extends({}, entityReducers, (_extends6 = {}, _extends6[actions["import"].request] = function (state, action) {
        state.loading = true;
      }, _extends6[actions["import"].success] = function (state, action) {
        state.loading = false;
        state.modalOpenStatus = false;
      }, _extends6[actions["import"].failure] = function (state, action) {
        state.loading = false;
        state.errors = action.payload || {
          message: "An error occured while importing your file."
        };
      }, _extends6[actions["import"].toggleDialogStatus] = function (state, action) {
        state.modalOpenStatus = action.payload.open;
      }, _extends6));
    }

    var subscribedEvents = currentEntity.getSubscribedEvents();

    if (subscribedEvents) {
      var eventReducers = {
        create: function create(state, action) {
          state.data.unshift(action.payload);
          state.totalEntries += 1;
        },
        "delete": function _delete(state, action) {
          var index = state.data.findIndex(function (el) {
            return currentEntity.compareIdentifierValue(el, action.payload.id);
          });
          if (index !== -1) state.data.splice(index, 1);
          state.totalEntries -= 1;
        },
        edit: function edit(state, action) {
          var index = state.data.findIndex(function (el) {
            return currentEntity.compareIdentifierValue(el, action.payload.id);
          });
          if (index !== -1) state.data[index] = action.payload;
        }
      };
      var subscribedEventReducers = subscribedEvents.reduce(function (accum, event) {
        accum[actions.eventSubscriptions[event]] = eventReducers[event];
        return accum;
      }, {});
      entityReducers = _extends({}, entityReducers, subscribedEventReducers);
    }

    if (currentEntity.isApiFieldsSource()) {
      var _extends7;

      entityReducers = _extends({}, entityReducers, (_extends7 = {}, _extends7[actions.apiFieldsSource.request] = function (state, action) {
        var fieldUniqueId = action.payload.fieldUniqueId;
        state.loading[fieldUniqueId] = true;
      }, _extends7[actions.apiFieldsSource.success] = function (state, action) {
        var _action$payload3 = action.payload,
            fieldUniqueId = _action$payload3.fieldUniqueId,
            schemaAccessor = _action$payload3.schemaAccessor,
            data = _objectWithoutPropertiesLoose(_action$payload3, _excluded2$5);

        state.loading[fieldUniqueId] = false;
        state.current = data;
        state.data[action.payload[schemaAccessor] || action.payload.id] = action.payload;
      }, _extends7[actions.apiFieldsSource.failure] = function (state, action) {
        var fieldUniqueId = action.payload.fieldUniqueId;
        state.loading[fieldUniqueId] = false;
      }, _extends7));
    }

    if (!currentEntity.isReferenced && typeof entities[entityName].customReducers === "object") {
      entityReducers = _extends({}, entityReducers, entities[entityName].customReducers);
    }

    accum[entities[entityName].isReferenced ? entityName : entities[entityName].pluralName] = createReducer(preloadedState(currentEntity), entityReducers);
    return accum;
  }, {});
  return reducers;
};

var _createReducer;

var success = validatePinPoint.success,
    request$1 = validatePinPoint.request,
    failure = validatePinPoint.failure;
var reducer$2 = createReducer({
  current: {}
}, (_createReducer = {}, _createReducer[request$1] = function (state, action) {
  var id = action.payload.id;
  state.current[id] = {
    loading: true,
    errors: {}
  };
}, _createReducer[success] = function (state, action) {
  var id = action.payload.id;
  state.current[id] = _extends({}, action.payload, {
    loading: false
  });
}, _createReducer[failure] = function (state, action) {
  var _action$payload = action.payload,
      id = _action$payload.id,
      errors = _action$payload.errors;
  state.current[id] = {
    errors: errors || "there was an error",
    loading: false
  };
}, _createReducer[resetPin] = function (state, action) {
  var id = action.payload.id;
  delete state.current[id];
}, _createReducer));

var _createReducer$1;

var successScan = scanItem.success,
    requestScan = scanItem.request,
    failureScan = scanItem.failure;
var successRemove = removeItem.success,
    requestRemove = removeItem.request,
    failureRemove = removeItem.failure;
var reducer$3 = createReducer({
  current: [],
  loading: false,
  errors: {}
}, (_createReducer$1 = {}, _createReducer$1[setInitialData] = function (state, action) {
  state.current = action.payload.current;
}, _createReducer$1[requestScan] = function (state, action) {
  state.loading = true;
  state.errors = {};
}, _createReducer$1[successScan] = function (state, action) {
  state.loading = false;
  var index = state.current.findIndex(function (value) {
    return value.id === action.payload.id;
  });
  state.current[index] = action.payload;
}, _createReducer$1[failureScan] = function (state, action) {
  state.loading = false;
  state.errors = action.payload || {
    errors: ["There was an error in scanning item"]
  };
}, _createReducer$1[requestRemove] = function (state, action) {
  state.loading = true;
  state.errors = {};
}, _createReducer$1[successRemove] = function (state, action) {
  state.loading = false;
  var index = state.current.findIndex(function (value) {
    return value.id === action.payload.id;
  });
  state.current[index] = action.payload;
}, _createReducer$1[failureRemove] = function (state, action) {
  state.loading = false;
  state.errors = action.payload || {
    errors: ["There was an error in scanning item"]
  };
}, _createReducer$1));

var _createReducer$2;

var dashboardReducer = createReducer({
  dashboard: {},
  loading: false
}, (_createReducer$2 = {}, _createReducer$2[dashboardData.request] = function (state) {
  state.loading = true;
}, _createReducer$2[dashboardData.success] = function (state, action) {
  state.dashboard.current = action.payload;
  state.loading = false;
}, _createReducer$2[dashboardData.failure] = function (state) {
  state.loading = false;
}, _createReducer$2[dashboardGroupData.request] = function (state, action) {
  var id = action.payload.id;
  state[id] = {
    loading: true
  };
}, _createReducer$2[dashboardGroupData.success] = function (state, action) {
  var id = action.payload.id;
  state[id] = _extends({
    loading: false
  }, action.payload);
}, _createReducer$2[dashboardGroupData.failure] = function (state, action) {
  var id = action.payload.id;
  state[id] = {
    loading: false
  };
}, _createReducer$2));

var _createReducer$3;

var displayInfoReducer = createReducer({}, (_createReducer$3 = {}, _createReducer$3[displayInfoData.request] = function (state, action) {
  var id = action.payload.id;
  state[id] = {
    loading: true
  };
}, _createReducer$3[displayInfoData.success] = function (state, action) {
  var id = action.payload.id;
  state[id] = _extends({
    loading: false
  }, action.payload);
}, _createReducer$3[displayInfoData.failure] = function (state, action) {
  var id = action.payload.id;
  state[id] = {
    loading: false
  };
}, _createReducer$3));

var _createReducer$4;

var initialState = {
  data: [],
  loading: false,
  errors: {},
  ids: [],
  entities: {},
  syncCounter: 0
};
var reducer$4 = createReducer(initialState, (_createReducer$4 = {}, _createReducer$4[fetch$1.request] = function (state, action) {
  state.loading = true;
}, _createReducer$4[fetch$1.success] = function (state, action) {
  state.data = action.payload;
  action.payload.forEach(function (entity) {
    state.ids.push(entity.id);
    state.entities[entity.id] = entity;
  });
  state.loading = false;
  state.syncCounter += 1;
}, _createReducer$4[fetch$1.failure] = function (state, action) {
  state.errors = action.payload;
  state.loading = false;
}, _createReducer$4[createSuccess] = function (state, action) {
  var id = action.payload.id;
  state.ids.push(id);
  state.entities[id] = action.payload;
  state.syncCounter += 1;
}, _createReducer$4[updateSuccess] = function (state, action) {
  var id = action.payload.id;
  state.entities[id] = action.payload;
  state.syncCounter += 1;
}, _createReducer$4[deleteSuccess] = function (state, action) {
  var id = action.payload.id;
  delete state.entities[id];
  state.ids = state.ids.filter(function (storeId) {
    return storeId !== id;
  });
  state.syncCounter += 1;
}, _createReducer$4));

var rootReducer = function rootReducer(role, entities) {
  var _adminConfigs$getConf = adminConfigs.getConfigs(),
      notificationConfigs = _adminConfigs$getConf.notificationConfigs,
      apiEntitiesConfig = _adminConfigs$getConf.apiEntitiesConfig;

  return _extends({}, generatorReducers(role, entities), {
    maps: reducer$2,
    dashboard: dashboardReducer,
    scan: reducer$3,
    displayInfo: displayInfoReducer
  }, notificationConfigs.enabled && {
    notifications: notificationsSlice.reducer,
    firebaseTokens: firebaseTokensSlice.reducer
  }, apiEntitiesConfig.enabled && {
    apiEntities: reducer$4
  });
};

var APIEntityBuilder = /*#__PURE__*/function () {
  function APIEntityBuilder(entitySchema, config) {
    if (config === void 0) {
      config = {};
    }

    var _config = config,
        _config$overrides = _config.overrides,
        overrides = _config$overrides === void 0 ? {} : _config$overrides,
        valueAccessorName = _config.valueAccessorName;
    this.entitySchema = entitySchema;
    this.fieldsSchema = entitySchema.schema;
    this.overrides = overrides;
    this.valueAccessorName = valueAccessorName;
    this.config = config;
  }

  var _proto = APIEntityBuilder.prototype;

  _proto.build = function build() {
    var _this = this;

    var entity = new Entity(_extends({}, this.entityConfig(), {
      fields: []
    }));
    this.fieldsSchema.map(function (schema) {
      return new SchemaFieldBuilder(schema, {
        entity: entity,
        customConfig: {
          isVirtualField: false,
          inList: true,
          accessor: function accessor(dataObject) {
            var _dataObject$_this$val;

            return _this.valueAccessorName ? (_dataObject$_this$val = dataObject[_this.valueAccessorName]) === null || _dataObject$_this$val === void 0 ? void 0 : _dataObject$_this$val[schema.name] : dataObject[schema.name];
          },
          usedToShow: _this.entitySchema.slug_field_name === schema.name
        }
      }).build();
    });
    return entity;
  };

  _proto.entityConfig = function entityConfig() {
    var _this$entitySchema = this.entitySchema,
        name = _this$entitySchema.name,
        slug = _this$entitySchema.slug,
        _this$entitySchema$al = _this$entitySchema.allowCreate,
        allowCreate = _this$entitySchema$al === void 0 ? true : _this$entitySchema$al,
        _this$entitySchema$al2 = _this$entitySchema.allowEdit,
        allowEdit = _this$entitySchema$al2 === void 0 ? true : _this$entitySchema$al2,
        _this$entitySchema$al3 = _this$entitySchema.allowDelete,
        allowDelete = _this$entitySchema$al3 === void 0 ? true : _this$entitySchema$al3,
        entitySchemaSeverName = _this$entitySchema.server_name,
        entitySchemaServerPluralName = _this$entitySchema.server_plural_name;
    var _this$config = this.config,
        endpointPrefix = _this$config.endpointPrefix,
        serverPluralName = _this$config.serverPluralName,
        serverName = _this$config.serverName;
    var endpointSuffix = slug || entitySchemaServerPluralName;
    var endpoint = endpointPrefix ? endpointPrefix + "/" + endpointSuffix : endpointSuffix;

    var newEntityConfig = _extends({
      name: name,
      pluralName: name,
      endpoint: endpoint,
      serverName: entitySchemaSeverName || serverName,
      serverPluralName: entitySchemaServerPluralName || serverPluralName,
      displayName: name,
      pathName: name,
      allowCreate: allowCreate,
      apiEntity: true,
      allowEdit: allowEdit,
      allowDelete: allowDelete,
      showRowActions: true
    }, this.overrides[name]);

    return newEntityConfig;
  };

  return APIEntityBuilder;
}();

var useAPIEntities = function useAPIEntities(_ref) {
  var didMount = _ref.didMount,
      auth = _ref.auth;
  var apiEntitiesData = useSelector(function (state) {
    return getEntity(state, "apiEntities");
  });
  var isInitialFetchDone = useRef(false);

  var _ref2 = apiEntitiesData || {},
      _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? false : _ref2$loading,
      _ref2$ids = _ref2.ids,
      ids = _ref2$ids === void 0 ? [] : _ref2$ids,
      entities = _ref2.entities,
      syncCounter = _ref2.syncCounter;

  var _adminConfigs$getConf = adminConfigs.getConfigs(),
      apiEntitiesConfig = _adminConfigs$getConf.apiEntitiesConfig;

  var _ref3 = apiEntitiesConfig || {},
      endpoint = _ref3.endpoint,
      serverName = _ref3.serverName,
      enabled = _ref3.enabled,
      entitiesConfig = _ref3.entitiesConfig;

  var dispatch = useDispatch();
  var apiEntities = useMemo(function () {
    return ids.reduce(function (accum, id) {
      var newEntity = new APIEntityBuilder(entities[id], entitiesConfig).build();
      accum[newEntity.name] = newEntity;
      return accum;
    }, {});
  }, [syncCounter]);
  useEffect(function () {
    if (isInitialFetchDone.current || ids.length > 0 || !enabled || !didMount || !auth) return;
    dispatch(fetch$1.request({
      endpoint: endpoint,
      serverName: serverName
    }));
    isInitialFetchDone.current = true;
  }, [didMount, auth]);
  return {
    apiEntities: enabled ? apiEntities : null,
    loading: loading,
    syncCounter: syncCounter
  };
};

var _marked$1 = /*#__PURE__*/_regeneratorRuntime().mark(authEffect),
    _marked2$1 = /*#__PURE__*/_regeneratorRuntime().mark(authShowEffect),
    _marked3$1 = /*#__PURE__*/_regeneratorRuntime().mark(authWatcher),
    _marked4$1 = /*#__PURE__*/_regeneratorRuntime().mark(authShowWatcher),
    _marked5$1 = /*#__PURE__*/_regeneratorRuntime().mark(logoutEffect),
    _marked6$1 = /*#__PURE__*/_regeneratorRuntime().mark(logoutWatcher);

function authEffect(_ref) {
  var _ref$payload, config, credentials, redirectPath, action, entity, setFirebaseToken, url, method, saveToLocalStorage, successMessage, successRedirectPath, failureRedirectPath, useFormData, authenticated, updateAuthAfterSuccess, persistAuthAfterSuccess, enableRedirects, _adminConfigs$getConf, authConfig, publicRouteURL, loginURL, response, _response$data, successRedirect, redirect, _error$response, _error$response2, failureRedirect;

  return _regeneratorRuntime().wrap(function authEffect$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref$payload = _ref.payload, config = _ref$payload.config, credentials = _ref$payload.credentials, redirectPath = _ref$payload.redirectPath, action = _ref$payload.action, entity = _ref$payload.entity, setFirebaseToken = _ref$payload.setFirebaseToken;
          url = config.url, method = config.method, saveToLocalStorage = config.saveToLocalStorage, successMessage = config.successMessage, successRedirectPath = config.successRedirectPath, failureRedirectPath = config.failureRedirectPath, useFormData = config.useFormData, authenticated = config.authenticated, updateAuthAfterSuccess = config.updateAuthAfterSuccess, persistAuthAfterSuccess = config.persistAuthAfterSuccess, enableRedirects = config.enableRedirects;
          _context.prev = 2;
          _adminConfigs$getConf = adminConfigs.getConfigs(), authConfig = _adminConfigs$getConf.authConfig, publicRouteURL = _adminConfigs$getConf.publicRouteURL;
          loginURL = getURL(publicRouteURL, "/login");
          _context.next = 7;
          return call$1(request, {
            url: url,
            method: method,
            data: useFormData ? jsonToFormData(credentials) : credentials,
            authenticated: action === "edit" || authenticated,
            enableRedirects: enableRedirects
          });

        case 7:
          response = _context.sent;
          if (enableRedirects && response.redirected) window.location = response.url;

          if (saveToLocalStorage) {
            addToLocalStorage(authConfig.name, response.data[authConfig.serverName] || ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data));
            setFirebaseToken && setFirebaseToken();
          }

          if (!updateAuthAfterSuccess) {
            _context.next = 13;
            break;
          }

          _context.next = 13;
          return put(updateAuth(_extends({}, response.data[authConfig.serverName])));

        case 13:
          _context.next = 15;
          return put(authAction.success(_extends({}, response.data, {
            persistAuthAfterSuccess: persistAuthAfterSuccess,
            successMessage: getTranslatedValue(successMessage)
          })));

        case 15:
          if (entity !== null && entity !== void 0 && entity.showAuthFormNotification) entity.handleNotification("success");
          successRedirect = typeof successRedirectPath === "function" ? successRedirectPath(response.data) : successRedirectPath;
          redirect = successRedirect || redirectPath;

          if (!redirect) {
            _context.next = 21;
            break;
          }

          _context.next = 21;
          return put(push(redirect));

        case 21:
          if (!(successRedirectPath === loginURL)) {
            _context.next = 24;
            break;
          }

          _context.next = 24;
          return put(logout());

        case 24:
          _context.next = 35;
          break;

        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](2);
          _context.next = 30;
          return put(authAction.failure(_context.t0.response.data || {
            errors: [getTranslatedValue(config.errorMessage)]
          }));

        case 30:
          if (!failureRedirectPath) {
            _context.next = 34;
            break;
          }

          failureRedirect = typeof failureRedirectPath === "function" ? failureRedirectPath(_context.t0.response.data) : failureRedirectPath;
          _context.next = 34;
          return put(push(failureRedirect));

        case 34:
          if (entity !== null && entity !== void 0 && entity.showAuthFormNotification) entity.handleNotification("errorMsg", (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data, formatErrors((_error$response2 = _context.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data));

        case 35:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$1, null, [[2, 26]]);
}

function authShowEffect(action) {
  var _action$payload, authConfig, _action$payload$reque, requestConfig, isProfileAuthorizationCheck, authIdentifier, urlSuffix, response;

  return _regeneratorRuntime().wrap(function authShowEffect$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload = action.payload, authConfig = _action$payload.authConfig, _action$payload$reque = _action$payload.requestConfig, requestConfig = _action$payload$reque === void 0 ? {} : _action$payload$reque, isProfileAuthorizationCheck = _action$payload.isProfileAuthorizationCheck;
          _context2.prev = 1;
          authIdentifier = loadFromLocalStorage(authConfig.name)[requestConfig.entityIdentifier];
          urlSuffix = authConfig.customShowEndpoint || (isProfileAuthorizationCheck ? "self" : authIdentifier);
          _context2.next = 6;
          return call$1(request, {
            url: authConfig.endpoint + "/" + urlSuffix,
            method: "get",
            authenticated: true
          });

        case 6:
          response = _context2.sent;
          _context2.next = 9;
          return put(authActionShow.success(response.data[authConfig.serverName]));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return put(authActionShow.failure());

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$1, null, [[1, 11]]);
}

function authWatcher() {
  return _regeneratorRuntime().wrap(function authWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeLatest(authAction.request, authEffect);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$1);
}

function authShowWatcher() {
  return _regeneratorRuntime().wrap(function authShowWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(authActionShow.request, authShowEffect);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4$1);
}

function logoutEffect() {
  var _adminConfigs$getConf2, authConfig, publicRouteURL, deleteFirebaseToken, loginURL, authHeaders;

  return _regeneratorRuntime().wrap(function logoutEffect$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _adminConfigs$getConf2 = adminConfigs.getConfigs(), authConfig = _adminConfigs$getConf2.authConfig, publicRouteURL = _adminConfigs$getConf2.publicRouteURL, deleteFirebaseToken = _adminConfigs$getConf2.deleteFirebaseToken;
          loginURL = getURL(publicRouteURL, "/login");
          authHeaders = loadFromLocalStorage("authHeaders");
          if (deleteFirebaseToken) deleteFirebaseToken(authHeaders);
          localStorage.removeItem("authHeaders");
          localStorage.removeItem(authConfig.name);
          _context5.next = 8;
          return put(push(loginURL));

        case 8:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5$1);
}

function logoutWatcher() {
  return _regeneratorRuntime().wrap(function logoutWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return takeLatest(logout, logoutEffect);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6$1);
}

var authSagas = [authWatcher, logoutWatcher, authShowWatcher];

var _marked$2 = /*#__PURE__*/_regeneratorRuntime().mark(validatePinPointSaga),
    _marked2$2 = /*#__PURE__*/_regeneratorRuntime().mark(validatePinPointWatcher);

function validatePinPointSaga(action) {
  var _action$payload, data, _action$payload$data, lng, lat, id, endPoint, success, failure, response;

  return _regeneratorRuntime().wrap(function validatePinPointSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, data = _action$payload.data, _action$payload$data = _action$payload.data, lng = _action$payload$data.lng, lat = _action$payload$data.lat, id = _action$payload.id, endPoint = _action$payload.endPoint;
          success = validatePinPoint.success, failure = validatePinPoint.failure;
          _context.prev = 2;
          _context.next = 5;
          return call$1(request, {
            url: endPoint,
            method: "post",
            authenticated: true,
            data: data
          });

        case 5:
          response = _context.sent;
          _context.next = 8;
          return put(success(_extends({}, response.data, {
            lng: lng,
            lat: lat,
            id: id
          })));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          _context.next = 14;
          return put(failure({
            erorrs: _context.t0.response.data,
            id: id
          }));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$2, null, [[2, 10]]);
}

function validatePinPointWatcher() {
  return _regeneratorRuntime().wrap(function validatePinPointWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(validatePinPoint.request, validatePinPointSaga);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$2);
}

var mapSagas = [validatePinPointWatcher];

var _marked$3 = /*#__PURE__*/_regeneratorRuntime().mark(scanningSaga),
    _marked2$3 = /*#__PURE__*/_regeneratorRuntime().mark(removingSaga),
    _marked3$2 = /*#__PURE__*/_regeneratorRuntime().mark(scanningItemWatcher),
    _marked4$2 = /*#__PURE__*/_regeneratorRuntime().mark(removingItemWatcher);

function scanningSaga(action) {
  var _action$payload, data, endPoint, dataAccessor, errorAccessor, success, failure, response, responseData;

  return _regeneratorRuntime().wrap(function scanningSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, data = _action$payload.data, endPoint = _action$payload.endPoint, dataAccessor = _action$payload.dataAccessor, errorAccessor = _action$payload.errorAccessor;
          success = scanItem.success, failure = scanItem.failure;
          _context.prev = 2;
          _context.next = 5;
          return call$1(request, {
            url: endPoint,
            method: "post",
            authenticated: true,
            data: data
          });

        case 5:
          response = _context.sent;
          responseData = dataAccessor ? dataAccessor(response.data) : response.data;
          _context.next = 9;
          return put(success(responseData));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          _context.next = 15;
          return put(failure({
            errors: errorAccessor ? errorAccessor(_context.t0.response.data) : _context.t0.response.data
          }));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$3, null, [[2, 11]]);
}

function removingSaga(action) {
  var _action$payload2, data, endPoint, dataAccessor, errorAccessor, success, failure, response, responseData;

  return _regeneratorRuntime().wrap(function removingSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload2 = action.payload, data = _action$payload2.data, endPoint = _action$payload2.endPoint, dataAccessor = _action$payload2.dataAccessor, errorAccessor = _action$payload2.errorAccessor;
          success = removeItem.success, failure = removeItem.failure;
          _context2.prev = 2;
          _context2.next = 5;
          return call$1(request, {
            url: endPoint,
            method: "delete",
            authenticated: true,
            data: data
          });

        case 5:
          response = _context2.sent;
          responseData = dataAccessor ? dataAccessor(response.data) : response.data;
          _context2.next = 9;
          return put(success(responseData));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          _context2.next = 15;
          return put(failure({
            errors: errorAccessor ? errorAccessor(_context2.t0.response.data) : _context2.t0.response.data
          }));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$3, null, [[2, 11]]);
}

function scanningItemWatcher() {
  return _regeneratorRuntime().wrap(function scanningItemWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeLatest(scanItem.request, scanningSaga);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$2);
}

function removingItemWatcher() {
  return _regeneratorRuntime().wrap(function removingItemWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(removeItem.request, removingSaga);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4$2);
}

var scanSagas = [scanningItemWatcher, removingItemWatcher];

var _marked$4 = /*#__PURE__*/_regeneratorRuntime().mark(getDataSaga),
    _marked2$4 = /*#__PURE__*/_regeneratorRuntime().mark(watchDashboardGetData);

function getDataSaga(action) {
  var _action$payload, id, endpoint, response;

  return _regeneratorRuntime().wrap(function getDataSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, id = _action$payload.id, endpoint = _action$payload.endpoint;
          _context.prev = 1;
          _context.next = 4;
          return call$1(request, {
            url: endpoint,
            method: "get",
            authenticated: true,
            skipSaveAuthHeader: true
          });

        case 4:
          response = _context.sent;

          if (!id) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return put(dashboardGroupData.success(_extends({
            id: id
          }, response.data)));

        case 8:
          _context.next = 12;
          break;

        case 10:
          _context.next = 12;
          return put(dashboardData.success(_extends({}, response.data)));

        case 12:
          _context.next = 24;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](1);
          showNotification(null, "error", i18n.t("dashboard:error"));

          if (!id) {
            _context.next = 22;
            break;
          }

          _context.next = 20;
          return put(dashboardGroupData.failure({
            id: id
          }));

        case 20:
          _context.next = 24;
          break;

        case 22:
          _context.next = 24;
          return put(dashboardData.failure());

        case 24:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$4, null, [[1, 14]]);
}

function watchDashboardGetData() {
  return _regeneratorRuntime().wrap(function watchDashboardGetData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery([dashboardGroupData.request, dashboardData.request], getDataSaga);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$4);
}

var dashboardSagas = [watchDashboardGetData];

var _marked$5 = /*#__PURE__*/_regeneratorRuntime().mark(getDataSaga$1),
    _marked2$5 = /*#__PURE__*/_regeneratorRuntime().mark(watchDashboardGetData$1);

function getDataSaga$1(action) {
  var _action$payload, id, endpoint, response;

  return _regeneratorRuntime().wrap(function getDataSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, id = _action$payload.id, endpoint = _action$payload.endpoint;
          _context.prev = 1;
          _context.next = 4;
          return call$1(request, {
            url: endpoint,
            method: "get",
            authenticated: true,
            skipSaveAuthHeader: true
          });

        case 4:
          response = _context.sent;
          _context.next = 7;
          return put(displayInfoData.success(_extends({
            id: id
          }, response.data)));

        case 7:
          _context.next = 14;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          showNotification(null, "error", i18n.t("unhandledErrors:error"));
          _context.next = 14;
          return put(displayInfoData.failure({
            id: id
          }));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$5, null, [[1, 9]]);
}

function watchDashboardGetData$1() {
  return _regeneratorRuntime().wrap(function watchDashboardGetData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(displayInfoData.request, getDataSaga$1);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$5);
}

var displayInfoSagas = [watchDashboardGetData$1];

var _marked$6 = /*#__PURE__*/_regeneratorRuntime().mark(fetchSaga),
    _marked2$6 = /*#__PURE__*/_regeneratorRuntime().mark(fetchSagaWatcher);

var success$1 = fetch$1.success,
    failure$1 = fetch$1.failure;

function fetchSaga(action) {
  var _action$payload, endpoint, serverName, response;

  return _regeneratorRuntime().wrap(function fetchSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, endpoint = _action$payload.endpoint, serverName = _action$payload.serverName;
          _context.prev = 1;
          _context.next = 4;
          return call$1(request, {
            url: endpoint,
            method: "get",
            authenticated: true,
            params: {
              show_all: true
            }
          });

        case 4:
          response = _context.sent;
          _context.next = 7;
          return put(success$1(response.data[serverName]));

        case 7:
          _context.next = 13;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          _context.next = 13;
          return put(failure$1({
            errors: _context.t0.response.data
          }));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$6, null, [[1, 9]]);
}

function fetchSagaWatcher() {
  return _regeneratorRuntime().wrap(function fetchSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(fetch$1.request, fetchSaga);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$6);
}

var apiEntitiesSagas = [fetchSagaWatcher];

var _marked$7 = /*#__PURE__*/_regeneratorRuntime().mark(sagaCreator);

var AdminSagasCreator = function AdminSagasCreator() {
  var _adminConfigs$getConf = adminConfigs.getConfigs(),
      allEntities = _adminConfigs$getConf.allEntities,
      notificationConfigs = _adminConfigs$getConf.notificationConfigs,
      apiEntitiesConfig = _adminConfigs$getConf.apiEntitiesConfig;

  var allActions = generateActions(null, allEntities);

  var _seperateActions = seperateActions(allActions),
      staticEntityActions = _seperateActions.staticEntityActions;

  return [].concat(authSagas, generatorSagas(staticEntityActions), mapSagas, scanSagas, dashboardSagas, displayInfoSagas, entitiesCustomSagas(allEntities || []), notificationConfigs.enabled ? sagas : [], apiEntitiesConfig.enabled ? apiEntitiesSagas : []);
};

function sagaCreator(sagas) {
  var sagasList;
  return _regeneratorRuntime().wrap(function sagaCreator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          sagasList = sagas.map(function (saga) {
            return saga();
          });
          _context.next = 3;
          return all(sagasList);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$7);
}

var useAuthorization = function useAuthorization(authConfig, storedRole, enableFirebase) {
  var _auth$authConfig$name;

  var storedRoleRef = useRef(storedRole);

  var _useFirebasePermissio = useFirebasePermissions(),
      setFirebaseToken = _useFirebasePermissio.setFirebaseToken,
      deleteDeviceToken = _useFirebasePermissio.deleteDeviceToken;

  var didMount = useRef(false);
  var auth = useSelector(function (state) {
    return getEntity(state, "auth");
  });
  var role = (_auth$authConfig$name = auth[authConfig.name]) === null || _auth$authConfig$name === void 0 ? void 0 : _auth$authConfig$name.role;
  var previousApiEntitySaga = useRef(null);

  var _useAPIEntities = useAPIEntities({
    didMount: didMount.current,
    auth: auth[authConfig.name]
  }),
      apiEntities = _useAPIEntities.apiEntities,
      syncCounter = _useAPIEntities.syncCounter;

  var apiEntitiesRef = useRef(null);

  var _adminConfigs$getConf = adminConfigs.getConfigs(),
      runSaga = _adminConfigs$getConf.runSaga;

  var newAPIEntitiesFound = apiEntitiesRef.current !== apiEntities && !(isEmpty(apiEntities) && syncCounter === 0);
  if (newAPIEntitiesFound) adminConfigs.addApiEntities(apiEntities);
  useEffect(function () {
    if (auth[authConfig.name] && enableFirebase) {
      setFirebaseToken();
      adminConfigs.setDeleteFirebaseToken(deleteDeviceToken);
    }
  }, []);

  var setNewApiEntitiesSagas = function setNewApiEntitiesSagas() {
    var _previousApiEntitySag;

    if (!runSaga) return;

    var _seperateActions = seperateActions(entitiesActions),
        apiEntityActions = _seperateActions.apiEntityActions;

    var sagas = generatorSagas(apiEntityActions);
    (_previousApiEntitySag = previousApiEntitySaga.current) === null || _previousApiEntitySag === void 0 ? void 0 : _previousApiEntitySag.cancel();
    previousApiEntitySaga.current = runSaga(sagaCreator, sagas);
  };

  useProfileAuthorizationCheck(auth.current, storedRole, authConfig);
  var authorization = useMemo(function () {
    return adminConfigs.setAuthorization(role);
  }, [role, apiEntities]);

  if (storedRoleRef.current !== role || !didMount.current || newAPIEntitiesFound) {
    var entities = authorization[0];
    generateActions(role, entities);
    var nextReducer = rootReducer(role, entities);
    adminConfigs.getConfigs().replaceReducer(nextReducer);
    storedRoleRef.current = role;
    didMount.current = true;
    apiEntitiesRef.current = apiEntities;
    setNewApiEntitiesSagas();
  }

  return authorization;
};

var resetReducerHandler = function resetReducerHandler(state, authConfig) {
  state.message = null;
  state.error = null;
  state[authConfig.name] = {};
};

var AuthReducersCreator = function AuthReducersCreator(newAuthConfig) {
  var _createReducer, _createReducer2;

  var authConfig = adminConfigs.customAuthConfigs(newAuthConfig);
  var auth = createReducer((_createReducer = {}, _createReducer[authConfig.name] = loadFromLocalStorage(authConfig.name), _createReducer.loading = false, _createReducer.current = {}, _createReducer), (_createReducer2 = {}, _createReducer2[resetReducer] = resetReducerHandler, _createReducer2[logout] = function (state) {
    state[authConfig.name] = null;
    state.current = {};
  }, _createReducer2[updateAuth] = function (state, action) {
    state[authConfig.name] = action.payload;
  }, _createReducer2[authAction.request] = function (state, action) {
    var _action$payload, _action$payload$confi;

    if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && (_action$payload$confi = _action$payload.config) !== null && _action$payload$confi !== void 0 && _action$payload$confi.persistAuthAfterSuccess)) resetReducerHandler(state, authConfig);
    state.loading = true;
  }, _createReducer2[authAction.failure] = function (state, action) {
    var payload = action.payload;
    state.error = payload;
    state.loading = false;
  }, _createReducer2[authAction.success] = function (state, action) {
    if (!action.payload.persistAuthAfterSuccess) state[authConfig.name] = action.payload[authConfig.serverName];
    state.message = action.payload.successMessage;
    state.loading = false;
  }, _createReducer2[authActionShow.request] = function (state, action) {
    state.loading = true;
    state.current = {};
    state.error = null;
  }, _createReducer2[authActionShow.success] = function (state, action) {
    state.loading = false;
    state.current = action.payload;
  }, _createReducer2[authActionShow.failure] = function (state, action) {
    state.loading = false;
    state.current = action.payload;
    state.error = action.payload || "there was an error";
  }, _createReducer2));
  return auth;
};

var DateFilter = function DateFilter(_ref) {
  var label = _ref.label,
      handleFilter = _ref.handleFilter,
      value = _ref.value,
      disableFuture = _ref.disableFuture,
      disablePast = _ref.disablePast,
      excludeDay = _ref.excludeDay,
      format = _ref.format;

  var _useState = useState(value || null),
      date = _useState[0],
      setDate = _useState[1];

  useEffect(function () {
    if (date) handleFilter(date);
  }, [date, handleFilter]);
  useEffect(function () {
    if (value === null) setDate(null);
  }, [value]);

  var handleChange = function handleChange(date) {
    setDate(moment(date).format(excludeDay ? "YYYY-MM" : moment.HTML5_FMT.DATE));
  };

  var disabledDate = function disabledDate(current) {
    var disbaled = false;
    if (disablePast) disbaled = disbaled || current < moment().startOf("day");
    if (disableFuture) disbaled = disbaled || current > moment().endOf("day");
    return disbaled;
  };

  return /*#__PURE__*/React__default.createElement(DatePickerWrapper, null, /*#__PURE__*/React__default.createElement(_DatePicker, {
    placeholder: label,
    onChange: handleChange,
    value: date && moment(date),
    format: format || "MMMM Do, YYYY",
    picker: excludeDay ? "month" : "date",
    inputReadOnly: true,
    allowClear: false,
    disabledDate: disabledDate
  }));
};

var DateFilter$1 = withFieldHandler(DateFilter);

var Root = function Root() {
  var configs = adminConfigs.getConfigs();
  var authConfig = configs.authConfig,
      storedRole = configs.storedRole,
      notificationConfigs = configs.notificationConfigs;

  var _useAuthorization = useAuthorization(authConfig, storedRole, notificationConfigs.enabled),
      entities = _useAuthorization[0],
      groups = _useAuthorization[1],
      routes = _useAuthorization[2];

  var appContext = _extends({}, adminConfigs.getConfigs(), {
    entities: entities,
    groups: groups,
    routes: routes
  });

  return /*#__PURE__*/React__default.createElement(AppContext.Provider, {
    value: appContext
  }, /*#__PURE__*/React__default.createElement(GlobalLayoutStyle, null), /*#__PURE__*/React__default.createElement(App, null));
};

export default Root;
export { ActionButton, AdminSagasCreator, AuthReducersCreator, AuthorizedEntities, ButtonContainer, CheckboxField, Container$1 as Container, CountryCodeField, CountryCodeWrapper, DataPagination, DateFilter$1 as DateFilter, DynamicCheckboxField, DynamicFieldsGroup, Entity, EntitySelect, ErrorMessage, Field, FieldHandler, FieldWithDescription, Field$1 as FormField, GoogleMap$1 as GoogleMap, Image, JsonField$1 as JsonField, LabelContainer, Loadable, MapElement, MarkerMapField$1 as MarkerMapField, PhoneNumberField, PolygonMapField$1 as PolygonMapField, RadioField$1 as RadioField, ReferenceField, SearchBar, SearchBox, Select, SelectField, SelectFilter, StyledField, StyledForm, TransferList, addToLocalStorage, adminConfigs, camelizeFromSnakeCase, capitalizeString, convertIdType, convertToEnglishNumbers, createActions$1 as createActions, currentRoleEqualTo, displayField, displayWithTag, displayedTag, entitiesActions, entitiesCustomSagas, fieldsToState, filtersToAttributes, generateActions, generateReferencedEntity, generateReferencedEntityCustomName, getAccessorValue, getActionsArrayOf, getDirection, getEntity, getFiltersDefaultValues, getJSONValue, getOptionalFunctionValue, getToggleValue, getTranslatedValue, getURL, getValue, handleFormatErrorsObject, humanize, initTranslation, isFileField, isValueEmpty, jsonToFormData, loadFromLocalStorage, modifyAccessor, pascalCaseToSentence, renderComponent, request, resources, sagaCreator, seperateActions, setDashBoardEntities, setReferencedEntities, showNotification, splitFirstCharacter, styledList, toggleLanguage, useChangeMarker, useDrawPolygon, useGetZones, useMarker, usePlaces, usePointValidator, usePolygonCoordinates, withFieldHandler };